var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
(function () {
    angular.module('QMC.Stammdaten', ['QMC.Klient']).config(routes);
    routes.$inject = ['$locationProvider', '$stateProvider', '$urlRouterProvider', 'qmcBase'];
    function routes($locationProvider, $stateProvider, $urlRouterProvider, qmcBase) {
        $locationProvider.html5Mode({
            enabled: false,
            requireBase: false
        });
        var params = {
            dataId: {
                dynamic: true
            }
        };
        $stateProvider
            // client
            .state('stammdatenOwn', {
            url: '/stammdaten',
            templateUrl: qmcBase + '/stammdaten',
            controller: 'StammdatenClientListController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: Stammdaten client list');
                    }]
            }
        })
            .state('stammdaten', {
            url: '/stammdaten/:id',
            templateUrl: qmcBase + '/stammdaten',
            controller: 'StammdatenClientListController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: Stammdaten client list');
                    }]
            }
        })
            .state('detail', {
            url: '/stammdaten/detail/:client',
            templateUrl: qmcBase + '/stammdaten/detail',
            controller: 'StammdatenClientDetailController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: Stammdaten client detail');
                    }]
            }
        })
            // detail
            .state('detail.address', {
            url: '/address/:id?:dataId',
            templateUrl: qmcBase + '/stammdaten/detail/address',
            controller: 'DetailAddressController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: Stammdaten client detail address');
                    }]
            },
            params: params
        })
            .state('detail.communication', {
            url: '/communication/:id?:dataId',
            templateUrl: qmcBase + '/stammdaten/detail/communication',
            controller: 'DetailCommunicationController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: Stammdaten client detail communication');
                    }]
            },
            params: params
        })
            .state('detail.contactperson', {
            url: '/contactperson/:id?:dataId',
            templateUrl: qmcBase + '/stammdaten/detail/contactperson',
            controller: 'DetailContactPersonController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: Stammdaten client detail contact person');
                    }]
            },
            params: params
        })
            .state('detail.cover', {
            url: '/cover/:id',
            templateUrl: qmcBase + '/stammdaten/detail/cover',
            controller: 'DetailCoverController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: Stammdaten client detail cover');
                    }]
            }
        })
            .state('detail.doctorsvisit', {
            url: '/doctorsvisit/:id?:dataId',
            templateUrl: qmcBase + '/stammdaten/detail/doctorsvisit',
            controller: 'DetailDoctorsVisitController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: Stammdaten client detail doctors visit');
                    }]
            },
            params: params
        })
            .state('detail.disease', {
            url: '/disease/:id?:dataId',
            templateUrl: qmcBase + '/stammdaten/detail/disease',
            controller: 'DetailDiseaseController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: Stammdaten client detail disease');
                    }]
            },
            params: params
        })
            .state('detail.note', {
            url: '/note/:id',
            templateUrl: qmcBase + '/stammdaten/detail/note',
            controller: 'DetailNoteController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: Stammdaten client detail note');
                    }]
            }
        })
            .state('detail.education', {
            url: '/education/:id?:dataId',
            templateUrl: qmcBase + '/stammdaten/detail/education',
            controller: 'DetailEducationController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: Stammdaten client detail school');
                    }]
            },
            params: params
        })
            .state('detail.vaccination', {
            url: '/vaccination/:id?:dataId',
            templateUrl: qmcBase + '/stammdaten/detail/vaccination',
            controller: 'DetailVaccinationController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: Stammdaten client detail vaccination');
                    }]
            },
            params: params
        })
            .state('detail.hobby', {
            url: '/hobby/:id',
            templateUrl: qmcBase + '/stammdaten/detail/hobby',
            controller: 'DetailHobbyController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: Stammdaten client detail hobby');
                    }]
            }
        })
            .state('detail.checklist', {
            url: '/checklist/:id?:dataId',
            templateUrl: qmcBase + '/stammdaten/detail/checklist',
            controller: 'DetailChecklistController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: Stammdaten client detail checklist');
                    }]
            },
            params: params
        })
            .state('detail.document', {
            url: '/documents/:id',
            templateUrl: qmcBase + '/stammdaten/detail/document',
            controller: 'DetailDocumentsController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: Stammdaten client detail document');
                    }]
            },
            params: params
        })
            .state('detail.absenteeism', {
            url: '/absenteeism/:id',
            templateUrl: qmcBase + '/stammdaten/detail/absenteeism',
            controller: 'DetailAbsenteeismController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: Stammdaten client detail absenteeism');
                    }]
            }
        })
            .state('detail.accountingBook', {
            url: '/accountingBook/:id',
            templateUrl: qmcBase + '/stammdaten/detail/accountingBook',
            controller: 'DetailAccountingBookController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: Stammdaten client detail accounting book');
                    }]
            }
        })
            .state('detail.legal', {
            url: '/legal/:id?:dataId',
            templateUrl: qmcBase + '/stammdaten/detail/legal',
            controller: 'DetailLegalController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: Stammdaten client detail legal');
                    }]
            },
            params: params
        })
            .state('detail.extendedMainData', {
            url: '/extendedMainData/:id',
            templateUrl: qmcBase + '/stammdaten/detail/extendedMainData',
            controller: 'DetailExtendedMainDataController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: Stammdaten client detail extended Main Data');
                    }]
            }
        })
            .state('detail.tempInstituteChange', {
            url: '/tempInstituteChange/:id',
            templateUrl: qmcBase + '/stammdaten/detail/tempInstituteChange',
            controller: 'DetailTempInstituteChangeController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: Stammdaten client temp institute change');
                    }]
            }
        })
            .state('detail.clientInfo', {
            url: '/clientInformation/:id',
            templateUrl: qmcBase + '/stammdaten/detail/clientInfo',
            controller: 'DetailClientInfoController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: Stammdaten ClientInfo');
                    }]
            }
        })
            .state('detail.udf', {
            url: '/udf/:type/:definitionId/:definitionObjectType/:id',
            templateUrl: qmcBase + '/stammdaten/detail/udf',
            controller: 'DetailUdfController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: Stammdaten UDF');
                    }]
            }
        })
            // misc
            .state('globalDocuments', {
            url: '/globalDocuments',
            templateUrl: qmcBase + '/stammdaten/globaldocuments/List',
            controller: 'GlobalDocumentsListController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: Stammdaten GlobalDocuments');
                    }]
            }
        })
            .state('orgaAccountingBooks', {
            url: '/orgaAccountingBooks',
            templateUrl: qmcBase + '/stammdaten/orgaAccountingBooks/List',
            controller: 'OrgaAccountingBooksListController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: Stammdaten Organsations Accounting Books');
                    }]
            }
        });
    }
})();
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        var HttpProvider = /** @class */ (function () {
            function HttpProvider() {
            }
            HttpProvider.configureHttpProvider = function ($httpProvider) {
                // initialize get if not there
                if (!$httpProvider.defaults.headers.get) {
                    $httpProvider.defaults.headers.get = {};
                }
                // disable IE ajax request caching
                $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
                // extra
                $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
                $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';
            };
            return HttpProvider;
        }());
        Stammdaten.HttpProvider = HttpProvider;
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
(function () {
    angular.module('QMC.Stammdaten')
        .config(['$httpProvider', QMC.Stammdaten.HttpProvider.configureHttpProvider]);
})();
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        var StammdatenService = /** @class */ (function (_super) {
            __extends(StammdatenService, _super);
            function StammdatenService($http, $q) {
                var _this = _super.call(this, $http, $q) || this;
                _this.$http = $http;
                _this.$q = $q;
                _this.modulePath = '/Stammdaten';
                return _this;
            }
            /***** Check for warnings and errors related to the social insurance number *****/
            StammdatenService.prototype.getPersonValidation = function (dataPersonValidation) {
                return _super.prototype.post.call(this, '/Person/WarningsAndErrors', dataPersonValidation).then(function (dataResult) {
                    return dataResult;
                });
            };
            StammdatenService.prototype.getParticipantsSelectionAssignment = function (key, addEmptyItem) {
                if (addEmptyItem === void 0) { addEmptyItem = false; }
                return _super.prototype.getItem.call(this, "/Person/PeopleSelectionAssignment/" + key, { addEmptyItem: addEmptyItem }, function (data) {
                    return data;
                });
            };
            /***** Doctor *****/
            StammdatenService.prototype.getDoctorList = function () {
                return _super.prototype.get.call(this, '/Person/Doctor', {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.getMedicalOrganisationList = function () {
                return _super.prototype.get.call(this, '/Person/MedicalOrganisation', {}, function (data) {
                    return data;
                });
            };
            /***** Address *****/
            StammdatenService.prototype.getAddressList = function (parentObjectId) {
                return _super.prototype.get.call(this, this.modulePath + '/Address/' + parentObjectId, {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.getAddress = function (parentObjectId, id) {
                return _super.prototype.get.call(this, this.modulePath + '/Address/' + parentObjectId + '/' + id, {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.getAddressWv = function () {
                return _super.prototype.getItem.call(this, this.modulePath + '/Address/WvModel', {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.getStatesWv = function (id) {
                return _super.prototype.get.call(this, this.modulePath + '/Address/StatesWv/' + id, {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.getCityByPostCodeList = function (countryId, searchPostCode) {
                return _super.prototype.get.call(this, this.modulePath + '/Address/CitiesByPostCode/' + countryId + '/' + searchPostCode, {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.getPostCodeByCityList = function (countryId, searchCity) {
                return _super.prototype.get.call(this, this.modulePath + '/Address/PostCodesByCity/' + countryId + '/' + searchCity, {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.postAddress = function (data) {
                return _super.prototype.post.call(this, this.modulePath + '/Address', data).then(function (d) {
                    return d;
                });
            };
            StammdatenService.prototype.putAddress = function (parentObjectId, id, data) {
                return _super.prototype.put.call(this, this.modulePath + '/Address/' + parentObjectId + '/' + id, data).then(function (data) {
                    console.log(data);
                    return data;
                });
            };
            StammdatenService.prototype.deleteAddress = function (parentObjectId, id) {
                return _super.prototype.delete.call(this, this.modulePath + '/Address/' + parentObjectId + '/' + id).then(function (e) {
                    return e;
                });
            };
            /***** AccountingBook *****/
            StammdatenService.prototype.checkForWarningsAndErrors = function (data) {
                return _super.prototype.post.call(this, this.modulePath + '/AccountingBook/WarningsAndErrors', data).then(function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.getAccountingBooks = function () {
                return _super.prototype.get.call(this, this.modulePath + '/AccountingBook/', {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.getAccountingBookList = function (parentId) {
                return _super.prototype.get.call(this, this.modulePath + '/AccountingBook/' + parentId, {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.getAccountingBook = function (parentObjectid, bookId, dateFrom, dateTo) {
                return _super.prototype.getItem.call(this, this.modulePath + '/AccountingBook/' + parentObjectid + "/" + bookId, { dateFrom: dateFrom, dateTo: dateTo }, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.postAccountingBook = function (data) {
                return _super.prototype.post.call(this, this.modulePath + '/AccountingBook', data).then(function (d) {
                    return d;
                });
            };
            StammdatenService.prototype.postAccountingBookEntry = function (data) {
                return _super.prototype.post.call(this, this.modulePath + '/AccountingBook/Entry', data).then(function (d) {
                    return d;
                });
            };
            StammdatenService.prototype.putAccountingBook = function (parentObjectId, id, data) {
                return _super.prototype.put.call(this, this.modulePath + '/AccountingBook/' + parentObjectId + '/' + id, data).then(function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.putAccountingBookEntry = function (id, data) {
                return _super.prototype.put.call(this, this.modulePath + '/AccountingBook/Entry/' + id, data).then(function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.deleteAccountingBook = function (parentObjectId, id) {
                return _super.prototype.delete.call(this, this.modulePath + '/AccountingBook/' + parentObjectId + '/' + id).then(function (e) {
                    return e;
                });
            };
            StammdatenService.prototype.deleteAccountingBookEntry = function (bookId, id) {
                return _super.prototype.delete.call(this, this.modulePath + '/AccountingBook/Entry/' + bookId + '/' + id).then(function (e) {
                    return e;
                });
            };
            StammdatenService.prototype.getAccountingBookWv = function () {
                return _super.prototype.getItem.call(this, this.modulePath + '/AccountingBook/WvModel', {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.getAccountingBookWvForCountry = function (id) {
                return _super.prototype.getItem.call(this, this.modulePath + '/AccountingBook/WvModel/' + id, {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.getAccountingBookUserConfig = function () {
                return _super.prototype.getItem.call(this, this.modulePath + '/AccountingBook/UserConfig', {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.getAccountingBookReferences = function () {
                var cacheName = 'AccountingBookReferenceCache';
                var cacheContent = sessionStorage.getItem(cacheName);
                if (cacheContent) {
                    return this.$q(function (resolve, reject) {
                        try {
                            resolve(JSON.parse(cacheContent));
                        }
                        catch (e) {
                            console.log('failed cache parsing for AccountingBookReferences', e);
                            reject([]);
                        }
                    });
                }
                return _super.prototype.get.call(this, "/Person/PeopleSelectionAssignment/KASSENBUCHDATENBEZUG.PERSONENTYP", {}, function (data) {
                    sessionStorage.setItem(cacheName, JSON.stringify(data));
                    return data;
                });
            };
            /***** Authority *****/
            StammdatenService.prototype.getAuthorityList = function () {
                return _super.prototype.get.call(this, '/Person/Authority', {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.getAuthorityContactList = function () {
                return _super.prototype.get.call(this, '/Person/Authority/Contact', {}, function (data) {
                    return data;
                });
            };
            /***** Checklist *****/
            StammdatenService.prototype.getChecklistList = function (referenceType) {
                return _super.prototype.get.call(this, this.modulePath + '/Checklist/', { referenceType: referenceType }, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.getChecklistItemList = function (parentObjectId, checklistId) {
                return _super.prototype.get.call(this, this.modulePath + '/Checklist/Items/' + parentObjectId + '/' + checklistId, {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.getChecklistItem = function (parentObjectId, checklistId, itemid) {
                return _super.prototype.getItem.call(this, this.modulePath + ("/Checklist/Items/" + parentObjectId + "/" + checklistId + "/" + itemid), {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.postCheckedItem = function (parentObjectId, data) {
                return _super.prototype.post.call(this, this.modulePath + "/Checklist/Items/" + parentObjectId, data).then(function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.putCheckedItem = function (parentObjectId, itemId, data) {
                return _super.prototype.put.call(this, this.modulePath + "/Checklist/Items/" + parentObjectId + "/" + itemId, data).then(function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.deleteCheckedItems = function (parentObjectId, itemId) {
                return _super.prototype.delete.call(this, this.modulePath + "/Checklist/Items/" + parentObjectId + "/" + itemId).then(function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.deleteCheckedItem = function (parentObjectId, itemId, id) {
                return _super.prototype.delete.call(this, this.modulePath + "/Checklist/Items/" + parentObjectId + "/" + itemId + "/" + id).then(function (data) {
                    return data;
                });
            };
            /***** Communication *****/
            StammdatenService.prototype.getCommunicationList = function (parentObjectId) {
                return _super.prototype.get.call(this, this.modulePath + '/Communication/' + parentObjectId, {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.getCommunication = function (parentObjectId, id) {
                return _super.prototype.get.call(this, this.modulePath + '/Communication/' + parentObjectId + '/' + id, {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.getCommunicationWv = function () {
                return _super.prototype.getItem.call(this, this.modulePath + '/Communication/WvModel', {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.postCommunication = function (data) {
                return _super.prototype.post.call(this, this.modulePath + '/Communication', data).then(function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.putCommunication = function (parentObjectId, id, data) {
                return _super.prototype.put.call(this, this.modulePath + '/Communication/' + parentObjectId + '/' + id, data).then(function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.deleteCommunication = function (parentObjectId, id) {
                return _super.prototype.delete.call(this, this.modulePath + '/Communication/' + parentObjectId + '/' + id).then(function (data) {
                    return data;
                });
            };
            /***** Society (VEREIN) *****/
            StammdatenService.prototype.getSocietyListItem = function () {
                return _super.prototype.get.call(this, '/Person/Society/', {}, function (data) {
                    return data;
                });
            };
            /***** Contact Person *****/
            StammdatenService.prototype.getContactPersonList = function (parentObjectId, categoryId, contactPersonStatusId) {
                var additionalParams = "";
                if (categoryId !== null)
                    additionalParams += "?categoryId=" + categoryId;
                if (contactPersonStatusId !== null) {
                    if (categoryId !== null)
                        additionalParams += "&activeStatusId=" + contactPersonStatusId;
                    else
                        additionalParams += "?activeStatusId=" + contactPersonStatusId;
                }
                return _super.prototype.get.call(this, this.modulePath + '/ContactPerson/' + parentObjectId + additionalParams, {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.getContactPersonWvList = function () {
                return _super.prototype.getItem.call(this, this.modulePath + '/ContactPerson/WvModel', {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.getContactPersonCategories = function () {
                return _super.prototype.get.call(this, this.modulePath + '/ContactPerson/Category', {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.getContactPerson = function (parentObjectId, id) {
                return _super.prototype.get.call(this, this.modulePath + '/ContactPerson/' + parentObjectId + '/' + id, {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.postContactPerson = function (data) {
                return _super.prototype.post.call(this, this.modulePath + '/ContactPerson', data).then(function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.putContactPerson = function (parentObjectId, id, data) {
                return _super.prototype.put.call(this, this.modulePath + '/ContactPerson/' + parentObjectId + '/' + id, data).then(function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.deleteContactPerson = function (parentObjectId, id) {
                return _super.prototype.delete.call(this, this.modulePath + '/ContactPerson/' + parentObjectId + '/' + id).then(function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.validateContactPersonDeletion = function (referenceId, referenceObjectId) {
                return _super.prototype.post.call(this, this.modulePath + "/ContactPerson/DeletionValidation", { contactPersonId: referenceId, contactPersonObjId: referenceObjectId }).then(function (data) {
                    return data;
                });
            };
            /***** Training ****/
            StammdatenService.prototype.getTrainingList = function (parentObjectId, parentObjectType) {
                return _super.prototype.get.call(this, this.modulePath + '/Training/' + parentObjectId + '/' + parentObjectType, {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.getTraining = function (parentObjectId, id) {
                return _super.prototype.getItem.call(this, this.modulePath + '/Training/' + parentObjectId + '/' + id, {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.getTrainingWvList = function () {
                return _super.prototype.getItem.call(this, this.modulePath + '/Training/WvModel', {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.postTraining = function (data) {
                return _super.prototype.post.call(this, this.modulePath + '/Training', data).then(function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.putTraining = function (parentObjectId, id, data) {
                return _super.prototype.put.call(this, this.modulePath + '/Training/' + parentObjectId + '/' + id, data).then(function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.deleteTraining = function (parentObjectId, id) {
                return _super.prototype.delete.call(this, this.modulePath + '/Training/' + parentObjectId + '/' + id).then(function (data) {
                    return data;
                });
            };
            /***** Education ****/
            StammdatenService.prototype.getEducationList = function (parentObjectId) {
                return _super.prototype.get.call(this, this.modulePath + '/Education/' + parentObjectId, {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.getCompaniesList = function () {
                return _super.prototype.get.call(this, '/Person/Company', {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.getSchoolsList = function () {
                return _super.prototype.get.call(this, '/Person/School', {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.getGradeLevelList = function (parentObjectId) {
                return _super.prototype.get.call(this, '/Person/School/GradeLevel/' + parentObjectId, {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.getEducation = function (parentObjectId, id, educationKind) {
                return _super.prototype.getItem.call(this, this.modulePath + '/Education/' + parentObjectId + '/' + id + '/' + educationKind, {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.getEducationWvList = function () {
                return _super.prototype.getItem.call(this, this.modulePath + '/Education/WvModel', {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.postEducation = function (data) {
                return _super.prototype.post.call(this, this.modulePath + '/Education', data).then(function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.putEducation = function (parentObjectId, id, data) {
                return _super.prototype.put.call(this, this.modulePath + '/Education/' + parentObjectId + '/' + id, data).then(function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.deleteEducation = function (parentObjectId, id, educationKind) {
                return _super.prototype.delete.call(this, this.modulePath + '/Education/' + parentObjectId + '/' + id + '/' + educationKind).then(function (data) {
                    return data;
                });
            };
            /***** Disease ****/
            StammdatenService.prototype.getDiseaseRequiredFields = function () {
                return _super.prototype.getItem.call(this, this.modulePath + '/Disease/RequiredFields/', {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.getDiseaseList = function (parentObjectId) {
                return _super.prototype.get.call(this, this.modulePath + '/Disease/' + parentObjectId, {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.getDisease = function (parentObjectId, id) {
                return _super.prototype.get.call(this, this.modulePath + '/Disease/' + parentObjectId + '/' + id, {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.getDiseaseWvList = function () {
                return _super.prototype.getItem.call(this, this.modulePath + '/Disease/WvModel', {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.getDiseasesBySearchText = function (codeSchemaWvId, searchText) {
                return _super.prototype.get.call(this, this.modulePath + '/Disease/Base/MatchSearchText/' + codeSchemaWvId + '/' + searchText, {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.postDisease = function (data) {
                return _super.prototype.post.call(this, this.modulePath + '/Disease', data).then(function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.putDisease = function (parentObjectId, id, data) {
                return _super.prototype.put.call(this, this.modulePath + '/Disease/' + parentObjectId + '/' + id, data).then(function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.deleteDisease = function (parentObjectId, id) {
                return _super.prototype.delete.call(this, this.modulePath + '/Disease/' + parentObjectId + '/' + id).then(function (data) {
                    return data;
                });
            };
            /***** Legal *****/
            StammdatenService.prototype.getLegalList = function (parentObjectId) {
                return _super.prototype.get.call(this, this.modulePath + '/Legal/' + parentObjectId, {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.getLegal = function (parentObjectId, id) {
                return _super.prototype.getItem.call(this, this.modulePath + '/Legal/' + parentObjectId + '/' + id, {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.getLegalWvList = function () {
                return _super.prototype.getItem.call(this, this.modulePath + '/Legal/WvModel', {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.postLegal = function (data) {
                return _super.prototype.post.call(this, this.modulePath + '/Legal', data).then(function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.putLegal = function (parentobjectId, id, data) {
                return _super.prototype.put.call(this, this.modulePath + '/Legal/' + parentobjectId + '/' + id, data).then(function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.deleteLegal = function (parentObjectId, id) {
                return _super.prototype.delete.call(this, this.modulePath + '/Legal/' + parentObjectId + '/' + id).then(function (data) {
                    return data;
                });
            };
            /***** Doctors Visit *****/
            StammdatenService.prototype.getDoctorsVisitList = function (parentObjectId) {
                return _super.prototype.get.call(this, this.modulePath + '/DoctorsVisit/' + parentObjectId, {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.getDoctorsVisit = function (parentObjectId, id) {
                return _super.prototype.getItem.call(this, this.modulePath + '/DoctorsVisit/' + parentObjectId + '/' + id, {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.postDoctorsVisit = function (data) {
                return _super.prototype.post.call(this, this.modulePath + '/DoctorsVisit', data).then(function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.putDoctorsVisit = function (parentObjectId, id, data) {
                return _super.prototype.put.call(this, this.modulePath + '/DoctorsVisit/' + parentObjectId + '/' + id, data).then(function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.deleteDoctorsVisit = function (parentObjectId, id) {
                return _super.prototype.delete.call(this, this.modulePath + '/DoctorsVisit/' + parentObjectId + '/' + id).then(function (data) {
                    return data;
                });
            };
            /**** Notes *****/
            StammdatenService.prototype.getNote = function (parentObjectId) {
                return _super.prototype.getItem.call(this, '/Client/Note/' + parentObjectId, {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.putNote = function (parentObjectId, data) {
                return _super.prototype.put.call(this, '/Client/Note/' + parentObjectId, data).then(function (data) {
                    return data;
                });
            };
            /***** Vaccination *****/
            StammdatenService.prototype.getVaccinationList = function (parentObjectId) {
                return _super.prototype.get.call(this, this.modulePath + '/Vaccination/' + parentObjectId, {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.getVaccination = function (parentObjectId, id) {
                return _super.prototype.get.call(this, this.modulePath + '/Vaccination/' + parentObjectId + '/' + id, {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.getVaccinationWv = function () {
                return _super.prototype.getItem.call(this, this.modulePath + '/Vaccination/WvModel', {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.postVaccination = function (data) {
                return _super.prototype.post.call(this, this.modulePath + '/Vaccination', data).then(function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.putVaccination = function (parentObjectId, id, data) {
                return _super.prototype.put.call(this, this.modulePath + '/Vaccination/' + parentObjectId + '/' + id, data).then(function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.deleteVaccination = function (parentObjectId, id) {
                return _super.prototype.delete.call(this, this.modulePath + '/Vaccination/' + parentObjectId + '/' + id).then(function (data) {
                    return data;
                });
            };
            /***** Hobby *****/
            StammdatenService.prototype.getHobbyRequiredFields = function () {
                return _super.prototype.getItem.call(this, this.modulePath + '/Hobby/' + "/RequiredFields", {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.getHobbyList = function (parentObjectId) {
                return _super.prototype.get.call(this, this.modulePath + '/Hobby/' + parentObjectId, {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.getHobby = function (parentObjectId, id) {
                return _super.prototype.getItem.call(this, this.modulePath + '/Hobby/' + parentObjectId + '/' + id, {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.getHobbyWv = function () {
                return _super.prototype.getItem.call(this, this.modulePath + '/Hobby/WvModel', {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.postHobby = function (data) {
                return _super.prototype.post.call(this, this.modulePath + '/Hobby', data).then(function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.putHobby = function (parentObjectId, id, data) {
                return _super.prototype.put.call(this, this.modulePath + '/Hobby/' + parentObjectId + '/' + id, data).then(function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.deleteHobby = function (parentObjectId, id) {
                return _super.prototype.delete.call(this, this.modulePath + '/Hobby/' + parentObjectId + '/' + id).then(function (data) {
                    return data;
                });
            };
            /***** Documents ****/
            StammdatenService.prototype.getDocumentsUserConfig = function () {
                return _super.prototype.getItem.call(this, '/Document/UserConfig', {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.getDocumentList = function (parentObjectId) {
                return _super.prototype.get.call(this, '/Document/' + parentObjectId, {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.getDocument = function (parentObjectId, id) {
                return _super.prototype.getItem.call(this, '/Document/' + parentObjectId + '/' + id, {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.downloadAttachment = function (documentId, attachmentId) {
                return _super.prototype.getItem.call(this, '/Document/Media/' + documentId + '/' + attachmentId, {}).then(function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.postNewDocument = function (data) {
                return _super.prototype.post.call(this, '/Document', data).then(function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.editDocument = function (parentObjectId, id, data) {
                return _super.prototype.put.call(this, '/Document/' + parentObjectId + '/' + id, data).then(function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.addFileToDocument = function (data) {
                return _super.prototype.post.call(this, '/Document/Media', data).then(function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.deleteDocument = function (parentObjectId, id) {
                return _super.prototype.delete.call(this, '/Document/' + parentObjectId + '/' + id).then(function (e) {
                    return e;
                });
            };
            StammdatenService.prototype.deleteFile = function (documentId, id) {
                return _super.prototype.delete.call(this, '/Document/Media/' + documentId + "/" + id).then(function (e) {
                    return e;
                });
            };
            StammdatenService.prototype.getDocumentWV = function () {
                return _super.prototype.cachedGetItem.call(this, '/Document/WvModel', {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.getDocumentMappingForObjecttype = function (type) {
                return _super.prototype.cachedGetItem.call(this, "/Document/Media/DocumentMapping/" + type).then(function (data) { return data; });
            };
            /***** Absenteeism *****/
            StammdatenService.prototype.getAbsenteeismList = function (parentObjectId) {
                return _super.prototype.get.call(this, this.modulePath + '/Absenteeism/' + parentObjectId, {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.getAbsenteeismBanList = function (clientId) {
                return _super.prototype.get.call(this, this.modulePath + '/Absenteeism/Bans/' + clientId, {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.getAbsenteeism = function (parentObjectId, id) {
                return _super.prototype.getItem.call(this, this.modulePath + '/Absenteeism/' + parentObjectId + '/' + id, {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.postAbsenteeism = function (data) {
                return _super.prototype.post.call(this, this.modulePath + '/Absenteeism', data).then(function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.putAbsenteeism = function (parentObjectId, id, data) {
                return _super.prototype.put.call(this, this.modulePath + '/Absenteeism/' + parentObjectId + '/' + id, data).then(function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.deleteAbsenteeism = function (parentObjectId, id) {
                return _super.prototype.delete.call(this, this.modulePath + '/Absenteeism/' + parentObjectId + '/' + id).then(function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.getAbsenteeismWv = function () {
                return _super.prototype.cachedGetItem.call(this, this.modulePath + '/Absenteeism/WvModel', {}, function (data) {
                    return data;
                });
            };
            /***** Check for warnings and errors *****/
            StammdatenService.prototype.checkAbsenteeismValidation = function (dataAbsenteeismValidation) {
                return _super.prototype.post.call(this, this.modulePath + '/Absenteeism/WarningsAndErrors', dataAbsenteeismValidation).then(function (dataResult) {
                    return dataResult;
                });
            };
            /***** Media *****/
            StammdatenService.prototype.getClientImage = function (clientId, thumbnail, objectType) {
                if (objectType === void 0) { objectType = 140031; }
                if (clientId !== undefined) {
                    var thumbnailString = thumbnail ? 'true' : 'false';
                    return _super.prototype.cachedGetItem.call(this, '/Media/Image/MainImage', { parentObjectId: clientId, getThumbnail: thumbnailString, objectType: objectType }, function (data) {
                        return data;
                    });
                }
                return null;
            };
            StammdatenService.prototype.getAvatarByName = function (foreName, name) {
                if (foreName !== "" && name !== "") {
                    return _super.prototype.cachedGetItem.call(this, 'Media/Image/CreateAvatar', { foreName: foreName, name: name }, function (data) {
                        return data;
                    });
                }
                return null;
            };
            StammdatenService.prototype.getClientImageList = function (clientIds, thumbnail, objectType) {
                if (objectType === void 0) { objectType = 140031; }
                if (clientIds !== undefined) {
                    console.log("ids", clientIds);
                    var thumbnailString = thumbnail ? 'true' : 'false';
                    return _super.prototype.get.call(this, 'Media/Image/MainImageList', { objectIdList: clientIds, getThumbnail: thumbnailString, objectType: objectType }, function (data) {
                        return data;
                    });
                }
            };
            /***** GlobalDocuments *****/
            StammdatenService.prototype.getGlobalDocumentList = function (dateFrom, dateTo, showOnlyGlobal, referenceObjectType, page, pageSize, searchString, searchProperties) {
                if (searchProperties === void 0) { searchProperties = []; }
                return _super.prototype.getPagination.call(this, '/GlobalDocuments', { dateFrom: dateFrom, dateTo: dateTo, showOnlyGlobal: showOnlyGlobal, referenceObjectType: referenceObjectType, page: page, pageSize: pageSize, listSearch: searchString, searchProperties: searchProperties }, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.getGlobalDocumentReferences = function () {
                return _super.prototype.get.call(this, '/GlobalDocuments/References', {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.getGlobalDocumentFile = function (id) {
                return _super.prototype.getItem.call(this, '/GlobalDocuments/Media/' + id, {}).then(function (data) {
                    return data === null || data === void 0 ? void 0 : data.base64;
                });
            };
            StammdatenService.prototype.postGlobalDocument = function (data) {
                return _super.prototype.post.call(this, '/GlobalDocuments', data).then(function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.deleteGlobalDocument = function (document) {
                //return super.delete('/GlobalDocuments/' + document.grandParentId + "/" + document.parentId + "/" + document.objectId).then((e) => {
                return _super.prototype.delete.call(this, '/GlobalDocuments/' + document.objectId).then(function (e) {
                    return e;
                });
            };
            /***** MedicalEvidence ****/
            StammdatenService.prototype.getMedicalEvidenceList = function (parentObjectId) {
                return _super.prototype.get.call(this, this.modulePath + '/MedicalEvidence/' + parentObjectId, {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.getMedicalEvidence = function (parentObjectId, id) {
                return _super.prototype.getItem.call(this, this.modulePath + '/MedicalEvidence/' + parentObjectId + '/' + id, {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.getMedicalEvidenceWvList = function () {
                return _super.prototype.getItem.call(this, this.modulePath + '/MedicalEvidence/WvModel', {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.postMedicalEvidence = function (data) {
                return _super.prototype.post.call(this, this.modulePath + '/MedicalEvidence', data).then(function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.putMedicalEvidence = function (parentObjectId, id, data) {
                return _super.prototype.put.call(this, this.modulePath + '/MedicalEvidence/' + parentObjectId + '/' + id, data).then(function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.deleteMedicalEvidence = function (parentObjectId, id) {
                return _super.prototype.delete.call(this, this.modulePath + '/MedicalEvidence/' + parentObjectId + '/' + id).then(function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.getMedicalEvidenceExecutioners = function () {
                return _super.prototype.get.call(this, "/Person/PeopleSelectionAssignment/MedNachweisDurchfuehrender", {}, function (data) {
                    return data;
                });
            };
            /***** MedicationResponsible / Medication Issued Through ****/
            StammdatenService.prototype.getMedicationResponsibleMedicatioThroughList = function (parentObjectId, assignmentType) {
                return _super.prototype.get.call(this, this.modulePath + '/MedicalResponsible/' + parentObjectId + '/' + assignmentType, {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.getMedResponsibleIssuedThroughItem = function (parentObjectId, id) {
                return _super.prototype.getItem.call(this, this.modulePath + '/MedicalResponsible/' + parentObjectId + '/' + id, {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.postMedResponsibleIssuedThroughItem = function (data) {
                return _super.prototype.post.call(this, this.modulePath + '/MedicalResponsible', data).then(function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.putMedResponsibleIssuedThroughItem = function (parentObjectId, id, data) {
                return _super.prototype.put.call(this, this.modulePath + '/MedicalResponsible/' + parentObjectId + '/' + id, data).then(function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.deleteMedResponsibleIssuedThroughItem = function (parentObjectId, assignmentType, id) {
                return _super.prototype.delete.call(this, this.modulePath + '/MedicalResponsible/' + parentObjectId + '/' + assignmentType + '/' + id).then(function (data) {
                    return data;
                });
            };
            /***** TempInstituteChange ****/
            StammdatenService.prototype.getTempInstituteChangeList = function (parentObjectId) {
                return _super.prototype.get.call(this, this.modulePath + '/TempInstituteChange/' + parentObjectId, {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.getTempInstituteChange = function (parentObjectId, id) {
                return _super.prototype.getItem.call(this, this.modulePath + '/TempInstituteChange/' + parentObjectId + '/' + id, {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.getTempInstituteChangeWvList = function () {
                return _super.prototype.getItem.call(this, this.modulePath + '/TempInstituteChange/WvModel', {}, function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.postTempInstituteChange = function (data) {
                return _super.prototype.post.call(this, this.modulePath + '/TempInstituteChange', data).then(function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.putTempInstituteChange = function (parentObjectId, id, data) {
                return _super.prototype.put.call(this, this.modulePath + '/TempInstituteChange/' + parentObjectId + '/' + id, data).then(function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.deleteTempInstituteChange = function (parentObjectId, id) {
                return _super.prototype.delete.call(this, this.modulePath + '/TempInstituteChange/' + parentObjectId + '/' + id).then(function (data) {
                    return data;
                });
            };
            /***** Organisation *****/
            StammdatenService.prototype.getOrganisationList = function () {
                return _super.prototype.get.call(this, '/Person/Organisation').then(function (data) {
                    return data;
                });
            };
            StammdatenService.prototype.getOrganisationForPerson = function (personId) {
                return _super.prototype.getItem.call(this, '/Person/Organisation/' + personId, {}, function (data) {
                    return data;
                });
            };
            /***** ReweCommon *****/
            StammdatenService.prototype.getReweNumber = function (objectType, referenceId) {
                return _super.prototype.get.call(this, '/ReweCommon/ReweNumber', { objectType: objectType, referenceId: referenceId }, function (data) {
                    return data;
                });
            };
            StammdatenService = __decorate([
                QMC.Service('QMC.Stammdaten', 'StammdatenService'),
                QMC.Inject('$http', '$q')
            ], StammdatenService);
            return StammdatenService;
        }(QMC.Common.BaseService));
        Stammdaten.StammdatenService = StammdatenService;
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        var StammdatenClientListController = /** @class */ (function () {
            /**
             * Creates an instance of StammdatenClientListController.
             * @param {StammdatenService} stammdatenService
             * @param {any} $qui
             * @param {Klient.KlientService} clientService
             * @param {any} $stateParams
             * @param {any} $scope
             * @param {any} $state
             *
             * @memberOf StammdatenClientListController
             */
            function StammdatenClientListController($location, stammdatenService, $qui, clientService, $stateParams, $scope, $state, userService, permissionService) {
                var _this = this;
                this.$location = $location;
                this.stammdatenService = stammdatenService;
                this.$qui = $qui;
                this.clientService = clientService;
                this.$state = $state;
                this.userService = userService;
                this.permissionService = permissionService;
                this.ui = new QMC.Stammdaten.UserInterface();
                this.allowTableExport = false;
                this.page = 0;
                this.filter = {
                    searchText: "",
                    searchId: QMC.Common.Constants.DEFAULT_CLIENT_PREDEFINED_SEARCH_ID,
                    showActiveOnly: false
                };
                this.clientListSchema = {
                    "config": {
                        "tableRowLink": "#/stammdaten/detail/{{id}}/cover/{{id}}",
                    },
                    "table": {
                        "Bild": {
                            "label": "id",
                            "dType": "Avatar",
                            "name": "name",
                            "href": "#/stammdaten/detail/{{id}}/cover/{{id}}",
                            "forename": "forename"
                        },
                        "Name": {
                            "label": "name",
                            "dType": "string",
                            "lngTag": "20000072"
                        },
                        "Vorname": {
                            "label": "forename",
                            "dType": "string",
                            "lngTag": "20000057"
                        },
                        "Kürzel": {
                            "label": "shortCaption",
                            "dType": "string",
                            "lngTag": "20000221"
                        },
                        "Nummer": {
                            "label": "clientNumber",
                            "dType": "string",
                            "lngTag": "20000316"
                        },
                        "Stammhaus": {
                            "label": "actualInstitution",
                            "dType": "string",
                            "lngTag": "20000031"
                        },
                        "Geburtsdatum": {
                            "label": "birthday",
                            "dType": "Date",
                            "lngTag": "21002004"
                        },
                    },
                    "card": {
                        "avatar": {
                            "name": "name",
                            "forename": "forename",
                            "label": "id",
                            "href": "#/stammdaten/detail/{{id}}/cover/{{id}}",
                        },
                        "text": {
                            "label": ["name", "forename"],
                            "dType": "string"
                        },
                        "subtext": [
                            {
                                "label": "shortCaption",
                                "dType": "string"
                            },
                            {
                                "label": "clientNumber",
                                "dType": "string"
                            },
                            {
                                "label": "actualInstitution",
                                "dType": "string"
                            },
                            {
                                "label": "birthday",
                                "dType": "Date",
                            }
                        ],
                        "buttons": []
                    },
                    "data": []
                };
                $qui.init($qui.getSectionColor($location.path()), function () {
                    $qui.anonAvatar();
                    $('.qm-card').unbind('click');
                    _this.events();
                });
                if (document.getElementById("permissions").getAttribute("client").toLocaleLowerCase() !== "true") {
                    console.log("No rights to see module client");
                    this.forbidden = true;
                    return;
                }
                permissionService.getPermissionsByObjectTypes([140000]).then(function (data) {
                    _this.allowTableExport = data[0].print;
                });
                $scope.Model = $scope.Model || { Name: 'xxx' };
                this.fullClientList = [];
                this.cards = QMC.Common.Constants.IS_MOBILE;
                this.mobile = QMC.Common.Constants.IS_MOBILE;
                this.getFilterFromStorage();
                if ($('#session').data('data-stammdaten-grid') === ('false' || false))
                    this.cards = true;
                this.$qui.getTableAutoload(this.userService).then(function (ltd) {
                    _this.shouldLoadTableData = ltd;
                    if (_this.shouldLoadTableData) {
                        _this.getClients(_this.filter.searchId, _this.page);
                    }
                });
                var isFirstLoad = true;
                $scope.$watch('vm.filter.searchId', function (newValue, oldValue) {
                    if (newValue != oldValue) {
                        if (isFirstLoad) {
                            setTimeout(function () {
                                isFirstLoad = false;
                            }, 5);
                        }
                        else if (_this.shouldLoadTableData) {
                            _this.page = 0;
                            _this.getData();
                        }
                    }
                });
                $scope.$watch('vm.filter.showActiveOnly', function (newValue, oldValue) {
                    if (newValue != oldValue && _this.shouldLoadTableData) {
                        _this.toggleShowActiveOnly();
                    }
                });
                $scope.$watch('vm.filter.searchText', function (newValue, oldValue) {
                    if (newValue != oldValue) {
                        if (isFirstLoad) {
                            setTimeout(function () {
                                isFirstLoad = false;
                            }, 5);
                        }
                        else if (_this.shouldLoadTableData) {
                            var lastValue_1 = _this.filter.searchText;
                            setTimeout(function () {
                                if (_this.filter.searchText === lastValue_1 && (newValue.length < oldValue.length || _this.filter.searchText.length >= 3)) {
                                    _this.page = 0;
                                    _this.getData();
                                }
                            }, 1500);
                        }
                    }
                });
                $scope.$watch('vm.page', function (newValue, oldValue) {
                    if (newValue != oldValue)
                        if (isFirstLoad) {
                            setTimeout(function () {
                                isFirstLoad = false;
                            }, 5);
                        }
                        else {
                            _this.getData();
                        }
                });
                // Get data
                this.getSearchValues();
            }
            /**
             * register view events
             *
             * @private
             *
             * @memberOf StammdatenClientListController
             */
            StammdatenClientListController.prototype.events = function () {
            };
            StammdatenClientListController.prototype.getClients = function (searchId, page) {
                var _this = this;
                if (searchId === (undefined || null))
                    searchId = QMC.Common.Constants.DEFAULT_CLIENT_PREDEFINED_SEARCH_ID;
                this.page = page;
                this.loading = true;
                this.clientListSchema.data = [];
                this.setFilterToStorage();
                this.clientService.getClientListByPredefinedSearch(searchId, page, 30, this.filter.searchText, this.filter.showActiveOnly, ['name', 'forename', 'shortCaption', 'clientNumber', 'actualInstitution', 'birthday']).then(function (data) {
                    _this.clientListSchema.data = data.items;
                    _this.pagination = data.paginationInfo;
                    $('.qm-card').unbind('click');
                    _this.loading = false;
                    _this.$qui.functionWaiter("createTable", _this);
                });
            };
            /**
             * search clients by a search value
             *
             * @private
             *
             * @memberOf StammdatenClientListController
             */
            StammdatenClientListController.prototype.getSearchValues = function () {
                var _this = this;
                this.loading = true;
                this.clientService.getPredefinedSearches().then(function (data) {
                    _this.searchValues = data;
                    _this.searchValuesMap = _this.$qui.selectAutoMap(data, 'id', 'caption');
                    _this.loading = false;
                });
            };
            StammdatenClientListController.prototype.toggleShowActiveOnly = function () {
                this.setFilterToStorage();
                if (this.shouldLoadTableData)
                    this.getClients(this.filter.searchId, this.page);
            };
            /**
             * get a filtered list of clients
             *
             * @private
             *
             * @memberOf StammdatenClientListController
             */
            StammdatenClientListController.prototype.getData = function () {
                this.getClients(this.filter.searchId, this.page);
            };
            StammdatenClientListController.prototype.setFilterToStorage = function () {
                localStorage.setItem('client-list-settings', JSON.stringify(this.filter));
            };
            StammdatenClientListController.prototype.getFilterFromStorage = function () {
                var store = localStorage.getItem('client-list-settings');
                if (store == (null || undefined))
                    return;
                this.filter = JSON.parse(store);
            };
            /**
             * toggle the between card and table view
             *
             * @private
             *
             * @memberOf StammdatenClientListController
             */
            StammdatenClientListController.prototype.changeTableView = function () {
                this.cards = !this.cards;
                $('#session').data('data-stammdaten-grid', this.cards.toString());
            };
            StammdatenClientListController = __decorate([
                QMC.Controller('QMC.Stammdaten', 'StammdatenClientListController'),
                QMC.Inject('$location', 'StammdatenService', '$qui', 'KlientService', '$stateParams', '$scope', '$state', 'UserService', 'QmcPermissionService')
            ], StammdatenClientListController);
            return StammdatenClientListController;
        }());
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        var StammdatenClientDetailController = /** @class */ (function () {
            /**
             * Creates an instance of StammdatenClientDetailController.
             * @param {StammdatenService} stammdatenService
             * @param {any} $qui
             * @param {Klient.KlientService} clientService
             * @param {any} $stateParams
             * @param {any} $scope
             * @param {any} $location
             * @param {Common.QmcLanguageService} lng
             * @param {Common.QmcPermissionService} permissionService
             *
             * @memberOf StammdatenClientDetailController
             */
            function StammdatenClientDetailController(stammdatenService, $qui, clientService, $stateParams, $scope, $location, lng, permissionService, udfService) {
                var _this = this;
                this.stammdatenService = stammdatenService;
                this.$qui = $qui;
                this.clientService = clientService;
                this.$scope = $scope;
                this.$location = $location;
                this.lng = lng;
                this.permissionService = permissionService;
                this.ui = new Stammdaten.DetailUI();
                this.createForm = null;
                this.menuItems = [];
                this.loading = true;
                this.formState = 'new';
                this.udf = [];
                $qui.init($qui.getSectionColor("/stammdaten"), function () {
                    $qui.bindEvents();
                    _this.events();
                    $('.qm-card').unbind('click');
                });
                if (document.getElementById("permissions").getAttribute("client").toLocaleLowerCase() !== "true") {
                    console.log("No rights to see module client");
                    this.forbidden = true;
                    return;
                }
                this.$scope.Model = this.$scope.Model || { Name: 'xxx' };
                this.id = $stateParams.client;
                this.section = $location.$$path.split('/')[4];
                permissionService.getPermissionsByObjectTypes([140000, 140002, 140003, 140005, 140006, 140008, 140021, 140023, 140027, 140032, 140033, 140054, 140057, 140068, 140086, 143000, 820003]).then(function (data) {
                    _this.permissionService.getPermissionsForDataset(_this.id, null).then(function (dData) {
                        _this.permissions = data;
                        _this.permissions[0] = dData[0];
                        _this.permissions[0].objectType = 140000;
                        _this.permissions = data;
                        if (!window.license || window.license === 'loading')
                            permissionService.getLicense().then(function (license) {
                                window.license = license !== null && license !== void 0 ? license : []; //since we already got it, might as well set it in windowstore. might reduce waittime later
                                _this.createMenuByPermissions();
                            });
                        else {
                            _this.createMenuByPermissions();
                        }
                    });
                });
                udfService.getUserDefinedFields(140000).then(function (data) {
                    _this.udf = data;
                    _this.addUdfMenu();
                });
                this.getClientWv().then(function () {
                    _this.getClientData(_this.id);
                    _this.getClientAvatar(_this.id);
                });
                $qui.init($qui.getSectionColor("/stammdaten"), function () {
                    $qui.bindEvents();
                    _this.events();
                    $('.qm-card').unbind('click');
                });
            }
            /////////////// DISPLAY LOGIC ///////////////
            /**
             * register view events
             *
             * @private
             *
             * @memberOf StammdatenClientDetailController
             */
            StammdatenClientDetailController.prototype.events = function () {
                var _this = this;
                this.$scope.$watch('vm.mobileSelect', function () {
                    if (_this.mobileSelect !== (null || undefined)) {
                        _this.changeSection(_this.mobileSelect);
                    }
                });
                this.$scope.$on('$locationChangeStart', function (_event, next) {
                    var activeItem = _this.menuItems.filter(function (x) { return next.includes("stammdaten/detail/" + _this.id + "/" + x.section + "/" + _this.id); })[0];
                    if (activeItem)
                        _this.section = activeItem.section;
                });
            };
            /**
             * init form
             *
             * @private
             *
             * @memberOf StammdatenClientDetailController
             */
            StammdatenClientDetailController.prototype.initForm = function () {
                this.form = {
                    id: null,
                    objectId: null,
                    name: "",
                    forename: "",
                    birthday: new Date(),
                    birthplace: "",
                    birthname: "",
                    salutationId: null,
                    titleId: null,
                    secondTitleId: null,
                    genderId: null,
                    shortCaption: '',
                    clientNumber: ''
                };
            };
            /**
             * create the stammdaten menue by given permissions
             *
             * @private
             *
             * @memberOf StammdatenClientDetailController
             */
            StammdatenClientDetailController.prototype.createMenuByPermissions = function () {
                this.menuItems = [];
                // Address
                if ($.grep(this.permissions, function (item) { return item.objectType === 140021; })[0].moduleAccess) {
                    this.menuItems.push({ caption: this.lng.translate(20001511, "Adressen"), section: "address", icon: "qm-icon-location_pin" });
                }
                // Communication
                if ($.grep(this.permissions, function (item) { return item.objectType === 140023; })[0].moduleAccess) {
                    this.menuItems.push({ caption: this.lng.translate(20001047, "Kommunikation"), section: "communication", icon: "qm-icon-book_telephone" });
                }
                // Contact Person
                if ($.grep(this.permissions, function (item) { return item.objectType === 140006; })[0].moduleAccess) {
                    this.menuItems.push({ caption: this.lng.translate(20004000, "Kontaktpersonen"), section: "contactperson", icon: "qm-icon-users" });
                }
                // Doctors Visit
                if ($.grep(this.permissions, function (item) { return item.objectType === 140003; })[0].moduleAccess) {
                    this.menuItems.push({ caption: this.lng.translate(20010000, "Arztbesuche"), section: "doctorsvisit", icon: "qm-icon-doctor" });
                }
                // Vaccination
                if ($.grep(this.permissions, function (item) { return item.objectType === 140005; })[0].moduleAccess) {
                    this.menuItems.push({ caption: this.lng.translate(20009000, "Impfungen"), section: "vaccination", icon: "qm-icon-injection" });
                }
                // Education
                if ($.grep(this.permissions, function (item) { return item.objectType === 140068; })[0].moduleAccess) {
                    this.menuItems.push({ caption: this.lng.translate(20012032, "Lebenslauf / Ausbildungen"), section: "education", icon: "qm-icon-graduation_hat2" });
                }
                // Disease
                if ($.grep(this.permissions, function (item) { return item.objectType === 140002; })[0].moduleAccess) {
                    this.menuItems.push({ caption: this.lng.translate(20007504, "Krankheiten"), section: "disease", icon: "qm-icon-virus" });
                }
                // Note
                if ($.grep(this.permissions, function (item) { return item.objectType === 140000; })[0].moduleAccess) {
                    this.menuItems.push({ caption: this.lng.translate(21007000, "Notizen"), section: "note", icon: "qm-icon-note" });
                }
                // Hobby
                if ($.grep(this.permissions, function (item) { return item.objectType === 140054; })[0].moduleAccess) {
                    this.menuItems.push({ caption: this.lng.translate(20008004, "Hobby"), section: "hobby", icon: "qm-icon-soccer_ball" });
                }
                // Checklist
                if ($.grep(this.permissions, function (item) { return item.objectType === 140057; })[0].moduleAccess) {
                    this.menuItems.push({ caption: this.lng.translate(20011505, "Checklisten"), section: "checklist", icon: "qm-icon-check" });
                }
                // Document
                if ($.grep(this.permissions, function (item) { return item.objectType === 140032; })[0].moduleAccess) {
                    this.menuItems.push({ caption: this.lng.translate(21006000, "Dokumente"), section: "documents", icon: "qm-icon-document_attachment" });
                }
                // Absenteeism
                if ($.grep(this.permissions, function (item) { return item.objectType === 140033; })[0].moduleAccess) {
                    this.menuItems.push({ caption: this.lng.translate(21008000, "Abwesenheiten"), section: "absenteeism", icon: "qm-icon-calendar_7" });
                }
                // AccountingBook
                if ($.grep(this.permissions, function (item) { return item.objectType === 140008; })[0].moduleAccess && window.license.some(function (x) { return x.license === 'KASSENBUCH' && x.granted; })) {
                    this.menuItems.push({ caption: this.lng.translate(20001044, "Kassenbuch"), section: "accountingBook", icon: "qm-icon-cashier" });
                }
                // Legal
                if ($.grep(this.permissions, function (item) { return item.objectType === 140027; })[0].moduleAccess) {
                    this.menuItems.push({ caption: this.lng.translate(20022000, "Rechtliches"), section: "legal", icon: "qm-icon-codes_of_law" });
                }
                // TempInstituteChange
                if ($.grep(this.permissions, function (item) { return item.objectType === 820003; })[0].moduleAccess) {
                    this.menuItems.push({ caption: this.lng.translate(20032000, "Temp. Organisationswechsel"), section: "tempInstituteChange", icon: "qm-icon-arrow_circle2" });
                }
                // ClientInfo
                if ($.grep(this.permissions, function (item) { return item.objectType === 143000; })[0].moduleAccess) {
                    this.menuItems.push({ caption: this.lng.translate(20001063, "KlientInformation"), section: "clientInformation", icon: "qm-icon-print_layout_single" });
                }
                this.addUdfMenu();
                this.menuItems = this.menuItems.sort(function (a, b) { return a.caption > b.caption ? 1 : a.caption < b.caption ? -1 : 0; });
                this.menuItems.unshift({ caption: this.lng.translate(21002031, "Deckblatt"), section: "cover", icon: "qm-icon-form" });
                // Erweiterte Stammdaten
                if ($.grep(this.permissions, function (item) { return item.objectType === 140086; })[0].moduleAccess) {
                    this.menuItems.splice(1, 0, { caption: this.lng.translate(21002048, "Erweiterte Stammdaten"), section: "extendedMainData", icon: "qm-icon-id_cards" });
                }
            };
            StammdatenClientDetailController.prototype.addUdfMenu = function () {
                var _this = this;
                this.udf.sort(function (a, b) { return a.caption > b.caption ? 1 : a.caption < b.caption ? -1 : 0; }).forEach(function (udf) {
                    _this.menuItems.push({
                        caption: udf.caption,
                        section: "udf/" + udf.type + "/" + udf.definitionId + "/" + udf.objectType,
                        icon: "qm-icon-window_explorer"
                    });
                });
            };
            /**
             * change the section given by the view
             *
             * @private
             * @param {string} section
             *
             * @memberOf StammdatenClientDetailController
             */
            StammdatenClientDetailController.prototype.changeSection = function (section) {
                this.section = section;
                console.log("SECTION", section);
                this.$location.search('');
                this.$location.path("stammdaten/detail/" + this.id + "/" + section + "/" + this.id);
                $('#mobile-data').css('display', 'none'); // Hide mobile menu after selecting a section
                this.toggleInfoBox(false);
            };
            StammdatenClientDetailController.prototype.toggleInfoBox = function (state) {
                if (state === void 0) { state = !this.showinfoBox; }
                var header = window.getComputedStyle(document.getElementById('largerClientDetailHeader'));
                if (header.display === 'none')
                    return; // if we got no option to show details again, never hide them
                var element = document.getElementById('infoContent');
                this.showinfoBox = state;
                if (this.showinfoBox)
                    element.style.display = 'unset';
                else
                    element.style.display = 'none';
            };
            /////////////// SERVICE FUNCTIONS ///////////////
            /**
             * get the client avatar by id
             *
             * @private
             * @param {Guid} id
             *
             * @memberOf StammdatenClientDetailController
             */
            StammdatenClientDetailController.prototype.getClientAvatar = function (id) {
                var _this = this;
                this.stammdatenService.getClientImage(id, true).then(function (data) {
                    if (data.imageData.length > 1) {
                        _this.clientAvatar = data.imageData;
                    }
                }).catch(function (data) {
                    console.error(data);
                });
            };
            /**
             * get the client data by id
             *
             * @private
             * @param {Guid} id
             *
             * @memberOf StammdatenClientDetailController
             */
            StammdatenClientDetailController.prototype.getClientData = function (id) {
                var _this = this;
                console.time('answer time');
                return this.clientService.getClient(id).then(function (data) {
                    _this.$qui.functionWaiter("createForm", _this);
                    _this.form = angular.copy(data);
                    console.log('this.form', _this.form);
                    _this.client = data;
                    var birthday = moment(data.birthday);
                    var prehistoric = moment('1900-01-01').endOf('day');
                    _this.client.birthday = birthday <= prehistoric ? null : _this.form.birthday;
                    _this.clientAge = birthday <= prehistoric ? '?' : moment().diff(birthday, 'years');
                    _this.clientDaysToBirthday = moment(data.birthday).add(_this.clientAge, 'years').fromNow();
                    if (_this.clientDaysToBirthday.includes('ago')) {
                        _this.clientAge = Number(_this.clientAge);
                    }
                    setTimeout(function () {
                        console.timeEnd('answer time');
                        _this.$qui.anonAvatar();
                    }, 500);
                });
            };
            /**
             * edit the client
             *
             * @private
             * @param {Guid} id
             *
             * @memberOf StammdatenClientDetailController
            */
            StammdatenClientDetailController.prototype.editClient = function () {
                this.formState = "edit";
                $('#edit-client').modal('toggle');
                this.loading = false;
            };
            /**
             * get the client wv list
             *
             * @private
             * @param {Guid} id
             *
             * @memberOf StammdatenClientDetailController
            */
            StammdatenClientDetailController.prototype.getClientWv = function () {
                var _this = this;
                return this.clientService.getClientWv().then(function (data) {
                    console.log("wv list", data);
                    _this.wv = data;
                });
            };
            /**
             * get the client title list
             *
             * @private
             * @param {Guid} id
             *
             * @memberOf StammdatenClientDetailController
            */
            StammdatenClientDetailController.prototype.getTitleList = function () {
                return this.wv.titleWvList.map(function (obj) {
                    return {
                        value: obj.objectId,
                        text: obj.name,
                        isFix: obj.isFix
                    };
                });
            };
            StammdatenClientDetailController.prototype.getSecondTitleList = function () {
                return this.wv.secondTitleWvList.map(function (obj) {
                    return {
                        value: obj.objectId,
                        text: obj.name,
                        isFix: obj.isFix
                    };
                });
            };
            /**
             * get the client salutation list
             *
             * @private
             * @param {Guid} id
             *
             * @memberOf StammdatenClientDetailController
            */
            StammdatenClientDetailController.prototype.getSalutationList = function () {
                return this.wv.salutationWvList.map(function (obj) {
                    return {
                        value: obj.objectId,
                        text: obj.name,
                        isFix: obj.isFix
                    };
                });
            };
            /**
             * get the client gender list
             *
             * @private
             * @param {Guid} id
             *
             * @memberOf StammdatenClientDetailController
            */
            StammdatenClientDetailController.prototype.getGenderList = function () {
                return this.wv.genderWvList.map(function (obj) {
                    return {
                        value: obj.objectId,
                        text: obj.name,
                        isFix: obj.isFix
                    };
                });
            };
            /**
             * get the client wv list
             *
             * @private
             * @param {Guid} id
             *
             * @memberOf StammdatenClientDetailController
            */
            StammdatenClientDetailController.prototype.updateClient = function (data) {
                var _this = this;
                this.clientService.putClient(this.id, this.form).then(function (data) {
                    _this.$qui.notify(_this.$qui.successNote);
                    _this.getClientData(_this.id);
                });
            };
            /**
             * get the last admission date for client
             *
             * @private
             *
             * @memberOf StammdatenClientDetailController
            */
            StammdatenClientDetailController.prototype.getLastAdmissionDate = function () {
                if (this.client === (null || undefined) || this.client.admissions.length < 1) {
                    return;
                }
                return this.client.admissions[this.client.admissions.length - 1].date;
            };
            /**
             * get the first admission date for client
             *
             * @private
             *
             * @memberOf StammdatenClientDetailController
            */
            StammdatenClientDetailController.prototype.getFirstAdmissionDate = function () {
                if (this.client === (null || undefined) || this.client.admissions.length < 1) {
                    return;
                }
                return this.client.admissions[0].date;
            };
            /**
             * get the last dismissal date for client
             *
             * @private
             *
             * @memberOf StammdatenClientDetailController
            */
            StammdatenClientDetailController.prototype.getLastDismissalDate = function () {
                if (this.client === (null || undefined) || this.client.dismissals.length < 1) {
                    return;
                }
                return this.client.dismissals[this.client.dismissals.length - 1].date;
            };
            StammdatenClientDetailController = __decorate([
                QMC.Controller('QMC.Stammdaten', 'StammdatenClientDetailController'),
                QMC.Inject('StammdatenService', '$qui', 'KlientService', '$stateParams', '$scope', '$location', 'QmcLanguageService', 'QmcPermissionService', 'QmcUdfService')
            ], StammdatenClientDetailController);
            return StammdatenClientDetailController;
        }());
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        var GlobalDocumentsListController = /** @class */ (function () {
            /**
             * Creates an instance of GlobalDocumentsListController.
             * @param {StammdatenService} stammdatenService
             * @param {any} $qui
             * @param {Klient.KlientService} clientService
             * @param {any} $stateParams
             * @param {any} $scope
             * @param {any} $state
             * @param {Common.QmcLanguageService} lng
             * @param {Common.QmcPermissionService} permissionService
             *
             * @memberOf GlobalDocumentsListController
             */
            function GlobalDocumentsListController($location, stammdatenService, $qui, clientService, $stateParams, $scope, $state, lng, permissionService, userService) {
                var _this = this;
                var _a, _b;
                this.$location = $location;
                this.stammdatenService = stammdatenService;
                this.$qui = $qui;
                this.clientService = clientService;
                this.$scope = $scope;
                this.$state = $state;
                this.lng = lng;
                this.permissionService = permissionService;
                this.userService = userService;
                this.ui = new Stammdaten.UserInterface();
                this.allowTableExport = false;
                this.files = [];
                this.showPrivateCheckbox = true;
                this.showOnlyGlobalFiles = false;
                this.showMonthFilter = false;
                this.isFirstLoad = true;
                this.subCategoryList = [];
                this.dontAllowDownload = true;
                this.filterCacheName = "GlobalDocumentFilterCache";
                this.page = 0;
                this.pageWatcher = [];
                $qui.init($qui.getSectionColor($location.path()), function () {
                    $qui.bindEvents();
                    $('.qm-card').unbind('click');
                });
                if (document.getElementById("permissions").getAttribute("globalDocuments").toLocaleLowerCase() !== "true") {
                    console.log("No rights to see module global documents");
                    this.forbidden = true;
                    return;
                }
                if (!this.tableFilter) {
                    this.tableFilter = '';
                }
                ;
                this.references = [{ text: "- " + this.lng.translate(20000162, 'Alle') + " -", value: 0 }];
                this.stammdatenService.getGlobalDocumentReferences().then(function (data) {
                    data.sort(function (a, b) { return (a.caption > b.caption) ? 1 : -1; });
                    _this.references = _this.references.concat(data.map(function (x) { return ({ value: x.objectType, text: x.caption }); }));
                });
                permissionService.getPermissionsByObjectTypes([905001, 920002, 905000]).then(function (data) {
                    _this.delete = data[0].delete && data[0].moduleAccess;
                    _this.new = data[0].new && data[0].moduleAccess;
                    _this.modify = data[0].modify && data[0].moduleAccess;
                    if (!_this.new) {
                        _this.$qui.waitForEl('#newModalButton', function () {
                            document.getElementsByName('newModalButton').forEach(function (x) { return x.style.visibility = 'hidden'; });
                        });
                    }
                    _this.dontAllowDownload = !data[1].openFile;
                    _this.allowTableExport = data[2].print;
                    var isFirstLoad = true;
                    _this.$qui.getTableAutoload(_this.userService).then(function (ltd) {
                        _this.shouldLoadTableData = ltd;
                        if (_this.shouldLoadTableData) {
                            _this.getDocumentList();
                        }
                    });
                    _this.userService.getGlobalSettings(["MEDIEN.DOKUMENT.ALLOWPRIVATEDOCUMENTS"], false).then(function (dataSettings) {
                        _this.showPrivateCheckbox = dataSettings[0].value.toLowerCase() === 'true';
                    });
                    _this.getWv();
                    _this.init();
                });
                this.promptOptions = {
                    title: this.lng.translate(20001062, 'Dokumentverwaltung'),
                    yesNo: true,
                    icon: "qm-icon-document_attachment",
                    text: this.lng.translate(20000290, 'Wollen Sie den Eintrag wirklich löschen?')
                };
                var cache = localStorage.getItem(this.filterCacheName);
                if (cache) {
                    var jsonCache = JSON.parse(cache);
                    this.filter = {
                        dateFrom: this.$qui.createDateFromString((_a = jsonCache.dateFrom) !== null && _a !== void 0 ? _a : moment().startOf('month').toDate()),
                        dateTo: this.$qui.createDateFromString((_b = jsonCache.dateTo) !== null && _b !== void 0 ? _b : moment().endOf('month').toDate()),
                        parentObjectType: jsonCache.parentObjectType
                    };
                    this.showOnlyGlobalFiles = jsonCache.onlyGlobalFiles;
                }
                else {
                    this.filter = {
                        dateFrom: moment().startOf('month').toDate(),
                        dateTo: moment().endOf('month').toDate(),
                        parentObjectType: 0,
                        onlyGlobalFiles: false
                    };
                }
                this.events();
            }
            /////////////// DISPLAY LOGIC ///////////////
            GlobalDocumentsListController.prototype.init = function () {
                this.initForm();
            };
            GlobalDocumentsListController.prototype.initForm = function () {
                this.form = {
                    title: '',
                    subtitle: '',
                    comment: '',
                    documentTypeId: QMC.Common.Constants.GUID_EMPTY,
                    mainCategoryId: QMC.Common.Constants.GUID_EMPTY,
                    subCategoryId: QMC.Common.Constants.GUID_EMPTY,
                    fileName: '',
                    base64String: '',
                    isPrivate: false
                };
                var fileSelector = angular.element('#fileselect');
                if (fileSelector[0] && fileSelector[0].files.length > 0) {
                    $("#fileselect").val('');
                }
                ;
                this.showError = "";
                this.files = [];
                this.listLoad = false;
                this.$qui.scopeApply(this.$scope);
            };
            /**
            * Register view events
            *
            * @private
            *
            * @memberOf FlsDocumentationListController
            */
            GlobalDocumentsListController.prototype.events = function () {
                var _this = this;
                this.$scope.$watch('vm.tableFilter', function (newValue, oldValue) {
                    var _this = this;
                    if (newValue !== oldValue) {
                        if (this.isFirstLoad) {
                            setTimeout(function () {
                                _this.isFirstLoad = false;
                            }, 5);
                        }
                        else {
                            var lastValue_2 = this.tableFilter;
                            setTimeout(function () {
                                if (_this.tableFilter === lastValue_2) {
                                    _this.page = 0;
                                    _this.getData();
                                }
                            }, 500);
                        }
                        this.cacheFilter();
                    }
                }.bind(this, this));
                this.$scope.$watch('vm.filter.dateFrom', function (newValue, oldValue) {
                    var _this = this;
                    if (newValue !== oldValue) {
                        if (this.isFirstLoad) {
                            setTimeout(function () {
                                _this.isFirstLoad = false;
                            }, 5);
                        }
                        else {
                            var lastValue_3 = this.tableFilter;
                            setTimeout(function () {
                                if (_this.tableFilter === lastValue_3) {
                                    _this.page = 0;
                                    _this.getData();
                                }
                            }, 500);
                        }
                        this.cacheFilter();
                    }
                }.bind(this, this));
                this.$scope.$watch('vm.filter.dateTo', function (newValue, oldValue) {
                    var _this = this;
                    if (newValue !== oldValue) {
                        if (this.isFirstLoad) {
                            setTimeout(function () {
                                _this.isFirstLoad = false;
                            }, 5);
                        }
                        else {
                            var lastValue_4 = this.tableFilter;
                            setTimeout(function () {
                                if (_this.tableFilter === lastValue_4) {
                                    _this.page = 0;
                                    _this.getData();
                                }
                            }, 500);
                        }
                        this.cacheFilter();
                    }
                }.bind(this, this));
                this.$scope.$watch('vm.filter.parentObjectType', function (newValue, oldValue) {
                    var _this = this;
                    if (newValue !== oldValue) {
                        if (this.isFirstLoad) {
                            setTimeout(function () {
                                _this.isFirstLoad = false;
                            }, 5);
                        }
                        else {
                            var lastValue_5 = this.tableFilter;
                            setTimeout(function () {
                                if (_this.tableFilter === lastValue_5) {
                                    _this.page = 0;
                                    _this.getData();
                                }
                            }, 500);
                        }
                        this.cacheFilter();
                    }
                }.bind(this, this));
                this.$scope.$watchCollection('vm.showOnlyGlobalFiles', function (newValue, oldValue) {
                    if (newValue === oldValue)
                        return;
                    _this.getData();
                    _this.cacheFilter();
                });
                this.$scope.$watchCollection('vm.tableFilter', function (newValue, oldValue) {
                    if (newValue === oldValue)
                        return;
                    _this.getData();
                    _this.cacheFilter();
                });
                this.$scope.$watch('vm.form.mainCategoryId', function () {
                    if (_this.wv !== null && _this.wv !== undefined)
                        _this.getSubCategoryList();
                });
                this.$scope.$watch('vm.parentObjectType', function (newVal, oldVal) {
                    if (newVal !== oldVal) {
                        _this.cacheFilter();
                        _this.getData();
                    }
                });
            };
            GlobalDocumentsListController.prototype.setPage = function (page) {
                this.page = page;
            };
            GlobalDocumentsListController.prototype.getData = function () {
                this.clearPageWatcher();
                this.getDocumentList();
                this.page = 0;
            };
            GlobalDocumentsListController.prototype.open = function (item) {
                var _this = this;
                $('#loadingScreen').modal('show');
                this.fileInfos = {
                    base64: '',
                    fileType: '',
                    fileName: ''
                };
                this.stammdatenService.getGlobalDocumentFile(item.objectId).then(function (data) {
                    $('#loadingScreen').modal('hide');
                    try {
                        var filename = item.fileName;
                        // get filename suffix and contenttype
                        var temp = filename.split('.');
                        var ext = temp[temp.length - 1];
                        _this.fileInfos = {
                            base64: data,
                            fileType: ext,
                            fileName: filename
                        };
                        $('#previewModal').modal('show');
                    }
                    catch (e) {
                        console.log("downloadDocument Fehler: ", e);
                    }
                });
            };
            GlobalDocumentsListController.prototype.download = function (item) {
                var _this = this;
                $('#loadingScreen').modal('show');
                // get filename suffix and contenttype
                var temp = item.fileName.split('.');
                var ext = temp.length > 0 ? temp[temp.length - 1] : '';
                this.stammdatenService.getGlobalDocumentFile(item.objectId).then(function (data) {
                    $('#loadingScreen').modal('hide');
                    var blob = _this.$qui.base64ToBlob(data, _this.$qui.extToMime(ext));
                    _this.$qui.downloadBlob(item.fileName, blob);
                });
            };
            GlobalDocumentsListController.prototype.getSubCategoryList = function () {
                var data = [];
                this.form.subCategoryId = null;
                for (var i = 0; i < this.wv.subCategoryWvList.length; i++) {
                    if ((this.wv.subCategoryWvList[i].parentWvId === this.form.mainCategoryId) && !(/^\s*$/).test(this.wv.subCategoryWvList[i].name)) {
                        data.push(this.wv.subCategoryWvList[i]);
                    }
                }
                this.subCategoryList = this.$qui.select(data, { value: 'objectId', text: 'name' });
            };
            GlobalDocumentsListController.prototype.cacheFilter = function () {
                var cacheObject = {
                    dateFrom: this.filter.dateFrom,
                    dateTo: this.filter.dateTo,
                    parentObjectType: this.filter.parentObjectType,
                    onlyGlobalFiles: this.showOnlyGlobalFiles
                };
                localStorage.setItem(this.filterCacheName, JSON.stringify(cacheObject));
            };
            GlobalDocumentsListController.prototype.shouldDisableTimeFilter = function (filterString) {
                if (!filterString)
                    return false;
                return filterString.length > 0;
            };
            GlobalDocumentsListController.prototype.isFormInvalid = function () {
                return !this.new || this.files.length < 1 || !this.form.mainCategoryId || !this.form.documentTypeId || this.form.mainCategoryId === QMC.Common.Constants.GUID_EMPTY || this.form.documentTypeId === QMC.Common.Constants.GUID_EMPTY;
            };
            GlobalDocumentsListController.prototype.clearPageWatcher = function () {
                for (var _i = 0, _a = this.pageWatcher; _i < _a.length; _i++) {
                    var watcher = _a[_i];
                    if (watcher)
                        watcher();
                }
                this.pageWatcher = [];
            };
            GlobalDocumentsListController.prototype.getDocumentList = function () {
                var _this = this;
                var currentRequest = {
                    dateFrom: this.tableFilter.length > 0 || !this.filter || this.showOnlyGlobalFiles === true ? null : this.filter.dateFrom,
                    dateTo: this.tableFilter.length > 0 || !this.filter || this.showOnlyGlobalFiles === true ? null : this.filter.dateTo,
                    onlyGlobal: this.showOnlyGlobalFiles,
                    parentTypeId: this.filter.parentObjectType !== 0 && this.showOnlyGlobalFiles === false ? this.filter.parentObjectType : null,
                    page: this.page,
                    text: this.tableFilter.length > 0 ? this.tableFilter : null,
                };
                if (JSON.stringify(currentRequest) === JSON.stringify(this.lastRequest))
                    return;
                this.lastRequest = currentRequest;
                var rId = this.$qui.generateGuid();
                this.requestId = rId;
                this.listLoad = true;
                this.documentList = [];
                this.stammdatenService.getGlobalDocumentList(this.tableFilter.length > 0 || !this.filter || this.showOnlyGlobalFiles === true ? null : this.filter.dateFrom, this.tableFilter.length > 0 || !this.filter || this.showOnlyGlobalFiles === true ? null : this.filter.dateTo, this.showOnlyGlobalFiles, this.filter.parentObjectType !== 0 && this.showOnlyGlobalFiles === false ? this.filter.parentObjectType : null, this.page, QMC.Common.Constants.DEFAULT_PAGINATION_SIZE, this.tableFilter.length > 0 ? this.tableFilter : null, __spreadArrays(this.ui.getDisplayedPropertiesFromSchema(this.ui.documentTable), ["fileName"])).then(function (data) {
                    if (_this.requestId !== rId)
                        return;
                    _this.clearPageWatcher();
                    _this.paginationInfo = data.paginationInfo;
                    for (var _i = 0, _a = data.items; _i < _a.length; _i++) {
                        var element = _a[_i];
                        element.truncatedFileName = element.fileName.substr(0, 27);
                        if (element.fileName.length > 27)
                            element.truncatedFileName += "...";
                    }
                    data.items.forEach(function (x) { return x.stateLink = _this.createStateLink(x); });
                    _this.documentList = data.items;
                    data.items.forEach(function (x) { return x.dontAllowDownload = _this.dontAllowDownload; });
                    _this.ui.documentTable.data = data.items;
                    _this.$qui.functionWaiter("ui.createTable", _this);
                    _this.listLoad = false;
                    _this.pageWatcher.push(_this.$scope.$watch('vm.page', function (newValue, oldValue) {
                        if (newValue !== oldValue)
                            _this.getDocumentList();
                    }));
                });
            };
            GlobalDocumentsListController.prototype.createStateLink = function (data) {
                if (!data.referenceObjectType || !data.referenceId || !data.parentReferenceId)
                    return undefined;
                var state = '';
                switch (data.referenceObjectType) {
                    case 120002:
                        state = 'employee.address';
                        break;
                    case 120004:
                        state = 'employee.communication';
                        break;
                    case 120012:
                        state = 'employee.contactperson';
                        break;
                    case 120020:
                        state = 'employee.checklist';
                        break;
                    case 120046:
                        state = 'employee.vaccination';
                        break;
                    case 140002:
                        state = 'detail.disease';
                        break;
                    case 140003:
                        state = 'detail.doctorsvisit';
                        break;
                    case 140005:
                        state = 'detail.vaccination';
                        break;
                    case 140006:
                        state = 'detail.contactperson';
                        break;
                    case 140021:
                        state = 'detail.address';
                        break;
                    case 140023:
                        state = 'detail.communication';
                        break;
                    case 140027:
                        state = 'detail.legal';
                        break;
                    case 140057:
                        state = 'detail.checklist';
                        break;
                    case 140068:
                        state = 'detail.education';
                        break;
                    default: return undefined;
                }
                return {
                    state: state,
                    parentId: data.parentReferenceId,
                    referenceId: data.referenceId
                };
            };
            GlobalDocumentsListController.prototype.openReference = function (data) {
                if (!data.stateLink)
                    return;
                this.$state.go(data.stateLink.state, { client: data.stateLink.parentId, id: data.stateLink.parentId, dataId: data.stateLink.referenceId });
            };
            GlobalDocumentsListController.prototype.newDocument = function () {
                var _this = this;
                if (this.form.title !== null && this.form.title !== undefined && this.form.title.length < 1) {
                    this.showError = this.lng.translate(21003017, 'Bitte einen Titel eingeben.');
                    return;
                }
                if (this.files.length < 1) {
                    this.showError = this.lng.translate(21003018, 'Bitte eine Datei auswählen.');
                    return;
                }
                this.form.fileName = this.files[this.files.length - 1].name;
                this.form.base64String = this.files[this.files.length - 1].base64;
                this.upload = true;
                this.stammdatenService.postGlobalDocument(this.form).then(function () {
                    $('#newDocumentModal').modal('hide');
                    _this.$qui.notify(_this.$qui.successNote);
                    _this.initForm();
                    _this.getDocumentList();
                    _this.upload = false;
                });
            };
            ;
            GlobalDocumentsListController.prototype.deleteItem = function (item) {
                var _this = this;
                if (!this.delete)
                    return;
                this.promptOptions.itemText = item.fileName;
                QMC.Common.Utilities.confirm(this.promptOptions, function (data) {
                    if (data) {
                        _this.stammdatenService.deleteGlobalDocument(item).then(function () {
                            _this.$qui.notify(_this.$qui.deleteNote);
                            _this.getDocumentList();
                        });
                    }
                });
            };
            GlobalDocumentsListController.prototype.getWv = function () {
                var _this = this;
                this.stammdatenService.getDocumentWV().then(function (data) {
                    _this.wv = data;
                    _this.documentTypeList = _this.$qui.select(data.documentTypeWvList, { value: 'objectId', text: 'name' });
                    _this.categoryList = _this.$qui.select(data.mainCategoryWvList, { value: 'objectId', text: 'name' });
                });
            };
            GlobalDocumentsListController = __decorate([
                QMC.Controller('QMC.Stammdaten', 'GlobalDocumentsListController'),
                QMC.Inject('$location', 'StammdatenService', '$qui', 'KlientService', '$stateParams', '$scope', '$state', 'QmcLanguageService', 'QmcPermissionService', 'UserService')
            ], GlobalDocumentsListController);
            return GlobalDocumentsListController;
        }());
        Stammdaten.GlobalDocumentsListController = GlobalDocumentsListController;
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        var OrgaAccountingBooksListController = /** @class */ (function () {
            function OrgaAccountingBooksListController($qui, $scope, $location, stammdatenService) {
                var _this = this;
                this.$qui = $qui;
                this.$scope = $scope;
                this.$location = $location;
                this.stammdatenService = stammdatenService;
                this.id = QMC.Common.Constants.GUID_EMPTY;
                this.organisations = [];
                $qui.init($qui.getSectionColor($location.path()), function () {
                    $qui.anonAvatar();
                    $('.qm-card').unbind('click');
                });
                this.getOrganisations();
                this.$scope.$watch('vm.selectedOrganisation', function (newVal, oldVal) {
                    if (newVal !== oldVal && _this.selectedOrganisation && _this.selectedOrganisation !== QMC.Common.Constants.GUID_EMPTY) {
                        _this.id = _this.selectedOrganisation;
                        localStorage.setItem(QMC.Common.LocalStorageConstants.ORGANISATION_LAST_SELECTED_ID, _this.selectedOrganisation);
                        _this.$qui.functionWaiter("createDirective", _this);
                    }
                });
            }
            OrgaAccountingBooksListController.prototype.getOrganisations = function () {
                var _this = this;
                this.stammdatenService.getOrganisationList().then(function (data) {
                    _this.organisations = data.map(function (x) { return ({ value: x.id, text: x.displayTitle }); });
                    if (localStorage.getItem(QMC.Common.LocalStorageConstants.ORGANISATION_LAST_SELECTED_ID) !== null) {
                        var organisationId = localStorage.getItem(QMC.Common.LocalStorageConstants.ORGANISATION_LAST_SELECTED_ID);
                        if (organisationId) {
                            _this.selectedOrganisation = organisationId;
                        }
                    }
                    else {
                        _this.$qui.functionWaiter("createDirective", _this);
                    }
                });
            };
            OrgaAccountingBooksListController = __decorate([
                QMC.Controller('QMC.Stammdaten', 'OrgaAccountingBooksListController'),
                QMC.Inject('$qui', '$scope', '$location', 'StammdatenService')
            ], OrgaAccountingBooksListController);
            return OrgaAccountingBooksListController;
        }());
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        /**
         * Stammdaten UserInterface class
         *
         * @export
         * @class UserInterface
         * @extends {Common.UserInterface}
         */
        var UserInterface = /** @class */ (function (_super) {
            __extends(UserInterface, _super);
            function UserInterface() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                /**
                 * Client detail address table
                 * @memberOf UserInterface
                 */
                _this.documentTable = {
                    "config": {
                        "defaultSort": "title",
                        "sortReverse": "true",
                    },
                    "table": {
                        "Kategorie": {
                            "label": "category",
                            "dType": "string",
                            "lngTag": "20000137"
                        },
                        "Unterkategorie": {
                            "label": "subCategory",
                            "dType": "string",
                            "lngTag": "21006003"
                        },
                        "Dokumentkategorie": {
                            "label": "documentCategory",
                            "dType": "string",
                            "lngTag": "20021010"
                        },
                        "Ordnerstruktur": {
                            "label": "folderStructure",
                            "dType": "string",
                            "lngTag": "21006025"
                        },
                        "Titel": {
                            "label": "title",
                            "dType": "string",
                            "lngTag": "20000066"
                        },
                        "Angelegt am": {
                            "label": "dateFrom",
                            "dType": "Date",
                            "withTime": "true",
                            "lngTag": "20021002"
                        },
                        "Bezug": {
                            "label": "parent",
                            "dType": "string",
                            "lngTag": "20000283"
                        },
                        "Dateiname": {
                            "label": "truncatedFileName",
                            "dType": "string",
                            "lngTag": "21006017"
                        },
                        "Art": {
                            "label": "type",
                            "dType": "string",
                            "lngTag": "20000138"
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-download grey",
                                "click": "download",
                                "dType": "Button",
                                "tooltip": "Download",
                                "lngTag": "21006014",
                                "events": {
                                    "hide": "dontAllowDownload",
                                }
                            }, {
                                "icon": "qm-icon-document_attachment green",
                                "click": "open",
                                "dType": "Button",
                                "tooltip": "Vorschau",
                                "lngTag": "20000091",
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteItem",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            },
                            {
                                "icon": "qm-icon-arrow_into orange",
                                "click": "openReference",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Referenz-Datensatz öffnen",
                                "lngTag": "21006030",
                                "events": {
                                    "hide": "!stateLink",
                                }
                            }],
                    }, "card": {
                        "avatar": {
                            "icon": "qm-icon-document_attachment"
                        },
                        "text": {
                            "label": "title",
                            "dType": "string"
                        },
                        "subtext": [
                            {
                                "label": "category",
                                "dType": "string",
                            },
                            {
                                "label": "truncatedFileName",
                                "dType": "string"
                            },
                            {
                                "label": "parent",
                                "dType": "string"
                            },
                            {
                                "label": "dateFrom",
                                "withTime": "true",
                                "dType": "Date"
                            }
                        ],
                        "buttons": [{
                                "icon": "qm-icon-download grey",
                                "click": "download",
                                "dType": "Button",
                                "tooltip": "Download",
                                "lngTag": "21006014",
                                "events": {
                                    "hide": "dontAllowDownload",
                                }
                            }, {
                                "icon": "qm-icon-document_attachment green",
                                "click": "open",
                                "dType": "Button",
                                "tooltip": "Vorschau",
                                "lngTag": "20000091",
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteItem",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            },
                            {
                                "icon": "qm-icon-arrow_into orange",
                                "click": "openReference",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Referenz-Datensatz öffnen",
                                "lngTag": "21006030",
                                "events": {
                                    "hide": "!stateLink",
                                }
                            }]
                    },
                    "data": null
                };
                return _this;
            }
            return UserInterface;
        }(QMC.Common.UserInterface));
        Stammdaten.UserInterface = UserInterface;
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
(function () {
    angular.module('QMC.Employee', []).config(routes);
    routes.$inject = ['$locationProvider', '$stateProvider', 'qmcBase'];
    function routes($locationProvider, $stateProvider, qmcBase) {
        $locationProvider.html5Mode({
            enabled: false,
            requireBase: false
        });
        var params = {
            dataId: {
                dynamic: true
            }
        };
        $stateProvider
            // employee
            .state('employeeList', {
            url: '/employee',
            templateUrl: qmcBase + '/stammdaten/employee',
            controller: 'EmployeeListController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: Employee list');
                    }]
            }
        })
            .state('employee', {
            url: '/employee/:id',
            templateUrl: qmcBase + '/stammdaten/employee/detail',
            controller: 'EmployeeDetailController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: employee detail');
                    }]
            }
        })
            // Detail
            .state('employee.cover', {
            url: '/cover/:id',
            templateUrl: qmcBase + '/stammdaten/detail/cover',
            controller: 'DetailCoverController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: Stammdaten client detail cover');
                    }]
            }
        })
            .state('employee.communication', {
            url: '/communication/:id?:dataId',
            templateUrl: qmcBase + '/stammdaten/detail/communication',
            controller: 'DetailCommunicationController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: Stammdaten employee detail communication');
                    }]
            },
            params: params
        })
            .state('employee.document', {
            url: '/documents/:id',
            templateUrl: qmcBase + '/stammdaten/detail/document',
            controller: 'DetailDocumentsController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: Stammdaten employee detail document');
                    }]
            },
            params: params
        })
            .state('employee.vaccination', {
            url: '/vaccination/:id?:dataId',
            templateUrl: qmcBase + '/stammdaten/detail/vaccination',
            controller: 'DetailVaccinationController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: Stammdaten employee detail vaccination');
                    }]
            },
            params: params
        })
            .state('employee.medicalEvidence', {
            url: '/medicalEvidence/:id',
            templateUrl: qmcBase + '/stammdaten/detail/medicalEvidence',
            controller: 'DetailMedicalEvidenceController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: Stammdaten employee MedicalEvidence doctors visit');
                    }]
            }
        })
            .state('employee.medicalResponsible', {
            url: '/medicalResponsible/:id',
            templateUrl: qmcBase + '/stammdaten/detail/medicalResponsible',
            controller: 'DetailMedicalResponsibleController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: Stammdaten employee Medical Responsible / Medication is done by');
                    }]
            }
        })
            .state('employee.contactperson', {
            url: '/contactperson/:id?:dataId',
            templateUrl: qmcBase + '/stammdaten/detail/contactperson',
            controller: 'DetailContactPersonController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: Stammdaten employee detail contact person');
                    }]
            },
            params: params
        })
            .state('employee.training', {
            url: '/training/:id',
            templateUrl: qmcBase + '/stammdaten/detail/training',
            controller: 'DetailTrainingController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: Stammdaten employee trainings list');
                    }]
            }
        })
            .state('employee.extendedMainData', {
            url: '/extendedMainData/:id',
            templateUrl: qmcBase + '/stammdaten/detail/extendedMainData',
            controller: 'DetailExtendedMainDataController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: Stammdaten employee detail extended Main Data');
                    }]
            }
        })
            .state('employee.address', {
            url: '/address/:id?:dataId',
            templateUrl: qmcBase + '/stammdaten/detail/address',
            controller: 'DetailAddressController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: Stammdaten employee detail address');
                    }]
            },
            params: params
        })
            .state('employee.checklist', {
            url: '/checklist/:id?:dataId',
            templateUrl: qmcBase + '/stammdaten/detail/checklist',
            controller: 'DetailChecklistController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: Stammdaten employee detail address');
                    }]
            },
            params: params
        })
            .state('employee.udf', {
            url: '/udf/:type/:definitionId/:definitionObjectType/:id',
            templateUrl: qmcBase + '/stammdaten/detail/udf',
            controller: 'DetailUdfController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: Stammdaten employee udf');
                    }]
            }
        });
    }
})();
var QMC;
(function (QMC) {
    var Employee;
    (function (Employee) {
        var EmployeeListController = /** @class */ (function () {
            function EmployeeListController($location, $qui, employeeService, $scope, userService, permissionService) {
                var _this = this;
                this.$location = $location;
                this.$qui = $qui;
                this.employeeService = employeeService;
                this.$scope = $scope;
                this.userService = userService;
                this.permissionService = permissionService;
                this.storageName = 'employee-list-settings';
                this.allowTableExport = false;
                this.page = 0;
                this.filter = {
                    searchText: '',
                    searchId: '1655659a-5e10-4a1f-b6c6-e69cb74b64c7'
                };
                this.schema = {
                    "config": {
                        "tableRowLink": "#/employee/{{id}}/cover/{{id}}",
                    },
                    "table": {
                        "Bild": {
                            "label": "id",
                            "dType": "Avatar",
                            "name": "name",
                            "href": "#/employee/{{id}}/cover/{{id}}",
                            "forename": "forename"
                        },
                        "Name": {
                            "label": "name",
                            "dType": "string",
                            "lngTag": "20000072"
                        },
                        "Vorname": {
                            "label": "forename",
                            "dType": "string",
                            "lngTag": "20000057"
                        },
                        "Kürzel": {
                            "label": "abbreviation",
                            "dType": "string",
                            "lngTag": "20000221"
                        },
                        "Nummer": {
                            "label": "employeeNr",
                            "dType": "string",
                            "lngTag": "20000316"
                        },
                        "Stammhaus": {
                            "label": "institute",
                            "dType": "string",
                            "lngTag": "20000031"
                        },
                        "Geburtsdatum": {
                            "label": "birthday",
                            "dType": "Date",
                            "lngTag": "21002004"
                        },
                    },
                    "card": {
                        "avatar": {
                            "name": "name",
                            "forename": "forename",
                            "label": "id",
                            "href": "#/employee/{{id}}/cover/{{id}}",
                        },
                        "text": {
                            "label": ["name", "forename"],
                            "dType": "string"
                        },
                        "subtext": [
                            {
                                "label": "abbreviation",
                                "dType": "string"
                            },
                            {
                                "label": "employeeNr",
                                "dType": "string"
                            },
                            {
                                "label": "actualInstitution",
                                "dType": "string"
                            },
                            {
                                "label": "birthday",
                                "dType": "Date",
                            }
                        ],
                        "buttons": []
                    },
                    "data": []
                };
                this.getFilterFromStorage();
                $qui.init($qui.getSectionColor(this.$location.path()), function () {
                    $qui.anonAvatar();
                    $('.qm-card').unbind('click');
                });
                // get base permissions
                this.permissionService.getPermissionsByObjectTypes([120000]).then(function (data) {
                    _this.allowTableExport = data[0].print;
                    // if we arent allowed to mess with employees stop here
                    if (!data[0].moduleAccess)
                        return;
                    _this.employeeService.getPredefinedSearches().then(function (data) {
                        _this.searchValues = data;
                        _this.searchValuesMap = _this.$qui.selectAutoMap(data, 'id', 'caption');
                    });
                    _this.$qui.getTableAutoload(_this.userService).then(function (ltd) {
                        _this.shouldLoadTableData = ltd;
                        if (_this.shouldLoadTableData) {
                            _this.getData();
                        }
                    });
                });
                this.events();
            }
            /**
             * register view events
             *
             * @private
             *
             * @memberOf StammdatenClientListController
             */
            EmployeeListController.prototype.events = function () {
                var _this = this;
                this.$scope.$watch('vm.filter.searchId', function (newValue, oldValue) {
                    if (newValue !== oldValue) {
                        if (_this.shouldLoadTableData) {
                            _this.page = 0;
                            _this.getData();
                        }
                        _this.setFilterToStorage();
                    }
                });
                this.$scope.$watch('vm.filter.searchText', function (newValue, oldValue) {
                    if (newValue !== oldValue) {
                        if (_this.shouldLoadTableData) {
                            var lastValue_6 = _this.filter.searchText;
                            setTimeout(function () {
                                if (_this.filter.searchText === lastValue_6 && ((newValue === null || newValue === void 0 ? void 0 : newValue.length) < (oldValue === null || oldValue === void 0 ? void 0 : oldValue.length) || _this.filter.searchText.length >= 3)) {
                                    _this.page = 0;
                                    _this.getData();
                                }
                            }, 1500);
                        }
                        _this.setFilterToStorage();
                    }
                });
                this.$scope.$watch('vm.page', function (newValue, oldValue) {
                    if (newValue !== oldValue)
                        _this.getData();
                });
            };
            /**
             * get a filtered list of clients
             *
             * @private
             *
             * @memberOf StammdatenClientListController
             */
            EmployeeListController.prototype.getData = function () {
                var _this = this;
                this.loading = true;
                this.employeeService.getEmployeeListByPredfinedSearch(this.filter.searchId, this.page, 30, this.filter.searchText, ['name', 'forename', 'abbreviation', 'employeeNr', 'institute', 'birthday']).then(function (data) {
                    _this.schema.data = data.items;
                    _this.pagination = data.paginationInfo;
                    _this.$qui.functionWaiter("createTable", _this);
                }).catch(function (e) {
                    _this.schema.data = [];
                    console.error(e);
                }).finally(function () {
                    _this.loading = false;
                });
            };
            EmployeeListController.prototype.setFilterToStorage = function () {
                localStorage.setItem(this.storageName, JSON.stringify(this.filter));
            };
            EmployeeListController.prototype.getFilterFromStorage = function () {
                var store = localStorage.getItem(this.storageName);
                if (!store)
                    return;
                this.filter = JSON.parse(store);
            };
            EmployeeListController = __decorate([
                QMC.Controller('QMC.Employee', 'EmployeeListController'),
                QMC.Inject('$location', '$qui', 'EmployeeService', '$scope', 'UserService', 'QmcPermissionService')
            ], EmployeeListController);
            return EmployeeListController;
        }());
    })(Employee = QMC.Employee || (QMC.Employee = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Employee;
    (function (Employee) {
        var EmployeeDetailController = /** @class */ (function () {
            function EmployeeDetailController($qui, $stateParams, $scope, $location, lng, employeeService, permissionService, udfService) {
                var _this = this;
                this.$qui = $qui;
                this.$scope = $scope;
                this.$location = $location;
                this.lng = lng;
                this.employeeService = employeeService;
                this.permissionService = permissionService;
                this.udfService = udfService;
                this.menuItems = [];
                this.loading = true;
                this.loadingWv = true;
                this.showInfoBox = true;
                this.section = 'cover';
                this.formState = 'edit';
                this.udf = [];
                this.formSchema = {
                    form: [{
                            label: "Name",
                            type: "String",
                            lngTag: 20000072,
                            model: "name",
                            required: true,
                            validate: {
                                message: "Bitte den Namen angeben",
                                messageTag: 21002015
                            },
                            style: {
                                icon: "fa fa-font",
                                class: "col-xs-12 col-md-6"
                            }
                        }, {
                            label: "Vorname",
                            required: true,
                            type: "String",
                            lngTag: 20000057,
                            model: "forename",
                            validate: {
                                message: "Bitte den Vornamen angeben",
                                messageTag: 21003037
                            },
                            style: {
                                icon: "fa fa-font",
                                class: "col-xs-12 col-md-6"
                            }
                        }, {
                            label: "Kürzel",
                            type: "String",
                            lngTag: 20000221,
                            model: "abbreviation",
                            style: {
                                icon: "fa fa-font",
                                class: "col-xs-12 col-md-6"
                            }
                        }, {
                            label: "Mitarbeiter Nr.",
                            type: "String",
                            lngTag: 21002053,
                            model: "employeeNr",
                            style: {
                                icon: "fa fa-hashtag",
                                class: "col-xs-12 col-md-6"
                            }
                        }, {
                            label: "Geburtsdatum",
                            required: true,
                            type: "Date",
                            lngTag: 21002004,
                            model: "birthday",
                            validate: {
                                message: "Bitte das Geburtsdatum angeben",
                                messageTag: 21002018
                            },
                            style: {
                                class: "col-xs-12 col-md-6"
                            }
                        }, {
                            label: "Anrede",
                            type: "Select",
                            lngTag: 20004005,
                            model: "salutationId",
                            dataSource: "getSalutationList",
                            style: {
                                class: "col-xs-12 col-md-6"
                            }
                        }, {
                            label: "Titel",
                            type: "Select",
                            lngTag: 21002024,
                            model: "titleId",
                            dataSource: "getTitleList",
                            style: {
                                class: "col-xs-12 col-md-6"
                            }
                        }, {
                            label: "Titel, nach",
                            type: "Select",
                            lngTag: 21002054,
                            model: "secondTitleId",
                            dataSource: "getSecondTitleList",
                            style: {
                                class: "col-xs-12 col-md-6"
                            }
                        }, {
                            label: "Geschlecht",
                            type: "Select",
                            lngTag: 21002025,
                            model: "genderId",
                            dataSource: "getGenderList",
                            style: {
                                class: "col-xs-12 col-md-6"
                            },
                        }, {
                            label: "Status",
                            type: "Select",
                            lngTag: 20000164,
                            model: "personStatusId",
                            dataSource: "getStatusList",
                            style: {
                                class: "col-xs-12 col-md-6"
                            },
                        }],
                    actions: {
                        put: "updateEmployee",
                        post: ""
                    }
                };
                $qui.init($qui.getSectionColor("/employee"), function () {
                    $qui.bindEvents();
                    _this.events();
                    $('.qm-card').unbind('click');
                });
                this.id = $stateParams.id;
                this.section = $location.$$path.split('/')[3];
                this.initForm();
                this.getEmployee();
                this.getEmployeeImage();
                this.getEmployeeWv();
                this.permissionService.getPermissionsByObjectTypes([120000, 120002, 120004, 120007, 120012, 120020, 120023, 120034, 120044, 120046]).then(function (data) {
                    _this.permissionService.getPermissionsForDataset(_this.id, null).then(function (dData) {
                        _this.permissions = data;
                        _this.permissions[0] = dData[0];
                        _this.permissions[0].objectType = 120000;
                        _this.createMenuByPermissions();
                    });
                });
                udfService.getUserDefinedFields(120000).then(function (data) {
                    _this.udf = data;
                    _this.addUdfMenu();
                });
            }
            /////////////// DISPLAY LOGIC ///////////////
            /**
             * register view events
             *
             * @private
             *
             * @memberOf StammdatenClientDetailController
             */
            EmployeeDetailController.prototype.events = function () {
                var _this = this;
                this.$scope.$watch('vm.mobileSelect', function () {
                    if (_this.mobileSelect !== (null || undefined)) {
                        _this.changeSection(_this.mobileSelect);
                    }
                });
                this.$scope.$on('$locationChangeStart', function (_event, next) {
                    var activeItem = _this.menuItems.filter(function (x) { return next.includes("stammdaten/detail/" + _this.id + "/" + x.section + "/" + _this.id); })[0];
                    if (activeItem)
                        _this.section = activeItem.section;
                });
            };
            EmployeeDetailController.prototype.initForm = function () {
                this.form = {
                    id: null,
                    objectId: null,
                    name: '',
                    forename: '',
                    displayTitle: '',
                    abbreviation: '',
                    birthday: null,
                    gender: null,
                    institute: '',
                    title: '',
                    amountChildren: 0,
                    birthName: '',
                    birthplace: '',
                    bloodType: '',
                    bloodTypeId: null,
                    comment: '',
                    dateOfDeath: null,
                    employeeNr: '',
                    eyeColor: '',
                    eyeColorId: null,
                    familyStatus: '',
                    familyStatusId: null,
                    firstLanguage: '',
                    firstLanguageId: null,
                    firstNationality: '',
                    firstNationalityId: null,
                    genderId: null,
                    hairColor: '',
                    hairColorId: null,
                    instituteId: null,
                    isBaptized: false,
                    originCountry: '',
                    originCountryId: null,
                    permissions: { view: false, new: false, modify: false, delete: false },
                    personStatus: '',
                    personStatusId: null,
                    postalSalutation: '',
                    postalSalutationId: null,
                    religion: '',
                    religionId: null,
                    salutation: '',
                    salutationId: null,
                    secondLanguage: '',
                    secondLanguageId: null,
                    secondNationality: '',
                    secondNationalityId: null,
                    titleId: null,
                };
            };
            /**
             * create the stammdaten menue by given permissions
             *
             * @private
             *
             * @memberOf StammdatenClientDetailController
             */
            EmployeeDetailController.prototype.createMenuByPermissions = function () {
                this.menuItems = [];
                //medicalEvidence
                if ($.grep(this.permissions, function (item) { return item.objectType === 120044; })[0].moduleAccess) {
                    this.menuItems.push({ caption: this.lng.translate(20031000, "Med. Nachweis"), section: "medicalEvidence", icon: "qm-icon-stethoscope" });
                }
                if ($.grep(this.permissions, function (item) { return item.objectType === 120034; })[0].moduleAccess) {
                    this.menuItems.push({ caption: this.lng.translate(0, "Med. Verantwortlich / Medikamentausgabe"), section: "medicalResponsible", icon: "qm-icon-stethoscope" });
                }
                // Communication
                if ($.grep(this.permissions, function (item) { return item.objectType === 120004; })[0].moduleAccess) {
                    this.menuItems.push({ caption: this.lng.translate(20001047, "Kommunikation"), section: "communication", icon: "qm-icon-book_telephone" });
                }
                // Contact Person
                if ($.grep(this.permissions, function (item) { return item.objectType === 120012; })[0].moduleAccess) {
                    this.menuItems.push({ caption: this.lng.translate(20004000, "Kontaktpersonen"), section: "contactperson", icon: "qm-icon-users" });
                }
                // Document
                if ($.grep(this.permissions, function (item) { return item.objectType === 120007; })[0].moduleAccess) {
                    this.menuItems.push({ caption: this.lng.translate(21006000, "Dokumente"), section: "documents", icon: "qm-icon-document_attachment" });
                }
                //Training
                if ($.grep(this.permissions, function (item) { return item.objectType === 120023; })[0].moduleAccess) {
                    this.menuItems.push({ caption: this.lng.translate(20033000, "Fähigkeit / Fortbildung"), section: "training", icon: "qm-icon-graduation_hat2" });
                }
                // Vaccination
                if ($.grep(this.permissions, function (item) { return item.objectType === 120046; })[0].moduleAccess) {
                    this.menuItems.push({ caption: this.lng.translate(20009000, "Impfungen"), section: "vaccination", icon: "qm-icon-injection" });
                }
                //Adress
                if ($.grep(this.permissions, function (item) { return item.objectType === 120002; })[0].moduleAccess) {
                    this.menuItems.push({ caption: this.lng.translate(20001511, "Adressen"), section: "address", icon: "qm-icon-location_pin" });
                }
                // Checklist
                if ($.grep(this.permissions, function (item) { return item.objectType === 120020; })[0].moduleAccess) {
                    this.menuItems.push({ caption: this.lng.translate(20011505, "Checklisten"), section: "checklist", icon: "qm-icon-check" });
                }
                this.addUdfMenu();
                this.menuItems = this.menuItems.sort(function (a, b) { return a.caption > b.caption ? 1 : a.caption < b.caption ? -1 : 0; });
                this.menuItems.unshift({ caption: this.lng.translate(21002031, "Deckblatt"), section: "cover", icon: "qm-icon-form" });
                // Extended main data
                if ($.grep(this.permissions, function (item) { return item.objectType === 120000; })[0].moduleAccess) {
                    this.menuItems.splice(1, 0, { caption: this.lng.translate(21002048, "Erweiterte Stammdaten"), section: "extendedMainData", icon: "qm-icon-id_cards" });
                }
            };
            EmployeeDetailController.prototype.addUdfMenu = function () {
                var _this = this;
                this.udf.sort(function (a, b) { return a.caption > b.caption ? 1 : a.caption < b.caption ? -1 : 0; }).forEach(function (udf) {
                    _this.menuItems.push({
                        caption: udf.caption,
                        section: "udf/" + udf.type + "/" + udf.definitionId + "/" + udf.objectType,
                        icon: "qm-icon-window_explorer"
                    });
                });
            };
            /**
             * change the section given by the view
             *
             * @private
             * @param {string} section
             *
             * @memberOf StammdatenClientDetailController
             */
            EmployeeDetailController.prototype.changeSection = function (section) {
                this.section = section;
                console.log("SECTION", section);
                this.$location.search('');
                this.$location.path("employee/" + this.id + "/" + section + "/" + this.id);
                $('#mobile-data').css('display', 'none'); // Hide mobile menu after selecting a section
                this.toggleInfoBox(false);
            };
            EmployeeDetailController.prototype.toggleInfoBox = function (state) {
                if (state === void 0) { state = !this.showInfoBox; }
                var header = window.getComputedStyle(document.getElementById('largerEmployeeDetailHeader'));
                if (header.display === 'none')
                    return; // if we got no option to show details again, never hide them
                var element = document.getElementById('infoContent');
                this.showInfoBox = state;
                if (this.showInfoBox)
                    element.style.display = 'unset';
                else
                    element.style.display = 'none';
            };
            EmployeeDetailController.prototype.editEmployee = function () {
                this.formState = "edit";
                this.$qui.functionWaiter("createForm", this);
                $('#edit-employee').modal('toggle');
            };
            /////////////// SERVICE FUNCTIONS ///////////////
            EmployeeDetailController.prototype.getEmployee = function () {
                var _this = this;
                this.loading = true;
                this.employeeService.getEmployee(this.id).then(function (data) {
                    _this.employee = data;
                    var birthday = moment(data.birthday);
                    var prehistoric = moment('1900-01-01').endOf('day');
                    _this.form.birthday = birthday <= prehistoric ? null : _this.form.birthday;
                    _this.form = angular.copy(data);
                    _this.age = birthday <= prehistoric ? '?' : moment().diff(birthday, 'years');
                }).finally(function () {
                    _this.loading = false;
                });
            };
            EmployeeDetailController.prototype.getEmployeeImage = function () {
                var _this = this;
                this.employeeService.getEmployeeImage(this.id, true).then(function (data) {
                    if (data.imageData.length > 1) {
                        _this.avatar = data.imageData;
                    }
                });
            };
            EmployeeDetailController.prototype.getEmployeeWv = function () {
                var _this = this;
                this.loadingWv = true;
                this.employeeService.getEmployeeWv().then(function (data) {
                    _this.wv = data;
                }).finally(function () {
                    _this.loadingWv = false;
                });
            };
            EmployeeDetailController.prototype.updateEmployee = function (form) {
                var _this = this;
                this.loading = true;
                this.employeeService.putEmployee(form.objectId, form).then(function () {
                    _this.getEmployee();
                }).catch(function () {
                    _this.loading = false;
                });
            };
            EmployeeDetailController.prototype.getSalutationList = function () {
                return this.wv.salutationWvList.map(function (x) { return ({ text: x.name, value: x.objectId }); });
            };
            EmployeeDetailController.prototype.getTitleList = function () {
                return this.wv.titleWvList.map(function (x) { return ({ text: x.name, value: x.objectId }); });
            };
            EmployeeDetailController.prototype.getSecondTitleList = function () {
                return this.wv.secondTitleWvList.map(function (x) { return ({ text: x.name, value: x.objectId }); });
            };
            EmployeeDetailController.prototype.getGenderList = function () {
                return this.wv.genderWvList.map(function (x) { return ({ text: x.name, value: x.objectId }); });
            };
            EmployeeDetailController.prototype.getStatusList = function () {
                return this.wv.personStatusWvList.map(function (x) { return ({ text: x.name, value: x.objectId }); });
            };
            EmployeeDetailController = __decorate([
                QMC.Controller('QMC.Employee', 'EmployeeDetailController'),
                QMC.Inject('$qui', '$stateParams', '$scope', '$location', 'QmcLanguageService', 'EmployeeService', 'QmcPermissionService', 'QmcUdfService')
            ], EmployeeDetailController);
            return EmployeeDetailController;
        }());
    })(Employee = QMC.Employee || (QMC.Employee = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Employee;
    (function (Employee) {
        var EmployeeService = /** @class */ (function (_super) {
            __extends(EmployeeService, _super);
            function EmployeeService($http, $q) {
                var _this = _super.call(this, $http, $q) || this;
                _this.$http = $http;
                _this.$q = $q;
                _this.modulePath = '/Person/Employee';
                return _this;
            }
            EmployeeService.prototype.getEmployeeList = function () {
                return _super.prototype.get.call(this, this.modulePath, {}, function (data) {
                    return data;
                });
            };
            EmployeeService.prototype.getEmployeeListByPredfinedSearch = function (id, page, pagesize, searchString, searchProperties) {
                if (pagesize === void 0) { pagesize = 30; }
                if (searchString === void 0) { searchString = ''; }
                if (searchProperties === void 0) { searchProperties = []; }
                return _super.prototype.getItem.call(this, this.modulePath + '/ByPredefinedSearch/' + id, { listSearch: searchString, page: page, pageSize: pagesize, searchProperties: searchProperties }, function (data) {
                    return data;
                });
            };
            EmployeeService.prototype.getPredefinedSearches = function () {
                return _super.prototype.get.call(this, '/PredefinedSearch', { objecttype: 120000 }, function (data) {
                    return data;
                });
            };
            EmployeeService.prototype.getEmployee = function (id) {
                return _super.prototype.getItem.call(this, this.modulePath + '/' + id, {}, function (data) {
                    return data;
                });
            };
            EmployeeService.prototype.getEmployeeWv = function () {
                return _super.prototype.getItem.call(this, this.modulePath + '/WvModel', {}, function (data) {
                    return data;
                });
            };
            EmployeeService.prototype.putEmployee = function (parentObjectId, data) {
                return _super.prototype.put.call(this, this.modulePath + '/' + parentObjectId, data).then(function (data) {
                    console.log(data);
                    return data;
                });
            };
            EmployeeService.prototype.getEmployeeImage = function (id, thumbnail, objectType) {
                if (objectType === void 0) { objectType = 120006; }
                if (id !== undefined) {
                    var thumbnailString = thumbnail ? 'true' : 'false';
                    return _super.prototype.cachedGetItem.call(this, '/Media/Image/MainImage', { parentObjectId: id, getThumbnail: thumbnailString, objectType: objectType }, function (data) {
                        return data;
                    });
                }
                return null;
            };
            EmployeeService = __decorate([
                QMC.Service('QMC.Employee', 'EmployeeService'),
                QMC.Inject('$http', '$q')
            ], EmployeeService);
            return EmployeeService;
        }(QMC.Common.BaseService));
        Employee.EmployeeService = EmployeeService;
    })(Employee = QMC.Employee || (QMC.Employee = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        var DetailAddressController = /** @class */ (function () {
            /**
             * QMC.Stammdaten.DetailAdressController
             * @constructor
             * @param stammdatenService
             * @param $qui
             * @param clientService
             * @param $stateParams
             * @param $scope
             * @param $state
             * @param lng
             */
            function DetailAddressController(stammdatenService, $qui, clientService, $stateParams, $scope, $state, lng, permissionService, userService, $timeout, $location, udfService) {
                var _this = this;
                this.stammdatenService = stammdatenService;
                this.$qui = $qui;
                this.clientService = clientService;
                this.$stateParams = $stateParams;
                this.$scope = $scope;
                this.$state = $state;
                this.lng = lng;
                this.permissionService = permissionService;
                this.userService = userService;
                this.$timeout = $timeout;
                this.$location = $location;
                //formModalId = 'edit-form';
                this.formModalId = 'edit-form';
                this.allowTableExport = false;
                this.ui = new Stammdaten.DetailUI(this.formModalId);
                this.udfs = [];
                $scope.Model = $scope.Model || { Name: "xxx" };
                this.id = $stateParams.id;
                switch (this.$location.$$path.split('/')[1]) {
                    case 'employee':
                        this.parentObjectType = 120000;
                        this.objectType = 120002;
                        this.documentObjectType = 120007;
                        break;
                    default:
                        this.parentObjectType = 140000;
                        this.objectType = 140021;
                        this.documentObjectType = 140117;
                        break;
                }
                permissionService.getPermissionsByObjectTypes([this.objectType, this.documentObjectType]).then(function (data) {
                    _this.delete = data[0].delete;
                    _this.new = data[0].new;
                    _this.modify = data[0].modify;
                    _this.moduleAccess = data[0].moduleAccess && data[0].view;
                    _this.allowTableExport = data[0].print;
                    _this.enableDocuments = data[1].moduleAccess;
                    $timeout(function () {
                        if (!_this.new)
                            document.getElementsByName('newModalButton').forEach(function (x) { return x.style.visibility = 'hidden'; });
                        else
                            document.getElementsByName('newModalButton').forEach(function (x) { return x.style.visibility = 'unset'; });
                    });
                    _this.getWv();
                    _this.$qui.getTableAutoload(_this.userService).then(function (ltd) {
                        _this.shouldLoadTableData = ltd;
                        if (_this.shouldLoadTableData) {
                            _this.getData();
                        }
                    });
                });
                //$qui.init("stammdaten", () => {
                $qui.init($qui.getSectionColor("/stammdaten"), function () {
                    $qui.bindEvents();
                    $(".qm-card").unbind("click");
                });
                this.lang = lng;
                this.promptOptions = {
                    title: "Adresse",
                    yesNo: true,
                    icon: "qm-icon-history2",
                    text: this.lang.translate(20000290, "Wollen Sie den Eintrag wirklich löschen?")
                };
                var vm = this;
                $timeout(function () { return $("#" + _this.formModalId).on('hidden.bs.modal', function () {
                    _this.$state.go('.', { dataId: undefined }, { reload: false });
                    $timeout(function () { return vm.initForm(); });
                    $("#edit-form").find('.tab-content').children().removeClass('in').removeClass('active');
                    $("#edit-form").find('.tab-content').find('#baseDataTab').addClass('in active');
                }); });
                udfService.getUserDefinedFields(this.objectType).then(function (data) {
                    _this.udfs = data.sort(function (a, b) { return a.caption.localeCompare(b.caption); });
                });
            }
            DetailAddressController.prototype.getData = function () {
                this.getAdress();
            };
            /////////////// DISPLAY LOGIC ///////////////
            /**
             * Init view events
             *
             * @private
             *
             * @memberOf DetailAddressController
             */
            DetailAddressController.prototype.events = function () {
                var vm = this;
                $("#city .typeahead").typeahead({
                    minLength: 3,
                    source: function (query, process) {
                        vm.stammdatenService.getPostCodeByCityList(vm.form.objectIdCountry, query).then(function (data) {
                            process(data.map(function (obj) {
                                return obj.postCodeAndCity;
                            }));
                        });
                    },
                    updater: function (item) {
                        var data = item.split("...");
                        vm.form.postCode = data[0];
                        $("#postCode input").val(data[0]).trigger("change");
                        return data[1];
                    }
                });
                $("#postCode .typeahead").typeahead({
                    minLength: 3,
                    source: function (query, process) {
                        vm.stammdatenService.getCityByPostCodeList(vm.form.objectIdCountry, query).then(function (data) {
                            process(data.map(function (obj) {
                                return obj.postCodeAndCity;
                            }));
                        });
                    },
                    updater: function (item) {
                        var data = item.split("...");
                        vm.form.city = data[1];
                        $("#city input").val(data[1]).trigger("change");
                        return data[0];
                    }
                });
            };
            /**
             * init form
             *
             * @private
             *
             * @memberOf DetailAddressController
             */
            DetailAddressController.prototype.initForm = function () {
                var _this = this;
                this.formState = "new";
                this.form = {
                    id: null,
                    objectId: null,
                    objectType: this.objectType,
                    parentObjectType: this.parentObjectType,
                    parentObjectId: this.id,
                    street: null,
                    houseNumber: null,
                    addressAddition: null,
                    postCode: null,
                    city: null,
                    dateFrom: null,
                    dateTo: null,
                    objectIdCountry: QMC.Common.Constants.DEFAULT_COUNTRY_ID,
                    objectIdState: null,
                    objectIdAddressType: null,
                    isMainRecord: true,
                    isPostOfficeBox: false,
                    isHouseless: false,
                    comment: null,
                    isDatatransferForbidden: false,
                    isEmergency: false
                };
                this.userService.getUserSettings(["GLOBAL.DEFAULTLAND"], false).then(function (dataGlobal) {
                    _this.form.objectIdCountry = dataGlobal[0].value;
                });
                this.userService.getUserSettings(["GLOBAL.DEFAULTBUNDESLAND"], false).then(function (dataGlobal) {
                    _this.form.objectIdState = dataGlobal[0].value;
                });
                this.$qui.functionWaiter("ui.createForm", this);
            };
            /////////////// SERVICE FUNCTIONS ///////////////
            /**
             * get the address type list
             *
             * @private
             * @returns {ng.IPromise<any>}
             *
             * @memberOf DetailAddressController
             */
            DetailAddressController.prototype.getAdressTypeList = function () {
                return this.wv.addressTypeWvList.map(function (obj) { return ({
                    value: obj.objectId,
                    text: obj.name
                }); });
            };
            /**
             * get the country list
             *
             * @private
             * @returns {ng.IPromise<any>}
             *
             * @memberOf DetailAddressController
             */
            DetailAddressController.prototype.getCountryList = function () {
                var _this = this;
                return this.stammdatenService.getAddressWv().then(function (data) {
                    return _this.ui.select(data.countriesWvList, { value: "objectId", text: "name" });
                });
            };
            /**
             * get the state list
             *
             * @private
             * @param {Guid} id
             * @returns {ng.IPromise<any>}
             *
             * @memberOf DetailAddressController
             */
            DetailAddressController.prototype.getStatesList = function (id) {
                var _this = this;
                if (this.form.objectIdCountry === null)
                    return null;
                this.form.objectIdState = null;
                return this.stammdatenService.getStatesWv(this.form.objectIdCountry).then(function (data) {
                    return _this.ui.select(data, { value: "id", text: "caption" });
                });
            };
            /**
             * get the wv list
             *
             * @private
             *
             * @memberOf DetailAddressController
             */
            DetailAddressController.prototype.getWv = function () {
                var _this = this;
                this.loading = true;
                this.stammdatenService.getAddressWv().then(function (data) {
                    _this.wv = data;
                    _this.initForm();
                    _this.$qui.functionWaiter("ui.createForm", _this);
                    setTimeout(function () {
                        _this.events();
                    }, 200);
                    _this.loading = false;
                });
            };
            /**
             * get all addresses
             *
             * @private
             *
             * @memberOf DetailAddressController
             */
            DetailAddressController.prototype.getAdress = function () {
                var _this = this;
                this.loading = true;
                this.stammdatenService.getAddressList(this.id).then(function (data) {
                    data = data.map(function (obj) {
                        if (obj.isDatatransferForbidden)
                            obj.style = { 'background-color': 'orangered', 'color': 'white', 'font-weight': 'bold' };
                        return obj;
                    });
                    _this.ui.addressTable.data = data;
                    _this.$qui.functionWaiter("ui.createTable", _this);
                    _this.loading = false;
                    if (_this.$stateParams.dataId) {
                        var address = data.filter(function (x) { return x.objectId === _this.$stateParams.dataId; })[0];
                        console.log('open', _this.$stateParams.dataId, _this.formModalId, address);
                        if (address) {
                            $("#" + _this.formModalId).modal('show');
                            _this.editAdress(address);
                        }
                    }
                });
            };
            /**
             * add an address
             *
             * @private
             * @param {IAddress} form
             *
             * @memberOf DetailAddressController
             */
            DetailAddressController.prototype.addAddress = function (form) {
                var _this = this;
                form.parentObjectId = this.id;
                this.loading = true;
                this.stammdatenService.postAddress(form).then(function (e) {
                    _this.ui.notify(_this.ui.successNote);
                    _this.getAdress();
                    _this.formState = "new";
                    $("#" + _this.formModalId).modal('hide');
                });
            };
            /**
             * put an existing address
             *
             * @private
             * @param {IAddress} form
             *
             * @memberOf DetailAddressController
             */
            DetailAddressController.prototype.putAddress = function (form) {
                var _this = this;
                form.parentObjectId = this.id;
                this.loading = true;
                this.stammdatenService.putAddress(form.parentObjectId, form.objectId, form).then(function (data) {
                    _this.ui.notify(_this.ui.successNote);
                    _this.getAdress();
                    _this.formState = "new";
                    $("#" + _this.formModalId).modal('hide');
                });
                this.udfs.forEach(function (x) { var _a; return (_a = x.save) === null || _a === void 0 ? void 0 : _a.call(x, false); });
            };
            /**
             * delete an existing address
             *
             * @private
             * @param {IAddress} data
             *
             * @memberOf DetailAddressController
             */
            DetailAddressController.prototype.deleteAdress = function (item) {
                var _this = this;
                this.promptOptions.itemText = item.streetAndHouseNumber + ", " + item.postCode + " " + item.city;
                QMC.Common.Utilities.confirm(this.promptOptions, function (data) {
                    if (data) {
                        _this.loading = true;
                        _this.stammdatenService.deleteAddress(_this.id, item.objectId).then(function (dataDelete) {
                            _this.ui.notify(_this.ui.deleteNote);
                            _this.getAdress();
                            _this.formState = "new";
                            $("#" + _this.formModalId).modal('hide');
                        });
                    }
                });
            };
            /**
             * edit an existing address
             *
             * @private
             * @param {IAddress} data
             *
             * @memberOf DetailAddressController
             */
            DetailAddressController.prototype.editAdress = function (data) {
                this.formState = "edit";
                this.form = angular.copy(data);
                if (data.dateFrom != null) {
                    this.form.dateFrom = moment(data.dateFrom).toDate();
                }
                if (this.form.dateTo !== null)
                    this.form.dateTo = moment(data.dateTo).toDate();
                this.$qui.waitForEl('#standardTabButton', function () {
                    $('#standardTabButton').click();
                });
                this.$state.go('.', { dataId: data.objectId });
            };
            DetailAddressController = __decorate([
                QMC.Controller("QMC.Stammdaten", "DetailAddressController"),
                QMC.Inject("StammdatenService", "$qui", "KlientService", "$stateParams", "$scope", "$state", "QmcLanguageService", "QmcPermissionService", 'UserService', '$timeout', '$location', 'QmcUdfService')
            ], DetailAddressController);
            return DetailAddressController;
        }());
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        var DetailChecklistController = /** @class */ (function () {
            /**
             * Creates an instance of DetailChecklistController.
             *
             * @memberOf DetailChecklistController
             */
            function DetailChecklistController(stammdatenService, $qui, $stateParams, $scope, permissionService, userService, lng, $state, $location, $timeout, udfService) {
                var _this = this;
                this.stammdatenService = stammdatenService;
                this.$qui = $qui;
                this.$stateParams = $stateParams;
                this.$scope = $scope;
                this.permissionService = permissionService;
                this.userService = userService;
                this.lng = lng;
                this.$state = $state;
                this.ui = new QMC.Stammdaten.DetailUI();
                this.checkListItems = [];
                this.formState = 'new';
                this.cacheName = 'checklistCache';
                this.udfs = [];
                this.promptOptions = {
                    title: this.lng.translate(20011510, 'Checklisteneinträge'),
                    yesNo: true,
                    icon: 'qm-icon-check',
                    text: this.lng.translate(20000299, 'Wollen Sie wirklich alle Einträge löschen?'),
                    itemText: ''
                };
                this.promptOptionsHistory = {
                    title: this.lng.translate(20011511, 'Checklisteneintrag'),
                    yesNo: true,
                    icon: 'qm-icon-check',
                    text: this.lng.translate(20000290, "Wollen Sie den Eintrag wirklich löschen?"),
                    itemText: ''
                };
                this.historyFormState = 'new';
                this.id = this.$stateParams.id;
                switch ($location.$$path.split('/')[1]) {
                    case 'employee':
                        this.parentObjectType = 120000;
                        this.objectType = 120020;
                        this.documentObjectType = 120021;
                        this.historyObjectType = 120022;
                        break;
                    default:
                        this.parentObjectType = 140000;
                        this.objectType = 140057;
                        this.documentObjectType = 140059;
                        this.historyObjectType = 140060;
                        break;
                }
                this.maps = {
                    list: []
                };
                this.loading = {
                    items: false,
                    list: false,
                    save: false
                };
                this.initForm();
                this.permissionService.getPermissionsByObjectTypes([this.objectType, this.documentObjectType, this.historyObjectType]).then(function (data) {
                    _this.delete = data[0].delete;
                    _this.new = data[0].new;
                    _this.modify = data[0].modify;
                    _this.allowTableExport = data[0].print;
                    _this.moduleAccess = data[0].moduleAccess && data[0].view;
                    _this.documentPermissions = data[1];
                    _this.historyDelete = data[2].delete && data[2].moduleAccess;
                    _this.historyModify = data[2].modify && data[2].moduleAccess;
                    _this.historyNew = data[2].new && data[2].moduleAccess;
                    _this.historyModuleAccess = data[2].moduleAccess && data[2].view;
                });
                //$qui.init('stammdaten', () => {
                $qui.init($qui.getSectionColor("/stammdaten"), function () {
                    $qui.bindEvents();
                    $('.qm-card').unbind('click');
                });
                this.$qui.waitForEl('#newModalButton', function () {
                    document.getElementsByName('newModalButton').forEach(function (x) { return x.style.visibility = 'hidden'; });
                });
                this.$qui.getTableAutoload(this.userService).then(function (ltd) {
                    _this.shouldLoadTableData = ltd;
                    if (_this.shouldLoadTableData) {
                        _this.events();
                    }
                    _this.getChecklists();
                });
                var vm = this;
                $timeout(function () { return $("#edit-form").on('hidden.bs.modal', function () {
                    _this.$state.go('.', { dataId: undefined }, { reload: false });
                    $timeout(function () { return vm.initForm(); });
                    $("#edit-form").find('.tab-content').children().removeClass('in').removeClass('active');
                    $("#edit-form").find('.tab-content').find('#baseDataTab').addClass('in active');
                }); });
                udfService.getUserDefinedFields(this.objectType).then(function (data) {
                    _this.udfs = data.sort(function (a, b) { return a.caption.localeCompare(b.caption); });
                });
            }
            /**
             * init the form with default values
             *
             * @private
             *
             * @memberOf DetailChecklistController
             */
            DetailChecklistController.prototype.initForm = function () {
                this.form = {
                    id: null,
                    objectId: null,
                    date: new Date(),
                    dateShowAgain: null,
                    dateFrom: null,
                    dateTo: null,
                    comment: null,
                    caption: '',
                    order: 0,
                    checklistId: null,
                    checklistItemId: null,
                    history: [],
                    reminder: 0,
                    reminderActive: false
                };
                this.$qui.functionWaiter("ui.createForm", this);
            };
            /////////////// DISPLAY LOGIC ///////////////
            /**
             * create events for the view
             *
             * @private
             *
             * @memberOf DetailChecklistController
             */
            DetailChecklistController.prototype.events = function () {
                var _this = this;
                this.$scope.$watch('vm.checkListId', function (newVal, oldVal) {
                    if (newVal === oldVal)
                        return;
                    _this.checkListItems = [];
                    if (!_this.checkListId || _this.checkListId.length === 0)
                        return;
                    _this.getCheckListItems();
                });
            };
            DetailChecklistController.prototype.getList = function () {
                return this.maps.list;
            };
            DetailChecklistController.prototype.getData = function () {
                this.getCheckListItems();
            };
            DetailChecklistController.prototype.formatItemForTable = function (item) {
                item.state = this.lng.translate(20011512, 'keiner');
                if (item.date) {
                    item.isChecked = true;
                    item.date = this.$qui.createDateFromString(item.date);
                    item.state = this.lng.translate(20011513, 'gültig');
                }
                ;
                if (item.dateFrom)
                    item.dateFrom = this.$qui.createDateFromString(item.dateFrom);
                if (item.dateTo)
                    item.dateTo = this.$qui.createDateFromString(item.dateTo);
                if (item.dateShowAgain)
                    item.dateShowAgain = this.$qui.createDateFromString(item.dateShowAgain);
                if (item.dateTo && item.dateTo < new Date()) {
                    item.isChecked = 'invalid';
                    item.state = this.lng.translate(20011514, 'abgelaufen');
                }
                else if (item.dateFrom && item.dateFrom > new Date()) {
                    item.isChecked = 'invalid';
                    item.state = this.lng.translate(20011515, 'zukünftig');
                }
                return item;
            };
            DetailChecklistController.prototype.toggleCommentModal = function (data) {
                this.commentModalData = data;
                $('#commentModal').modal('show');
            };
            /////////////// SERVICE FUNCTIONS ///////////////
            /**
             * get the list of checklists
             *
             * @private
             *
             * @memberOf DetailChecklistController
             */
            DetailChecklistController.prototype.getChecklists = function () {
                var _this = this;
                this.loading.list = true;
                this.stammdatenService.getChecklistList(this.parentObjectType).then(function (data) {
                    _this.maps.list = data.map(function (x) { return ({ text: x.caption, value: x.objectId, group: x.category }); });
                    if (data.length === 1) {
                        _this.checkListId = data[0].objectId;
                        _this.getCheckListItems();
                    }
                    else if (localStorage.getItem(_this.cacheName) && _this.maps.list.some(function (x) { return x.value === localStorage.getItem(_this.cacheName); })) {
                        _this.checkListId = localStorage.getItem(_this.cacheName);
                    }
                    _this.loading.list = false;
                });
            };
            DetailChecklistController.prototype.getCheckListItems = function () {
                var _this = this;
                if (!this.checkListId || this.checkListId === QMC.Common.Constants.GUID_EMPTY)
                    return;
                this.loading.items = true;
                localStorage.setItem(this.cacheName, this.checkListId);
                this.ui.checklistTable.data = [];
                this.stammdatenService.getChecklistItemList(this.id, this.checkListId).then(function (data) {
                    for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
                        var item = data_1[_i];
                        item = _this.formatItemForTable(item);
                    }
                    _this.ui.checklistTable.data = data.sort(function (a, b) { return a.order - b.order; });
                    _this.loading.items = false;
                    _this.$qui.functionWaiter("ui.createTable", _this);
                    if (_this.$stateParams.dataId) {
                        var item = data.filter(function (x) { return x.objectId === _this.$stateParams.dataId; })[0];
                        if (item) {
                            $("#edit-form").modal('show');
                            _this.editCheck(item);
                        }
                    }
                });
            };
            DetailChecklistController.prototype.newCheck = function (data) {
                this.formState = 'new';
                this.initForm();
                this.form.checklistItemId = data.checklistItemId;
                this.form.checklistId = data.checklistId;
                this.form.caption = data.caption;
                this.$qui.waitForEl('#standardTabButton', function () {
                    $('#standardTabButton').click();
                });
            };
            DetailChecklistController.prototype.editCheck = function (data) {
                var _this = this;
                this.formState = 'edit';
                this.loading.save = true;
                this.stammdatenService.getChecklistItem(this.id, data.checklistId, data.checklistItemId).then(function (data) {
                    if (data.date)
                        data.date = _this.$qui.createDateFromString(data.date);
                    if (data.dateFrom)
                        data.dateFrom = _this.$qui.createDateFromString(data.dateFrom);
                    if (data.dateTo)
                        data.dateTo = _this.$qui.createDateFromString(data.dateTo);
                    if (data.dateShowAgain)
                        data.dateShowAgain = _this.$qui.createDateFromString(data.dateShowAgain);
                    _this.form = data;
                    for (var _i = 0, _a = data.history; _i < _a.length; _i++) {
                        var item = _a[_i];
                        item = _this.formatItemForTable(item);
                    }
                    _this.ui.checklistHistoryTable.data = data.history.sort(function (a, b) { return a.order - b.order; });
                    _this.$qui.functionWaiter("createHistoryTable", _this);
                }).finally(function () {
                    _this.loading.save = false;
                });
                this.$qui.waitForEl('#standardTabButton', function () {
                    $('#standardTabButton').click();
                });
                this.$state.go('.', { dataId: data.objectId });
            };
            DetailChecklistController.prototype.addChecklist = function (data) {
                var _this = this;
                this.loading.save = true;
                this.loading.items = true;
                this.stammdatenService.postCheckedItem(this.id, data).then(function () {
                    _this.ui.notify(_this.ui.successNote);
                    _this.getCheckListItems();
                    $('#edit-form').modal('hide');
                }).finally(function () {
                    _this.loading.save = false;
                });
            };
            DetailChecklistController.prototype.putChecklist = function (data) {
                var _this = this;
                this.loading.save = true;
                this.loading.items = true;
                this.stammdatenService.putCheckedItem(this.id, data.objectId, data).then(function () {
                    _this.ui.notify(_this.ui.successNote);
                    _this.getCheckListItems();
                    $('#edit-form').modal('hide');
                    $('#historyFormModal').modal('hide');
                }).finally(function () {
                    _this.loading.save = false;
                });
                this.udfs.forEach(function (x) { var _a; return (_a = x.save) === null || _a === void 0 ? void 0 : _a.call(x, false); });
            };
            DetailChecklistController.prototype.deleteCheck = function (data) {
                var _this = this;
                this.promptOptions.itemText = data.caption;
                QMC.Common.Utilities.confirm(this.promptOptions, function (decission) {
                    if (decission) {
                        _this.loading.save = true;
                        _this.stammdatenService.deleteCheckedItems(_this.$stateParams.client, data.checklistItemId).then(function () {
                            _this.ui.notify(_this.ui.deleteNote);
                            _this.getCheckListItems();
                            _this.formState = "new";
                        }).finally(function () {
                            _this.loading.save = false;
                        });
                    }
                    $('#edit-form').modal('hide');
                });
            };
            DetailChecklistController.prototype.editHistory = function (data) {
                this.historyFormState = 'edit';
                this.historyForm = angular.copy(data);
                this.createHistoryForm();
                this.$qui.functionWaiter("createHistoryDirective", this);
                this.$qui.functionWaiter("createHistoryForm", this);
                this.$qui.waitForEl('#standardHistoryTabButton', function () {
                    $('#standardHistoryTabButton').click();
                });
            };
            DetailChecklistController.prototype.deleteHistory = function (data) {
                var _this = this;
                this.promptOptionsHistory.itemText = data.state + " " + this.lng.translate(20000218, 'vom') + " " + moment(data.date).format('DD.MM.yyyy');
                QMC.Common.Utilities.confirm(this.promptOptionsHistory, function (decission) {
                    if (decission) {
                        _this.loading.save = true;
                        _this.stammdatenService.deleteCheckedItem(_this.$stateParams.client, data.checklistItemId, data.objectId).then(function () {
                            _this.ui.notify(_this.ui.deleteNote);
                            _this.getCheckListItems();
                            _this.historyFormState = "new";
                        }).finally(function () {
                            _this.loading.save = false;
                        });
                        $('#edit-form').modal('hide');
                    }
                }, '#historyDeletePrompt');
            };
            DetailChecklistController = __decorate([
                QMC.Controller('QMC.Stammdaten', 'DetailChecklistController'),
                QMC.Inject('StammdatenService', '$qui', '$stateParams', '$scope', 'QmcPermissionService', 'UserService', 'QmcLanguageService', '$state', '$location', '$timeout', 'QmcUdfService')
            ], DetailChecklistController);
            return DetailChecklistController;
        }());
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        var DetailClientInfoController = /** @class */ (function () {
            /**
             * QMC.Stammdaten.DetailAbsenteeismController
             * @constructor
             * @param stammdatenService
             * @param clientService
             * @param $stateParams
             * @param $scope
             * @param $state
             * @param lng
             */
            function DetailClientInfoController($qui, $stateParams, userService, lngService) {
                this.$qui = $qui;
                this.userService = userService;
                this.lngService = lngService;
                this.selectedClients = [];
                this.isMobile = document.body.classList.contains('mobile');
                this.newView = true;
                this.selectedClients.push($stateParams.id);
                this.$qui.waitForEl('#newModalButton', function () {
                    document.getElementsByName('newModalButton').forEach(function (x) { return x.style.visibility = 'hidden'; });
                });
                var ceBaseUrl = $('#session').data().ceUrl;
                this.allowExchange = (ceBaseUrl || ceBaseUrl.length > 0);
                this.newView = this.allowExchange;
                this.$qui.init($qui.getSectionColor("/stammdaten"), function () {
                    $qui.bindEvents();
                    $('.qm-card').unbind('click');
                });
            }
            DetailClientInfoController.prototype.toggleView = function () {
                this.userService.postActionLogEntry({ type: this.newView ? 11 : 10, source: 1, area: 'ClientInformation', reference: 'toggle' });
                this.newView = !this.newView;
            };
            DetailClientInfoController.prototype.getTooltip = function () {
                return this.lngService.translate(this.newView ? 20000322 : 20000321, 'Ansicht wechseln');
            };
            DetailClientInfoController = __decorate([
                QMC.Controller('QMC.Stammdaten', 'DetailClientInfoController'),
                QMC.Inject('$qui', '$stateParams', 'UserService', 'QmcLanguageService')
            ], DetailClientInfoController);
            return DetailClientInfoController;
        }());
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        var DetailCommunicationController = /** @class */ (function () {
            /**
             * Creates an instance of DetailCommunicationController.
             *
             * @memberOf DetailCommunicationController
             */
            function DetailCommunicationController(stammdatenService, $qui, $stateParams, $scope, $state, lng, permissionService, userService, $timeout, $location, udfService) {
                var _this = this;
                this.stammdatenService = stammdatenService;
                this.$qui = $qui;
                this.$stateParams = $stateParams;
                this.$state = $state;
                this.lng = lng;
                this.userService = userService;
                this.$location = $location;
                this.allowTableExport = false;
                this.ui = new QMC.Stammdaten.DetailUI();
                this.enableDocuments = false;
                this.udfs = [];
                $scope.Model = $scope.Model || { Name: 'xxx' };
                this.id = $stateParams.id;
                switch (this.$location.$$path.split('/')[1]) {
                    case 'employee':
                        this.parentObjectType = 120000;
                        this.objectType = 120004;
                        this.documentObjectType = 120050;
                        break;
                    default:
                        this.parentObjectType = 140000;
                        this.objectType = 140023;
                        this.documentObjectType = 140118;
                        break;
                }
                permissionService.getPermissionsByObjectTypes([this.objectType, this.documentObjectType]).then(function (data) {
                    _this.delete = data[0].delete;
                    _this.new = data[0].new;
                    _this.modify = data[0].modify;
                    _this.moduleAccess = data[0].moduleAccess && data[0].view;
                    _this.allowTableExport = data[0].print;
                    _this.enableDocuments = data[1].moduleAccess;
                    $timeout(function () {
                        if (!_this.new)
                            document.getElementsByName('newModalButton').forEach(function (x) { return x.style.visibility = 'hidden'; });
                        else
                            document.getElementsByName('newModalButton').forEach(function (x) { return x.style.visibility = 'unset'; });
                    });
                    _this.getWv();
                    _this.userService.getUserSettings(["KOMMUNIKATION.ENABLE.EMAILSEND", "KOMMUNIKATION.ENABLE.TELCALL", "KOMMUNIKATION.ENABLE.URLOPEN"], false).then(function (data) {
                        _this.linkSetting = {
                            mail: data[0].value.toLowerCase() === 'true',
                            tele: data[1].value.toLowerCase() === 'true',
                            href: data[2].value.toLowerCase() === 'true'
                        };
                        _this.$qui.getTableAutoload(_this.userService).then(function (ltd) {
                            _this.shouldLoadTableData = ltd;
                            if (_this.shouldLoadTableData) {
                                _this.getData();
                            }
                        });
                    });
                });
                //$qui.init('stammdaten', () => {
                $qui.init($qui.getSectionColor("/stammdaten"), function () {
                    $qui.bindEvents();
                    $('.qm-card').unbind('click');
                });
                this.promptOptions = {
                    title: "Kommunikation",
                    yesNo: true,
                    icon: "qm-icon-history2",
                    text: this.lng.translate(20000290, 'Wollen Sie den Eintrag wirklich löschen?')
                };
                var vm = this;
                $("#edit-form").on('hidden.bs.modal', function () {
                    _this.$state.go('.', { dataId: undefined }, { reload: false });
                    $timeout(function () { return vm.initForm(); });
                    $("#edit-form").find('.tab-content').children().removeClass('in').removeClass('active');
                    $("#edit-form").find('.tab-content').find('#baseDataTab').addClass('in active');
                });
                udfService.getUserDefinedFields(this.objectType).then(function (data) {
                    _this.udfs = data.sort(function (a, b) { return a.caption.localeCompare(b.caption); });
                });
            }
            /**
             * init the form with default values
             *
             * @private
             *
             * @memberOf DetailCommunicationController
             */
            DetailCommunicationController.prototype.initForm = function () {
                this.formState = 'new';
                this.form = {
                    id: null,
                    objectId: null,
                    dateFrom: null,
                    dateTo: null,
                    targetAddress: null,
                    isMainRecord: true,
                    isTypeMain: true,
                    communicationCategoryId: null,
                    communicationTypeId: "53fd55a0-9efe-41aa-9099-5c3b7b4e972f",
                    communicationTypeName: null,
                    comment: null,
                    countryCode: null,
                    areaCode: null,
                    isDatatransferForbidden: false,
                    displayAddress: null,
                    objectType: this.objectType,
                    parentObjectType: this.parentObjectType
                };
                this.$qui.functionWaiter("ui.createForm", this);
            };
            DetailCommunicationController.prototype.getData = function () {
                this.getCommunications();
            };
            /////////////// SERVICE FUNCTIONS ///////////////
            /**
             * get the communication type list
             *
             * @private
             * @returns {ng.IPromise<any>}
             *
             * @memberOf DetailCommunicationController
             */
            DetailCommunicationController.prototype.getCommunicationTypeList = function () {
                return this.wvList.communicationTypeWvList.map(function (obj) {
                    return {
                        value: obj.objectId,
                        text: obj.name,
                        isFix: obj.isFix
                    };
                });
            };
            /**
             * get the communication category list
             *
             * @private
             * @param {Guid} id
             * @returns {ng.IPromise<any>}
             *
             * @memberOf DetailCommunicationController
             */
            DetailCommunicationController.prototype.getCommunicationCategoryList = function () {
                if (this.form.communicationCategoryName === "")
                    this.form.communicationCategoryId = null;
                for (var i = 0; i < this.wvList.communicationTypeWvList.length; i++) {
                    if (this.wvList.communicationTypeWvList[i].id === this.form.communicationTypeId) {
                        this.form.communicationTypeName = this.wvList.communicationTypeWvList[i].name.charAt(0).toLowerCase() + this.wvList.communicationTypeWvList[i].name.slice(1);
                        ;
                        break;
                    }
                }
                if (this.form.communicationTypeName !== (null || undefined || "") && this.wvList !== (null || undefined)) {
                    return this.wvList.communicationCategoryWvList[this.form.communicationTypeName].map(function (obj) {
                        return {
                            value: obj.id,
                            text: obj.name,
                            isFix: obj.isFix
                        };
                    });
                }
                else {
                    return null;
                }
            };
            /**
             * get the list of communications
             *
             * @private
             *
             * @memberOf DetailCommunicationController
             */
            DetailCommunicationController.prototype.getCommunications = function () {
                var _this = this;
                this.stammdatenService.getCommunicationList(this.id).then(function (data) {
                    data = data.map(function (obj) {
                        if (obj.isDatatransferForbidden)
                            obj.style = { 'background-color': 'orangered', 'color': 'white', 'font-weight': 'bold' };
                        switch (obj.communicationTypeId) {
                            case '930511d9-aa40-4927-b8b0-bbfc2e040de6': // fax
                            case '6729f858-ca6d-4efe-8397-376133a2d974': // telephon
                                obj.type = this.linkSetting.tele ? 'tel' : undefined;
                                break;
                            case 'f25005b8-3a66-4b36-9395-60ce7896f7d6': // website
                                obj.type = this.linkSetting.href ? 'site' : undefined;
                                break;
                            case '53fd55a0-9efe-41aa-9099-5c3b7b4e972f': // email
                                obj.type = this.linkSetting.mail ? 'mail' : undefined;
                                break;
                        }
                        return obj;
                    }.bind(_this));
                    _this.ui.communicationTable.data = data;
                    _this.$qui.functionWaiter("ui.createTable", _this);
                    _this.loading = false;
                    if (_this.$stateParams.dataId) {
                        var item = data.filter(function (x) { return x.objectId === _this.$stateParams.dataId; })[0];
                        if (item) {
                            $("#edit-form").modal('show');
                            _this.editCommunication(item);
                        }
                    }
                });
            };
            /**
             * get the wv list
             *
             * @private
             *
             * @memberOf DetailCommunicationController
             */
            DetailCommunicationController.prototype.getWv = function () {
                var _this = this;
                this.stammdatenService.getCommunicationWv().then(function (data) {
                    _this.wvList = data;
                    _this.initForm();
                    _this.$qui.functionWaiter("ui.createForm", _this);
                });
            };
            /**
             * add a communication
             *
             * @private
             * @param {ICommunication} form
             *
             * @memberOf DetailCommunicationController
             */
            DetailCommunicationController.prototype.addCommunication = function (form) {
                var _this = this;
                this.loading = true;
                form.parentObjectId = this.id;
                this.stammdatenService.postCommunication(form).then(function () {
                    _this.ui.notify(_this.ui.successNote);
                    _this.formState = "new";
                    _this.getCommunications();
                    $('#edit-form').modal('hide');
                });
            };
            /**
             * put an existing communication
             *
             * @private
             * @param {ICommunication} form
             *
             * @memberOf DetailCommunicationController
             */
            DetailCommunicationController.prototype.putCommunication = function () {
                var _this = this;
                this.loading = true;
                this.stammdatenService.putCommunication(this.form.parentObjectId, this.form.objectId, this.form).then(function () {
                    _this.ui.notify(_this.ui.successNote);
                    _this.getCommunications();
                    _this.formState = "new";
                    $('#edit-form').modal('hide');
                });
                this.udfs.forEach(function (x) { var _a; return (_a = x.save) === null || _a === void 0 ? void 0 : _a.call(x, false); });
            };
            /**
             * delete an existing communication
             *
             * @private
             * @param {ICommunication} data
             *
             * @memberOf DetailCommunicationController
             */
            DetailCommunicationController.prototype.deleteCommunication = function (item) {
                var _this = this;
                this.promptOptions.itemText = item.communicationCategoryName.length > 0 ? item.communicationCategoryName + ": " + item.targetAddress : item.targetAddress;
                QMC.Common.Utilities.confirm(this.promptOptions, function (data) {
                    if (data)
                        _this.stammdatenService.deleteCommunication(_this.id, item.objectId).then(function () {
                            _this.ui.notify(_this.ui.deleteNote);
                            _this.formState = "new";
                            _this.getCommunications();
                        });
                });
            };
            /**
             * edit an existing communication
             *
             * @private
             * @param {ICommunication} data
             *
             * @memberOf DetailCommunicationController
             */
            DetailCommunicationController.prototype.editCommunication = function (data) {
                if (data.communicationCategoryName === "")
                    data.communicationCategoryId = null;
                this.formState = "edit";
                this.form = data;
                this.$qui.waitForEl('#standardTabButton', function () {
                    $('#standardTabButton').click();
                });
                this.$state.go('.', { dataId: data.objectId });
            };
            DetailCommunicationController = __decorate([
                QMC.Controller('QMC.Stammdaten', 'DetailCommunicationController'),
                QMC.Inject('StammdatenService', '$qui', '$stateParams', '$scope', '$state', 'QmcLanguageService', 'QmcPermissionService', 'UserService', '$timeout', '$location', 'QmcUdfService')
            ], DetailCommunicationController);
            return DetailCommunicationController;
        }());
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        var DetailContactPersonController = /** @class */ (function () {
            /**
             * Creates an instance of DetailContactPersonController.
             *
             * @memberOf DetailContactPersonController
             */
            function DetailContactPersonController(stammdatenService, $qui, $stateParams, $scope, $state, lng, permissionService, userService, $timeout, $location, udfService) {
                var _this = this;
                this.stammdatenService = stammdatenService;
                this.$qui = $qui;
                this.$stateParams = $stateParams;
                this.$scope = $scope;
                this.$state = $state;
                this.lng = lng;
                this.userService = userService;
                this.$location = $location;
                this.allowTableExport = false;
                this.ui = new Stammdaten.DetailUI();
                this.selectedCategoryId = QMC.Common.Constants.GUID_EMPTY;
                this.addressLoading = false;
                //communication
                this.communicationLoading = false;
                this.enableDocuments = false;
                this.udfs = [];
                this.id = $stateParams.id;
                switch (this.$location.$$path.split('/')[1]) {
                    case 'employee':
                        this.parentObjectType = 120000;
                        this.objectType = 120012;
                        this.documentObjectType = 0;
                        break;
                    default:
                        this.parentObjectType = 140000;
                        this.objectType = 140006;
                        this.documentObjectType = 140119;
                        break;
                }
                this.adrObjectType = this.objectType === 140006 ? 140017 : 120014;
                this.comObjectType = this.objectType === 140006 ? 140028 : 120013;
                permissionService.getPermissionsByObjectTypes([this.objectType, this.adrObjectType, this.comObjectType, this.documentObjectType]).then(function (data) {
                    _this.delete = data[0].delete;
                    _this.new = data[0].new;
                    _this.modify = data[0].modify;
                    _this.moduleAccess = data[0].moduleAccess && data[0].view;
                    _this.allowTableExport = data[0].print;
                    _this.enableDocuments = data[3].moduleAccess;
                    $timeout(function () {
                        if (!_this.new)
                            document.getElementsByName('newModalButton').forEach(function (x) { return x.style.visibility = 'hidden'; });
                        else
                            document.getElementsByName('newModalButton').forEach(function (x) { return x.style.visibility = 'unset'; });
                    });
                    for (var _i = 0, data_2 = data; _i < data_2.length; _i++) {
                        var permission = data_2[_i];
                        if (permission.objectType === _this.adrObjectType) {
                            _this.deleteAdr = permission.delete;
                            _this.newAdr = permission.new;
                            _this.modifyAdr = permission.modify;
                            _this.moduleAccessAdr = permission.moduleAccess && permission.view;
                        }
                        if (permission.objectType === _this.comObjectType) {
                            _this.deleteCom = permission.delete;
                            _this.newCom = permission.new;
                            _this.modifyCom = permission.modify;
                            _this.moduleAccessCom = permission.moduleAccess && permission.view;
                        }
                    }
                    _this.userService.getUserSettings(["KOMMUNIKATION.ENABLE.EMAILSEND", "KOMMUNIKATION.ENABLE.TELCALL", "KOMMUNIKATION.ENABLE.URLOPEN"], false).then(function (data) {
                        _this.linkSetting = {
                            mail: data[0].value.toLowerCase() === 'true',
                            tele: data[1].value.toLowerCase() === 'true',
                            href: data[2].value.toLowerCase() === 'true'
                        };
                        _this.getWvList();
                        _this.getCategories();
                    });
                });
                $qui.init($qui.getSectionColor("/stammdaten"), function () {
                    $qui.bindEvents();
                    $('.qm-card').unbind('click');
                });
                this.lang = lng;
                this.promptOptions = {
                    title: this.lang.translate(20004502, "Kontaktpersonen löschen"),
                    yesNo: true,
                    icon: "qm-icon-history2",
                    text: this.lang.translate(20000290, "Wollen Sie den Eintrag wirklich löschen?")
                };
                var vm = this;
                $("#edit-form").on('hidden.bs.modal', function () {
                    _this.$state.go('.', { dataId: undefined }, { reload: false });
                    $timeout(function () { return vm.initForm(); });
                    $("#edit-form").find('.tab-content').children().removeClass('in').removeClass('active');
                    $("#edit-form").find('.tab-content').find('#baseDataTab').addClass('in active');
                });
                udfService.getUserDefinedFields(this.objectType).then(function (data) {
                    _this.udfs = data.sort(function (a, b) { return a.caption.localeCompare(b.caption); });
                });
            }
            /////////////// DISPLAY LOGIC ///////////////
            /**
             * init the form with default values
             *
             * @private
             *
             * @memberOf DetailContactPersonController
             */
            DetailContactPersonController.prototype.initForm = function () {
                this.formState = "new";
                this.form = {
                    id: null,
                    objectId: null,
                    objectType: this.objectType,
                    name: null,
                    forename: null,
                    birthday: new Date(1990, 1, 1),
                    birthplace: null,
                    dateFrom: new Date(),
                    dateTo: null,
                    salutationId: null,
                    titleId: null,
                    secondTitleId: null,
                    contactPersonTypeId: null,
                    contactPersonType: '',
                    comment: null,
                    isContactBan: false,
                    parentObjectType: this.parentObjectType,
                    isContactBanText: 'Nein'
                };
                this.loading = false;
                this.$qui.functionWaiter("ui.createForm", this);
            };
            DetailContactPersonController.prototype.getData = function () {
                this.getContacts();
            };
            /////////////// SERVICE FUNCTIONS ///////////////
            /**
             * get the wv list for communication and address
             *
             * @private
             *
             * @memberOf DetailContactPersonController
             */
            DetailContactPersonController.prototype.getWvList = function () {
                var _this = this;
                this.stammdatenService.getContactPersonWvList().then(function (data) {
                    _this.wvList = data;
                    _this.initForm();
                    _this.$qui.functionWaiter("createForm", _this);
                    _this.selectedContactPersonStatusId = _this.wvList.contactPersonStatusWvList[0].objectId;
                    _this.contactPersonStatusMap = _this.$qui.selectAutoMap(_this.wvList.contactPersonStatusWvList, 'id', 'name');
                    _this.$qui.getTableAutoload(_this.userService).then(function (ltd) {
                        _this.shouldLoadTableData = ltd;
                        if (_this.shouldLoadTableData) {
                            _this.getData();
                        }
                    });
                });
                this.stammdatenService.getCommunicationWv().then(function (data) {
                    _this.communicationWv = data;
                });
                this.stammdatenService.getAddressWv().then(function (data) {
                    _this.addressWv = data;
                });
                this.$scope.$watch('vm.selectedCategoryId', function (newVal, oldVal) {
                    if (newVal === oldVal)
                        return;
                    _this.getContacts();
                });
                this.$scope.$watch('vm.selectedContactPersonStatusId', function (newVal, oldVal) {
                    if (newVal === oldVal)
                        return;
                    _this.getContacts();
                });
            };
            /**
             * get the contact person type list
             *
             * @private
             * @returns {*}
             *
             * @memberOf DetailContactPersonController
             */
            DetailContactPersonController.prototype.getContactPersonTypeList = function () {
                return this.wvList.contactPersonTypeWvList.map(function (obj) {
                    return {
                        value: obj.id,
                        text: obj.name,
                        isFix: obj.isFix,
                    };
                });
            };
            /**
             * get the gender wv list
             *
             * @private
             * @returns {ISelectListItem[]}
             *
             * @memberOf DetailContactPersonController
             */
            DetailContactPersonController.prototype.getGenderList = function () {
                return this.wvList.genderWvList.map(function (obj) {
                    return {
                        value: obj.id,
                        text: obj.name,
                        isFix: obj.isFix
                    };
                });
            };
            /**
             * get the salutaion wv list
             *
             * @private
             * @returns {*}
             *
             * @memberOf DetailContactPersonController
             */
            DetailContactPersonController.prototype.getSalutationList = function () {
                var _this = this;
                if (this.wvList === undefined) {
                    return this.stammdatenService.getContactPersonWvList().then(function (data) {
                        _this.wvList = data;
                        return _this.wvList.salutationWvList.map(function (obj) {
                            return {
                                value: obj.id,
                                text: obj.name,
                                isFix: obj.isFix
                            };
                        });
                    });
                }
                else
                    return this.wvList.salutationWvList.map(function (obj) {
                        return {
                            value: obj.id,
                            text: obj.name,
                            isFix: obj.isFix
                        };
                    });
            };
            /**
             * get the title wv list
             *
             * @private
             * @returns {*}
             *
             * @memberOf DetailContactPersonController
             */
            DetailContactPersonController.prototype.getTitleList = function () {
                var _this = this;
                if (this.wvList === undefined) {
                    return this.stammdatenService.getContactPersonWvList().then(function (data) {
                        _this.wvList = data;
                        return _this.wvList.titleWvList.map(function (obj) {
                            return {
                                value: obj.id,
                                text: obj.name,
                                isFix: obj.isFix
                            };
                        });
                    });
                }
                else
                    return this.wvList.titleWvList.map(function (obj) { return ({
                        value: obj.id,
                        text: obj.name,
                        isFix: obj.isFix
                    }); });
            };
            DetailContactPersonController.prototype.getSecondTitleList = function () {
                if (!this.wvList)
                    return [];
                return this.wvList.secondTitleWvList.map(function (x) { return ({ text: x.name, value: x.objectId }); });
            };
            DetailContactPersonController.prototype.getCategories = function () {
                var _this = this;
                this.stammdatenService.getContactPersonCategories().then(function (data) {
                    _this.categoryList = data;
                    _this.categoryListMap = _this.$qui.selectAutoMap(data, 'id', 'caption');
                    _this.categoryListMap.unshift({ text: _this.lng.translate(20000212, '- Alle -'), value: QMC.Common.Constants.GUID_EMPTY });
                });
            };
            DetailContactPersonController.prototype.setCategoryFilter = function (categoryId) {
            };
            /**
             * get the list of contacts
             *
             * @private
             *
             * @memberOf DetailContactPersonController
             */
            DetailContactPersonController.prototype.getContacts = function () {
                var _this = this;
                this.loading = true;
                this.stammdatenService.getContactPersonList(this.id, this.selectedCategoryId, this.selectedContactPersonStatusId).then(function (data) {
                    _this.loading = false;
                    // ugly way to catch minDate from DB. this is done to decide if any birthday should be displayed at all
                    for (var _i = 0, data_3 = data; _i < data_3.length; _i++) {
                        var contact = data_3[_i];
                        if (contact.isContactBan) {
                            contact.style = { 'background-color': 'orangered', 'color': 'white', 'font-weight': 'bold' };
                        }
                        if (contact.birthday !== null)
                            if (contact.birthday.toString().substr(0, 19) === "1900-01-01T12:00:00")
                                contact.birthday = null;
                        switch (contact.mainCommunicationTypeId) {
                            case '930511d9-aa40-4927-b8b0-bbfc2e040de6': // fax
                            case '6729f858-ca6d-4efe-8397-376133a2d974': // telephon
                                contact.type = _this.linkSetting.tele ? 'tel' : undefined;
                                break;
                            case 'f25005b8-3a66-4b36-9395-60ce7896f7d6': // website
                                contact.type = _this.linkSetting.href ? 'site' : undefined;
                                break;
                            case '53fd55a0-9efe-41aa-9099-5c3b7b4e972f': // email
                                contact.type = _this.linkSetting.mail ? 'mail' : undefined;
                                break;
                        }
                    }
                    _this.ui.contactPersonTable.data = data;
                    _this.$qui.functionWaiter("createTable", _this);
                    if (_this.$stateParams.dataId) {
                        var item = data.filter(function (x) { return x.objectId === _this.$stateParams.dataId; })[0];
                        if (item) {
                            $("#edit-form").modal('show');
                            _this.editContact(item);
                        }
                    }
                });
            };
            /**
             * add a new contact person
             *
             * @private
             * @param {IContactPerson} form
             *
             * @memberOf DetailContactPersonController
             */
            DetailContactPersonController.prototype.addContact = function (form) {
                var _this = this;
                this.loading = true;
                form.parentObjectId = this.id;
                this.stammdatenService.postContactPerson(form).then(function (e) {
                    _this.formState = "new";
                    _this.ui.notify(_this.ui.successNote);
                    _this.getContacts();
                    $('#edit-form').modal('hide');
                });
            };
            /**
             * put a existing contact person
             *
             * @private
             * @param {IContactPerson} form
             *
             * @memberOf DetailContactPersonController
             */
            DetailContactPersonController.prototype.putContact = function (form) {
                var _this = this;
                this.loading = true;
                this.stammdatenService.putContactPerson(this.id, form.objectId, form).then(function (data) {
                    _this.formState = "new";
                    _this.ui.notify(_this.ui.successNote);
                    _this.getContacts();
                    $('#edit-form').modal('hide');
                });
                this.udfs.forEach(function (x) { var _a; return (_a = x.save) === null || _a === void 0 ? void 0 : _a.call(x, false); });
            };
            /**
             * delete a existing contact person
             *
             * @private
             * @param {IContactPerson} data
             *
             * @memberOf DetailContactPersonController
             */
            DetailContactPersonController.prototype.deleteContact = function (item) {
                var _this = this;
                this.promptOptions.title = this.lang.translate(20004502, "Kontaktpersonen löschen");
                this.promptOptions.itemText = item.contactPersonType.length > 0
                    ? item.name + ", " + item.forename + " (" + item.contactPersonType + ")"
                    : item.name + ", " + item.forename;
                QMC.Common.Utilities.confirm(this.promptOptions, function (data) {
                    if (data) {
                        _this.validation = {
                            loading: true,
                            warnings: [],
                            errors: [],
                            reference: item
                        };
                        $('#validationModal').modal('show');
                        _this.stammdatenService.validateContactPersonDeletion(item.id, item.objectId).then(function (data) {
                            var _a;
                            console.log(data);
                            _this.validation.errors = data.errors;
                            _this.validation.warnings = data.warnings;
                            if (!((_a = data.errors) === null || _a === void 0 ? void 0 : _a.length) && !data.warnings.length) {
                                _this.performDeletion();
                                $('#validationModal').modal('hide');
                            }
                        }).catch(function () {
                            _this.validation.errors = [_this.lng.translate(20000328, 'Die Validierung konnte nicht durchgeführt werden!')];
                        }).finally(function () {
                            _this.validation.loading = false;
                        });
                    }
                });
            };
            DetailContactPersonController.prototype.performDeletion = function () {
                var _this = this;
                this.stammdatenService.deleteContactPerson(this.id, this.validation.reference.objectId).then(function (data) {
                    _this.ui.notify(_this.ui.deleteNote);
                    _this.getContacts();
                });
            };
            /**
             * show the details of an contact person
             *
             * @private
             * @param {IContactPerson} data
             *
             * @memberOf DetailContactPersonController
             */
            DetailContactPersonController.prototype.showDetailContact = function (data) {
                this.currentPerson = data.forename + " " + data.name;
                this.formState = "new";
                this.showDetail = true;
                this.setupAddress(data.objectId);
                this.setupCommunication(data.objectId);
            };
            /**
             * edit a existing contact person
             *
             * @private
             * @param {IContactPerson} data
             *
             * @memberOf DetailContactPersonController
             */
            DetailContactPersonController.prototype.editContact = function (data) {
                this.formState = "edit";
                this.form = angular.copy(data);
                this.form.dateFrom = moment(data.dateFrom).toDate();
                if (this.form.birthday !== null)
                    this.form.birthday = moment(data.birthday).toDate();
                if (data.dateTo !== null)
                    this.form.dateTo = moment(data.dateTo).toDate();
                this.$qui.waitForEl('#standardTabButton', function () {
                    $('#standardTabButton').click();
                });
                this.$state.go('.', { dataId: data.objectId });
            };
            /////////////// ADDRESS FUNCTIONS ///////////////
            /**
             * setup address for a contact person
             *
             * @private
             * @param {Guid} id
             *
             * @memberOf DetailContactPersonController
             */
            DetailContactPersonController.prototype.setupAddress = function (id) {
                this.addressLoading = true;
                this.getAddresses(id);
                this.getAddressWv(id);
            };
            /**
             * init the address form with default values
             *
             * @private
             * @param {Guid} id
             *
             * @memberOf DetailContactPersonController
             */
            DetailContactPersonController.prototype.initAddressForm = function (id) {
                var _this = this;
                this.addressForm = {
                    id: null,
                    objectId: null,
                    objectType: this.adrObjectType,
                    parentObjectId: id,
                    parentObjectType: this.objectType,
                    street: null,
                    houseNumber: null,
                    addressAddition: null,
                    postCode: null,
                    city: null,
                    dateFrom: new Date(),
                    dateTo: null,
                    objectIdCountry: QMC.Common.Constants.DEFAULT_COUNTRY_ID,
                    objectIdState: null,
                    objectIdAddressType: null,
                    isMainRecord: true,
                    isPostOfficeBox: false,
                    isHouseless: false,
                    comment: null,
                    isDatatransferForbidden: false,
                    isEmergency: false
                };
                //this is for a pull request change
                this.createAddressForm();
                setTimeout(function () {
                    _this.addressEvents();
                }, 200);
            };
            /**
             * view events for the address form
             *
             * @private
             *
             * @memberOf DetailContactPersonController
             */
            DetailContactPersonController.prototype.addressEvents = function () {
                /**
                 * Address Autocomplete
                 */
                var vm = this;
                $('#city .typeahead').typeahead({
                    minLength: 3,
                    source: function (query, process) {
                        vm.stammdatenService.getPostCodeByCityList(vm.addressForm.objectIdCountry, query).then(function (data) {
                            process(data.map(function (obj) {
                                return obj.postCodeAndCity;
                            }));
                        });
                    },
                    updater: function (item) {
                        var data = item.split('...');
                        vm.addressForm.postCode = data[0];
                        $('#postCode input').val(data[0]).trigger('change');
                        return data[1];
                    }
                });
                $('#postCode .typeahead').typeahead({
                    minLength: 3,
                    source: function (query, process) {
                        vm.stammdatenService.getCityByPostCodeList(vm.addressForm.objectIdCountry, query).then(function (data) {
                            process(data.map(function (obj) {
                                return obj.postCodeAndCity;
                            }));
                        });
                    },
                    updater: function (item) {
                        var data = item.split('...');
                        vm.addressForm.city = data[1];
                        $('#city input').val(data[1]).trigger('change');
                        return data[0];
                    }
                });
            };
            /**
             * get the address wv list
             * @description get the wv list of address.
             * @private
             * @param {any} id
             *
             * @memberOf DetailContactPersonController
             */
            DetailContactPersonController.prototype.getAddressWv = function (id) {
                var _this = this;
                this.stammdatenService.getAddressWv().then(function (data) {
                    _this.addressWv = data;
                });
                // call init address form
                this.initAddressForm(id);
            };
            /**
             * Get the State list, by country id
             * @description get the state list
             * @private
             * @param {any} id
             *
             * @memberOf DetailContactPersonController
             */
            DetailContactPersonController.prototype.getStates = function () {
                var _this = this;
                this.stateList = null;
                this.stammdatenService.getStatesWv(this.addressForm.objectIdCountry).then(function (data) {
                    _this.stateList = data.map(function (obj) {
                        return {
                            id: obj.id,
                            text: obj.caption
                        };
                    });
                    if (_this.stateList.length < 1) {
                        _this.stateList = null;
                        _this.addressForm.objectIdState = null;
                    }
                });
            };
            /**
             * get the address type list
             * @description get the addres type list
             * @private
            * @returns {ng.IPromise<ISelectListItem[]>}
             *
             * @memberOf DetailContactPersonController
             */
            DetailContactPersonController.prototype.getAdressTypeList = function () {
                return this.stammdatenService.getAddressWv().then(function (data) {
                    return data.addressTypeWvList.map(function (obj) {
                        return {
                            value: obj.objectId,
                            text: obj.name
                        };
                    });
                });
            };
            /**
             * get the country wv list
             *
             * @private
             * @returns {ng.IPromise<any>}
             *
             * @memberOf DetailContactPersonController
             */
            DetailContactPersonController.prototype.getCountryList = function () {
                var _this = this;
                return this.stammdatenService.getAddressWv().then(function (data) {
                    return _this.ui.select(data.countriesWvList, { value: "objectId", text: "name" });
                });
            };
            /**
             * get the state list by country id
             *
             * @private
             * @param {Guid} id
             * @returns {ng.IPromise<any>}
             *
             * @memberOf DetailContactPersonController
             */
            DetailContactPersonController.prototype.getStatesList = function (id) {
                var _this = this;
                //Use the id from form as hotfix, since the provided id is always undefined
                //return this.stammdatenService.getStatesWv(id).then((data: IStatesWv[]) => {
                return this.stammdatenService.getStatesWv(this.addressForm.objectIdCountry).then(function (data) {
                    return _this.ui.select(data, { value: "id", text: "caption" });
                });
            };
            /**
             * create a empty address form
             *
             * @private
             * @param {ICommunication} data
             *
             * @memberOf DetailContactPersonController
             */
            DetailContactPersonController.prototype.newAddress = function (data) {
                this.initAddressForm(data.objectId);
            };
            /**
             * add a new address
             *
             * @private
             * @param {IAddress} form
             *
             * @memberOf DetailContactPersonController
             */
            DetailContactPersonController.prototype.addAddress = function (form) {
                var _this = this;
                this.stammdatenService.postAddress(form).then(function (e) {
                    _this.getAddresses(form.parentObjectId);
                    _this.ui.notify(_this.ui.successNote, 'Ihre Adresse wurde gespeichert');
                    _this.formState = "new";
                });
            };
            /**
             * delete an existing address
             *
             * @private
             * @param {IAddress} form
             *
             * @memberOf DetailContactPersonController
             */
            DetailContactPersonController.prototype.deleteAdress = function (form) {
                var _this = this;
                this.promptOptions.title = this.lang.translate(20003503, "Addresse löschen");
                QMC.Common.Utilities.confirm(this.promptOptions, function (data) {
                    if (data)
                        _this.stammdatenService.deleteAddress(form.parentObjectId, form.objectId).then(function (data) {
                            _this.getAddresses(form.parentObjectId);
                            _this.ui.notify(_this.ui.deleteNote);
                            _this.formState = "new";
                        });
                });
            };
            /**
             * edit an existing address
             *
             * @private
             * @param {IAddress} address
             *
             * @memberOf DetailContactPersonController
             */
            DetailContactPersonController.prototype.editAdress = function (address) {
                this.addressForm = angular.copy(address);
                this.formState = "edit";
                this.addressForm.dateFrom = moment(address.dateFrom).toDate();
                if (this.addressForm.dateTo !== null)
                    this.addressForm.dateTo = moment(address.dateTo).toDate();
            };
            /**
             * put a existing address
             *
             * @private
             * @param {IAddress} form
             *
             * @memberOf DetailContactPersonController
             */
            DetailContactPersonController.prototype.putAddress = function (form) {
                var _this = this;
                this.stammdatenService.putAddress(form.parentObjectId, form.objectId, form).then(function (data) {
                    _this.getAddresses(form.parentObjectId);
                    _this.ui.notify(_this.ui.successNote);
                    _this.formState = "new";
                });
            };
            /**
             * get the list of addresses for a contact person
             *
             * @private
             * @param {Guid} id
             *
             * @memberOf DetailContactPersonController
             */
            DetailContactPersonController.prototype.getAddresses = function (id) {
                var _this = this;
                this.stammdatenService.getAddressList(id).then(function (data) {
                    data = data.map(function (obj) {
                        if (obj.isDatatransferForbidden)
                            obj.style = { 'background-color': 'orangered', 'color': 'white', 'font-weight': 'bold' };
                        return obj;
                    });
                    _this.ui.contactPersonAddressTable.data = data;
                    _this.createAddressTable();
                    _this.getData(); //Daten (Kontakte) müssen auch geholt werden, auch wenn Adressen (noch) nicht in der Table angezeigt werden
                    _this.addressLoading = false;
                });
            };
            /////////////// COMMUNICATION FUNCTIONS ///////////////
            /**
             * get the list of communications for a contact person
             *
             * @private
             * @param {Guid} id
             *
             * @memberOf DetailContactPersonController
             */
            DetailContactPersonController.prototype.getCommunications = function (id) {
                var _this = this;
                this.stammdatenService.getCommunicationList(id).then(function (data) {
                    data = data.map(function (obj) {
                        if (obj.isDatatransferForbidden)
                            obj.style = { 'background-color': 'orangered', 'color': 'white', 'font-weight': 'bold' };
                        switch (obj.communicationTypeId) {
                            case '930511d9-aa40-4927-b8b0-bbfc2e040de6': // fax
                            case '6729f858-ca6d-4efe-8397-376133a2d974': // telephon
                                obj.type = _this.linkSetting.tele ? 'tel' : undefined;
                                break;
                            case 'f25005b8-3a66-4b36-9395-60ce7896f7d6': // website
                                obj.type = _this.linkSetting.href ? 'site' : undefined;
                                break;
                            case '53fd55a0-9efe-41aa-9099-5c3b7b4e972f': // email
                                obj.type = _this.linkSetting.mail ? 'mail' : undefined;
                                break;
                        }
                        return obj;
                    });
                    _this.ui.contactpersonCommunicationTable.data = data;
                    _this.createCommunicationTable();
                    _this.getData(); //Daten (Kontakte) müssen neu geladen werden
                    _this.communicationLoading = false;
                });
            };
            /**
             * get the communication type list
             *
             * @private
             * @returns {ng.IPromise<ISelectItem[]>}
             *
             * @memberOf DetailContactPersonController
             */
            DetailContactPersonController.prototype.getCommunicationTypeList = function () {
                var _this = this;
                return this.stammdatenService.getCommunicationWv().then(function (data) {
                    _this.communicationWv = data;
                    return _this.communicationWv.communicationTypeWvList.map(function (obj) {
                        return {
                            value: obj.objectId,
                            text: obj.name,
                            isFix: obj.isFix
                        };
                    });
                });
            };
            /**
             * get the communication category wv list
             *
             * @private
             * @param {Guid} id
             * @returns {QMC.Common.ISelectItem[]}
             *
             * @memberOf DetailContactPersonController
             */
            DetailContactPersonController.prototype.getCommunicationCategoryList = function (id) {
                var _a, _b;
                if (this.communicationWv === undefined)
                    return null;
                for (var _i = 0, _c = this.communicationWv.communicationTypeWvList; _i < _c.length; _i++) {
                    var wv = _c[_i];
                    if (wv.id === this.communicationForm.communicationTypeId) {
                        console.log("id", wv.id);
                        this.communicationForm.communicationTypeName = wv.name.charAt(0).toLowerCase() + wv.name.slice(1);
                        break;
                    }
                }
                if (((_a = this.communicationForm.communicationTypeName) === null || _a === void 0 ? void 0 : _a.length) && this.communicationWv) {
                    return (_b = this.communicationWv.communicationCategoryWvList[this.communicationForm.communicationTypeName]) === null || _b === void 0 ? void 0 : _b.map(function (obj) {
                        return {
                            value: obj.id,
                            text: obj.name,
                            isFix: obj.isFix
                        };
                    });
                }
            };
            /**
             * set up a new communication form
             *
             * @private
             * @param {Guid} id
             *
             * @memberOf DetailContactPersonController
             */
            DetailContactPersonController.prototype.setupCommunication = function (id) {
                this.getCommunications(id);
                this.getCommunicationWv(id);
            };
            /**
             * get the communication wv list
             *
             * @private
             * @param {Guid} id
             *
             * @memberOf DetailContactPersonController
             */
            DetailContactPersonController.prototype.getCommunicationWv = function (id) {
                var _this = this;
                this.stammdatenService.getCommunicationWv().then(function (data) {
                    //window.scrollTo(0, document.body.scrollHeight);
                    var element = $("#scrollTarget");
                    $("html, body").animate({ scrollTop: $("#scrollTarget").last().offset().top }, 1000);
                    _this.communicationWv = data;
                    _this.initCommunicationForm(id);
                });
            };
            /**
             * init the communication form with default values
             *
             * @private
             * @param {Guid} id
             *
             * @memberOf DetailContactPersonController
             */
            DetailContactPersonController.prototype.initCommunicationForm = function (id) {
                this.communicationForm = {
                    id: null,
                    objectId: null,
                    objectType: this.comObjectType,
                    parentObjectId: id,
                    parentObjectType: this.objectType,
                    dateFrom: null,
                    dateTo: null,
                    targetAddress: null,
                    isMainRecord: true,
                    isTypeMain: true,
                    communicationCategoryId: null,
                    communicationTypeId: "53fd55a0-9efe-41aa-9099-5c3b7b4e972f",
                    communicationTypeName: null,
                    comment: null,
                    countryCode: null,
                    areaCode: null,
                    displayAddress: '',
                    isDatatransferForbidden: false
                };
                this.createCommunicationForm();
            };
            /**
             * init a new communication form
             *
             * @private
             * @param {ICommunicationWv} data
             *
             * @memberOf DetailContactPersonController
             */
            DetailContactPersonController.prototype.newCommunication = function (data) {
                this.initCommunicationForm(data.objectId);
            };
            /**
             * add a new communication
             *
             * @private
             * @param {ICommunication} form
             *
             * @memberOf DetailContactPersonController
             */
            DetailContactPersonController.prototype.addCommunication = function (form) {
                var _this = this;
                this.stammdatenService.postCommunication(this.communicationForm).then(function (data) {
                    _this.getCommunications(form.parentObjectId);
                    _this.ui.notify(_this.ui.successNote, _this.lng.translate(20000291, 'Der Eintrag wurde gespeichert.'));
                    _this.formState = "new";
                });
            };
            /**
             * delete a existing communication
             *
             * @private
             * @param {ICommunication} data
             *
             * @memberOf DetailContactPersonController
             */
            DetailContactPersonController.prototype.deleteCommunication = function (datas) {
                var _this = this;
                this.promptOptions.title = this.lang.translate(20005503, "Kommunikation löschen");
                QMC.Common.Utilities.confirm(this.promptOptions, function (data) {
                    if (data)
                        _this.stammdatenService.deleteCommunication(datas.parentObjectId, datas.objectId).then(function (data) {
                            _this.getCommunications(datas.parentObjectId);
                            _this.ui.notify(_this.ui.deleteNote);
                            _this.formState = "new";
                        });
                });
            };
            /**
             * edit a existing communication
             *
             * @private
             * @param {ICommunication} data
             *
             * @memberOf DetailContactPersonController
             */
            DetailContactPersonController.prototype.editCommunication = function (data) {
                this.formState = "edit";
                this.communicationForm = angular.copy(data);
            };
            /**
             * put a existing communication
             *
             * @private
             * @param {ICommunication} form
             *
             * @memberOf DetailContactPersonController
             */
            DetailContactPersonController.prototype.putCommunication = function (form) {
                var _this = this;
                this.stammdatenService.putCommunication(form.parentObjectId, form.objectId, form).then(function (data) {
                    _this.getCommunications(form.parentObjectId);
                    _this.ui.notify(_this.ui.successNote);
                    _this.formState = "new";
                });
            };
            DetailContactPersonController = __decorate([
                QMC.Controller('QMC.Stammdaten', 'DetailContactPersonController'),
                QMC.Inject('StammdatenService', '$qui', '$stateParams', '$scope', '$state', 'QmcLanguageService', 'QmcPermissionService', 'UserService', '$timeout', '$location', 'QmcUdfService')
            ], DetailContactPersonController);
            return DetailContactPersonController;
        }());
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        var DetailCoverController = /** @class */ (function () {
            /**
             * Creates an instance of DetailNoteController.
             * @param {StammdatenService} stammdatenService
             * @param {any} $qui
             * @param {any} $state
             * @param {any} $stateParams
             * @param {any} $scope
             *
             * @memberOf DetailCoverController
             */
            function DetailCoverController($qui, $stateParams, $scope, lng, reportingService, userService, $location) {
                var _this = this;
                this.$qui = $qui;
                this.$scope = $scope;
                this.lng = lng;
                this.reportingService = reportingService;
                this.userService = userService;
                this.$location = $location;
                this.loading = {
                    report: false
                };
                this.coverCacheName = QMC.Common.LocalStorageConstants.CLIENT_COVER;
                this.invalidCover = false;
                this.clientCoverReportTemplates = [];
                this.clientCoverReportTemplatesMap = [];
                this.clientCoverTemplate = QMC.Common.Constants.GUID_EMPTY;
                this.id = $stateParams.id;
                this.$qui.waitForEl('#newModalButton', function () {
                    document.getElementsByName('newModalButton').forEach(function (x) { return x.style.visibility = 'hidden'; });
                });
                switch (this.$location.$$path.split('/')[1]) {
                    case 'employee':
                        this.objectType = 120000;
                        this.coverCacheName = 'EmployeeCover';
                        break;
                    default:
                        this.objectType = 140000;
                        this.coverCacheName = QMC.Common.LocalStorageConstants.CLIENT_COVER;
                        break;
                }
                this.userService.getCoverReportTemplates(this.objectType).then(function (list) {
                    for (var _i = 0, list_1 = list; _i < list_1.length; _i++) {
                        var item = list_1[_i];
                        var reportItem = {
                            id: item.id,
                            objectId: item.objectId,
                            name: item.name,
                            reportType: item.reportType,
                            reportTypeName: _this.getReportTypeCaption(item.reportType)
                        };
                        _this.clientCoverReportTemplates.push(reportItem);
                    }
                    _this.clientCoverReportTemplatesMap = list.map(function (x) { return { text: x.name, value: x.objectId, group: _this.getReportTypeCaption(x.reportType) }; });
                    if (_this.clientCoverReportTemplatesMap.length === 1)
                        _this.clientCoverTemplate = _this.clientCoverReportTemplatesMap[0].value;
                    var cache = localStorage.getItem(_this.coverCacheName);
                    if (cache && cache !== null && cache !== undefined) {
                        var parsedCache = JSON.parse(cache);
                        if (parsedCache.reference === _this.id && moment(parsedCache.timestamp).isAfter(moment().subtract(5, 'minutes'))) {
                            _this.setReportFromResult(parsedCache, parsedCache.reportType);
                        }
                        _this.clientCoverTemplate = parsedCache.reportTemplateId;
                    }
                    else {
                        _this.getReportIdAndExecute();
                    }
                    _this.$scope.$watch('vm.clientCoverTemplate', function (newVal, oldVal) {
                        if (newVal !== oldVal && newVal && newVal !== QMC.Common.Constants.GUID_EMPTY) {
                            _this.generateReport(_this.clientCoverTemplate);
                        }
                    });
                });
                $qui.init(undefined, function () {
                    $qui.bindEvents();
                    $('.qm-card').unbind('click');
                });
                this.pdfCallbackButton = {
                    icon: 'qm-icon-arrow_circle',
                    label: this.lng.translate(20000241, 'Aktualisieren')
                };
            }
            DetailCoverController.prototype.getReportTypeCaption = function (reportType) {
                switch (reportType) {
                    case 7000:
                        return this.lng.translate(20015036, 'Vorlage');
                    case 3000:
                        return this.lng.translate(20015038, 'Tabellenkalkulation');
                    default:
                        return '';
                }
            };
            DetailCoverController.prototype.getReportIdAndExecute = function () {
                var _this = this;
                this.userService.getUserSettings(["FRADECKBLATT." + this.objectType + ".REPORTID"], false).then(function (data) {
                    _this.clientCoverTemplate = (data[0].value && data[0].value.length > 0 && data[0].value !== QMC.Common.Constants.GUID_EMPTY) ? data[0].value : _this.clientCoverTemplate;
                    var report = _this.GetReportDataFromList(_this.clientCoverTemplate, _this.clientCoverReportTemplates);
                    if (!report) {
                        _this.invalidCover = _this.clientCoverTemplate !== QMC.Common.Constants.GUID_EMPTY;
                        return;
                    }
                    _this.invalidCover = false;
                    _this.generateReport(_this.clientCoverTemplate, report.reportType);
                });
            };
            DetailCoverController.prototype.GetReportDataFromList = function (id, list) {
                for (var _i = 0, list_2 = list; _i < list_2.length; _i++) {
                    var item = list_2[_i];
                    if (item.id === id || item.objectId === id)
                        return item;
                }
                return null;
            };
            DetailCoverController.prototype.generateReport = function (reportTemplateId, reportType) {
                var _this = this;
                if (reportType === void 0) { reportType = -1; }
                if (!this.clientCoverReportTemplates || this.clientCoverReportTemplates.length === 0 || !reportTemplateId || reportTemplateId === QMC.Common.Constants.GUID_EMPTY)
                    return;
                this.invalidCover = false;
                this.loading.report = true;
                var reportForId = this.clientCoverReportTemplates.filter(function (reportItem) { return reportItem.objectId === reportTemplateId; });
                var postItem = {
                    reportObjectId: reportTemplateId,
                    serverJobObjectId: this.$qui.generateGuid(),
                    reportType: reportType === -1 ? reportForId[0].reportType : reportType,
                    parameters: [],
                    isCancelled: false,
                    detailParentId: this.id
                };
                this.reportingService.postReportJob(postItem).then(function (id) {
                    _this.getFinishedReportFile(id, postItem.reportType, reportTemplateId);
                }).catch(function () {
                    _this.invalidCover = true;
                    _this.loading.report = false;
                    _this.base64Data = undefined;
                });
            };
            DetailCoverController.prototype.getFinishedReportFile = function (id, reportType, templateId) {
                var _this = this;
                this.fileName = this.lng.translate(21002031, 'Deckblatt');
                this.reportId = id;
                this.reportingService.getFinishedReportBase64(id, reportType, this.fileName).then(function (data) {
                    _this.setReportFromResult(data, reportType);
                    data.reference = _this.id;
                    data.reportType = reportType;
                    data.reportTemplateId = templateId;
                    data.timestamp = moment();
                    localStorage.setItem(_this.coverCacheName, JSON.stringify(data));
                }).catch(function () {
                    _this.invalidCover = true;
                    _this.base64Data = undefined;
                }).finally(function () {
                    _this.loading.report = false;
                    _this.$qui.scopeApply();
                });
            };
            DetailCoverController.prototype.setReportFromResult = function (data, reportType) {
                var _this = this;
                this.loading.report = false;
                this.reportType = reportType;
                this.base64Data = data.base64;
                if (reportType === 7000) {
                    this.fileType = 'pdf';
                }
                if (reportType === 3000) {
                    this.fileType = 'excel';
                }
                this.$qui.waitForEl('#infoContent', function () {
                    _this.$qui.waitForEl('#infoToggler', function () {
                        if (document.getElementById('infoContent').style.display !== 'none')
                            document.getElementById('infoToggler').click();
                    });
                });
            };
            DetailCoverController = __decorate([
                QMC.Controller('QMC.Stammdaten', 'DetailCoverController'),
                QMC.Inject('$qui', '$stateParams', '$scope', "QmcLanguageService", 'ReportingService', 'UserService', '$location')
            ], DetailCoverController);
            return DetailCoverController;
        }());
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        var DetailNoteController = /** @class */ (function () {
            /**
             * Creates an instance of DetailNoteController.
             * @param {StammdatenService} stammdatenService
             * @param {any} $qui
             * @param {Klient.KlientService} clientService
             * @param {any} $state
             * @param {any} $stateParams
             * @param {any} $scope
             * @param {Common.QmcPermissionService} permissionService
             *
             * @memberOf DetailNoteController
             */
            function DetailNoteController(stammdatenService, $qui, clientService, $state, $stateParams, permissionService) {
                var _this = this;
                this.stammdatenService = stammdatenService;
                this.$qui = $qui;
                this.clientService = clientService;
                this.$state = $state;
                // Permissions
                this.ui = new QMC.Stammdaten.DetailUI();
                this.loading = true;
                this.parentObjectId = $stateParams.id;
                this.$qui.waitForEl('#newModalButton', function () {
                    document.getElementsByName('newModalButton').forEach(function (x) { return x.style.visibility = 'hidden'; });
                });
                this.stammdatenService.getNote(this.parentObjectId).then(function (data) {
                    permissionService.getPermissionsForDataset(_this.parentObjectId, null).then(function (data) {
                        _this.delete = data[0].delete;
                        _this.new = data[0].new;
                        _this.modify = data[0].modify;
                        _this.moduleAccess = data[0].moduleAccess;
                    });
                    _this.text = data.text;
                    _this.loading = false;
                });
            }
            /**
             * update the client node
             *
             * @private
             *
             * @memberOf DetailNoteController
             */
            DetailNoteController.prototype.updateNote = function () {
                var _this = this;
                var data = {
                    parentObjectId: this.parentObjectId,
                    text: this.text,
                    permission: null
                };
                this.stammdatenService.putNote(this.parentObjectId, data).then(function (data) {
                    _this.ui.notify(_this.ui.successNote);
                });
            };
            DetailNoteController = __decorate([
                QMC.Controller('QMC.Stammdaten', 'DetailNoteController'),
                QMC.Inject('StammdatenService', '$qui', 'KlientService', '$state', '$stateParams', 'QmcPermissionService')
            ], DetailNoteController);
            return DetailNoteController;
        }());
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        var DetailVaccinationController = /** @class */ (function () {
            /**
             * Creates an instance of DetailVaccinationController.
             *
             * @memberOf DetailVaccinationController
             */
            function DetailVaccinationController(stammdatenService, $qui, $stateParams, $scope, $state, lng, permissionService, userService, $timeout, $location, udfService) {
                var _this = this;
                this.stammdatenService = stammdatenService;
                this.$qui = $qui;
                this.$stateParams = $stateParams;
                this.$scope = $scope;
                this.$state = $state;
                this.lng = lng;
                this.userService = userService;
                this.$location = $location;
                this.allowTableExport = false;
                this.ui = new QMC.Stammdaten.DetailUI();
                this.formState = "new";
                this.enableDocuments = false;
                this.udfs = [];
                $scope.Model = $scope.Model || { Name: 'xxx' };
                this.id = $stateParams.id;
                switch (this.$location.$$path.split('/')[1]) {
                    case 'employee':
                        this.parentobjectType = 120000;
                        this.objectType = 120046;
                        this.documentObjectType = 0; // not impl., no objectType
                        break;
                    default:
                        this.parentobjectType = 140000;
                        this.objectType = 140005;
                        this.documentObjectType = 140114;
                        break;
                }
                this.permissionLoading = true;
                this.doctorsAndMedicalOrganisations = [];
                permissionService.getPermissionsByObjectTypes([this.objectType, this.documentObjectType]).then(function (data) {
                    _this.delete = data[0].delete;
                    _this.new = data[0].new;
                    _this.modify = data[0].modify;
                    _this.moduleAccess = data[0].moduleAccess && data[0].view;
                    _this.allowTableExport = data[0].print;
                    _this.enableDocuments = data[1].moduleAccess;
                    $timeout(function () {
                        if (!_this.new)
                            document.getElementsByName('newModalButton').forEach(function (x) { return x.style.visibility = 'hidden'; });
                        else
                            document.getElementsByName('newModalButton').forEach(function (x) { return x.style.visibility = 'unset'; });
                    });
                    _this.initForm();
                    _this.$qui.getTableAutoload(_this.userService).then(function (ltd) {
                        _this.shouldLoadTableData = ltd;
                        if (_this.shouldLoadTableData) {
                            _this.getData();
                        }
                    });
                    _this.permissionLoading = false;
                });
                //$qui.init('stammdaten', () => {
                $qui.init($qui.getSectionColor("/stammdaten"), function () {
                    $qui.bindEvents();
                    $('.qm-card').unbind('click');
                });
                this.lang = lng;
                this.promptOptions = {
                    title: "Impfung",
                    yesNo: true,
                    icon: "qm-icon-history2",
                    text: this.lang.translate(20000290, "Wollen Sie den Eintrag wirklich löschen?")
                };
                var vm = this;
                $("#edit-form").on('hidden.bs.modal', function () {
                    _this.$state.go('.', { dataId: undefined }, { reload: false });
                    $timeout(function () { return vm.initForm(); });
                    $("#edit-form").find('.tab-content').children().removeClass('in').removeClass('active');
                    $("#edit-form").find('.tab-content').find('#baseDataTab').addClass('in active');
                });
                udfService.getUserDefinedFields(this.objectType).then(function (data) {
                    _this.udfs = data.sort(function (a, b) { return a.caption.localeCompare(b.caption); });
                });
            }
            DetailVaccinationController.prototype.getData = function () {
                this.getVaccinations();
            };
            /////////////// DISPLAY LOGIC ///////////////
            /**
             * init a new form with default values
             *
             * @private
             *
             * @memberOf DetailVaccinationController
             */
            DetailVaccinationController.prototype.initForm = function () {
                this.formState = "new";
                this.form = {
                    id: null,
                    objectId: null,
                    parentObjectId: this.id,
                    date: new Date(),
                    dateFollowupAppointment: null,
                    caption: null,
                    comment: null,
                    batchNumber: null,
                    diseaseId: null,
                    doctorId: null,
                    parentObjectType: this.parentobjectType,
                    objectType: this.objectType
                };
                this.$qui.functionWaiter("ui.createForm", this);
            };
            /////////////// SERVICE FUNCTIONS ///////////////
            /**
             * get a list of vaccinations
             *
             * @private
             *
             * @memberOf DetailVaccinationController
             */
            DetailVaccinationController.prototype.getVaccinations = function () {
                var _this = this;
                this.loading = true;
                this.stammdatenService.getVaccinationList(this.id).then(function (data) {
                    _this.ui.vaccinationTable.data = data;
                    _this.$qui.functionWaiter("ui.createTable", _this);
                    _this.loading = false;
                    if (_this.$stateParams.dataId) {
                        var item = data.filter(function (x) { return x.objectId === _this.$stateParams.dataId; })[0];
                        if (item) {
                            _this.$qui.waitForEl('#edit-form', function () {
                                $("#edit-form").modal('show');
                            });
                            _this.editVaccination(item);
                        }
                    }
                });
            };
            DetailVaccinationController.prototype.getDoctorsAndMedicalOrg = function () {
                var _this = this;
                return this.stammdatenService.getDoctorList().then(function (dataDoctors) {
                    dataDoctors.forEach(function (doctor) {
                        _this.doctorsAndMedicalOrganisations.push(doctor);
                    });
                    return _this.stammdatenService.getMedicalOrganisationList().then(function (dataMedicalOrg) {
                        var result = _this.doctorsAndMedicalOrganisations.map(function (x) { return { text: x.displayTitle, value: x.id, group: _this.lng.translate(20010508, 'Arzt') }; });
                        result = result.concat(dataMedicalOrg.map(function (x) { return { text: x.displayTitle, value: x.id, group: _this.lng.translate(20023005, 'Medizinische Organisation') }; }));
                        return result;
                    });
                });
            };
            DetailVaccinationController.prototype.getDiseases = function () {
                var _this = this;
                return this.stammdatenService.getVaccinationWv().then(function (data) {
                    _this.dieseasesWv = data.diseaseVaccinationWvList;
                    return _this.ui.select(data.diseaseVaccinationWvList, { value: 'id', text: 'name' });
                });
            };
            /**
             * add a new vaccination
             *
             * @private
             *
             * @memberOf DetailVaccinationController
             */
            DetailVaccinationController.prototype.addVaccination = function (form) {
                var _this = this;
                form.parentObjectId = this.id;
                this.stammdatenService.postVaccination(form).then(function (e) {
                    _this.formState = "new";
                    _this.ui.notify(_this.ui.successNote);
                    _this.getVaccinations();
                    $('#edit-form').modal('hide');
                });
            };
            /**
             * delete a existing vaccination
             *
             * @private
             * @param {IVaccination} data
             *
             * @memberOf DetailVaccinationController
             */
            DetailVaccinationController.prototype.deleteVaccination = function (item) {
                var _this = this;
                this.loading = true;
                this.promptOptions.itemText = moment(item.date).format("DD.MM.YYYY") + " " + item.diseaseName;
                QMC.Common.Utilities.confirm(this.promptOptions, function (data) {
                    if (data)
                        _this.stammdatenService.deleteVaccination(_this.id, item.objectId).then(function (data) {
                            _this.ui.notify(_this.ui.deleteNote);
                            _this.formState = "new";
                            _this.getVaccinations();
                            $('#edit-form').modal('hide');
                        });
                });
            };
            /**
             * edit a existing vaccination
             *
             * @private
             * @param {IVaccination} data
             *
             * @memberOf DetailVaccinationController
             */
            DetailVaccinationController.prototype.editVaccination = function (data) {
                this.form = angular.copy(data);
                this.formState = "edit";
                this.form.date = moment(data.date).toDate();
                if (this.form.dateFollowupAppointment !== null) {
                    this.form.dateFollowupAppointment = moment(data.dateFollowupAppointment).toDate();
                }
                this.$qui.waitForEl('#standardTabButton', function () {
                    $('#standardTabButton').click();
                });
                this.$state.go('.', { dataId: data.objectId });
            };
            DetailVaccinationController.prototype.putVaccination = function (form) {
                var _this = this;
                this.loading = true;
                this.stammdatenService.putVaccination(this.form.parentObjectId, this.form.objectId, form).then(function (data) {
                    _this.ui.notify(_this.ui.successNote);
                    _this.formState = "new";
                    $('#edit-form').modal('hide');
                }).finally(function () { return _this.getVaccinations(); });
                this.udfs.forEach(function (x) { var _a; return (_a = x.save) === null || _a === void 0 ? void 0 : _a.call(x, false); });
            };
            DetailVaccinationController = __decorate([
                QMC.Controller('QMC.Stammdaten', 'DetailVaccinationController'),
                QMC.Inject('StammdatenService', '$qui', '$stateParams', '$scope', '$state', 'QmcLanguageService', 'QmcPermissionService', 'UserService', '$timeout', '$location', 'QmcUdfService')
            ], DetailVaccinationController);
            return DetailVaccinationController;
        }());
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        var DetailHobbyController = /** @class */ (function () {
            /**
             * Creates an instance of DetailHobbyController.
             *
             * @memberOf DetailHobbyController
             */
            function DetailHobbyController(stammdatenService, $qui, clientService, $stateParams, $scope, lng, permissionService, userService, $timeout, udfService) {
                var _this = this;
                this.stammdatenService = stammdatenService;
                this.$qui = $qui;
                this.clientService = clientService;
                this.$scope = $scope;
                this.lng = lng;
                this.userService = userService;
                this.allowTableExport = false;
                this.ui = new QMC.Stammdaten.DetailUI();
                this.formState = "new";
                this.objectType = 140054;
                this.udfs = [];
                $scope.Model = $scope.Model || { Name: 'xxx' };
                this.id = $stateParams.id;
                this.permissionLoading = true;
                permissionService.getPermissionsByObjectType(this.objectType).then(function (data) {
                    _this.delete = data[0].delete;
                    _this.new = data[0].new;
                    _this.modify = data[0].modify;
                    _this.moduleAccess = data[0].moduleAccess && data[0].view;
                    _this.allowTableExport = data[0].print;
                    _this.$qui.waitForEl('#newModalButton', function () {
                        if (!_this.new)
                            document.getElementsByName('newModalButton').forEach(function (x) { return x.style.visibility = 'hidden'; });
                        else
                            document.getElementsByName('newModalButton').forEach(function (x) { return x.style.visibility = 'unset'; });
                    });
                    _this.societyList = null;
                    _this.contactPersonList = null;
                    _this.getWvList();
                    _this.$qui.getTableAutoload(_this.userService).then(function (ltd) {
                        _this.shouldLoadTableData = ltd;
                        if (_this.shouldLoadTableData) {
                            _this.getData();
                        }
                    });
                    _this.permissionLoading = false;
                });
                //$qui.init('stammdaten', () => {
                $qui.init($qui.getSectionColor("/stammdaten"), function () {
                    $qui.bindEvents();
                    $('.qm-card').unbind('click');
                });
                this.promptOptions = {
                    title: "Hobby",
                    yesNo: true,
                    icon: "qm-icon-soccer_ball",
                    text: this.lng.translate(20000290, "Wollen Sie den Eintrag wirklich löschen?")
                };
                this.$scope.$watch('vm.form.typeId', function (newVal, oldVal) {
                    if (newVal === oldVal)
                        return;
                    _this.form.isHobbyDisabled = !newVal || newVal === QMC.Common.Constants.GUID_EMPTY;
                });
                $("#edit-form").on('hidden.bs.modal', function () {
                    $timeout(function () { return $scope.vm.initForm(); });
                    $("#edit-form").find('.tab-content').children().removeClass('in').removeClass('active');
                    $("#edit-form").find('.tab-content').find('#baseDataTab').addClass('in active');
                });
                udfService.getUserDefinedFields(this.objectType).then(function (data) {
                    _this.udfs = data.sort(function (a, b) { return a.caption.localeCompare(b.caption); });
                });
            }
            DetailHobbyController.prototype.getData = function () {
                this.getHobbies();
            };
            /////////////// DISPLAY LOGIC ///////////////
            /**
             * init a new form with default values
             *
             * @private
             *
             * @memberOf DetailHobbyController
             */
            DetailHobbyController.prototype.initForm = function () {
                this.formState = "new";
                this.form = {
                    id: null,
                    objectId: null,
                    validFrom: new Date(),
                    validTo: null,
                    typeId: QMC.Common.Constants.GUID_EMPTY,
                    subTypeId: QMC.Common.Constants.GUID_EMPTY,
                    societyId: QMC.Common.Constants.GUID_EMPTY,
                    caption: '',
                    comment: '',
                    contactPersonId: QMC.Common.Constants.GUID_EMPTY,
                    parentObjectId: this.id,
                    membershipNo: ''
                };
            };
            /////////////// SERVICE FUNCTIONS ///////////////
            /**
             * get a list of hobbies
             *
             * @private
             *
             * @memberOf DetailHobbyController
             */
            DetailHobbyController.prototype.getHobbies = function () {
                var _this = this;
                this.loading = true;
                this.stammdatenService.getHobbyList(this.id).then(function (data) {
                    _this.ui.hobbyTable.data = data;
                    _this.$qui.functionWaiter("ui.createTable", _this);
                    _this.loading = false;
                });
            };
            DetailHobbyController.prototype.getAdditionalInfos = function () {
                var _this = this;
                this.stammdatenService.getSocietyListItem().then(function (dataSociety) {
                    _this.societyList = dataSociety;
                    return _this.clientService.getContactPersonListOfPerson(_this.form.societyId, "", true, false, true).then(function (dataContactPerson) {
                        var values = dataContactPerson.map(function (x) { return ({ value: x.objectId, text: x.displayTitle }); });
                        values.sort(function (a, b) { return (a.text.toLocaleLowerCase() > b.text.toLocaleLowerCase()) ? 1 : ((b.text.toLocaleLowerCase() > a.text.toLocaleLowerCase()) ? -1 : 0); });
                        _this.contactPersonList = values;
                        _this.$qui.functionWaiter("ui.createForm", _this);
                    });
                });
            };
            DetailHobbyController.prototype.getSocietyListItems = function () {
                if (this.societyList != (null || undefined)) {
                    return this.ui.select(this.societyList, { value: 'id', text: 'displayTitle' });
                }
                else {
                    return null;
                }
            };
            DetailHobbyController.prototype.getContactPersonItems = function () {
                var _this = this;
                if (this.form.societyId != (null || undefined || "") && this.contactPersonList != (null || undefined)) {
                    return this.clientService.getContactPersonListOfPerson(this.form.societyId, "", true, false, true).then(function (data) {
                        var values = data.map(function (x) { return ({ value: x.objectId, text: x.displayTitle }); });
                        values.sort(function (a, b) { return (a.text.toLocaleLowerCase() > b.text.toLocaleLowerCase()) ? 1 : ((b.text.toLocaleLowerCase() > a.text.toLocaleLowerCase()) ? -1 : 0); });
                        _this.contactPersonList = values;
                        if (_this.contactPersonList.length === 0) {
                            _this.form.contactPersonId = null;
                        }
                        return _this.ui.select(values, { value: 'value', text: 'text' });
                    });
                }
                else {
                    return null;
                }
            };
            /**
             * get the wv list
             *
             * @private
             *
             * @memberOf DetailHobbyController
             */
            DetailHobbyController.prototype.getWvList = function () {
                var _this = this;
                this.loading = true;
                this.stammdatenService.getHobbyWv().then(function (wvData) {
                    _this.wvList = wvData;
                    _this.getAdditionalInfos();
                    _this.getHobbyRequiredFields();
                    _this.initForm();
                    _this.loading = false;
                });
            };
            DetailHobbyController.prototype.getHobbyRequiredFields = function () {
                var _this = this;
                this.stammdatenService.getHobbyRequiredFields().then(function (data) {
                    _this.hobbyRequiredFields = data;
                });
            };
            DetailHobbyController.prototype.getTypeWv = function () {
                return this.wvList.typeWvList.map(function (obj) {
                    return {
                        value: obj.id,
                        text: obj.name
                    };
                });
            };
            DetailHobbyController.prototype.getSubTypeWv = function () {
                var data = [];
                if (!this.form.typeId || this.form.typeId === QMC.Common.Constants.GUID_EMPTY)
                    return [];
                var hobbyTypeName = this.getHobyTypeName(this.form.typeId);
                data = this.wvList.subTypeWvList[hobbyTypeName];
                return data.map(function (obj) {
                    return {
                        value: obj.id,
                        text: obj.name
                    };
                });
            };
            DetailHobbyController.prototype.getHobyTypeName = function (hobbyTypeId) {
                var hobbyTypeConst = this.wvList.typeWvList.filter(function (hobbyType) { return hobbyType.objectId === hobbyTypeId; });
                return hobbyTypeConst ? (hobbyTypeConst[0].name.substring(0, 1).toLowerCase() + hobbyTypeConst[0].name.substring(1)).trim() : '';
            };
            /**
             * add a new hobby
             *
             * @private
             *
             * @memberOf DetailHobbyController
             */
            DetailHobbyController.prototype.addHobby = function (form) {
                var _this = this;
                form.parentObjectId = this.id;
                this.stammdatenService.postHobby(form).then(function (e) {
                    _this.formState = "new";
                    _this.ui.notify(_this.ui.successNote);
                    _this.getHobbies();
                    $('#edit-form').modal('hide');
                });
            };
            /**
             * delete an existing hobby
             *
             * @private
             * @param {IHobby} data
             *
             * @memberOf DetailHobbyController
             */
            DetailHobbyController.prototype.deleteHobby = function (item) {
                var _this = this;
                this.promptOptions.itemText = item.validFrom != null ? moment(item.validFrom).format("DD.MM.YYYY") + " " + item.caption : item.caption;
                QMC.Common.Utilities.confirm(this.promptOptions, function (data) {
                    if (data)
                        _this.stammdatenService.deleteHobby(_this.id, item.objectId).then(function (data) {
                            _this.ui.notify(_this.ui.deleteNote);
                            _this.formState = "new";
                            _this.getHobbies();
                        });
                });
            };
            /**
             * edit a existing hobby
             *
             * @private
             * @param {IHobby} data
             *
             * @memberOf DetailHobbyController
             */
            DetailHobbyController.prototype.editHobby = function (data) {
                this.form = angular.copy(data);
                this.formState = "edit";
                this.form.validFrom = moment(data.validFrom).toDate();
                if (data.validTo != null) {
                    this.form.validTo = moment(data.validTo).toDate();
                }
                this.$qui.waitForEl('#standardTabButton', function () {
                    $('#standardTabButton').click();
                });
            };
            DetailHobbyController.prototype.putHobby = function (form) {
                var _this = this;
                this.loading = true;
                this.stammdatenService.putHobby(this.id, this.form.objectId, form).then(function (data) {
                    _this.ui.notify(_this.ui.successNote);
                    _this.formState = "new";
                    $('#edit-form').modal('hide');
                }).finally(function () { return _this.getHobbies(); });
                this.udfs.forEach(function (x) { var _a; return (_a = x.save) === null || _a === void 0 ? void 0 : _a.call(x, false); });
            };
            DetailHobbyController = __decorate([
                QMC.Controller('QMC.Stammdaten', 'DetailHobbyController'),
                QMC.Inject('StammdatenService', '$qui', 'KlientService', '$stateParams', '$scope', 'QmcLanguageService', 'QmcPermissionService', 'UserService', '$timeout', 'QmcUdfService')
            ], DetailHobbyController);
            return DetailHobbyController;
        }());
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        var DetailDocumentsController = /** @class */ (function () {
            function DetailDocumentsController($qui, $stateParams, $location) {
                this.$qui = $qui;
                this.$stateParams = $stateParams;
                this.$location = $location;
                this.id = this.$stateParams.id;
                switch (this.$location.$$path.split('/')[1]) {
                    case 'employee':
                        this.parentObjectType = 120000;
                        this.objectType = 120007;
                        break;
                    default:
                        this.parentObjectType = 140000;
                        this.objectType = 140032;
                        break;
                }
                this.$qui.waitForEl('#newModalButton', function () {
                    document.getElementsByName('newModalButton').forEach(function (x) { return x.style.visibility = 'hidden'; });
                });
                $qui.init(this.$qui.getSectionColor("/stammdaten"), function () {
                    $qui.bindEvents();
                    $('.qm-card').unbind('click');
                });
                this.$qui.functionWaiter("createDirective", this);
            }
            DetailDocumentsController = __decorate([
                QMC.Controller('QMC.Stammdaten', 'DetailDocumentsController'),
                QMC.Inject('$qui', '$stateParams', '$location')
            ], DetailDocumentsController);
            return DetailDocumentsController;
        }());
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        var DetailDiseaseController = /** @class */ (function () {
            /**
             * Creates an instance of DetailDiseaseController.
             *
             * @memberOf DetailDiseaseController
             */
            function DetailDiseaseController(stammdatenService, $qui, $stateParams, $scope, $state, lng, permissionService, userService, $timeout, udfService) {
                var _this = this;
                this.stammdatenService = stammdatenService;
                this.$qui = $qui;
                this.$stateParams = $stateParams;
                this.$state = $state;
                this.lng = lng;
                this.userService = userService;
                this.allowTableExport = false;
                this.ui = new QMC.Stammdaten.DetailUI();
                this.diseases = [];
                this.formState = "new";
                this.objectType = 140002;
                this.documentObjectType = 140110;
                this.enableDocuments = false;
                this.udfs = [];
                $scope.Model = $scope.Model || { Name: 'xxx' };
                this.id = $stateParams.id;
                permissionService.getPermissionsByObjectTypes([this.objectType, this.documentObjectType]).then(function (data) {
                    _this.delete = data[0].delete;
                    _this.new = data[0].new;
                    _this.modify = data[0].modify;
                    _this.moduleAccess = data[0].moduleAccess && data[0].view;
                    _this.allowTableExport = data[0].print;
                    _this.enableDocuments = data[1].moduleAccess;
                    $timeout(function () {
                        if (!_this.new)
                            document.getElementsByName('newModalButton').forEach(function (x) { return x.style.visibility = 'hidden'; });
                        else
                            document.getElementsByName('newModalButton').forEach(function (x) { return x.style.visibility = 'unset'; });
                    });
                    _this.diseaseWvList = [];
                    _this.getDiseaseWvList();
                    _this.$qui.getTableAutoload(_this.userService).then(function (ltd) {
                        _this.shouldLoadTableData = ltd;
                        if (_this.shouldLoadTableData) {
                            _this.getData();
                        }
                    });
                });
                //$qui.init('stammdaten', () => {
                $qui.init($qui.getSectionColor("/stammdaten"), function () {
                    $qui.bindEvents();
                    $('.qm-card').unbind('click');
                });
                this.promptOptions = {
                    title: "Krankheit",
                    yesNo: true,
                    icon: "qm-icon-history2",
                    text: this.lng.translate(20000290, "Wollen Sie den Eintrag wirklich löschen?")
                };
                var vm = this;
                $("#edit-form").on('hidden.bs.modal', function () {
                    _this.$state.go('.', { dataId: undefined }, { reload: false });
                    $timeout(function () { return vm.initForm(); });
                    $("#edit-form").find('.tab-content').children().removeClass('in').removeClass('active');
                    $("#edit-form").find('.tab-content').find('#baseDataTab').addClass('in active');
                });
                udfService.getUserDefinedFields(this.objectType).then(function (data) {
                    _this.udfs = data.sort(function (a, b) { return a.caption.localeCompare(b.caption); });
                });
            }
            DetailDiseaseController.prototype.getData = function () {
                this.getDiseases();
            };
            DetailDiseaseController.prototype.events = function () {
                var vm = this;
                $('#liveDiseases .typeahead').typeahead({
                    source: function (query, process) {
                        vm.stammdatenService.getDiseasesBySearchText(vm.form.diseaseCodeSchemaId, query).then(function (data) {
                            vm.diseases = data.items;
                            process(data.items.map(function (obj) {
                                return obj.name;
                            }));
                        });
                        vm.form.diseaseId = null;
                        if (vm.invalidateForm)
                            vm.invalidateForm('diseaseName');
                    },
                    items: -1,
                    menu: '<ul class="typeahead dropdown-menu pre-scrollable"></ul>',
                    fitToElement: true,
                    updater: function (item) {
                        /* Find the id to the selected text */
                        for (var i = 0; i < vm.diseases.length; i++) {
                            if (vm.diseases[i].name === item) {
                                vm.form.diseaseId = vm.diseases[i].id;
                                break;
                            }
                            else {
                                vm.form.diseaseId = null;
                                if (vm.invalidateForm)
                                    vm.invalidateForm('diseaseName');
                            }
                        }
                        return item;
                    },
                    //no default sorting from the component, use the sorting used in API for loading the data, BEZEICHNUNG
                    sorter: function (items) {
                        return items;
                    }
                });
            };
            /**
             * init a new form with default values
             *
             * @private
             *
             * @memberOf DetailDiseaseController
             */
            DetailDiseaseController.prototype.initForm = function () {
                this.formState = 'new';
                this.form = {
                    id: null,
                    objectId: null,
                    comment: null,
                    dateFrom: new Date(),
                    dateTo: null,
                    diseaseCodeSchemaId: QMC.Common.Constants.DEFAULT_DISEASE_CODE_SCHEMA,
                    diseaseId: null,
                    diseaseTypeId: null,
                    parentObjectId: this.id,
                    parentObjectType: QMC.Common.Constants.OBJECTTYPE_CLIENT
                };
                this.$qui.functionWaiter("ui.createForm", this);
            };
            /////////////// SERVICE FUNCTIONS ///////////////
            /**
             * get the disease wv list
             *
             * @private
             * @returns }
             *
             * @memberOf DetailDiseaseController
             */
            DetailDiseaseController.prototype.getDiseaseWvList = function () {
                var _this = this;
                return this.stammdatenService.getDiseaseWvList().then(function (data) {
                    _this.diseaseWvList.push(data);
                    _this.initForm();
                });
            };
            DetailDiseaseController.prototype.getDiseaseCodeSchemaWvList = function () {
                return this.ui.select(this.diseaseWvList[0].diseaseCodeSchemaWvList, { value: 'id', text: 'name' });
            };
            DetailDiseaseController.prototype.getDiseaseTypeWvList = function () {
                return this.ui.select(this.diseaseWvList[0].diseaseTypeWvList, { value: 'id', text: 'name' });
            };
            /**
             * get a list of diseases
             *
             * @private
             *
             * @memberOf DetailDiseaseController
             */
            DetailDiseaseController.prototype.getDiseases = function () {
                var _this = this;
                this.loading = true;
                this.stammdatenService.getDiseaseList(this.id).then(function (data) {
                    _this.ui.diseaseTable.data = data;
                    _this.$qui.functionWaiter("ui.createTable", _this);
                    setTimeout(function () {
                        _this.events();
                    }, 500);
                    _this.loading = false;
                    if (_this.$stateParams.dataId) {
                        var item = data.filter(function (x) { return x.objectId === _this.$stateParams.dataId; })[0];
                        if (item) {
                            $("#edit-form").modal('show');
                            _this.editDisease(item);
                        }
                    }
                });
            };
            /**
             * add a new disease
             *
             * @private
             * @param {IDisease} form
             *
             * @memberOf DetailDiseaseController
             */
            DetailDiseaseController.prototype.addDisease = function (form) {
                var _this = this;
                if (!this.form.diseaseId) {
                    console.warn('No disease code supplied (post)', this.form);
                    return;
                }
                this.loading = true;
                this.stammdatenService.postDisease(form).then(function () {
                    _this.ui.notify(_this.ui.successNote);
                    _this.formState = "new";
                    _this.getDiseases();
                    $('#edit-form').modal('hide');
                });
            };
            /**
             * put a existing disease
             *
             * @private
             * @param {IDisease} form
             *
             * @memberOf DetailDiseaseController
             */
            DetailDiseaseController.prototype.putDisease = function (form) {
                var _this = this;
                if (!this.form.diseaseId) {
                    console.warn('No disease code supplied (put)', this.form);
                    return;
                }
                this.loading = true;
                this.stammdatenService.putDisease(form.parentObjectId, form.objectId, form).then(function () {
                    _this.ui.notify(_this.ui.successNote);
                    _this.formState = "new";
                    _this.getDiseases();
                    $('#edit-form').modal('hide');
                });
                this.udfs.forEach(function (x) { var _a; return (_a = x.save) === null || _a === void 0 ? void 0 : _a.call(x, false); });
            };
            /**
             * edit a existing disease
             *
             * @private
             * @param {IDisease} data
             *
             * @memberOf DetailDiseaseController
             */
            DetailDiseaseController.prototype.editDisease = function (data) {
                this.formState = "edit";
                this.form = data;
                this.form.dateFrom = moment(data.dateFrom).toDate();
                if (this.form.dateTo !== null)
                    this.form.dateTo = moment(data.dateTo).toDate();
                this.$qui.waitForEl('#standardTabButton', function () {
                    $('#standardTabButton').click();
                });
                this.$state.go('.', { dataId: data.objectId });
            };
            /**
             * delete a existing disease
             *
             * @private
             * @param {IDisease} data
             *
             * @memberOf DetailDiseaseController
             */
            DetailDiseaseController.prototype.deleteDisease = function (item) {
                var _this = this;
                this.promptOptions.itemText = item.diseaseName;
                QMC.Common.Utilities.confirm(this.promptOptions, function (data) {
                    if (data)
                        _this.stammdatenService.deleteDisease(_this.id, item.objectId).then(function () {
                            _this.ui.notify(_this.ui.deleteNote);
                            _this.formState = "new";
                            _this.getDiseases();
                        });
                });
            };
            DetailDiseaseController = __decorate([
                QMC.Controller('QMC.Stammdaten', 'DetailDiseaseController'),
                QMC.Inject('StammdatenService', '$qui', '$stateParams', '$scope', '$state', 'QmcLanguageService', 'QmcPermissionService', 'UserService', '$timeout', 'QmcUdfService')
            ], DetailDiseaseController);
            return DetailDiseaseController;
        }());
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        var DetailDoctorsVisitController = /** @class */ (function () {
            /**
             * Creates an instance of DetailDoctorsVisitController.
             *
             * @memberOf DetailDoctorsVisitController
             */
            function DetailDoctorsVisitController(stammdatenService, $qui, $stateParams, $scope, $state, lng, permissionService, userService, $timeout, udfService) {
                var _this = this;
                this.stammdatenService = stammdatenService;
                this.$qui = $qui;
                this.$stateParams = $stateParams;
                this.$state = $state;
                this.lng = lng;
                this.userService = userService;
                this.allowTableExport = false;
                this.ui = new QMC.Stammdaten.DetailUI();
                this.medOrgas = [];
                this.doctors = [];
                this.objectType = 140003;
                this.documentObjectType = 140111;
                this.enableDocuments = false;
                this.udfs = [];
                $scope.Model = $scope.Model || { Name: 'xxx' };
                this.id = $stateParams.id;
                this.permissionLoading = true;
                permissionService.getPermissionsByObjectTypes([this.objectType, this.documentObjectType]).then(function (data) {
                    _this.delete = data[0].delete;
                    _this.new = data[0].new;
                    _this.modify = data[0].modify;
                    _this.moduleAccess = data[0].moduleAccess && data[0].view;
                    _this.allowTableExport = data[0].print;
                    _this.enableDocuments = data[1].moduleAccess;
                    $timeout(function () {
                        if (!_this.new)
                            document.getElementsByName('newModalButton').forEach(function (x) { return x.style.visibility = 'hidden'; });
                        else
                            document.getElementsByName('newModalButton').forEach(function (x) { return x.style.visibility = 'unset'; });
                    });
                    _this.stammdatenService.getDoctorList().then(function (data) {
                        _this.doctors = _this.ui.select(data, { value: 'id', text: 'displayTitle' });
                        _this.stammdatenService.getMedicalOrganisationList().then(function (data) {
                            _this.medOrgas = _this.ui.select(data, { value: 'id', text: 'name' });
                            _this.initForm();
                            _this.$qui.getTableAutoload(_this.userService).then(function (ltd) {
                                _this.shouldLoadTableData = ltd;
                                if (_this.shouldLoadTableData) {
                                    _this.getData();
                                }
                            });
                            _this.permissionLoading = false;
                        });
                    });
                });
                //$qui.init('stammdaten', () => {
                $qui.init($qui.getSectionColor("/stammdaten"), function () {
                    $qui.bindEvents();
                    $('.qm-card').unbind('click');
                });
                this.lang = lng;
                this.promptOptions = {
                    title: "Arztbesuch",
                    yesNo: true,
                    icon: "qm-icon-history2",
                    text: this.lang.translate(20000290, "Wollen Sie den Eintrag wirklich löschen?")
                };
                var vm = this;
                $("#edit-form").on('hidden.bs.modal', function () {
                    _this.$state.go('.', { dataId: undefined }, { reload: false });
                    $timeout(function () { return vm.initForm(); });
                    $("#edit-form").find('.tab-content').children().removeClass('in').removeClass('active');
                    $("#edit-form").find('.tab-content').find('#baseDataTab').addClass('in active');
                });
                udfService.getUserDefinedFields(this.objectType).then(function (data) {
                    _this.udfs = data.sort(function (a, b) { return a.caption.localeCompare(b.caption); });
                });
            }
            DetailDoctorsVisitController.prototype.getData = function () {
                this.getDocVisits();
            };
            /////////////// DISPLAY LOGIC ///////////////
            /**
             * init the form with default values
             *
             * @private
             *
             * @memberOf DetailDoctorsVisitController
             */
            DetailDoctorsVisitController.prototype.initForm = function () {
                this.formState = "new";
                this.form = {
                    id: null,
                    objectId: null,
                    date: new Date(),
                    time: new Date(),
                    treaterId: null,
                    treaterObjectType: 0,
                    diagnose: null,
                    discipline: null,
                    parentObjectId: null
                };
                this.$qui.functionWaiter("ui.createForm", this);
            };
            /////////////// SERVICE FUNCTIONS ///////////////
            /**
             * get the list of doc visits
             *
             * @private
             *
             * @memberOf DetailDoctorsVisitController
             */
            DetailDoctorsVisitController.prototype.getDocVisits = function () {
                var _this = this;
                this.loading = true;
                this.stammdatenService.getDoctorsVisitList(this.id).then(function (data) {
                    _this.ui.docVisitTable.data = data;
                    _this.$qui.functionWaiter("ui.createTable", _this);
                    _this.loading = false;
                    if (_this.$stateParams.dataId) {
                        var item = data.filter(function (x) { return x.objectId === _this.$stateParams.dataId; })[0];
                        if (item) {
                            $("#edit-form").modal('show');
                            _this.editDocVisit(item);
                        }
                    }
                });
            };
            /**
             * get the list of doctors
             *
             * @private
             * @returns {ng.IPromise<any>}
             *
             * @memberOf DetailDoctorsVisitController
             */
            DetailDoctorsVisitController.prototype.getDoctors = function () {
                var _this = this;
                var result = this.doctors.map(function (x) { return { text: x.text, value: x.value, group: _this.lng.translate(20010508, 'Arzt') }; });
                result = result.concat(this.medOrgas.map(function (x) { return { text: x.text, value: x.value, group: _this.lng.translate(20023005, 'Medizinische Organisation') }; }));
                return result;
            };
            /**
             * add a new doc visit
             *
             * @private
             * @param {IDoctorsVisit} form
             *
             * @memberOf DetailDoctorsVisitController
             */
            DetailDoctorsVisitController.prototype.addDocVisit = function (form) {
                var _this = this;
                form.parentObjectId = this.id;
                form.date = this.ui.addTimeToDate(form.date, form.time);
                form.time = form.date;
                form.treaterObjectType = this.getTreaterObjectType(form.treaterId);
                this.loading = true;
                this.stammdatenService.postDoctorsVisit(form).then(function () {
                    _this.ui.notify(_this.ui.successNote);
                    _this.formState = "new";
                    _this.getDocVisits();
                    $('#edit-form').modal('hide');
                });
            };
            /**
             * put a existing doc visit
             *
             * @private
             * @param {IDoctorsVisit} form
             *
             * @memberOf DetailDoctorsVisitController
             */
            DetailDoctorsVisitController.prototype.putDocVisit = function (form) {
                var _this = this;
                form.date = this.ui.addTimeToDate(form.date, form.time);
                form.time = form.date;
                form.treaterObjectType = this.getTreaterObjectType(form.treaterId);
                this.loading = true;
                this.stammdatenService.putDoctorsVisit(form.parentObjectId, form.objectId, form).then(function () {
                    _this.$qui.notify(_this.$qui.successNote);
                    _this.formState = "new";
                    $('#edit-form').modal('hide');
                    _this.getDocVisits();
                });
                this.udfs.forEach(function (x) { var _a; return (_a = x.save) === null || _a === void 0 ? void 0 : _a.call(x, false); });
            };
            DetailDoctorsVisitController.prototype.getTreaterObjectType = function (treaterId) {
                if (this.doctors.some(function (x) { return x.value === treaterId; }))
                    return 110000;
                if (this.medOrgas.some(function (x) { return x.value === treaterId; }))
                    return 310000;
                return 0;
            };
            /**
             * delete a existing doc visit
             *
             * @private
             * @param {IDoctorsVisit} item
             *
             * @memberOf DetailDoctorsVisitController
             */
            DetailDoctorsVisitController.prototype.deleteDocVisit = function (item) {
                var _this = this;
                this.loading = true;
                this.promptOptions.itemText = item.treaterName + " (" + moment(item.date).format("DD.MM.YYYY HH:mm") + ")";
                QMC.Common.Utilities.confirm(this.promptOptions, function (data) {
                    if (data)
                        _this.stammdatenService.deleteDoctorsVisit(_this.id, item.objectId).then(function () {
                            _this.ui.notify(_this.ui.deleteNote);
                            _this.formState = "new";
                            $('#edit-form').modal('hide');
                            _this.getDocVisits();
                        });
                });
            };
            /**
             * edit a existing doc visit
             *
             * @private
             * @param {IDoctorsVisit} data
             *
             * @memberOf DetailDoctorsVisitController
             */
            DetailDoctorsVisitController.prototype.editDocVisit = function (data) {
                var _this = this;
                console.log('edit', data);
                this.formState = "edit";
                this.stammdatenService.getDoctorsVisit(this.id, data.objectId).then(function (docVisit) {
                    _this.form = docVisit;
                    _this.form.date = moment(docVisit.date).toDate();
                    _this.form.time = moment(docVisit.time).toDate();
                    _this.$qui.waitForEl('#standardTabButton', function () {
                        $('#standardTabButton').click();
                    });
                });
                this.$state.go('.', { dataId: data.objectId });
            };
            DetailDoctorsVisitController = __decorate([
                QMC.Controller('QMC.Stammdaten', 'DetailDoctorsVisitController'),
                QMC.Inject('StammdatenService', '$qui', '$stateParams', '$scope', '$state', 'QmcLanguageService', 'QmcPermissionService', 'UserService', '$timeout', 'QmcUdfService')
            ], DetailDoctorsVisitController);
            return DetailDoctorsVisitController;
        }());
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        var DetailAbsenteeismController = /** @class */ (function () {
            /**
             * QMC.Stammdaten.DetailAbsenteeismController
             * @constructor
             * @param stammdatenService
             * @param clientService
             * @param $stateParams
             * @param $scope
             * @param $state
             * @param lng
             */
            function DetailAbsenteeismController(stammdatenService, $qui, clientService, $stateParams, $scope, $state, lng, permissionService, userService, $timeout) {
                var _this = this;
                this.stammdatenService = stammdatenService;
                this.$qui = $qui;
                this.clientService = clientService;
                this.$scope = $scope;
                this.$state = $state;
                this.lng = lng;
                this.permissionService = permissionService;
                this.userService = userService;
                this.$timeout = $timeout;
                this.allowTableExport = false;
                this.ui = new Stammdaten.DetailUI();
                this.formState = "new";
                this.overlapCheck = false;
                this.overlapCheckType = 'warnings';
                this.overlapCheckOnlyForSameType = false;
                this.validation = {
                    errors: [],
                    warnings: [],
                };
                this.validationSuccessfulMessage = '';
                $scope.Model = $scope.Model || { Name: 'xxx' };
                this.id = $stateParams.id;
                permissionService.getPermissionsByObjectType(140033).then(function (data) {
                    _this.loading = true;
                    _this.delete = data[0].delete;
                    _this.new = data[0].new;
                    _this.modify = data[0].modify;
                    _this.moduleAccess = data[0].moduleAccess && data[0].view;
                    _this.allowTableExport = data[0].print;
                    $timeout(function () {
                        if (!_this.new)
                            document.getElementsByName('newModalButton').forEach(function (x) { return x.style.visibility = 'hidden'; });
                        else
                            document.getElementsByName('newModalButton').forEach(function (x) { return x.style.visibility = 'unset'; });
                    });
                    _this.getAbsenteeismBans();
                    _this.initForm();
                    _this.userService.getUserSettings(['ABWESENHEIT.CHECK.OVERLAP', 'ABWESENHEIT.CHECK.OVERLAP.TYPEONLY'], false).then(function (data) {
                        if (data[0].value) {
                            _this.overlapCheck = data[0].value !== 'fe55229f-b052-4d3a-b2d1-e127b0d08879';
                            _this.overlapCheckType = data[0].value === '042e92e2-09b4-48b6-b3ee-7b0dc077d42b' ? 'errors' : 'warnings';
                        }
                        _this.overlapCheckOnlyForSameType = data[1].value.toLowerCase() === 'true';
                    });
                    _this.$qui.getTableAutoload(_this.userService).then(function (ltd) {
                        _this.shouldLoadTableData = ltd;
                        if (_this.shouldLoadTableData) {
                            _this.getData();
                        }
                    });
                });
                //$qui.init('stammdaten', () => {
                $qui.init($qui.getSectionColor("/stammdaten"), function () {
                    $qui.bindEvents();
                    $('.qm-card').unbind('click');
                });
                this.$scope.$watch('vm.form.absenteeismReasonId', function (newVal, oldVal) {
                    if (newVal === oldVal && !_this.loading)
                        return;
                    setTimeout(function () {
                        _this.validate();
                    }, 1000);
                }, true);
                this.$scope.$watch('vm.form.dateFrom', function (newVal, oldVal) {
                    if (newVal === oldVal && !_this.loading)
                        return;
                    setTimeout(function () {
                        _this.validate();
                    }, 1000);
                }, true);
                this.$scope.$watch('vm.form.dateTo', function (newVal, oldVal) {
                    if (newVal === oldVal && !_this.loading)
                        return;
                    setTimeout(function () {
                        _this.validate();
                    }, 1000);
                }, true);
                this.promptOptions = {
                    title: "Abwesenheit",
                    yesNo: true,
                    icon: "qm-icon-history2",
                    text: this.lng.translate(20000290, "Wollen Sie den Eintrag wirklich löschen?")
                };
            }
            DetailAbsenteeismController.prototype.getData = function () {
                this.getAbsenteeisms();
            };
            /////////////// DISPLAY LOGIC ///////////////
            /**
             * init the form with default values
             *
             * @private
             *
             * @memberOf DetailAbsenteeismController
             */
            DetailAbsenteeismController.prototype.initForm = function () {
                this.validation.errors = [];
                this.validation.warnings = [];
                this.validationSuccessfulMessage = this.lng.translate(21008009, 'Zeitraumsvalidierung erfolgreich');
                this.form = {
                    id: null,
                    objectId: null,
                    dateTo: null,
                    dateFrom: moment().startOf('day').toDate(),
                    absenteeismReasonId: null,
                    parentObjectId: null,
                    parentObjectType: QMC.Common.Constants.OBJECTTYPE_CLIENT,
                    comment: null,
                    contactPersonId: null
                };
                this.$qui.functionWaiter("ui.createForm", this);
            };
            DetailAbsenteeismController.prototype.getWvList = function () {
                var _this = this;
                return this.stammdatenService.getAbsenteeismWv().then(function (data) {
                    _this.wvList = data;
                    return _this.ui.select(data.absenteeismReasonWvList, { value: 'objectId', text: 'name' });
                });
            };
            DetailAbsenteeismController.prototype.getContactPersonList = function () {
                var _this = this;
                return this.stammdatenService.getParticipantsSelectionAssignment('ABWESENHEIT_AUFENTHALT_BEI', true).then(function (data) {
                    return _this.ui.select(data, { value: 'objectId', text: 'displayTitle', group: 'objectTypeCaption' });
                });
            };
            /**
             * Get all absenteeisms in array from WebAPI
             *
             * @private
             *
             * @memberOf DetailAbsenteeismController
             */
            DetailAbsenteeismController.prototype.getAbsenteeisms = function () {
                var _this = this;
                this.stammdatenService.getAbsenteeismList(this.id).then(function (data) {
                    _this.absenteeisms = data;
                    _this.ui.absenteeismTable.data = data.map(function (x) { return ({
                        id: x.id,
                        objectId: x.objectId,
                        absenteeismReasonId: x.absenteeismReasonId,
                        absenteeismReason: x.absenteeismReason,
                        comment: x.comment,
                        dateFrom: x.dateFrom,
                        dateTo: x.dateTo,
                        contactPersonName: x.contactPersonName,
                        contactPersonId: x.contactPersonId,
                        style: _this.isAbsenteeismBanned(x) ? { 'background-color': 'orangered', 'color': 'white', 'font-weight': 'bold' } : {}
                    }); });
                    _this.$qui.functionWaiter("ui.createTable", _this);
                    _this.loading = false;
                });
            };
            /**
             * Get all absenteeism bans in array from WebAPI
             *
             * @private
             *
             * @memberOf DetailAbsenteeismController
             */
            DetailAbsenteeismController.prototype.getAbsenteeismBans = function () {
                var _this = this;
                this.stammdatenService.getAbsenteeismBanList(this.id).then(function (data) {
                    _this.absenteeismBansList = data;
                });
            };
            /**
             * Add a new absenteeism
             *
             * @private
             * @param {IAbsenteeism} form
             *
             * @memberOf DetailAbsenteeismController
             */
            DetailAbsenteeismController.prototype.addAbsenteeism = function (form) {
                var _this = this;
                form.parentObjectId = this.id;
                if (this.checkIsBanned(this.form)) {
                    $('#absenteeismBan').modal('show');
                    return;
                }
                this.stammdatenService.postAbsenteeism(form).then(function () {
                    _this.ui.notify(_this.ui.successNote);
                    _this.formState = "new";
                    _this.getAbsenteeisms();
                });
            };
            /**
             * Edit an existing absenteeism
             *
             * @private
             * @param {IAbsenteeism} data
             *
             * @memberOf DetailAbsenteeismController
             */
            DetailAbsenteeismController.prototype.editAbsenteeism = function (data) {
                this.form = angular.copy(data);
                this.formState = "edit";
                this.form.dateFrom = moment(data.dateFrom).toDate();
                this.form.dateTo = data.dateTo ? moment(data.dateTo).toDate() : null;
            };
            /**
             * Update an existing absenteeism by id
             *
             * @private
             *
             * @memberOf DetailAbsenteeismController
             */
            DetailAbsenteeismController.prototype.putAbsenteeism = function () {
                var _this = this;
                if (this.checkIsBanned(this.form)) {
                    $('#absenteeismBan').modal('show');
                    return;
                }
                this.stammdatenService.putAbsenteeism(this.id, this.form.objectId, this.form).then(function () {
                    _this.ui.notify(_this.ui.successNote);
                    _this.formState = "new";
                    _this.getAbsenteeisms();
                });
            };
            /**
             * Delete an existing absenteeism by id
             *
             * @private
             * @param {any} data
             *
             * @memberOf DetailAbsenteeismController
             */
            DetailAbsenteeismController.prototype.deleteAbsenteeism = function (item) {
                var _this = this;
                if (!this.isAbsenteeismBanned(item, true)) {
                    this.promptOptions.itemText = item.absenteeismReason;
                    QMC.Common.Utilities.confirm(this.promptOptions, function (data) {
                        if (data)
                            _this.stammdatenService.deleteAbsenteeism(_this.id, item.objectId).then(function () {
                                _this.ui.notify(_this.ui.deleteNote);
                                _this.formState = "new";
                                _this.getAbsenteeisms();
                            });
                    });
                }
            };
            DetailAbsenteeismController.prototype.isAbsenteeismBanned = function (item, showWarning) {
                if (showWarning === void 0) { showWarning = false; }
                var isBanned = false;
                if (item && this.absenteeismBansList && item.id) {
                    isBanned = this.checkIsBanned(item);
                }
                if (isBanned && showWarning) {
                    this.$qui.notify({
                        message: this.lng.translate(21008006, "Abwesenheitsperre vorhanden"),
                        title: "Fehler",
                        icon: "qm-icon-error",
                        status: "warning",
                        timer: 3500
                    });
                }
                return isBanned;
            };
            DetailAbsenteeismController.prototype.checkIsBanned = function (item) {
                if (!this.absenteeismBansList || !item)
                    return;
                for (var _i = 0, _a = this.absenteeismBansList; _i < _a.length; _i++) {
                    var listItem = _a[_i];
                    if (moment(listItem.banDate).endOf('day').toDate() >= this.$qui.createDateFromString(item.dateFrom)) {
                        return true;
                    }
                }
                return false;
            };
            DetailAbsenteeismController.prototype.shouldDisableForm = function (form) {
                if (this.formState !== 'edit')
                    return false;
                var item = this.ui.absenteeismTable.data.filter(function (x) { return x.objectId === form.objectId; })[0];
                if (item)
                    return this.checkIsBanned(item);
                return false;
            };
            DetailAbsenteeismController.prototype.validate = function () {
                var _this = this;
                var _a;
                this.validation.errors = [];
                this.validation.warnings = [];
                if (this.overlapCheck) {
                    var absenteeismRequestValidation = {
                        dateFrom: this.form.dateFrom,
                        objectId: this.form.objectId,
                        parentObjectId: (_a = this.form.parentObjectId) !== null && _a !== void 0 ? _a : this.id,
                        dateTo: this.form.dateTo,
                        reasonId: this.form.absenteeismReasonId
                    };
                    this.stammdatenService.checkAbsenteeismValidation(absenteeismRequestValidation).then(function (data) {
                        _this.validation.errors = data.errors;
                        _this.validation.warnings = data.warnings;
                        if (_this.checkIsBanned(_this.form)) {
                            _this.validation.errors.push(_this.lng.translate(21008007, 'Der Zeitraum ist für Abwesenheiten gesperrt.'));
                        }
                    });
                }
            };
            DetailAbsenteeismController = __decorate([
                QMC.Controller('QMC.Stammdaten', 'DetailAbsenteeismController'),
                QMC.Inject('StammdatenService', '$qui', 'KlientService', '$stateParams', '$scope', '$state', 'QmcLanguageService', 'QmcPermissionService', 'UserService', '$timeout')
            ], DetailAbsenteeismController);
            return DetailAbsenteeismController;
        }());
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        var DetailEducationController = /** @class */ (function () {
            /**
             * Creates an instance of DetailEducationController.
             * @param {StammdatenService} stammdatenService
             * @param {any} $qui
             * @param {Klient.KlientService} clientService
             * @param {any} $stateParams
             * @param {any} $scope
             * @param {any} $state
             * @param {Common.QmcLanguageService} lng
             * @param {Common.QmcPermissionService} permissionService
             *
             * @memberOf DetailEducationController
             */
            function DetailEducationController(stammdatenService, $qui, clientService, $stateParams, $scope, $state, lng, permissionService, userService, $timeout) {
                var _this = this;
                this.stammdatenService = stammdatenService;
                this.$qui = $qui;
                this.clientService = clientService;
                this.$stateParams = $stateParams;
                this.$scope = $scope;
                this.$state = $state;
                this.lng = lng;
                this.permissionService = permissionService;
                this.userService = userService;
                this.$timeout = $timeout;
                this.allowTableExport = false;
                this.ui = new QMC.Stammdaten.DetailUI();
                this.formState = "new";
                this.educationKind = [];
                this.objectType = 140068;
                this.documentObjectType = 140102;
                this.enableDocuments = false;
                $scope.Model = $scope.Model || { Name: 'xxx' };
                this.id = $stateParams.id;
                permissionService.getPermissionsByObjectTypes([this.objectType, this.documentObjectType]).then(function (data) {
                    _this.delete = data[0].delete;
                    _this.new = data[0].new;
                    _this.modify = data[0].modify;
                    _this.moduleAccess = data[0].moduleAccess && data[0].view;
                    _this.allowTableExport = data[0].print;
                    _this.enableDocuments = data[1].moduleAccess;
                    $timeout(function () {
                        if (!_this.new)
                            document.getElementsByName('newModalButton').forEach(function (x) { return x.style.visibility = 'hidden'; });
                        else
                            document.getElementsByName('newModalButton').forEach(function (x) { return x.style.visibility = 'unset'; });
                    });
                    var schoolEducationKind = {
                        id: "0",
                        objectId: "0",
                        caption: _this.lang.translate(20012000, "Schulausbildung")
                    };
                    var professEducationKind = {
                        id: "1",
                        objectId: "1",
                        caption: _this.lang.translate(20012001, "Berufliche Ausbildung")
                    };
                    var professCareerEducationKind = {
                        id: "2",
                        objectId: "2",
                        caption: _this.lang.translate(20012002, "Beruflicher Werdegang")
                    };
                    _this.educationKind.push(schoolEducationKind);
                    _this.educationKind.push(professEducationKind);
                    _this.educationKind.push(professCareerEducationKind);
                    _this.educationSchemaWvList = [];
                    _this.schoolsList = null;
                    _this.gradeLevelList = null;
                    _this.companiesList = null;
                    _this.$qui.getTableAutoload(_this.userService).then(function (ltd) {
                        _this.shouldLoadTableData = ltd;
                        if (_this.shouldLoadTableData) {
                            _this.getData();
                        }
                    });
                    _this.getEducationWvList();
                });
                //$qui.init('stammdaten', () => {
                $qui.init($qui.getSectionColor("/stammdaten"), function () {
                    $qui.bindEvents();
                    $('.qm-card').unbind('click');
                });
                this.lang = lng;
                this.promptOptions = {
                    title: "Lebenslauf / Ausbildung",
                    yesNo: true,
                    icon: "qm-icon-history2",
                    text: this.lang.translate(20000290, "Wollen Sie den Eintrag wirklich löschen?")
                };
                var vm = this;
                $("#edit-form").on('hidden.bs.modal', function () {
                    _this.$state.go('.', { dataId: undefined }, { reload: false });
                    $timeout(function () { return vm.initForm(); });
                });
            }
            DetailEducationController.prototype.getData = function () {
                this.getEducations();
            };
            /**
             * init a new form with default values
             *
             * @private
             *
             * @memberOf DetailEducationController
             */
            DetailEducationController.prototype.initForm = function () {
                this.formState = "new";
                this.form = {
                    id: null,
                    educationKind: null,
                    objectId: null,
                    comment: null,
                    validFrom: new Date(),
                    validTo: null,
                    caption: null,
                    classId: null,
                    contactPersonId: null,
                    educationType: null,
                    schoolCompanyId: QMC.Common.Constants.GUID_EMPTY,
                    statusId: null,
                    parentObjectId: this.id,
                    parentObjectType: QMC.Common.Constants.OBJECTTYPE_CLIENT
                };
                this.$qui.functionWaiter("ui.createForm", this);
            };
            /////////////// SERVICE FUNCTIONS ///////////////
            /**
             * get the education wv list
             *
             * @private
             * @returns }
             *
             * @memberOf DetailEducationController
             */
            DetailEducationController.prototype.getEducationWvList = function () {
                var _this = this;
                this.loading = true;
                return this.stammdatenService.getEducationWvList().then(function (dataEducation) {
                    _this.educationSchemaWvList.push(dataEducation);
                    _this.initForm();
                    var counter = 0;
                    var createForm = function () {
                        counter++;
                        if (counter > 2)
                            _this.$qui.functionWaiter("ui.createForm", _this);
                    };
                    _this.stammdatenService.getSchoolsList().then(function (data) {
                        _this.schoolsList = data;
                        createForm();
                    });
                    _this.stammdatenService.getCompaniesList().then(function (data) {
                        _this.companiesList = data;
                        createForm();
                    });
                    _this.clientService.getContactPersonListOfPerson(_this.form.schoolCompanyId, "", true, false, true).then(function (dataContactPerson) {
                        var values = dataContactPerson.map(function (x) { return ({ value: x.objectId, text: x.displayTitle }); });
                        values.sort(function (a, b) { return (a.text.toLocaleLowerCase() > b.text.toLocaleLowerCase()) ? 1 : ((b.text.toLocaleLowerCase() > a.text.toLocaleLowerCase()) ? -1 : 0); });
                        _this.contactPersonsList = values;
                        _this.stammdatenService.getGradeLevelList(_this.form.schoolCompanyId).then(function (dataGradeLvel) {
                            _this.gradeLevelList = dataGradeLvel;
                            createForm();
                        });
                    });
                    _this.loading = false;
                });
            };
            DetailEducationController.prototype.getCompaniesItemList = function () {
                var _a;
                return this.ui.select((_a = this.companiesList) !== null && _a !== void 0 ? _a : [], { value: 'id', text: 'displayTitle' });
            };
            DetailEducationController.prototype.getSchoolsItemList = function () {
                var _a;
                return this.ui.select((_a = this.schoolsList) !== null && _a !== void 0 ? _a : [], { value: 'id', text: 'displayTitle' });
            };
            DetailEducationController.prototype.getContactPersonsItemList = function () {
                var _this = this;
                if (this.form.schoolCompanyId) {
                    return this.clientService.getContactPersonListOfPerson(this.form.schoolCompanyId, "", true, false, true).then(function (dataContactPerson) {
                        var _a;
                        var values = dataContactPerson.map(function (x) { return ({ value: x.objectId, text: x.displayTitle }); });
                        values.sort(function (a, b) { return (a.text.toLocaleLowerCase() > b.text.toLocaleLowerCase()) ? 1 : ((b.text.toLocaleLowerCase() > a.text.toLocaleLowerCase()) ? -1 : 0); });
                        _this.contactPersonsList = values;
                        //prevent illegal values in contactPersonId
                        if (!_this.contactPersonsList.some(function (x) { return x.value === _this.form.contactPersonId; }))
                            _this.form.contactPersonId = undefined;
                        return _this.ui.select((_a = _this.contactPersonsList) !== null && _a !== void 0 ? _a : [], { value: 'value', text: 'text' });
                    });
                }
                else {
                    return [];
                }
            };
            DetailEducationController.prototype.getGradeLevelList = function () {
                var _this = this;
                if (this.form.schoolCompanyId != (null || undefined || "") && this.gradeLevelList != (null || undefined)) {
                    return this.stammdatenService.getGradeLevelList(this.form.schoolCompanyId).then(function (dataGradeLvel) {
                        _this.gradeLevelList = dataGradeLvel;
                        return _this.ui.select(_this.gradeLevelList, { value: 'id', text: 'className' });
                    });
                }
                else {
                    return [];
                }
            };
            DetailEducationController.prototype.getEducationKindWv = function () {
                var _a;
                return this.ui.select((_a = this.educationKind) !== null && _a !== void 0 ? _a : [], { value: 'id', text: 'caption' });
            };
            DetailEducationController.prototype.getSchoolTypeWv = function () {
                var _a, _b;
                return this.ui.select((_b = (_a = this.educationSchemaWvList[0]) === null || _a === void 0 ? void 0 : _a.schoolTypeWvList) !== null && _b !== void 0 ? _b : [], { value: 'id', text: 'name' });
            };
            DetailEducationController.prototype.getSchoolGraduationWv = function () {
                var _a, _b;
                return this.ui.select((_b = (_a = this.educationSchemaWvList[0]) === null || _a === void 0 ? void 0 : _a.schoolGraduationWvList) !== null && _b !== void 0 ? _b : [], { value: 'id', text: 'name' });
            };
            DetailEducationController.prototype.getSchoolStatusWv = function () {
                var _a, _b;
                return this.ui.select((_b = (_a = this.educationSchemaWvList[0]) === null || _a === void 0 ? void 0 : _a.schoolStatusWvList) !== null && _b !== void 0 ? _b : [], { value: 'id', text: 'name' });
            };
            DetailEducationController.prototype.getProfessionalTypeWv = function () {
                var _a, _b;
                return this.ui.select((_b = (_a = this.educationSchemaWvList[0]) === null || _a === void 0 ? void 0 : _a.professionalTypeWvList) !== null && _b !== void 0 ? _b : [], { value: 'id', text: 'name' });
            };
            DetailEducationController.prototype.getProfessionalGraduationWv = function () {
                var _a, _b;
                return this.ui.select((_b = (_a = this.educationSchemaWvList[0]) === null || _a === void 0 ? void 0 : _a.professionalGraduationWvList) !== null && _b !== void 0 ? _b : [], { value: 'id', text: 'name' });
            };
            DetailEducationController.prototype.getProfessionalStatusWv = function () {
                var _a, _b;
                return this.ui.select((_b = (_a = this.educationSchemaWvList[0]) === null || _a === void 0 ? void 0 : _a.professionalStatusWvList) !== null && _b !== void 0 ? _b : [], { value: 'id', text: 'name' });
            };
            DetailEducationController.prototype.getProfessionalCareerTypeWv = function () {
                var _a, _b;
                return this.ui.select((_b = (_a = this.educationSchemaWvList[0]) === null || _a === void 0 ? void 0 : _a.professionalCareerTypeWvList) !== null && _b !== void 0 ? _b : [], { value: 'id', text: 'name' });
            };
            DetailEducationController.prototype.getProfessionalCareerStatusWv = function () {
                var _a, _b;
                return this.ui.select((_b = (_a = this.educationSchemaWvList[0]) === null || _a === void 0 ? void 0 : _a.professionalCareerStatusWvList) !== null && _b !== void 0 ? _b : [], { value: 'id', text: 'name' });
            };
            DetailEducationController.prototype.getProfessionalTrainingTypeWv = function () {
                var _a, _b;
                return this.ui.select((_b = (_a = this.educationSchemaWvList[0]) === null || _a === void 0 ? void 0 : _a.professionalTrainingTypeWvList) !== null && _b !== void 0 ? _b : [], { value: 'id', text: 'name' });
            };
            /**
             * get a list of education
             *
             * @private
             *
             * @memberOf DetailEducationController
             */
            DetailEducationController.prototype.getEducations = function () {
                var _this = this;
                this.loading = true;
                this.stammdatenService.getEducationList(this.id).then(function (data) {
                    _this.ui.educationTable.data = data;
                    _this.$qui.functionWaiter("ui.createTable", _this);
                    _this.loading = false;
                    if (_this.$stateParams.dataId) {
                        var item = data.filter(function (x) { return x.objectId === _this.$stateParams.dataId; })[0];
                        if (item) {
                            $("#edit-form").modal('show');
                            _this.editEducation(item);
                        }
                    }
                });
            };
            /**
             * add a new education
             *
             * @private
             * @param {IEducation} form
             *
             * @memberOf DetailEducationController
             */
            DetailEducationController.prototype.addEducation = function (form) {
                var _this = this;
                this.loading = true;
                this.stammdatenService.postEducation(form).then(function () {
                    _this.ui.notify(_this.ui.successNote);
                    _this.formState = "new";
                    _this.getEducations();
                    $('#edit-form').modal('hide');
                });
            };
            /**
             * put a existing education
             *
             * @private
             * @param {IEducation} form
             *
             * @memberOf DetailEducationController
             */
            DetailEducationController.prototype.putEducation = function (form) {
                var _this = this;
                this.loading = true;
                this.stammdatenService.putEducation(this.id, form.objectId, form).then(function () {
                    _this.ui.notify(_this.ui.successNote);
                    _this.formState = "new";
                    _this.getEducations();
                    $('#edit-form').modal('hide');
                });
            };
            /**
             * edit a existing education
             *
             * @private
             * @param {IEducation} data
             *
             * @memberOf DetailEducationController
             */
            DetailEducationController.prototype.editEducation = function (data) {
                this.formState = "edit";
                this.form = angular.copy(data);
                this.form.validFrom = moment(data.validFrom).toDate();
                if (this.form.validTo !== null)
                    this.form.validTo = moment(data.validTo).toDate();
                this.$qui.functionWaiter("ui.createForm", this);
                this.$qui.waitForEl('#standardTabButton', function () {
                    $('#standardTabButton').click();
                });
                this.$state.go('.', { dataId: data.objectId });
            };
            /**
             * delete a existing education
             *
             * @private
             * @param {IEducation} data
             *
             * @memberOf DetailEducationController
             */
            DetailEducationController.prototype.deleteEducation = function (item) {
                var _this = this;
                this.promptOptions.itemText = item.caption;
                QMC.Common.Utilities.confirm(this.promptOptions, function (data) {
                    if (data)
                        _this.stammdatenService.deleteEducation(_this.id, item.objectId, item.educationKind).then(function () {
                            _this.ui.notify(_this.ui.deleteNote);
                            _this.formState = "new";
                            _this.getEducations();
                        });
                });
            };
            DetailEducationController = __decorate([
                QMC.Controller('QMC.Stammdaten', 'DetailEducationController'),
                QMC.Inject('StammdatenService', '$qui', 'KlientService', '$stateParams', '$scope', '$state', 'QmcLanguageService', 'QmcPermissionService', 'UserService', '$timeout')
            ], DetailEducationController);
            return DetailEducationController;
        }());
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        var DetailTrainingController = /** @class */ (function () {
            /**
             * Creates an instance of DetailTrainingController.
             * @param {StammdatenService} stammdatenService
             * @param {any} $qui
             * @param {Klient.KlientService} clientService
             * @param {any} $stateParams
             * @param {any} $scope
             * @param {any} $state
             * @param {Common.QmcLanguageService} lng
             * @param {Common.QmcPermissionService} permissionService
             *
             * @memberOf DetailTrainingController
             */
            function DetailTrainingController(stammdatenService, $qui, clientService, $stateParams, $scope, $state, lng, permissionService, userService, $timeout) {
                var _this = this;
                this.stammdatenService = stammdatenService;
                this.$qui = $qui;
                this.clientService = clientService;
                this.$scope = $scope;
                this.$state = $state;
                this.lng = lng;
                this.permissionService = permissionService;
                this.userService = userService;
                this.$timeout = $timeout;
                this.allowTableExport = false;
                this.ui = new QMC.Stammdaten.DetailUI();
                this.formState = "new";
                $scope.Model = $scope.Model || { Name: 'xxx' };
                this.id = $stateParams.id;
                permissionService.getPermissionsByObjectType(120023).then(function (data) {
                    _this.delete = data[0].delete;
                    _this.new = data[0].new;
                    _this.modify = data[0].modify;
                    _this.moduleAccess = data[0].moduleAccess && data[0].view;
                    _this.allowTableExport = data[0].print;
                    $timeout(function () {
                        if (!_this.new)
                            document.getElementsByName('newModalButton').forEach(function (x) { return x.style.visibility = 'hidden'; });
                        else
                            document.getElementsByName('newModalButton').forEach(function (x) { return x.style.visibility = 'unset'; });
                    });
                    _this.$qui.getTableAutoload(_this.userService).then(function (ltd) {
                        _this.shouldLoadTableData = ltd;
                        _this.trainingSchemaWvList = [];
                        if (_this.shouldLoadTableData) {
                            _this.getData();
                        }
                    });
                });
                //$qui.init('stammdaten', () => {
                $qui.init($qui.getSectionColor("/stammdaten"), function () {
                    $qui.bindEvents();
                    $('.qm-card').unbind('click');
                });
                this.lang = lng;
                this.promptOptions = {
                    title: "Fähigkeit / Fortbildung",
                    yesNo: true,
                    icon: "qm-icon-history2",
                    text: this.lang.translate(20000290, "Wollen Sie den Eintrag wirklich löschen?")
                };
            }
            DetailTrainingController.prototype.getData = function () {
                this.getTrainingWvList();
                this.getTrainingList();
            };
            /**
             * init a new form with default values
             *
             * @private
             *
             * @memberOf DetailTrainingController
             */
            DetailTrainingController.prototype.initForm = function () {
                this.form = {
                    id: null,
                    objectId: null,
                    parentObjectId: this.id,
                    parentObjectType: QMC.Common.Constants.OBJECTTYPE_EMPLOYEE,
                    validFrom: null,
                    validTo: null,
                    assignmentType: null,
                    childObjectType: null,
                    acquiredById: null,
                    description: null,
                    trainingId: null,
                    trainingTypeId: null
                };
                this.$qui.functionWaiter("ui.createForm", this);
            };
            /////////////// SERVICE FUNCTIONS ///////////////
            /**
             * get the training wv list
             *
             * @private
             * @returns }
             *
             * @memberOf DetailTrainingController
             */
            DetailTrainingController.prototype.getTrainingWvList = function () {
                var _this = this;
                this.loading = true;
                return this.stammdatenService.getTrainingWvList().then(function (dataTrainingWv) {
                    _this.trainingSchemaWvList.push(dataTrainingWv);
                    _this.initForm();
                    _this.loading = false;
                });
            };
            DetailTrainingController.prototype.getAquiredByWv = function () {
                return this.ui.select(this.trainingSchemaWvList[0].acquiredByWvList, { value: 'id', text: 'name' });
            };
            DetailTrainingController.prototype.getTrainingTypeWv = function () {
                return this.ui.select(this.trainingSchemaWvList[0].trainingTypeWvList, { value: 'id', text: 'name' });
            };
            DetailTrainingController.prototype.getTrainingWv = function () {
                return this.ui.select(this.trainingSchemaWvList[0].trainingWvList, { value: 'id', text: 'name' });
            };
            /**
             * get a list of training
             *
             * @private
             *
             * @memberOf DetailTrainingController
             */
            DetailTrainingController.prototype.getTrainingList = function () {
                var _this = this;
                this.loading = true;
                this.stammdatenService.getTrainingList(this.id, QMC.Common.Constants.OBJECTTYPE_EMPLOYEE).then(function (data) {
                    _this.ui.trainingTable.data = data;
                    _this.$qui.functionWaiter("ui.createTable", _this);
                    _this.loading = false;
                });
            };
            /**
             * add a new training
             *
             * @private
             * @param {ITraining} form
             *
             * @memberOf DetailTrainingController
             */
            DetailTrainingController.prototype.addTraining = function (form) {
                var _this = this;
                this.stammdatenService.postTraining(form).then(function () {
                    _this.ui.notify(_this.ui.successNote);
                    _this.formState = "new";
                    _this.getTrainingList();
                });
            };
            /**
             * put an existing training
             *
             * @private
             * @param {ITraining} form
             *
             * @memberOf DetailTrainingController
             */
            DetailTrainingController.prototype.putTraining = function (form) {
                var _this = this;
                this.stammdatenService.putTraining(this.id, form.objectId, form).then(function () {
                    _this.ui.notify(_this.ui.successNote);
                    _this.formState = "new";
                    _this.getTrainingList();
                });
            };
            /**
             * edit an existing training
             *
             * @private
             * @param {ITraining} data
             *
             * @memberOf DetailTrainingController
             */
            DetailTrainingController.prototype.editTraining = function (data) {
                this.formState = "edit";
                this.form = angular.copy(data);
                this.form.validFrom = moment(data.validFrom).toDate();
                if (this.form.validTo !== null)
                    this.form.validTo = moment(data.validTo).toDate();
            };
            /**
             * delete a existing training
             *
             * @private
             * @param {ITraining} data
             *
             * @memberOf DetailTrainingController
             */
            DetailTrainingController.prototype.deleteTraining = function (item) {
                var _this = this;
                this.promptOptions.itemText = item.description;
                QMC.Common.Utilities.confirm(this.promptOptions, function (data) {
                    if (data)
                        _this.stammdatenService.deleteTraining(_this.id, item.objectId).then(function () {
                            _this.ui.notify(_this.ui.deleteNote);
                            _this.formState = "new";
                            _this.getTrainingList();
                        });
                });
            };
            DetailTrainingController = __decorate([
                QMC.Controller('QMC.Stammdaten', 'DetailTrainingController'),
                QMC.Inject('StammdatenService', '$qui', 'KlientService', '$stateParams', '$scope', '$state', 'QmcLanguageService', 'QmcPermissionService', 'UserService', '$timeout')
            ], DetailTrainingController);
            return DetailTrainingController;
        }());
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        var DetailAccountingBookController = /** @class */ (function () {
            function DetailAccountingBookController($qui, $stateParams) {
                this.$qui = $qui;
                this.reference = {
                    id: $stateParams.id,
                    objectType: QMC.Common.Constants.OBJECTTYPE_CLIENT
                };
                this.$qui.functionWaiter("createDirective", this);
                $qui.init($qui.getSectionColor("/stammdaten"), function () {
                    $qui.bindEvents();
                    $('.qm-card').unbind('click');
                });
            }
            DetailAccountingBookController = __decorate([
                QMC.Controller('QMC.Stammdaten', 'DetailAccountingBookController'),
                QMC.Inject('$qui', '$stateParams')
            ], DetailAccountingBookController);
            return DetailAccountingBookController;
        }());
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        var DetailLegalController = /** @class */ (function () {
            /**
             * QMC.Stammdaten.DetailLegalController
             * @constructor
             * @param stammdatenService
             * @param $qui
             * @param clientService
             * @param $stateParams
             * @param $scope
             * @param $state
             * @param lng
             */
            function DetailLegalController(stammdatenService, $qui, clientService, $stateParams, $scope, $state, lng, permissionService, userService, $timeout, udfService) {
                var _this = this;
                this.stammdatenService = stammdatenService;
                this.$qui = $qui;
                this.clientService = clientService;
                this.$stateParams = $stateParams;
                this.$scope = $scope;
                this.$state = $state;
                this.lng = lng;
                this.permissionService = permissionService;
                this.userService = userService;
                this.$timeout = $timeout;
                this.allowTableExport = false;
                this.ui = new Stammdaten.DetailUI();
                this.lawOwnerPersons = [];
                this.objectType = 140027;
                this.documentObjectType = 140116;
                this.enableDocuments = false;
                this.udfs = [];
                $scope.Model = $scope.Model || { Name: "xxx" };
                this.id = $stateParams.id;
                this.permissionLoad = true;
                permissionService.getPermissionsByObjectTypes([this.objectType, this.documentObjectType]).then(function (data) {
                    _this.delete = data[0].delete;
                    _this.new = data[0].new;
                    _this.modify = data[0].modify;
                    _this.moduleAccess = data[0].moduleAccess && data[0].view;
                    _this.allowTableExport = data[0].print;
                    _this.enableDocuments = data[0].moduleAccess;
                    $timeout(function () {
                        if (!_this.new)
                            document.getElementsByName('newModalButton').forEach(function (x) { return x.style.visibility = 'hidden'; });
                        else
                            document.getElementsByName('newModalButton').forEach(function (x) { return x.style.visibility = 'unset'; });
                    });
                    _this.$qui.getTableAutoload(_this.userService).then(function (ltd) {
                        _this.shouldLoadTableData = ltd;
                        if (_this.shouldLoadTableData) {
                            _this.getData();
                        }
                    });
                    _this.permissionLoad = false;
                    // get possible lawOwners, by generic method (only legal Carer)
                    _this.clientService.getPersonsByKeyAssignment('RECHTLICHES_RECHTEINHABER', false).then(function (data) {
                        _this.lawOwnerPersons = data;
                        _this.getWvList();
                    });
                });
                this.lang = lng;
                this.promptOptions = {
                    title: "Rechtliches löschen",
                    yesNo: true,
                    icon: "qm-icon-history2",
                    text: this.lang.translate(20000290, "Wollen Sie den Eintrag wirklich löschen?")
                };
                $qui.init($qui.getSectionColor("/stammdaten"), function () {
                    $qui.bindEvents();
                    $(".qm-card").unbind("click");
                });
                this.initForm();
                var vm = this;
                $("#edit-form").on('hidden.bs.modal', function () {
                    _this.$state.go('.', { dataId: undefined }, { reload: false });
                    $timeout(function () { return vm.initForm(); });
                    $("#edit-form").find('.tab-content').children().removeClass('in').removeClass('active');
                    $("#edit-form").find('.tab-content').find('#baseDataTab').addClass('in active');
                });
                udfService.getUserDefinedFields(this.objectType).then(function (data) {
                    _this.udfs = data.sort(function (a, b) { return a.caption.localeCompare(b.caption); });
                });
            }
            DetailLegalController.prototype.getData = function () {
                this.getLegalList();
            };
            /**
             * init form
             *
             * @private
             *
             * @memberOf DetailLegalController
             */
            DetailLegalController.prototype.initForm = function () {
                this.formState = "new";
                this.form = {
                    id: null,
                    objectId: null,
                    parentObjectId: this.id,
                    dateFrom: new Date(),
                    dateTo: null,
                    lawTypeId: null,
                    lawTypeName: '',
                    firstLawOwnerId: null,
                    firstLawOwnerName: '',
                    secondLawOwnerId: null,
                    secondLawOwnerName: '',
                    lawBookId: null,
                    lawBookName: '',
                    lawBookShortName: '',
                    legalScaleId: null,
                    legalScaleName: '',
                    legalBasisId: null,
                    legalBasisName: '',
                    comment: '',
                    hasNoLawAdditions: false,
                    hasNoParagraphs: false,
                    personTypeFirst: null,
                    personTypeSecond: null,
                };
            };
            /**
             * get the wv list
             *
             * @private
             *
             * @memberOf DetailAddressController
             */
            DetailLegalController.prototype.getWvList = function () {
                var _this = this;
                this.loading = true;
                this.stammdatenService.getLegalWvList().then(function (wvData) {
                    _this.wvList = wvData;
                    _this.loading = false;
                    _this.$qui.functionWaiter("ui.createForm", _this);
                });
            };
            /**
             * get all legal data of a client
             *
             * @private
             *
             * @memberOf DetailLegalController
             */
            DetailLegalController.prototype.getLegalList = function () {
                var _this = this;
                this.loading = true;
                this.stammdatenService.getLegalList(this.$stateParams.client).then(function (data) {
                    _this.ui.legalTable.data = data;
                    _this.$qui.functionWaiter("ui.createTable", _this);
                    _this.loading = false;
                    if (_this.$stateParams.dataId) {
                        var item = data.filter(function (x) { return x.objectId === _this.$stateParams.dataId; })[0];
                        if (item) {
                            $("#edit-form").modal('show');
                            _this.editLegal(item);
                        }
                    }
                });
            };
            /**
             * add a new legal
             *
             * @private
             * @param {ILegalCreate} form
             *
             * @memberOf DetailAddressController
             */
            DetailLegalController.prototype.addLegal = function (form) {
                var _this = this;
                if (this.form.lawBookId === null) {
                    this.form.legalBasisId = null;
                }
                this.loading = true;
                form.parentObjectId = this.id;
                this.stammdatenService.postLegal(form).then(function (e) {
                    _this.ui.notify(_this.ui.successNote);
                    _this.getLegalList();
                    _this.formState = "new";
                    $('#edit-form').modal('hide');
                });
            };
            /**
             * Edit an existing legal
             *
             * @private
             * @param {ILegalUpdate} data
             *
             * @memberOf DetailLegalController
             */
            DetailLegalController.prototype.editLegal = function (data) {
                var _this = this;
                this.formState = "edit";
                this.$qui.waitForEl('#standardTabButton', function () {
                    $('#standardTabButton').click();
                });
                this.$state.go('.', { dataId: data.objectId });
                setTimeout(function () {
                    _this.stammdatenService.getLegal(_this.id, data.id).then(function (data) {
                        _this.form = data;
                        _this.$qui.scopeApply(_this.$scope);
                    });
                });
            };
            /**
             * Updates an existing legal by id
             *
             * @private
             *
             * @memberOf DetailLegalController
             */
            DetailLegalController.prototype.putLegal = function () {
                var _this = this;
                if (this.form.lawBookId === null) {
                    this.form.legalBasisId = null;
                }
                this.loading = true;
                this.stammdatenService.putLegal(this.form.parentObjectId, this.form.objectId, this.form).then(function (data) {
                    _this.ui.notify(_this.ui.successNote);
                    _this.formState = "new";
                    _this.getLegalList();
                    $('#edit-form').modal('hide');
                });
                this.udfs.forEach(function (x) { var _a; return (_a = x.save) === null || _a === void 0 ? void 0 : _a.call(x, false); });
            };
            /**
             * Delete an existing legal by id
             *
             * @private
             * @param {any} data
             *
             * @memberOf DetailLegalController
             */
            DetailLegalController.prototype.deleteLegal = function (item) {
                var _this = this;
                QMC.Common.Utilities.confirm(this.promptOptions, function (data) {
                    if (data) {
                        _this.stammdatenService.deleteLegal(_this.id, item.objectId).then(function (e) {
                            _this.ui.notify(_this.ui.deleteNote);
                            _this.formState = "new";
                            _this.getLegalList();
                        });
                    }
                });
            };
            /**
             * get the law type list
             *
             * @returns {ng.IPromise<any>}
             *
             * @memberOf DetailLegalController
             */
            DetailLegalController.prototype.getLawTypeList = function () {
                return this.wvList.lawWvList.map(function (obj) {
                    return {
                        value: obj.objectId,
                        text: obj.name
                    };
                });
            };
            /**
             * get the law addition list
             *
             * @private
             * @returns {ng.IPromise<any>}
             *
             * @memberOf DetailLegalController
             */
            DetailLegalController.prototype.getLawAdditionList = function () {
                var data = [];
                if (this.form.hasNoLawAdditions) {
                    this.form.legalScaleId = null;
                }
                if (this.form.lawTypeId == null)
                    return [];
                var lawTypeName = this.getLawTypeName(this.form.lawTypeId);
                data = this.wvList.lawAdditionWvList[lawTypeName];
                this.form.hasNoLawAdditions = (data.length <= 0);
                return data.map(function (obj) {
                    return {
                        value: obj.objectId,
                        text: obj.name
                    };
                });
            };
            DetailLegalController.prototype.getLawTypeName = function (lawTypeId) {
                var lawType = this.wvList.lawWvList.filter(function (lawType) { return lawType.objectId === lawTypeId; });
                var lawTypeName = lawType[0].name;
                return lawTypeName.substring(0, 1).toLowerCase() + lawTypeName.substring(1);
            };
            DetailLegalController.prototype.getLawOwnerList = function () {
                var _this = this;
                var list = this.lawOwnerPersons.map(function (x) { return ({ value: x.objectId, text: _this.$qui.createPersonDisplay(x.name, x.forename, x.shortCaption, x.personNumber), subText: x.institute, group: x.objectTypeCaption }); });
                list.unshift({ text: '', value: '', group: '', subText: '' });
                return list;
            };
            DetailLegalController.prototype.getLawBooks = function () {
                return this.wvList.lawBookCategoryWvList.map(function (obj) {
                    return {
                        value: obj.objectId,
                        text: obj.name
                    };
                });
            };
            /**
             * get the paragraph (law Basis) list
             *
             * @private
             * @returns {ng.IPromise<any>}
             *
             * @memberOf DetailLegalController
             */
            DetailLegalController.prototype.getParagraphList = function () {
                var _this = this;
                if (this.form.lawBookId === null || this.form.lawBookId === QMC.Common.Constants.GUID_EMPTY) {
                    this.form.hasNoParagraphs = true;
                    return [];
                }
                var lawBookName = this.getLawBookName(this.form.lawBookId);
                var data = this.wvList.legalBasisWvList[lawBookName];
                if (!data) {
                    return [];
                }
                this.form.hasNoParagraphs = (data.length <= 0);
                if (this.form.hasNoParagraphs || this.form.lawBookId === null || this.form.lawBookId === QMC.Common.Constants.GUID_EMPTY) {
                    return [];
                }
                var lawBookId = data.find(function (lawBookId) { return lawBookId.objectId === _this.form.legalBasisId; });
                this.form.legalBasisId = lawBookId != null ? lawBookId.objectId : data[0].objectId;
                return data.map(function (obj) {
                    return {
                        value: obj.objectId,
                        text: obj.name
                    };
                });
            };
            DetailLegalController.prototype.getLawBookName = function (lawBookId) {
                if (!lawBookId || lawBookId === QMC.Common.Constants.GUID_EMPTY)
                    return "";
                var lawBook = this.wvList.lawBookCategoryWvList.filter(function (lawBook) { return lawBook.objectId === lawBookId; });
                var lawBookName = lawBook[0].name;
                return lawBookName.substring(0, 1).toLowerCase() + lawBookName.substring(1);
            };
            DetailLegalController = __decorate([
                QMC.Controller("QMC.Stammdaten", "DetailLegalController"),
                QMC.Inject("StammdatenService", "$qui", "KlientService", "$stateParams", "$scope", "$state", "QmcLanguageService", "QmcPermissionService", 'UserService', '$timeout', 'QmcUdfService')
            ], DetailLegalController);
            return DetailLegalController;
        }());
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        var DetailExtendedMainDataController = /** @class */ (function () {
            /**
             * Creates an instance of DetailExtendedMainDataController.
             * @param {StammdatenService} stammdatenService
             * @param {any} $qui
             * @param {Klient.KlientService} clientService
             * @param {any} $state
             * @param {any} $stateParams
             * @param {any} $scope
             * @param {Common.QmcPermissionService} permissionService
             *
             * @memberOf ExtendedMainDataController
             */
            function DetailExtendedMainDataController(stammdatenService, $qui, clientService, $state, $stateParams, $scope, permissionService, $timeout, employeeService, $location) {
                var _this = this;
                this.stammdatenService = stammdatenService;
                this.$qui = $qui;
                this.clientService = clientService;
                this.$state = $state;
                this.permissionService = permissionService;
                this.$timeout = $timeout;
                this.employeeService = employeeService;
                this.$location = $location;
                // Permissions
                this.ui = new QMC.Stammdaten.DetailUI();
                this.validation = {
                    errors: [],
                    warnings: []
                };
                this.loading = true;
                this.id = $stateParams.id;
                switch (this.$location.$$path.split('/')[1]) {
                    case 'employee':
                        this.parentObjectType = 120000;
                        this.objectType = 120033; //Mitarbeiter: Erweiterte Stammdaten
                        break;
                    default:
                        this.parentObjectType = 140000;
                        this.objectType = 140086; //Kliente: Erweiterte Stammdaten
                        break;
                }
                permissionService.getPermissionsForDataset(this.id, null).then(function (data) {
                    _this.delete = data[0].delete;
                    _this.new = data[0].new;
                    _this.modify = data[0].modify;
                    _this.moduleAccess = data[0].moduleAccess;
                });
                this.$qui.waitForEl('#newModalButton', function () {
                    document.getElementsByName('newModalButton').forEach(function (x) { return x.style.visibility = 'hidden'; });
                });
                this.initForm();
                this.getWv().then(function () {
                    _this.languageWvList = _this.wv.languageWvList.map(function (x) { return ({ text: x.name, value: x.objectId }); });
                    _this.familyStatusWvList = _this.wv.familyStatusWvList.map(function (x) { return ({ text: x.name, value: x.objectId }); });
                    _this.nationalityWvList = _this.wv.nationalityWvList.map(function (x) { return ({ text: x.name, value: x.objectId }); });
                    _this.hairColorWvList = _this.wv.hairColorWvList.map(function (x) { return ({ text: x.name, value: x.objectId }); });
                    if (_this.parentObjectType === 140000) {
                        _this.languageLevelWvList = _this.wv.languageLevelWvlist.map(function (x) { return ({ text: x.name, value: x.objectId }); });
                        _this.bloodCategoryWvList = _this.wv.bloodCategoryWvList.map(function (x) { return ({ text: x.name, value: x.objectId }); });
                        _this.eyesColorWvList = _this.wv.eyesColorWvList.map(function (x) { return ({ text: x.name, value: x.objectId }); });
                        _this.migrationBackgroundWvList = _this.wv.migrationBackgroundWvList.map(function (x) { return ({ text: x.name, value: x.objectId }); });
                        _this.birthCountryWvList = _this.wv.birthCountryWvList.map(function (x) { return ({ text: x.name, value: x.objectId }); });
                    }
                    else {
                        _this.bloodCategoryWvList = _this.wv.bloodTypeWvList.map(function (x) { return ({ text: x.name, value: x.objectId }); });
                        _this.eyesColorWvList = _this.wv.eyeColorWvList.map(function (x) { return ({ text: x.name, value: x.objectId }); });
                        _this.birthCountryWvList = _this.wv.countryWvList.map(function (x) { return ({ text: x.name, value: x.objectId }); });
                    }
                    _this.getData(_this.id);
                });
                this.saveEventChange = false;
            }
            /**
             * init form
             *
             * @private
             *
             * @memberOf StammdatenClientDetailController
             */
            DetailExtendedMainDataController.prototype.initForm = function () {
                if (this.parentObjectType === 140000) {
                    this.form = {
                        id: null,
                        objectId: null,
                        languageId: null,
                        languageLevelId: null,
                        secondLanguageId: null,
                        secondLanguageLevelId: null,
                        thirdLanguageId: null,
                        thirdLanguageLevelId: null,
                        bloodCategoryId: null,
                        hairColorId: null,
                        eyesColorId: null,
                        familyStatusId: null,
                        migrationBackgroundId: null,
                        nationalityId: null,
                        secondNationalityId: null,
                        socialInsuranceNumber: '',
                        dateOfDeath: null,
                        birthcountryId: null
                    };
                }
                else {
                    this.form = {
                        id: null,
                        objectId: null,
                        name: '',
                        forename: '',
                        displayTitle: '',
                        abbreviation: '',
                        birthday: null,
                        gender: null,
                        institute: '',
                        title: '',
                        amountChildren: 0,
                        birthName: '',
                        birthplace: '',
                        bloodType: '',
                        bloodTypeId: null,
                        comment: '',
                        dateOfDeath: null,
                        employeeNr: '',
                        eyeColor: '',
                        eyeColorId: null,
                        familyStatus: '',
                        familyStatusId: null,
                        firstLanguage: '',
                        firstLanguageId: null,
                        firstNationality: '',
                        firstNationalityId: null,
                        genderId: null,
                        hairColor: '',
                        hairColorId: null,
                        instituteId: null,
                        isBaptized: false,
                        originCountry: '',
                        originCountryId: null,
                        permissions: { view: false, new: false, modify: false, delete: false },
                        personStatus: '',
                        personStatusId: null,
                        postalSalutation: '',
                        postalSalutationId: null,
                        religion: '',
                        religionId: null,
                        salutation: '',
                        salutationId: null,
                        secondLanguage: '',
                        secondLanguageId: null,
                        secondNationality: '',
                        secondNationalityId: null,
                        socialInsuranceNumber: '',
                        titleId: null,
                    };
                }
            };
            /**
             * get the client wv list
             *
             * @private
             * @param {Guid} id
             *
             * @memberOf StammdatenClientDetailController
            */
            DetailExtendedMainDataController.prototype.getWv = function () {
                var _this = this;
                if (this.parentObjectType === 140000) {
                    return this.clientService.getClientWv().then(function (data) {
                        _this.wv = data;
                    });
                }
                else {
                    return this.employeeService.getEmployeeWv().then(function (data) {
                        _this.wv = data;
                    });
                }
            };
            DetailExtendedMainDataController.prototype.getData = function (id) {
                var _this = this;
                if (this.parentObjectType === 140000) {
                    return this.clientService.getClientExtendedMainData(id).then(function (data) {
                        _this.form = angular.copy(data);
                    }).finally(function () {
                        _this.loading = false;
                    });
                }
                else {
                    return this.employeeService.getEmployee(id).then(function (data) {
                        _this.form = angular.copy(data);
                    }).finally(function () {
                        _this.loading = false;
                    });
                }
            };
            /**
             * update the extended main data of a client
             *
             * @private
             * @param {Guid} id
             *
             * @memberOf StammdatenClientDetailController
            */
            DetailExtendedMainDataController.prototype.updateData = function (data) {
                var _this = this;
                this.validation.errors.length = 0;
                this.validation.warnings.length = 0;
                var validationRequest = {
                    socialInsuranceNumber: this.form.socialInsuranceNumber,
                    personObjectId: this.id
                };
                this.stammdatenService.getPersonValidation(validationRequest).then(function (dataValidationResult) {
                    _this.validation.errors = dataValidationResult.errors;
                    _this.validation.warnings = dataValidationResult.warnings;
                    if (_this.validation.errors.length === 0 && _this.validation.warnings.length === 0) {
                        _this.saveData();
                    }
                    else {
                        $('#validationModal').modal('toggle');
                    }
                });
            };
            DetailExtendedMainDataController.prototype.saveData = function () {
                var _this = this;
                this.saving = true;
                if (this.parentObjectType === 140000) {
                    this.clientService.putClientExtendedMainData(this.id, this.form).then(function (dataClient) {
                        _this.$qui.notify(_this.$qui.successNote);
                    }).finally(function () {
                        _this.saving = false;
                    });
                    ;
                }
                else {
                    this.employeeService.putEmployee(this.id, this.form).then(function (dataEmployee) {
                        _this.$qui.notify(_this.$qui.successNote);
                    }).finally(function () {
                        _this.saving = false;
                    });
                }
            };
            DetailExtendedMainDataController = __decorate([
                QMC.Controller('QMC.Stammdaten', 'DetailExtendedMainDataController'),
                QMC.Inject('StammdatenService', '$qui', 'KlientService', '$state', '$stateParams', '$scope', 'QmcPermissionService', '$timeout', 'EmployeeService', '$location')
            ], DetailExtendedMainDataController);
            return DetailExtendedMainDataController;
        }());
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        var DetailMedicalEvidenceController = /** @class */ (function () {
            /**
             * QMC.Stammdaten.DetailAdressController
             */
            function DetailMedicalEvidenceController(stammdatenService, $qui, $stateParams, lng, permissionService, userService, $location, $timeout, $scope, udfService) {
                var _this = this;
                this.stammdatenService = stammdatenService;
                this.$qui = $qui;
                this.lng = lng;
                this.userService = userService;
                this.$location = $location;
                this.allowTableExport = false;
                this.ui = new Stammdaten.DetailUI();
                this.udfs = [];
                this.id = $stateParams.id;
                switch (this.$location.$$path.split('/')[1]) {
                    case 'employee':
                        this.parentObjectType = 120000;
                        this.objectType = 120044;
                        break;
                    default:
                        this.parentObjectType = 140000;
                        this.objectType = 140044;
                        break;
                }
                permissionService.getPermissionsByObjectType(this.objectType).then(function (data) {
                    _this.delete = data[0].delete;
                    _this.new = data[0].new;
                    _this.modify = data[0].modify;
                    _this.moduleAccess = data[0].moduleAccess && data[0].view;
                    _this.allowTableExport = data[0].print;
                    _this.$qui.waitForEl('#newModalButton', function () {
                        if (!_this.new)
                            document.getElementsByName('newModalButton').forEach(function (x) { return x.style.visibility = 'hidden'; });
                        else
                            document.getElementsByName('newModalButton').forEach(function (x) { return x.style.visibility = 'unset'; });
                    });
                    _this.getWv();
                    _this.$qui.getTableAutoload(_this.userService).then(function (ltd) {
                        _this.shouldLoadTableData = ltd;
                        if (_this.shouldLoadTableData) {
                            _this.getData();
                        }
                    });
                });
                $qui.init(undefined, function () {
                    $qui.bindEvents();
                    $(".qm-card").unbind("click");
                });
                this.promptOptions = {
                    title: this.lng.translate(20031000, "Med. Nachweis"),
                    yesNo: true,
                    icon: "qm-icon-history2",
                    text: this.lng.translate(20000290, "Wollen Sie den Eintrag wirklich löschen?")
                };
                $("#edit-form").on('hidden.bs.modal', function () {
                    $timeout(function () { return $scope.vm.initForm(); });
                    $("#edit-form").find('.tab-content').children().removeClass('in').removeClass('active');
                    $("#edit-form").find('.tab-content').find('#baseDataTab').addClass('in active');
                });
                udfService.getUserDefinedFields(this.objectType).then(function (data) {
                    _this.udfs = data.sort(function (a, b) { return a.caption.localeCompare(b.caption); });
                });
            }
            DetailMedicalEvidenceController.prototype.getData = function () {
                this.getList();
            };
            /////////////// DISPLAY LOGIC ///////////////
            DetailMedicalEvidenceController.prototype.initForm = function () {
                this.formState = "new";
                this.form = {
                    id: null,
                    objectId: null,
                    date: new Date(),
                    validToDate: null,
                    additionalText: '',
                    executor: '',
                    executorId: null,
                    evidenceType: '',
                    evidenceTypeId: null,
                    evidenceKind: '',
                    evidenceKindId: null,
                    initiative: '',
                    initiativeId: null,
                    result: '',
                    resultId: null,
                    comment: '',
                    parentObjectId: this.id
                };
            };
            DetailMedicalEvidenceController.prototype.getEvidenceKind = function () {
                return this.wv.evidenceKindWvList.map(function (x) { return ({ text: x.name, value: x.objectId }); });
            };
            DetailMedicalEvidenceController.prototype.getEvidenceType = function () {
                return this.wv.evidenceTypeWvList.map(function (x) { return ({ text: x.name, value: x.objectId }); });
            };
            DetailMedicalEvidenceController.prototype.getInitiative = function () {
                var list = this.wv.initiativeWvList.map(function (x) { return ({ text: x.name, value: x.objectId }); });
                list.unshift({ text: '', value: '' });
                return list;
            };
            DetailMedicalEvidenceController.prototype.getExecutioner = function () {
                var list = this.executioners.map(function (x) { return ({ text: x.displayTitle, value: x.objectId, group: x.objectTypeCaption }); });
                list.unshift({ text: '', value: '', group: '' });
                return list;
            };
            DetailMedicalEvidenceController.prototype.getResult = function () {
                return this.wv.resultWvList.map(function (x) { return ({ text: x.name, value: x.objectId }); });
            };
            /////////////// SERVICE FUNCTIONS ///////////////
            DetailMedicalEvidenceController.prototype.getWv = function () {
                var _this = this;
                this.stammdatenService.getMedicalEvidenceWvList().then(function (data) {
                    _this.wv = data;
                    _this.stammdatenService.getMedicalEvidenceExecutioners().then(function (data) {
                        _this.executioners = data;
                        _this.initForm();
                        _this.$qui.functionWaiter("ui.createForm", _this);
                    });
                });
            };
            DetailMedicalEvidenceController.prototype.getList = function () {
                var _this = this;
                this.loading = true;
                this.stammdatenService.getMedicalEvidenceList(this.id).then(function (data) {
                    _this.ui.medicalEvidenceTable.data = data;
                    _this.$qui.functionWaiter("ui.createTable", _this);
                    _this.loading = false;
                });
            };
            DetailMedicalEvidenceController.prototype.addMedicalEvidence = function (form) {
                var _this = this;
                this.stammdatenService.postMedicalEvidence(form).then(function () {
                    _this.ui.notify(_this.ui.successNote);
                    _this.formState = "new";
                    _this.getList();
                    $('#edit-form').modal('hide');
                });
            };
            DetailMedicalEvidenceController.prototype.editMedicalEvidence = function (data) {
                this.formState = "edit";
                this.form = data;
                if (data.date)
                    this.form.date = this.$qui.createDateFromString(this.form.date);
                if (data.validToDate)
                    this.form.validToDate = this.$qui.createDateFromString(this.form.validToDate);
                this.$qui.waitForEl('#standardTabButton', function () {
                    $('#standardTabButton').click();
                });
            };
            DetailMedicalEvidenceController.prototype.putMedicalEvidence = function (form) {
                var _this = this;
                this.stammdatenService.putMedicalEvidence(this.id, form.objectId, form).then(function () {
                    _this.ui.notify(_this.ui.successNote);
                    _this.formState = "new";
                    _this.getList();
                    $('#edit-form').modal('hide');
                });
                this.udfs.forEach(function (x) { var _a; return (_a = x.save) === null || _a === void 0 ? void 0 : _a.call(x, false); });
            };
            DetailMedicalEvidenceController.prototype.deleteMedicalEvidence = function (item) {
                var _this = this;
                QMC.Common.Utilities.confirm(this.promptOptions, function (data) {
                    if (data)
                        _this.stammdatenService.deleteMedicalEvidence(_this.id, item.objectId).then(function () {
                            _this.ui.notify(_this.ui.deleteNote);
                            _this.formState = "new";
                            _this.getList();
                        });
                });
            };
            DetailMedicalEvidenceController = __decorate([
                QMC.Controller("QMC.Stammdaten", "DetailMedicalEvidenceController"),
                QMC.Inject("StammdatenService", "$qui", "$stateParams", "QmcLanguageService", "QmcPermissionService", 'UserService', '$location', '$timeout', '$scope', 'QmcUdfService')
            ], DetailMedicalEvidenceController);
            return DetailMedicalEvidenceController;
        }());
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        var DetailMedicalResponsibleController = /** @class */ (function () {
            /**
             * QMC.Stammdaten.DetailMedicalResponsibleController
             * @constructor
             * @param stammdatenService
             * @param $qui
             * @param clientService
             * @param $stateParams
             * @param $scope
             * @param $state
             * @param lng
             */
            function DetailMedicalResponsibleController(stammdatenService, $qui, $stateParams, lng, permissionService, userService) {
                var _this = this;
                this.stammdatenService = stammdatenService;
                this.$qui = $qui;
                this.$stateParams = $stateParams;
                this.lng = lng;
                this.permissionService = permissionService;
                this.userService = userService;
                this.allowTableExport = false;
                this.ui = new Stammdaten.DetailUI();
                this.institutes = [];
                this.id = this.$stateParams.id;
                this.medicationIssuedThroughData = null;
                this.medicalResponsibleData = null;
                this.permissionService.getPermissionsByObjectTypes([120028, 120034]).then(function (data) {
                    _this.deleteMedicalResponsiblePerm = data[0].delete;
                    _this.newMedicalResponsiblePerm = data[0].new;
                    _this.modifyMedicalResponsiblePerm = data[0].modify;
                    _this.moduleMedicalResponsiblePerm = data[0].moduleAccess && data[0].view;
                    _this.deleteMedicationIssuedThrough = data[1].delete;
                    _this.newMedicationIssuedThrough = data[1].new;
                    _this.modifyMedicationIssuedThrough = data[1].modify;
                    _this.moduleAccessMedicationIssuedThrough = data[1].moduleAccess && data[0].view;
                    _this.allowTableExport = data[0].print;
                    _this.$qui.waitForEl('#newModalButton', function () {
                        document.getElementsByName('newModalButton').forEach(function (x) { return x.style.visibility = 'hidden'; });
                    });
                    _this.getWv();
                    _this.$qui.getTableAutoload(_this.userService).then(function (ltd) {
                        _this.shouldLoadTableData = ltd;
                        if (_this.shouldLoadTableData) {
                            _this.getData();
                        }
                    });
                });
                $qui.init(undefined, function () {
                    $qui.bindEvents();
                    $(".qm-card").unbind("click");
                });
                this.promptOptions = {
                    title: this.lng.translate(20034005, "Med. Verantwortlich / Medikamentausgabe"),
                    yesNo: true,
                    icon: "qm-icon-history2",
                    text: this.lng.translate(20000290, "Wollen Sie den Eintrag wirklich löschen?")
                };
            }
            DetailMedicalResponsibleController.prototype.getData = function () {
                this.getList();
            };
            /////////////// DISPLAY LOGIC ///////////////
            DetailMedicalResponsibleController.prototype.initForm = function () {
                this.formState = "new";
                this.form = {
                    id: null,
                    organisationId: null,
                    objectId: null,
                    assignmentType: this.assignmentType,
                    displayTitle: null,
                    organisation: null,
                    organisationIds: [],
                    parentObjectId: null,
                    parentObjectType: 130000,
                    childObjectId: this.id,
                    childObjectType: QMC.Common.Constants.OBJECTTYPE_EMPLOYEE
                };
            };
            DetailMedicalResponsibleController.prototype.getInstitute = function () {
                return this.institutes.map(function (x) { return ({ text: x.caption, value: x.objectId }); });
                ;
            };
            /////////////// SERVICE FUNCTIONS ///////////////
            DetailMedicalResponsibleController.prototype.getWv = function () {
                var _this = this;
                this.stammdatenService.getInstituteList().then(function (data) {
                    _this.institutes = data;
                    _this.initForm();
                    _this.$qui.functionWaiter("ui.createForm", _this);
                });
            };
            DetailMedicalResponsibleController.prototype.getList = function () {
                this.getMedicalResponsibleList();
                this.getMedicationIssuedThroughList();
            };
            DetailMedicalResponsibleController.prototype.getMedicalResponsibleList = function () {
                var _this = this;
                this.loading = true;
                this.stammdatenService.getMedicationResponsibleMedicatioThroughList(this.id, 160).then(function (data) {
                    _this.medicalResponsibleData = data;
                    _this.ui.medicalResponsibleTable.data = data;
                    _this.$qui.functionWaiter("ui.createTable", _this);
                    _this.loading = false;
                });
            };
            DetailMedicalResponsibleController.prototype.getMedicationIssuedThroughList = function () {
                var _this = this;
                this.loading = true;
                this.stammdatenService.getMedicationResponsibleMedicatioThroughList(this.id, 150).then(function (data) {
                    _this.medicationIssuedThroughData = data;
                    _this.ui.medicationIssuedThroughTable.data = data;
                    _this.createMedicationIssuedThroughTable();
                    _this.loading = false;
                });
            };
            DetailMedicalResponsibleController.prototype.addOrRemoveOrganisationFrom = function (form) {
                var _this = this;
                //first remove from the dataset the removed items
                if (this.form.organisationIds.length > 0) {
                    var _loop_1 = function (i) {
                        var itemToCheck = form.assignmentType === 160 ? this_1.medicalResponsibleData[i] : this_1.medicationIssuedThroughData[i];
                        var itemFound = this_1.form.organisationIds.filter(function (item) { return item === itemToCheck.parentObjectId; });
                        if (itemFound.length === 0) {
                            this_1.stammdatenService.deleteMedResponsibleIssuedThroughItem(this_1.id, itemToCheck.assignmentType, itemToCheck.objectId);
                        }
                    };
                    var this_1 = this;
                    for (var i = 0; i < (form.assignmentType === 160 ? this.medicalResponsibleData.length : this.medicationIssuedThroughData.length); i++) {
                        _loop_1(i);
                    }
                    this.stammdatenService.postMedResponsibleIssuedThroughItem(form).then(function () {
                        _this.ui.notify(_this.ui.successNote);
                        _this.formState = "new";
                        setTimeout(function () { _this.getList(); }, 250);
                    });
                }
            };
            DetailMedicalResponsibleController.prototype.editMedicalResponsible = function (data) {
                this.formState = "edit";
                this.form = data;
            };
            DetailMedicalResponsibleController.prototype.putMedicalResponsible = function (form) {
                var _this = this;
                this.stammdatenService.putMedResponsibleIssuedThroughItem(this.id, form.objectId, form).then(function () {
                    _this.ui.notify(_this.ui.successNote);
                    _this.formState = "new";
                    _this.getList();
                });
            };
            DetailMedicalResponsibleController.prototype.deleteMedicalResponsible = function (item) {
                var _this = this;
                QMC.Common.Utilities.confirm(this.promptOptions, function (data) {
                    if (data)
                        _this.stammdatenService.deleteMedResponsibleIssuedThroughItem(_this.id, item.assignmentType, item.objectId).then(function () {
                            _this.ui.notify(_this.ui.deleteNote);
                            _this.formState = "new";
                            _this.getList();
                        });
                });
            };
            DetailMedicalResponsibleController.prototype.newEntry = function (assignmentType) {
                this.assignmentType = assignmentType;
                this.initForm();
                for (var i = 0; i < (assignmentType === 160 ? this.medicalResponsibleData.length : this.medicationIssuedThroughData.length); i++) {
                    this.form.organisationIds.push(assignmentType === 160 ? this.medicalResponsibleData[i].parentObjectId : this.medicationIssuedThroughData[i].parentObjectId);
                }
                $('#edit-form').modal('show');
            };
            DetailMedicalResponsibleController = __decorate([
                QMC.Controller("QMC.Stammdaten", "DetailMedicalResponsibleController"),
                QMC.Inject("StammdatenService", "$qui", "$stateParams", "QmcLanguageService", "QmcPermissionService", 'UserService')
            ], DetailMedicalResponsibleController);
            return DetailMedicalResponsibleController;
        }());
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        var DetailTempInstituteChangeController = /** @class */ (function () {
            /**
             * QMC.Stammdaten.DetailAdressController
             * @constructor
             * @param stammdatenService
             * @param $qui
             * @param clientService
             * @param $stateParams
             * @param $scope
             * @param $state
             * @param lng
             */
            function DetailTempInstituteChangeController(stammdatenService, $qui, $stateParams, lng, permissionService, userService) {
                var _this = this;
                this.stammdatenService = stammdatenService;
                this.$qui = $qui;
                this.$stateParams = $stateParams;
                this.lng = lng;
                this.permissionService = permissionService;
                this.userService = userService;
                this.allowTableExport = false;
                this.ui = new Stammdaten.DetailUI();
                this.institutes = [];
                this.id = this.$stateParams.id;
                this.permissionService.getPermissionsByObjectType(820003).then(function (data) {
                    _this.delete = data[0].delete;
                    _this.new = data[0].new;
                    _this.modify = data[0].modify;
                    _this.moduleAccess = data[0].moduleAccess && data[0].view;
                    _this.allowTableExport = data[0].print;
                    _this.$qui.waitForEl('#newModalButton', function () {
                        if (!_this.new)
                            document.getElementsByName('newModalButton').forEach(function (x) { return x.style.visibility = 'hidden'; });
                        else
                            document.getElementsByName('newModalButton').forEach(function (x) { return x.style.visibility = 'unset'; });
                    });
                    _this.getWv();
                    _this.$qui.getTableAutoload(_this.userService).then(function (ltd) {
                        _this.shouldLoadTableData = ltd;
                        if (_this.shouldLoadTableData) {
                            _this.getData();
                        }
                    });
                });
                $qui.init(undefined, function () {
                    $qui.bindEvents();
                    $(".qm-card").unbind("click");
                });
                this.promptOptions = {
                    title: this.lng.translate(20032000, "Temp. Organisationszuordnung"),
                    yesNo: true,
                    icon: "qm-icon-history2",
                    text: this.lng.translate(20000290, "Wollen Sie den Eintrag wirklich löschen?")
                };
            }
            DetailTempInstituteChangeController.prototype.getData = function () {
                this.getList();
            };
            /////////////// DISPLAY LOGIC ///////////////
            DetailTempInstituteChangeController.prototype.initForm = function () {
                this.formState = "new";
                this.form = {
                    id: null,
                    objectId: null,
                    dateFrom: null,
                    dateTo: null,
                    institute: '',
                    instituteId: null,
                    reason: '',
                    reasonId: null,
                    comment: '',
                    parentObjectId: this.id
                };
            };
            DetailTempInstituteChangeController.prototype.getReason = function () {
                return this.wv.reasonWvList.map(function (x) { return ({ text: x.name, value: x.objectId }); });
            };
            DetailTempInstituteChangeController.prototype.getInstitute = function () {
                return this.institutes.map(function (x) { return ({ text: x.caption, value: x.objectId }); });
                ;
            };
            /////////////// SERVICE FUNCTIONS ///////////////
            DetailTempInstituteChangeController.prototype.getWv = function () {
                var _this = this;
                this.stammdatenService.getTempInstituteChangeWvList().then(function (data) {
                    _this.wv = data;
                    _this.stammdatenService.getInstituteList().then(function (data) {
                        _this.institutes = data;
                        _this.initForm();
                        _this.$qui.functionWaiter("ui.createForm", _this);
                    });
                });
            };
            DetailTempInstituteChangeController.prototype.getList = function () {
                var _this = this;
                this.loading = true;
                this.stammdatenService.getTempInstituteChangeList(this.id).then(function (data) {
                    _this.ui.tempInstituteChangeTable.data = data;
                    _this.$qui.functionWaiter("ui.createTable", _this);
                    _this.loading = false;
                });
            };
            DetailTempInstituteChangeController.prototype.addTempInstituteChange = function (form) {
                var _this = this;
                this.stammdatenService.postTempInstituteChange(form).then(function () {
                    _this.ui.notify(_this.ui.successNote);
                    _this.formState = "new";
                    _this.getList();
                });
            };
            DetailTempInstituteChangeController.prototype.editTempInstituteChange = function (data) {
                this.formState = "edit";
                this.form = data;
                if (data.dateFrom)
                    this.form.dateFrom = this.$qui.createDateFromString(this.form.dateFrom);
                if (data.dateTo)
                    this.form.dateTo = this.$qui.createDateFromString(this.form.dateTo);
            };
            DetailTempInstituteChangeController.prototype.putTempInstituteChange = function (form) {
                var _this = this;
                this.stammdatenService.putTempInstituteChange(this.id, form.objectId, form).then(function () {
                    _this.ui.notify(_this.ui.successNote);
                    _this.formState = "new";
                    _this.getList();
                });
            };
            DetailTempInstituteChangeController.prototype.deleteTempInstituteChange = function (item) {
                var _this = this;
                QMC.Common.Utilities.confirm(this.promptOptions, function (data) {
                    if (data)
                        _this.stammdatenService.deleteTempInstituteChange(_this.id, item.objectId).then(function () {
                            _this.ui.notify(_this.ui.deleteNote);
                            _this.formState = "new";
                            _this.getList();
                        });
                });
            };
            DetailTempInstituteChangeController = __decorate([
                QMC.Controller("QMC.Stammdaten", "DetailTempInstituteChangeController"),
                QMC.Inject("StammdatenService", "$qui", "$stateParams", "QmcLanguageService", "QmcPermissionService", 'UserService')
            ], DetailTempInstituteChangeController);
            return DetailTempInstituteChangeController;
        }());
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        var DetailUdfController = /** @class */ (function () {
            function DetailUdfController($qui, $stateParams, $location) {
                this.$qui = $qui;
                this.$stateParams = $stateParams;
                this.$location = $location;
                this.show = true;
                this.objectType = 140000;
                switch (this.$location.$$path.split('/')[1]) {
                    case 'employee':
                        this.objectType = 120000;
                        break;
                    default:
                        this.objectType = 140000;
                        break;
                }
                this.id = this.$stateParams.id;
                this.type = this.$stateParams.type;
                this.definitionObjectType = this.$stateParams.definitionObjectType;
                this.definitionId = this.$stateParams.definitionId;
                $qui.init($qui.getSectionColor("/stammdaten"), function () {
                    $qui.bindEvents();
                    $('.qm-card').unbind('click');
                });
                this.$qui.waitForEl('#newModalButton', function () {
                    document.getElementsByName('newModalButton').forEach(function (x) { return x.style.visibility = 'hidden'; });
                });
            }
            DetailUdfController = __decorate([
                QMC.Controller('QMC.Stammdaten', 'DetailUdfController'),
                QMC.Inject('$qui', '$stateParams', '$location')
            ], DetailUdfController);
            return DetailUdfController;
        }());
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        /**
         * Stammdaten Detail UserInterface class
         *
        * @export
        * @class UserInterface
        * @extends {Common.UserInterface}
        */
        var DetailUI = /** @class */ (function (_super) {
            __extends(DetailUI, _super);
            function DetailUI(modalId) {
                var _this = _super.call(this) || this;
                _this.modalId = 'edit-form';
                /**
                * Client detail info form
                * @memberOf UserInterface
                */
                _this.infoForm = {
                    form: [{
                            label: "Name",
                            type: "String",
                            lngTag: 20000072,
                            model: "name",
                            required: true,
                            validate: {
                                message: "Bitte den Namen angeben",
                                messageTag: 21002015
                            },
                            style: {
                                icon: "fa fa-font",
                                class: "col-xs-12 col-md-6"
                            }
                        }, {
                            label: "Vorname",
                            required: true,
                            type: "String",
                            lngTag: 20000057,
                            model: "forename",
                            validate: {
                                message: "Bitte den Vornamen angeben",
                                messageTag: 21003037
                            },
                            style: {
                                icon: "fa fa-font",
                                class: "col-xs-12 col-md-6"
                            }
                        }, {
                            label: "Kürzel",
                            type: "String",
                            lngTag: 20000221,
                            model: "shortCaption",
                            validate: {
                                message: "Bitte ein Kürzel angeben",
                                messageTag: 21003008
                            },
                            style: {
                                icon: "fa fa-font",
                                class: "col-xs-12 col-md-6"
                            }
                        }, {
                            label: "Nummer",
                            type: "String",
                            lngTag: 20000316,
                            model: "clientNumber",
                            validate: {
                                message: "Bitte eine Nummer angeben",
                                messageTag: 21003008
                            },
                            style: {
                                icon: "fa fa-font",
                                class: "col-xs-12 col-md-6"
                            }
                        }, {
                            placeholder: "Geburtsname",
                            label: "Geburtsname",
                            type: "String",
                            lngTag: 21002021,
                            model: "birthname",
                            validate: {
                                message: "Bitte den Geburtsnamen angeben",
                                messageTag: 21002022
                            },
                            style: {
                                icon: "fa fa-font",
                                class: "col-xs-12 col-md-6"
                            }
                        }, {
                            placeholder: "Geburtsort",
                            label: "Geburtsort",
                            type: "String",
                            lngTag: 21002019,
                            model: "birthplace",
                            validate: {
                                message: "Bitte den Geburtsort angeben",
                                messageTag: 21002020
                            },
                            style: {
                                icon: "fa fa-globe",
                                class: "col-xs-12 col-md-6"
                            }
                        }, {
                            placeholder: "Geburtsdatum",
                            label: "Geburtsdatum",
                            required: true,
                            type: "Date",
                            lngTag: 21002004,
                            model: "birthday",
                            validate: {
                                message: "Bitte das Geburtsdatum angeben",
                                messageTag: 21002018
                            },
                            style: {
                                class: "col-xs-12 col-md-6"
                            }
                        }, {
                            placeholder: "Anrede angeben ...",
                            label: "Anrede",
                            type: "Select",
                            lngTag: 20004005,
                            model: "salutationId",
                            dataSource: "getSalutationList",
                            style: {
                                class: "col-xs-12 col-md-6"
                            }
                        }, {
                            placeholder: "Titel angeben ...",
                            label: "Titel",
                            type: "Select",
                            lngTag: 21002024,
                            model: "titleId",
                            dataSource: "getTitleList",
                            style: {
                                class: "col-xs-12 col-md-6"
                            }
                        }, {
                            placeholder: "Titel, nach angeben ...",
                            label: "Titel, nach",
                            type: "Select",
                            lngTag: 21002054,
                            model: "secondTitleId",
                            dataSource: "getSecondTitleList",
                            style: {
                                class: "col-xs-12 col-md-6"
                            }
                        }, {
                            placeholder: "Geschlecht angeben ...",
                            label: "Geschlecht",
                            type: "Select",
                            lngTag: 21002025,
                            model: "genderId",
                            dataSource: "getGenderList",
                            style: {
                                class: "col-xs-12 col-md-6"
                            },
                        }],
                    actions: {
                        put: "updateClient",
                        post: ""
                    }
                };
                /**
                * Client detail address table
                * @memberOf UserInterface
                */
                _this.addressTable = {
                    "table": {
                        "Typ": {
                            "label": "addressTypeName",
                            "dType": "string",
                            "lngTag": "20000025",
                            "style": "style"
                        },
                        "Straße": {
                            "label": "street",
                            "dType": "string",
                            "lngTag": "20003001",
                            "style": "style"
                        },
                        "Hausnummer": {
                            "label": "houseNumber",
                            "dType": "string",
                            "lngTag": "20003002",
                            "style": "style"
                        },
                        "PLZ": {
                            "label": "postCode",
                            "dType": "string",
                            "lngTag": "20003005",
                            "style": "style"
                        },
                        "Ort": {
                            "label": "city",
                            "dType": "string",
                            "lngTag": "20003004",
                            "style": "style"
                        },
                        "Land": {
                            "label": "countryName",
                            "dType": "string",
                            "lngTag": "20003521",
                            "style": "style"
                        },
                        "Bundesland": {
                            "label": "stateName",
                            "dType": "string",
                            "lngTag": "20000284",
                            "style": "style"
                        },
                        "Datum von": {
                            "label": "dateFrom",
                            "dType": "Date",
                            "lngTag": "20000047",
                            "style": "style"
                        },
                        "Datum bis": {
                            "label": "dateTo",
                            "dType": "Date",
                            "lngTag": "20000054",
                            "style": "style"
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editAdress",
                                "label": "data",
                                "dType": "Button",
                                "openModal": "true",
                                "targetModal": "#" + _this.modalId,
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify",
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteAdress",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            }]
                    },
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-location_pin"
                        },
                        "text": {
                            "label": ["street", "houseNumber"],
                            "dType": "string",
                            "lngTag": ""
                        },
                        "subtext": [{
                                "label": "city",
                                "dType": "string"
                            }, {
                                "label": "stateName",
                                "dType": "string",
                            }, {
                                "label": "type",
                                "dType": "string",
                            }],
                        "buttons": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editAdress",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Bearbeiten",
                                "openModal": "true",
                                "targetModal": "#" + _this.modalId,
                                "lngTag": "20000044",
                                "permission": "modify"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteAdress",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            }]
                    },
                    "data": null,
                };
                /**
                * Client detail address form
                * @memberOf UserInterface
                */
                _this.addressForm = {
                    form: [{
                            label: "Land",
                            type: "Select2",
                            placeholder: "Land",
                            lngTag: 20003521,
                            model: "objectIdCountry",
                            dataSource: "getCountryList",
                            events: {
                                updateDataSource: "objectIdState",
                            },
                            style: {
                                class: "col-md-6 col-xs-12",
                            },
                            wvId: '4969d506-cd05-427f-9cda-afd003cfc8e0',
                            wvListData: 'wvList.countriesWvList'
                        }, {
                            placeholder: "Bundesland",
                            label: "Bundesland",
                            type: "Select2",
                            lngTag: 20000284,
                            model: "objectIdState",
                            dataSource: "getStatesList",
                            style: {
                                class: "col-md-6 col-xs-12",
                            }
                        }, {
                            placeholder: "Adressart wählen ...",
                            label: "Adressart",
                            type: "Select2",
                            lngTag: 20003516,
                            model: "objectIdAddressType",
                            dataSource: "getAdressTypeList",
                            required: true,
                            style: {
                                class: "col-xs-12 col-md-6"
                            },
                            events: {
                                hideExpression: "(qmForm.isHouseless)"
                            },
                            wvId: 'da631a1c-5ace-4f33-8f4a-1aed8a3ade5e',
                            wvListData: 'wvList.addressTypeWvList'
                        }, {
                            placeholder: "Adressart wählen ...",
                            label: "Adressart",
                            type: "Select2",
                            lngTag: 20003516,
                            model: "objectIdAddressType",
                            dataSource: "getAdressTypeList",
                            required: false,
                            style: {
                                class: "col-xs-12 col-md-6"
                            },
                            events: {
                                hideExpression: "!(qmForm.isHouseless)"
                            },
                            wvId: 'da631a1c-5ace-4f33-8f4a-1aed8a3ade5e',
                            wvListData: 'wvList.addressTypeWvList'
                        }, {
                            type: "hr",
                        }, {
                            label: {
                                dateFrom: "Datum von",
                                dateTo: "Datum bis"
                            },
                            type: "DateRange",
                            model: {
                                dateFrom: "dateFrom",
                                dateTo: "dateTo"
                            },
                            lngTag: {
                                dateFrom: 20000047,
                                dateTo: 20000054
                            },
                            style: {
                                class: "col-xs-12"
                            },
                            config: {
                                displayDateTo: true,
                                dateFromNotRequired: true
                            }
                        }, {
                            label: "Wohnungslos",
                            type: "CheckboxInline",
                            lngTag: 20003008,
                            model: "isHouseless",
                            id: "isHouseless",
                            style: {
                                class: "col-xs-6"
                            }
                        }, {
                            label: "Postfach",
                            type: "CheckboxInline",
                            lngTag: 20003009,
                            model: "isPostOfficeBox",
                            id: "isPostOfficeBox",
                            style: {
                                class: "col-xs-6"
                            }
                        }, {
                            placeholder: "Postfach",
                            placeholderTag: '20003009',
                            label: "Postfach",
                            type: "String",
                            lngTag: 20003009,
                            required: true,
                            model: "street",
                            validate: {
                                message: "Bitte das Postfach angeben",
                                messageTag: 20003524
                            },
                            events: {
                                hideExpression: "(!(qmForm.isPostOfficeBox)||(qmForm.isHouseless))"
                            },
                            style: {
                                icon: "fa fa-road",
                                class: "col-xs-12"
                            }
                        }, {
                            placeholder: "Postfach",
                            placeholderTag: '20003009',
                            label: "Postfach",
                            type: "String",
                            lngTag: 20003009,
                            model: "street",
                            validate: {
                                message: "Bitte das Postfach angeben",
                                messageTag: 20003524
                            },
                            events: {
                                hideExpression: "(!(qmForm.isPostOfficeBox)||!(qmForm.isHouseless))"
                            },
                            style: {
                                icon: "fa fa-road",
                                class: "col-xs-12"
                            }
                        }, {
                            placeholder: "Straße",
                            placeholderTag: '20003001',
                            label: "Straße",
                            type: "String",
                            lngTag: 20003001,
                            required: true,
                            model: "street",
                            validate: {
                                message: "Bitte den Straßennamen angeben",
                                messageTag: 20003510
                            },
                            events: {
                                hideExpression: "(qmForm.isHouseless || qmForm.isPostOfficeBox)"
                            },
                            style: {
                                icon: "fa fa-road",
                                class: "col-md-8 col-xs-12"
                            }
                        }, {
                            placeholder: "Straße",
                            placeholderTag: '20003001',
                            label: "Straße",
                            type: "String",
                            lngTag: 20003001,
                            model: "street",
                            validate: {
                                message: "Bitte den Straßennamen angeben",
                                messageTag: 20003510
                            },
                            events: {
                                hideExpression: "(!qmForm.isHouseless || qmForm.isPostOfficeBox)"
                            },
                            style: {
                                icon: "fa fa-road",
                                class: "col-md-8 col-xs-12"
                            }
                        }, {
                            placeholder: "Hausnummer",
                            label: "Hausnummer",
                            type: "String",
                            lngTag: 20003006,
                            placeholderTag: '20003006',
                            maxLength: 10,
                            model: "houseNumber",
                            required: true,
                            validate: {
                                message: "Bitte die Hausnummer angeben ( 10 Zeichen Maximal )"
                            },
                            events: {
                                hideExpression: "(qmForm.isHouseless || qmForm.isPostOfficeBox)"
                            },
                            style: {
                                class: "col-xs-12 col-md-4",
                                icon: "fa fa-home",
                            }
                        }, {
                            placeholder: "Hausnummer",
                            label: "Hausnummer",
                            type: "String",
                            lngTag: 20003006,
                            placeholderTag: '20003006',
                            maxLength: 10,
                            model: "houseNumber",
                            validate: {
                                message: "Bitte die Hausnummer angeben ( 10 Zeichen Maximal )"
                            },
                            events: {
                                hideExpression: "(!qmForm.isHouseless || qmForm.isPostOfficeBox)"
                            },
                            style: {
                                class: "col-xs-12 col-md-4",
                                icon: "fa fa-home",
                            }
                        }, {
                            placeholder: "PLZ",
                            label: "PLZ",
                            type: "Autocomplete",
                            lngTag: 20003005,
                            placeholderTag: '20003005',
                            required: true,
                            maxLength: 10,
                            id: "postCode",
                            model: "postCode",
                            events: {
                                hide: "isHouseless"
                            },
                            validate: {
                                message: "Bitte den PLZ angeben."
                            },
                            style: {
                                class: "col-xs-12 col-md-4",
                                icon: "fa fa-hashtag"
                            }
                        }, {
                            placeholder: "PLZ",
                            label: "PLZ",
                            type: "Autocomplete",
                            lngTag: 20003005,
                            placeholderTag: '20003005',
                            required: false,
                            maxLength: 10,
                            id: "postCode",
                            model: "postCode",
                            events: {
                                hideExpression: "!(qmForm.isHouseless)"
                            },
                            validate: {
                                message: "Bitte den PLZ angeben."
                            },
                            style: {
                                class: "col-xs-12 col-md-4",
                                icon: "fa fa-hashtag"
                            }
                        }, {
                            label: "Ort",
                            placeholder: "Ort eintragen...",
                            type: "Autocomplete",
                            lngTag: 20003004,
                            placeholderTag: '20003004',
                            model: "city",
                            required: true,
                            id: "city",
                            events: {
                                hide: "isHouseless"
                            },
                            validate: {
                                message: "Bitte den Ort angeben."
                            },
                            style: {
                                class: "col-md-8 col-xs-12",
                                icon: "fa fa-globe"
                            }
                        }, {
                            label: "Ort",
                            placeholder: "Ort eintragen...",
                            type: "Autocomplete",
                            lngTag: 20003004,
                            placeholderTag: '20003004',
                            model: "city",
                            required: false,
                            id: "city",
                            events: {
                                hideExpression: "!(qmForm.isHouseless)"
                            },
                            validate: {
                                message: "Bitte den Ort angeben."
                            },
                            style: {
                                class: "col-md-8 col-xs-12",
                                icon: "fa fa-globe"
                            }
                        }, {
                            placeholder: "Bemerkung eintragen ...",
                            label: "Bemerkung",
                            type: "Textarea",
                            lngTag: 20000049,
                            placeholderTag: '20000049',
                            model: "comment",
                            maxLength: 255,
                            style: {
                                icon: "qm-icon-note_text",
                                class: "col-xs-12",
                            }
                        }, {
                            label: "Als Standard",
                            type: "CheckboxInline",
                            lngTag: 20000070,
                            model: "isMainRecord",
                            id: "isMainRecord",
                            style: {
                                class: "col-xs-6 col-sm-4"
                            }
                        }, {
                            label: "Keine Datenweitergabe",
                            type: "CheckboxInline",
                            lngTag: 20023021,
                            model: "isDatatransferForbidden",
                            id: "isDatatransferForbidden",
                            style: {
                                class: "col-xs-6 col-sm-4"
                            }
                        }, {
                            label: "Notfalldaten",
                            type: "CheckboxInline",
                            lngTag: 20003525,
                            model: "isEmergency",
                            id: "isEmergency",
                            style: {
                                class: "col-xs-6 col-sm-4"
                            }
                        }],
                    actions: {
                        put: "putAddress",
                        post: "addAddress"
                    }
                };
                /**
                * Client detail communication table
                * @memberOf UserInterface
                */
                _this.checklistTable = {
                    "config": {
                        "defaultSort": "order",
                        "sortReverse": "false",
                    },
                    "table": {
                        "StatusIcon": {
                            "label": "isChecked",
                            "dType": "Bool",
                            "noHeader": true
                        },
                        "Status": {
                            "label": "state",
                            "dType": "string",
                            "lngTag": "20000164"
                        },
                        "Bezeichnung": {
                            "label": "caption",
                            "dType": "string",
                            "lngTag": "20000053"
                        },
                        "Erhalten am": {
                            "label": "date",
                            "dType": "Date",
                            "lngTag": "20011508",
                        },
                        "Gültig von": {
                            "label": "dateFrom",
                            "dType": "Date",
                            "lngTag": "20000277"
                        },
                        "Gültig bis": {
                            "label": "dateTo",
                            "dType": "Date",
                            "lngTag": "20000278"
                        },
                        "Wiedervorlage am": {
                            "label": "dateShowAgain",
                            "dType": "Date",
                            "lngTag": "20011509"
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-checkbox green",
                                "click": "newCheck",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Abhaken",
                                "lngTag": "20011517",
                                "permission": "new",
                                "openModal": "true",
                                "targetModal": "#" + _this.modalId
                            }, {
                                "icon": "qm-icon-eye blue",
                                "click": "editCheck",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Ansehen",
                                "lngTag": "20000141",
                                "openModal": "true",
                                "targetModal": "#" + _this.modalId,
                                "events": {
                                    "hide": "!isChecked"
                                }
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteCheck",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete",
                                "events": {
                                    "hide": "!isChecked"
                                }
                            }]
                    },
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-check"
                        },
                        "text": {
                            "label": "caption",
                            "dType": "string"
                        },
                        "subtext": [{
                                "label": "state",
                                "dType": "string",
                                "type": "type"
                            }, {
                                "label": "date",
                                "dType": "Date",
                                "type": "type"
                            }],
                        "buttons": [{
                                "icon": "qm-icon-plus green",
                                "click": "newCheck",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Neu",
                                "lngTag": "20000298",
                                "permission": "new",
                                "openModal": "true",
                                "targetModal": "#" + _this.modalId
                            }, {
                                "icon": "qm-icon-eye blue",
                                "click": "editCheck",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Ansehen",
                                "lngTag": "20000141",
                                "openModal": "true",
                                "targetModal": "#" + _this.modalId,
                                "events": {
                                    "hide": "!isChecked"
                                }
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteCheck",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete",
                                "events": {
                                    "hide": "!isChecked"
                                }
                            }]
                    },
                    "data": null,
                };
                _this.checklistHistoryTable = {
                    "config": {
                        "defaultSort": "date",
                        "sortReverse": "true",
                    },
                    "table": {
                        "StatusIcon": {
                            "label": "isChecked",
                            "dType": "Bool",
                            "noHeader": true
                        },
                        "Status": {
                            "label": "state",
                            "dType": "string",
                            "lngTag": "20000164"
                        },
                        "Erhalten am": {
                            "label": "date",
                            "dType": "Date",
                            "lngTag": "20011508",
                        },
                        "Gültig von": {
                            "label": "dateFrom",
                            "dType": "Date",
                            "lngTag": "20000277"
                        },
                        "Gültig bis": {
                            "label": "dateTo",
                            "dType": "Date",
                            "lngTag": "20000278"
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-eye blue",
                                "click": "editHistory",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Ansehen",
                                "lngTag": "20000141",
                                "openModal": "true",
                                "targetModal": "#historyFormModal",
                                "permission": "historyModuleAccess"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteHistory",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "historyDelete"
                            }, {
                                "icon": "qm-icon-note_text darkslategray",
                                "click": "toggleCommentModal",
                                "label": "Comment",
                                "dType": "Button",
                                "events": {
                                    "hide": "!comment",
                                },
                                "tooltip": "Bemerkung",
                                "lngTag": "20000049",
                            }]
                    },
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-check"
                        },
                        "text": {
                            "label": "state",
                            "dType": "string"
                        },
                        "subtext": [{
                                "label": "date",
                                "dType": "Date",
                                "type": "type"
                            }],
                        "buttons": [{
                                "icon": "qm-icon-eye blue",
                                "click": "editHistory",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Ansehen",
                                "lngTag": "20000141",
                                "openModal": "true",
                                "targetModal": "#historyFormModal",
                                "permission": "historyModuleAccess"
                            }, {
                                "icon": "qm-icon-note_text darkslategray",
                                "click": "toggleCommentModal",
                                "label": "Comment",
                                "dType": "Button",
                                "events": {
                                    "hide": "!comment",
                                },
                                "tooltip": "Bemerkung",
                                "lngTag": "20000049",
                            }]
                    },
                    "data": null,
                };
                _this.checklistForm = {
                    form: [
                        {
                            label: "Erhalten am",
                            type: "Date",
                            lngTag: 20011508,
                            model: "date",
                            required: true,
                            validate: {
                                message: "Bitte das Datum angeben",
                                messageTag: 0,
                            },
                            style: {
                                icon: "fa fa-calendar",
                                class: "col-md-6 col-xs-12"
                            }
                        }, {
                            label: "Wiedervorlage am",
                            type: "Date",
                            lngTag: 20011509,
                            model: "dateShowAgain",
                            style: {
                                icon: "fa fa-calendar-o",
                                class: "col-md-6 col-xs-12"
                            }
                        }, {
                            label: {
                                dateFrom: "Gültig von",
                                dateTo: "Gültig bis"
                            },
                            type: "DateRange",
                            model: {
                                dateFrom: "dateFrom",
                                dateTo: "dateTo"
                            },
                            lngTag: {
                                dateFrom: 20000277,
                                dateTo: 20000278
                            },
                            style: {
                                class: "col-xs-12"
                            },
                            config: {
                                displayDateTo: true,
                                dateFromNotRequired: true
                            }
                        }, {
                            // commented since this is only applicable if workflow license is granted which is actually newver the case
                            //    label: "Erinnerung",
                            //    type: "Checkbox",
                            //    lngTag: 20011507,
                            //    model: "reminderActive",
                            //    style: {
                            //        class: "col-xs-12 col-md-4"
                            //    }
                            //},
                            //{
                            //    lngTag: "20011506",
                            //    label: "Tage vorher",
                            //    type: "Number",
                            //    model: "reminder",
                            //    style: {
                            //        class: "col-md-6 col-xs-12",
                            //        icon: "qm-icon-calendar_5"
                            //    },
                            //    events: {
                            //        hideExpression: "!qmForm.reminderActive"
                            //    }
                            //}, {
                            label: "Bemerkung",
                            type: "Summernote",
                            lngTag: "20000049",
                            model: "comment",
                            style: {
                                class: "col-xs-12",
                            }
                        }
                    ],
                    actions: {
                        post: "addChecklist",
                        put: "putChecklist"
                    }
                };
                /**
                * Client detail communication table
                * @memberOf UserInterface
                */
                _this.communicationTable = {
                    "table": {
                        "Typ": {
                            "label": "communicationTypeName",
                            "dType": "string",
                            "lngTag": "20005504",
                            "style": "style"
                        },
                        "Kommunikationsart": {
                            "label": "communicationCategoryName",
                            "dType": "string",
                            "lngTag": "20005511",
                            "style": "style"
                        },
                        "Adresse": {
                            "label": "displayAddress",
                            "dType": "string",
                            "lngTag": "20001045",
                            "style": "style",
                            "type": "type"
                        },
                        "Datum von": {
                            "label": "dateFrom",
                            "dType": "Date",
                            "lngTag": "20000047"
                        },
                        "Datum bis": {
                            "label": "dateTo",
                            "dType": "Date",
                            "lngTag": "20000054"
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editCommunication",
                                "label": "data",
                                "dType": "Button",
                                "openModal": "true",
                                "targetModal": "#" + _this.modalId,
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteCommunication",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            }]
                    },
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-book_telephone"
                        },
                        "text": {
                            "label": "communicationCategoryName",
                            "dType": "string"
                        },
                        "subtext": [{
                                "label": "displayAddress",
                                "dType": "string",
                                "type": "type"
                            }, {
                                "label": "communicationTypeName",
                                "dType": "string",
                            }],
                        "buttons": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editCommunication",
                                "label": "data",
                                "dType": "Button",
                                "openModal": "true",
                                "targetModal": "#" + _this.modalId,
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteCommunication",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            }]
                    },
                    "data": null,
                };
                /**
                 * Client detail communication form
                 * @memberOf UserInterface
                 */
                _this.communicationForm = {
                    form: [
                        {
                            label: "Datum von",
                            type: "Date",
                            lngTag: 20000047,
                            model: "dateFrom",
                            style: {
                                icon: "fa qm-icon-calendar_7",
                                class: "col-md-6 col-xs-12"
                            }
                        },
                        {
                            label: "Datum bis",
                            type: "Date",
                            lngTag: 20000054,
                            model: "dateTo",
                            style: {
                                icon: "fa qm-icon-calendar_7",
                                class: "col-md-6 col-xs-12"
                            }
                        }, {
                            placeholder: "Kommunikationstyp",
                            placeholderTag: "20005504",
                            label: "Kommunikationstyp",
                            type: "Select",
                            lngTag: 20005504,
                            id: "typeId",
                            model: "communicationTypeId",
                            required: true,
                            dataSource: "getCommunicationTypeList",
                            //events: {
                            //    updateDataSource: "communicationCategoryId"
                            //},
                            style: {
                                class: "col-xs-12 col-md-6"
                            }
                        }, {
                            placeholder: "Kommunikationsart wählen...",
                            placeholderTag: "20005511",
                            label: "Kommunikationsart",
                            type: "Select2",
                            lngTag: 20005511,
                            model: "communicationCategoryId",
                            dataSource: "getCommunicationCategoryList",
                            style: {
                                class: "col-xs-12 col-md-6"
                            },
                            validate: {
                                message: "Bitte eine Art auswählen!"
                            },
                            wvId: '05dd15e1-4db2-4b55-b92c-e150ed00e300',
                            wvSubParent: 'communicationTypeId'
                        }, {
                            placeholder: "E-Mail-Adresse",
                            placeholderTag: "20000069",
                            label: "E-Mail-Adresse",
                            type: "String",
                            lngTag: 20000069,
                            required: true,
                            model: "targetAddress",
                            style: {
                                class: "col-xs-12 col-md-6",
                                icon: "fa fa-at"
                            },
                            events: {
                                hideExpression: "!(qmForm.communicationTypeId == '53fd55a0-9efe-41aa-9099-5c3b7b4e972f')"
                            },
                            validate: {
                                message: "Bitte eine E-Mail Adresse angeben.",
                            },
                        }, {
                            placeholder: "Landesvorwahl",
                            placeholderTag: "20005505",
                            label: "Landesvorwahl",
                            type: "String",
                            lngTag: 20005505,
                            model: "countryCode",
                            style: {
                                class: "col-xs-12 col-md-6",
                                icon: "fa fa-fax"
                            },
                            events: {
                                hideExpression: "!(qmForm.communicationTypeId == '930511d9-aa40-4927-b8b0-bbfc2e040de6' || qmForm.communicationTypeId == '6729f858-ca6d-4efe-8397-376133a2d974')"
                            },
                            validate: {
                                message: "Bitte die Landesvorwahl angeben.",
                            },
                        }, {
                            placeholder: "Ortsvorwahl",
                            placeholderTag: "20005506",
                            label: "Ortsvorwahl",
                            type: "String",
                            lngTag: 20005506,
                            model: "areaCode",
                            style: {
                                class: "col-xs-12 col-md-6",
                                icon: "fa fa-fax"
                            },
                            events: {
                                hideExpression: "!(qmForm.communicationTypeId == '930511d9-aa40-4927-b8b0-bbfc2e040de6' || qmForm.communicationTypeId == '6729f858-ca6d-4efe-8397-376133a2d974')"
                            },
                            validate: {
                                message: "Bitte die Ortsvorwahl angeben.",
                            },
                        }, {
                            placeholder: "Rufnummer",
                            placeholderTag: "20005507",
                            label: "Rufnummer",
                            type: "String",
                            lngTag: 20005507,
                            required: true,
                            model: "targetAddress",
                            style: {
                                class: "col-xs-12 col-md-6",
                                icon: "fa fa-fax"
                            },
                            events: {
                                hideExpression: "!(qmForm.communicationTypeId == '930511d9-aa40-4927-b8b0-bbfc2e040de6' || qmForm.communicationTypeId == '6729f858-ca6d-4efe-8397-376133a2d974')"
                            },
                            validate: {
                                message: "Bitte die Rufnummer angeben.",
                            },
                        }, {
                            placeholder: "Messenger",
                            placeholderTag: "20005512",
                            label: "Messenger",
                            type: "String",
                            lngTag: 20005512,
                            required: true,
                            model: "targetAddress",
                            style: {
                                class: "col-xs-12 col-md-6",
                                icon: "fa fa-comments-o"
                            },
                            events: {
                                hideExpression: "!(qmForm.communicationTypeId == '968deb9e-9e7a-417b-b096-a20dac7e61b8')"
                            },
                            validate: {
                                message: "Bitte die Messenger ID angeben.",
                            },
                        }, {
                            placeholder: "Website",
                            placeholderTag: "20000014",
                            label: "Website",
                            type: "String",
                            lngTag: 20000014,
                            model: "targetAddress",
                            required: true,
                            style: {
                                class: "col-xs-12 col-md-6",
                                icon: "fa fa-share-square-o"
                            },
                            events: {
                                hideExpression: "!(qmForm.communicationTypeId == 'f25005b8-3a66-4b36-9395-60ce7896f7d6')"
                            },
                            validate: {
                                message: "Bitte die Website angeben.",
                            },
                        }, {
                            placeholder: "Sonstige",
                            placeholderTag: "20000238",
                            label: "Sonstige",
                            type: "String",
                            lngTag: 20000238,
                            required: true,
                            model: "targetAddress",
                            style: {
                                class: "col-xs-12 col-md-6",
                                icon: "qm-icon-note_text"
                            },
                            events: {
                                hideExpression: "!(qmForm.communicationTypeId == '9088ac4c-8ff8-4d6b-939a-19e9ad252cc9')"
                            },
                            validate: {
                                message: "Bitte angeben.",
                            },
                        }, {
                            type: "hr"
                        }, {
                            placeholder: "Bemerkung eintragen ...",
                            placeholderTag: "20000049",
                            label: "Bemerkung",
                            type: "Textarea",
                            maxLength: 255,
                            lngTag: 20000049,
                            model: "comment",
                            style: {
                                class: "col-xs-12 col-md-12",
                                icon: "qm-icon-note_text"
                            }
                        }, {
                            label: "Standard",
                            type: "Checkbox",
                            lngTag: 20000070,
                            model: "isMainRecord",
                            id: "com_isMainRecord",
                            style: {
                                class: "col-xs-12 col-md-4"
                            }
                        }, {
                            label: "Standard pro Typ",
                            type: "Checkbox",
                            lngTag: 20005521,
                            model: "isTypeMain",
                            id: "com_isTypeMain",
                            style: {
                                class: "col-xs-12 col-md-4"
                            }
                        }, {
                            label: "Keine Datenweitergabe",
                            type: "Checkbox",
                            lngTag: 20023021,
                            model: "isDatatransferForbidden",
                            id: "isDatatransferForbidden",
                            style: {
                                class: "col-xs-12 col-md-4"
                            }
                        }
                    ],
                    actions: {
                        post: "addCommunication",
                        put: "putCommunication"
                    }
                };
                /**
                 * Client detail contact person table
                 * @memberOf UserInterface
                 */
                _this.contactPersonTable = {
                    "config": {
                        "defaultSort": "category"
                    },
                    "table": {
                        "Kategorie": {
                            "label": "category",
                            "dType": "string",
                            "lngTag": "20000137",
                            "style": "style"
                        },
                        "Vorname": {
                            "label": "forename",
                            "dType": "string",
                            "lngTag": "20000057",
                            "style": "style"
                        },
                        "Nachname": {
                            "label": "name",
                            "dType": "string",
                            "lngTag": "20000058",
                            "style": "style"
                        },
                        "Kontaktpersonart": {
                            "label": "contactPersonType",
                            "dType": "string",
                            "lngTag": "20004003",
                            "style": "style"
                        },
                        "Kommunikation": {
                            "label": "mainCommunication",
                            "dType": "string",
                            "lngTag": "20001047",
                            "style": "style",
                            "type": "type"
                        },
                        "Bemerkung": {
                            "lngTag": "20000049",
                            "label": "comment",
                            "dType": "string",
                            "style": "style"
                        },
                        "Aktionen": [{
                                "icon": "qm-button blue qm-icon-eye green",
                                "click": "showDetailContact",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Ansehen",
                                "lngTag": "20000141",
                                "permission": "modify",
                                "events": {
                                //"hide": "showActions"
                                }
                            }, {
                                "icon": "qm-icon-pencil blue",
                                "click": "editContact",
                                "openModal": "true",
                                "targetModal": "#" + _this.modalId,
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify",
                                "events": {
                                    "hide": "!showActions"
                                }
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteContact",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete",
                                "events": {
                                    "hide": "!showActions"
                                }
                            }, {
                                "icon": "qm-icon-location_pin grey",
                                "click": "newAddress",
                                "openModal": "true",
                                "targetModal": "#edit-adress",
                                "dType": "Button",
                                "tooltip": "Adresse hinzufügen",
                                "lngTag": "20000142",
                                "permission": "newAdr",
                                "events": {
                                    "hide": "!showActions"
                                }
                            }, {
                                "icon": "qm-icon-book_telephone",
                                "click": "newCommunication",
                                "openModal": "true",
                                "targetModal": "#edit-communication",
                                "dType": "Button",
                                "tooltip": "Kommunikation hinzufügen",
                                "lngTag": "20000143",
                                "permission": "newCom",
                                "events": {
                                    "hide": "!showActions"
                                }
                            }]
                    },
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-users"
                        },
                        "text": {
                            "label": ["name", "forename"],
                            "dType": "string",
                            "style": "style"
                        },
                        "subtext": [{
                                "label": "contactPersonType",
                                "dType": "string",
                                "style": "style"
                            }, {
                                "label": "mainCommunication",
                                "dType": "string",
                                "style": "style"
                            }, {
                                "label": "stateName",
                                "dType": "string",
                                "style": "style"
                            }, {
                                "label": "type",
                                "dType": "string",
                                "style": "style"
                            }],
                        "buttons": [{
                                "icon": "qm-button blue qm-icon-eye green",
                                "click": "showDetailContact",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Ansehen",
                                "lngTag": "20000141",
                                "permission": "modify",
                                "events": {
                                //"hide": "hideActions"
                                }
                            }, {
                                "icon": "qm-icon-pencil blue",
                                "click": "editContact",
                                "openModal": "true",
                                "targetModal": "#" + _this.modalId,
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify",
                                "events": {
                                    "hide": "!showActions"
                                }
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteContact",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete",
                                "events": {
                                    "hide": "!showActions"
                                }
                            }, {
                                "icon": "qm-icon-location_pin grey",
                                "click": "newAddress",
                                "openModal": "true",
                                "targetModal": "#edit-adress",
                                "dType": "Button",
                                "tooltip": "Adresse hinzufügen",
                                "lngTag": "20000142",
                                "permission": "newAdr",
                                "events": {
                                    "hide": "!showActions"
                                }
                            }, {
                                "icon": "qm-icon-book_telephone",
                                "click": "newCommunication",
                                "openModal": "true",
                                "targetModal": "#edit-communication",
                                "dType": "Button",
                                "tooltip": "Kommunikation hinzufügen",
                                "lngTag": "20000143",
                                "permission": "newCom",
                                "events": {
                                    "hide": "!showActions"
                                }
                            }]
                    },
                    "data": null,
                };
                /**
        * Client detail contact person form
        * @memberOf UserInterface
        */
                _this.contactPersonForm = {
                    form: [{
                            placeholder: "Kontaktpersonart auswählen",
                            placeholderTag: "20004003",
                            label: "Kontaktpersonart",
                            type: "Select2",
                            model: "contactPersonTypeId",
                            lngTag: 20004003,
                            required: true,
                            dataSource: "getContactPersonTypeList",
                            style: {
                                class: "col-md-6 col-xs-12",
                            },
                            validate: {
                                message: "Bitte die Art auswählen!"
                            },
                            wvId: '3829213d-7823-4c31-b478-ac818b62c3a4',
                            wvListData: 'wvList.contactPersonTypeWvList'
                        }, {
                            placeholder: "Anrede auswählen",
                            placeholderTag: "20004005",
                            label: "Anrede",
                            type: "Select2",
                            model: "salutationId",
                            lngTag: 20004005,
                            dataSource: "getSalutationList",
                            style: {
                                class: "col-md-6 col-xs-12",
                            },
                            validate: {
                                message: "Bitte die Anrede auswählen!"
                            },
                            wvId: 'a1aaf203-f1ee-4147-abb1-1e2426303f6c',
                            wvListData: 'wvList.salutationWvList'
                        }, {
                            placeholder: "Titel auswählen",
                            placeholderTag: "21002024",
                            label: "Titel",
                            type: "Select2",
                            model: "titleId",
                            lngTag: 21002024,
                            dataSource: "getTitleList",
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                            wvId: '9fb4b9b9-33ad-4e7c-ac26-df3eacca2eba',
                            wvListData: 'wvList.titleWvList'
                        }, {
                            label: "Titel, nach",
                            type: "Select2",
                            model: "secondTitleId",
                            lngTag: 21002054,
                            dataSource: "getSecondTitleList",
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                            wvId: 'd0b392c7-3f9f-48d0-9c1b-6d6bf19f7352',
                            wvListData: 'wvList.secondTitleWvList'
                        }, {
                            type: "hr"
                        }, {
                            placeholder: "Vorname",
                            placeholderTag: "20000057",
                            label: "Vorname",
                            type: "String",
                            lngTag: 20000057,
                            model: "forename",
                            validate: {
                                message: "Bitte den Vornamen angeben",
                                messageTag: 20003510,
                            },
                            style: {
                                icon: "fa fa-font",
                                class: "col-md-6 col-xs-12"
                            }
                        }, {
                            placeholder: "Nachname",
                            placeholderTag: "20000058",
                            label: "Nachname",
                            type: "String",
                            lngTag: 20000058,
                            required: true,
                            model: "name",
                            validate: {
                                message: "Bitte den Nachnamen angeben",
                                messageTag: 20003510,
                            },
                            style: {
                                icon: "fa fa-font",
                                class: "col-md-6 col-xs-12"
                            }
                        }, {
                            placeholder: "Geburtsdatum",
                            placeholderTag: "21002004",
                            label: "Geburtsdatum",
                            type: "Date",
                            lngTag: 21002004,
                            model: "birthday",
                            validate: {
                                message: "Bitte das Geburtsdatum angeben",
                                messageTag: 21003020,
                            },
                            style: {
                                icon: "fa fa-font",
                                class: "col-md-6 col-xs-12"
                            }
                        }, {
                            lngTag: {
                                dateFrom: "20000277",
                                dateTo: "20000278"
                            },
                            label: {
                                dateFrom: "Gültig von",
                                dateTo: "Gültig bis"
                            },
                            type: "DateRange",
                            model: {
                                dateFrom: "dateFrom",
                                dateTo: "dateTo"
                            },
                            style: {
                                class: "col-xs-12"
                            },
                            config: {
                                displayDateTo: true
                            }
                        }, {
                            placeholder: "Bemerkung eintragen ...",
                            placeholderTag: "20000049",
                            label: "Bemerkung",
                            type: "Textarea",
                            maxLength: -1,
                            model: "comment",
                            lngTag: 20000049,
                            style: {
                                icon: "qm-icon-note_text",
                                class: "col-xs-12 col-md-12"
                            }
                        }, {
                            label: "Kontaktsperre",
                            type: "Checkbox",
                            model: "isContactBan",
                            lngTag: 20004512,
                            id: "isContactBan",
                            style: {
                                class: "medium"
                            }
                        }],
                    actions: {
                        post: "addContact",
                        put: "putContact"
                    }
                };
                /**
        * Client detail contact person address table
        * @memberOf UserInterface
        */
                _this.contactPersonAddressTable = {
                    "table": {
                        "Straße": {
                            "label": "street",
                            "dType": "string",
                            "lngTag": "20003001",
                            "style": "style",
                        },
                        "Hausnummer": {
                            "label": "houseNumber",
                            "dType": "string",
                            "lngTag": "20003002",
                            "style": "style",
                        },
                        "PLZ": {
                            "label": "postCode",
                            "dType": "string",
                            "lngTag": "20003005",
                            "style": "style",
                        },
                        "Ort": {
                            "label": "city",
                            "dType": "string",
                            "lngTag": "20003005",
                            "style": "style",
                        },
                        "Land": {
                            "label": "countryName",
                            "dType": "string",
                            "lngTag": "20003521",
                            "style": "style",
                        },
                        "Bundesland": {
                            "label": "stateName",
                            "dType": "string",
                            "lngTag": "20000284",
                            "style": "style",
                        },
                        "Typ": {
                            "label": "addressTypeName",
                            "dType": "string",
                            "lngTag": "20000025",
                            "style": "style",
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editAdress",
                                "label": "data",
                                "dType": "Button",
                                "openModal": "true",
                                "targetModal": "#edit-adress",
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify",
                                "permissionByDataSet": true
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteAdress",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete",
                                "permissionByDataSet": true
                            }]
                    },
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-location_pin"
                        },
                        "text": {
                            "label": ["street", "houseNumber"],
                            "dType": "string"
                        },
                        "subtext": [{
                                "label": "city",
                                "dType": "string"
                            }, {
                                "label": "stateName",
                                "dType": "string",
                            }, {
                                "label": "type",
                                "dType": "string",
                            }],
                        "buttons": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editAdress",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Bearbeiten",
                                "openModal": "true",
                                "targetModal": "#edit-adress",
                                "lngTag": "20000044",
                                "permission": "modify",
                                "permissionByDataSet": true
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteAdress",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete",
                                "permissionByDataSet": true
                            }]
                    },
                    "data": null,
                };
                /**
        * Client detail contact person communication table
        * @memberOf UserInterface
        */
                _this.contactpersonCommunicationTable = {
                    "table": {
                        "Kommunikationsart": {
                            "label": "communicationCategoryName",
                            "dType": "string",
                            "lngTag": "20005511",
                            "style": "style",
                        },
                        "Landesvorwahl": {
                            "label": "countryCode",
                            "dType": "string",
                            "lngTag": "20005505",
                            "style": "style",
                        },
                        "Ortsvorwahl": {
                            "label": "areaCode",
                            "dType": "string",
                            "lngTag": "20005506",
                            "style": "style",
                        },
                        "Adresse": {
                            "label": "targetAddress",
                            "dType": "string",
                            "lngTag": "20001045",
                            "style": "style",
                            "type": "type"
                        },
                        "Typ": {
                            "label": "communicationTypeName",
                            "dType": "string",
                            "lngTag": "20005504",
                            "style": "style",
                        },
                        "Standard": {
                            "label": "isMainRecord",
                            "dType": "Bool",
                            "lngTag": "20000070",
                            "style": "style",
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editCommunication",
                                "label": "data",
                                "dType": "Button",
                                "openModal": "true",
                                "targetModal": "#edit-communication",
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify",
                                "permissionByDataSet": true
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteCommunication",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete",
                                "permissionByDataSet": true
                            }]
                    },
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-book_telephone"
                        },
                        "text": {
                            "label": "communicationCategoryName",
                            "dType": "string"
                        },
                        "subtext": [{
                                "label": "targetAddress",
                                "dType": "string"
                            }, {
                                "label": "communicationTypeName",
                                "dType": "string",
                            }],
                        "buttons": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editCommunication",
                                "label": "data",
                                "dType": "Button",
                                "openModal": "true",
                                "targetModal": "#edit-communication",
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modifyCom",
                                "permissionByDataSet": true
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteCommunication",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "deleteCom",
                                "permissionByDataSet": true
                            }]
                    },
                    "data": null,
                };
                /**
        * Client detail doctor visit table
        * @memberOf UserInterface
        */
                _this.docVisitTable = {
                    "table": {
                        "Datum": {
                            "label": "date",
                            "dType": "Date",
                            "withTime": "true",
                            "lngTag": "20000045"
                        },
                        "Diagnose": {
                            "label": "diagnose",
                            "dType": "string",
                            "lngTag": "20010503"
                        },
                        "Arzt/Med. Organisation": {
                            "label": "treaterName",
                            "dType": "string",
                            "lngTag": "20010502"
                        },
                        //"Vorname": {
                        //    "label": "forename",
                        //    "dType": "string",
                        //    "lngTag": "20000057"
                        //},
                        "Fachrichtung": {
                            "label": "discipline",
                            "dType": "string",
                            "lngTag": "20023004"
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editDocVisit",
                                "openModal": "true",
                                "targetModal": "#" + _this.modalId,
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteDocVisit",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            }]
                    },
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-doctor"
                        },
                        "text": {
                            "label": "treaterName",
                            "dType": "string"
                        },
                        "subtext": [{
                                "label": "discipline",
                                "dType": "string"
                            }],
                        "buttons": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editDocVisit",
                                "openModal": "true",
                                "targetModal": "#" + _this.modalId,
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteDocVisit",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            }]
                    },
                    "data": null,
                };
                /**
        * Client detail doctor visit form
        * @memberOf UserInterface
        */
                _this.docVisitForm = {
                    form: [{
                            placeholder: "Datum",
                            label: "Datum",
                            type: "Date",
                            model: "date",
                            lngTag: 20000045,
                            required: true,
                            style: {
                                class: "col-md-6 col-xs-12",
                            }
                        }, {
                            placeholder: "Uhrzeit",
                            label: "Uhrzeit",
                            type: "Time",
                            lngTag: 20000046,
                            model: "time",
                            style: {
                                class: "col-md-6 col-xs-12",
                            },
                        }, {
                            placeholder: "Arzt/Med. Organisation",
                            label: "Arzt/Med. Organisation",
                            type: "Select2",
                            model: "treaterId",
                            lngTag: 20010502,
                            required: true,
                            dataSource: "getDoctors",
                            style: {
                                class: "col-md-12 col-xs-12",
                            },
                        }, {
                            label: "Diagnose",
                            placeholder: "Diagnose ...",
                            placeholderTag: "20010503",
                            type: "Summernote",
                            lngTag: "20010503",
                            model: "diagnose",
                            style: {
                                class: "col-xs-12",
                            }
                        }],
                    actions: {
                        put: "putDocVisit",
                        post: "addDocVisit"
                    }
                };
                /**
        * Client detail document table
        * @memberOf UserInterface
        */
                _this.clientAttachedFilesTable = {
                    "table": {
                        "Datum": {
                            "label": "date",
                            "dType": "Date",
                            "lngTag": "20000045"
                        },
                        "Dateiname": {
                            "label": "fileName",
                            "dType": "string",
                            "lngTag": "21006017"
                        },
                        "Dateigröße": {
                            "label": "fileSize",
                            "dType": "string",
                            "lngTag": "21006018"
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-download grey",
                                "click": "downloadFile",
                                "openModal": "false",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Herunterladen",
                                "lngTag": "21006014",
                                "permission": "allowDownload"
                            }, {
                                "icon": "qm-icon-document_attachment green",
                                "click": "previewDocument",
                                "openModal": "false",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Vorschau",
                                "lngTag": "20000091",
                                "permission": "allowPreview"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteFileFromFolder",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "deleteFile"
                            }]
                    },
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-document_attachment"
                        },
                        "text": {
                            "label": "fileName",
                            "dType": "string"
                        },
                        "subtext": [
                            {
                                "label": "date",
                                "dType": "Date"
                            }
                        ],
                        "buttons": [
                            {
                                "icon": "qm-icon-download grey",
                                "click": "downloadFile",
                                "openModal": "false",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Herunterladen",
                                "lngTag": "21006014",
                                "permission": "allowDownload"
                            }, {
                                "icon": "qm-icon-document_attachment green",
                                "click": "previewDocument",
                                "openModal": "false",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Vorschau",
                                "lngTag": "20000091",
                                "permission": "view"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteFileFromFolder",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            }
                        ]
                    },
                    "data": null,
                };
                /**
        * Client detail vaccination table
        * @memberOf UserInterface
        */
                _this.vaccinationTable = {
                    "table": {
                        "Datum": {
                            "label": "date",
                            "dType": "Date",
                            "lngTag": "20000045",
                        },
                        "Folgetermin": {
                            "label": "dateFollowupAppointment",
                            "dType": "Date",
                            "lngTag": "20009504",
                        },
                        "Arzt": {
                            "label": "doctorName",
                            "dType": "string",
                            "lngTag": "20010508",
                        },
                        "Impfung": {
                            "label": "diseaseName",
                            "dType": "string",
                            "lngTag": "20009514",
                        },
                        "Impfstoff": {
                            "label": "caption",
                            "dType": "string",
                            "lngTag": "20009506",
                        },
                        "Chargen-Nr": {
                            "label": "batchNumber",
                            "dType": "string",
                            "lngTag": "20009507",
                        },
                        "Bemerkung": {
                            "label": "commentPlain",
                            "dType": "string",
                            "lngTag": "20000049",
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editVaccination",
                                "label": "data",
                                "openModal": "true",
                                "targetModal": "#" + _this.modalId,
                                "dType": "Button",
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteVaccination",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            }]
                    },
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-injection"
                        },
                        "text": {
                            "label": "caption",
                            "dType": "string"
                        },
                        "subtext": [{
                                "label": "diseaseName",
                                "dType": "string"
                            }, {
                                "label": "doctorName",
                                "dType": "string",
                            }, {
                                "label": "type",
                                "dType": "string",
                            }],
                        "buttons": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editVaccination",
                                "label": "data",
                                "openModal": "true",
                                "targetModal": "#" + _this.modalId,
                                "dType": "Button",
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteVaccination",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            }]
                    },
                    "data": null,
                };
                /**
        * Client detail vaccination form
        * @memberOf UserInterface
        */
                _this.vaccinationForm = {
                    form: [{
                            lngTag: {
                                dateFrom: "20000045",
                                dateTo: "20009504"
                            },
                            label: {
                                dateFrom: "Datum",
                                dateTo: "Folgetermin"
                            },
                            type: "DateRange",
                            model: {
                                dateFrom: "date",
                                dateTo: "dateFollowupAppointment"
                            },
                            style: {
                                class: "col-xs-12"
                            },
                            config: {
                                displayDateTo: true
                            }
                        }, {
                            type: "hr"
                        }, {
                            placeholder: "Arzt auswählen",
                            label: "Arzt",
                            type: "Select2",
                            model: "doctorId",
                            lngTag: 20010502,
                            dataSource: "getDoctorsAndMedicalOrg",
                            required: true,
                            validate: {
                                message: "Bitte den Arzt angeben.",
                                messageTag: 21003014
                            },
                            style: {
                                class: "col-md-6 col-xs-12",
                            }
                        }, {
                            placeholder: "Impfung auswählen",
                            placeholderTag: "20009515",
                            label: "Impfung",
                            type: "Select2",
                            model: "diseaseId",
                            dataSource: "getDiseases",
                            lngTag: 20009514,
                            required: true,
                            id: "disease",
                            validate: {
                                message: "Bitte eine Krankheit angeben",
                                messageTag: 21003006
                            },
                            style: {
                                class: "col-md-6 col-xs-12",
                            },
                            wvId: '5485878a-6f2f-43fa-9d83-450732ff39b7',
                            wvListData: 'wvList.dieseasesWv'
                        }, {
                            placeholder: "Impfstoff Handelsname",
                            placeholderTag: "20009512",
                            label: "Impfstoff",
                            type: "String",
                            lngTag: 20009512,
                            model: "caption",
                            style: {
                                class: "col-md-6 col-xs-12",
                                icon: "fa fa-stethoscope"
                            },
                        }, {
                            placeholder: "Chargen-Nr",
                            placeholderTag: "20009507",
                            label: "Chargen-Nr",
                            type: "String",
                            model: "batchNumber",
                            lngTag: 20009507,
                            style: {
                                class: "col-md-6 col-xs-12",
                                icon: "fa fa-hashtag"
                            },
                        }, {
                            placeholder: "Bemerkung eintragen",
                            placeholderTag: "20000049",
                            label: "Bemerkung",
                            type: "Summernote",
                            maxLength: -1,
                            lngTag: 20000049,
                            model: "comment",
                            style: {
                                icon: "qm-icon-note_text",
                                class: "colm-md-6 col-xs-12",
                            }
                        },],
                    actions: {
                        put: "putVaccination",
                        post: "addVaccination"
                    }
                };
                /**
        * Client detail hobby table
        * @memberOf UserInterface
        */
                _this.hobbyTable = {
                    "table": {
                        "Gültig von": {
                            "label": "validFrom",
                            "dType": "Date",
                            "lngTag": "20008013",
                        },
                        "Gültig bis": {
                            "label": "validTo",
                            "dType": "Date",
                            "lngTag": "20008014",
                        },
                        "Bezeichnung": {
                            "label": "caption",
                            "dType": "string",
                            "lngTag": "20008006",
                        },
                        "Verein": {
                            "label": "societyName",
                            "dType": "string",
                            "lngTag": "20008008",
                        },
                        "Ansprechpartner/in": {
                            "label": "contactPerson",
                            "dType": "string",
                            "lngTag": "20008015",
                        },
                        "Hobbyart": {
                            "label": "type",
                            "dType": "string",
                            "lngTag": "20008002",
                        },
                        "Hobby": {
                            "label": "subType",
                            "dType": "string",
                            "lngTag": "20008004",
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editHobby",
                                "label": "data",
                                "openModal": "true",
                                "targetModal": "#" + _this.modalId,
                                "dType": "Button",
                                "tooltip": "Bearbeiten",
                                "lngTag": "20008016",
                                "permission": "modify"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteHobby",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20008017",
                                "permission": "delete"
                            }]
                    },
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-soccer_ball"
                        },
                        "text": {
                            "label": "caption",
                            "dType": "string"
                        },
                        "subtext": [{
                                "label": "type",
                                "dType": "string"
                            }, {
                                "label": "subType",
                                "dType": "string",
                            }, {
                                "label": "societyName",
                                "dType": "string",
                            }],
                        "buttons": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editHobby",
                                "label": "data",
                                "openModal": "true",
                                "targetModal": "#" + _this.modalId,
                                "dType": "Button",
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteHobby",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            }]
                    },
                    "data": null,
                };
                /**
        * Client detail hobby form
        * @memberOf UserInterface
        */
                _this.hobbyForm = {
                    form: [{
                            lngTag: {
                                dateFrom: "20008000",
                                dateTo: "20008001"
                            },
                            label: {
                                dateFrom: "Mitgliedschaft von",
                                dateTo: "bis"
                            },
                            type: "DateRange",
                            model: {
                                dateFrom: "validFrom",
                                dateTo: "validTo"
                            },
                            style: {
                                class: "col-xs-12"
                            },
                            config: {
                                displayDateTo: true
                            }
                        }, {
                            type: "hr"
                        }, {
                            placeholder: "Hobbyart auswählen",
                            label: "Hobbyart",
                            type: "Select2",
                            model: "typeId",
                            lngTag: 20008002,
                            dataSource: "getTypeWv",
                            required: true,
                            //events: {
                            //    updateDataSource: "subTypeId"
                            //},
                            validate: {
                                message: "Bitte den Hobbyart auswählen.",
                                messageTag: 20008003
                            },
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                            wvId: 'ebba5d70-a416-4d46-82cd-a12ddd906ff8',
                            wvListData: 'wvList.typeWvList'
                        }, {
                            placeholder: "Hobby auswählen",
                            label: "Hobby",
                            type: "Select2",
                            model: "subTypeId",
                            dataSource: "getSubTypeWv",
                            lngTag: 20008004,
                            required: true,
                            validate: {
                                message: "Bitte einen Hobby auswählen",
                                messageTag: 20008005
                            },
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                            wvId: 'af561b60-6040-41bb-96f7-a4a59cdce563',
                            wvSubParent: 'typeId',
                            events: {
                                hideExpression: "qmForm.isHobbyDisabled"
                            }
                        }, {
                            placeholder: "Hobby auswählen",
                            label: "Hobby",
                            type: "Select2",
                            model: "subTypeId",
                            dataSource: "getSubTypeWv",
                            lngTag: 20008004,
                            required: true,
                            disabled: true,
                            validate: {
                                message: "Bitte einen Hobby auswählen",
                                messageTag: 20008005
                            },
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                            events: {
                                hideExpression: "!qmForm.isHobbyDisabled"
                            }
                        }, {
                            placeholder: "Bezeichnung",
                            placeholderTag: "20008006",
                            label: "Bezeichnung",
                            type: "String",
                            lngTag: 20008006,
                            model: "caption",
                            style: {
                                class: "col-md-6 col-xs-12",
                                icon: "qm-icon-ballpen"
                            },
                        }, {
                            placeholder: "Verein auswählen",
                            placeholderTag: "20008007",
                            label: "Verein",
                            type: "Select2",
                            model: "societyId",
                            dataSource: "getSocietyListItems",
                            id: "society",
                            lngTag: 20008008,
                            events: {
                                updateDataSource: "contactPersonId"
                            },
                            style: {
                                class: "col-md-6 col-xs-12",
                            },
                        }, {
                            placeholder: "Ansprechpartner/in auswählen",
                            placeholderTag: "20008018",
                            label: "Ansprechpartner/in",
                            type: "Select2",
                            model: "contactPersonId",
                            dataSource: "getContactPersonItems",
                            id: "contactPerson",
                            lngTag: 20008015,
                            style: {
                                class: "col-md-6 col-xs-12",
                            },
                        }, {
                            placeholder: "Mitgliedsnummer",
                            placeholderTag: "20008010",
                            label: "Mitgliedsnummer",
                            type: "String",
                            model: "membershipNo",
                            lngTag: 20008010,
                            style: {
                                class: "col-md-6 col-xs-12",
                                icon: "fa fa-hashtag"
                            },
                        }, {
                            placeholder: "Bemerkung eintragen",
                            placeholderTag: "20008011",
                            label: "Bemerkung",
                            type: "Summernote",
                            maxLength: -1,
                            lngTag: 20008012,
                            model: "comment",
                            style: {
                                icon: "qm-icon-note_text",
                                class: "colm-md-6 col-xs-12",
                            }
                        },],
                    actions: {
                        put: "putHobby",
                        post: "addHobby"
                    }
                };
                /**
        * Client detail education table
        * @memberOf UserInterface
        */
                _this.educationTable = {
                    "table": {
                        "Gültig von": {
                            "label": "validFrom",
                            "dType": "Date",
                            "lngTag": "20012004",
                        },
                        "Gültig bis": {
                            "label": "validTo",
                            "dType": "Date",
                            "lngTag": "20012005",
                        },
                        "Ausbildungstyp": {
                            "label": "educationKindDescr",
                            "dType": "string",
                            "lngTag": "20012014",
                        },
                        "Schule/Firma": {
                            "label": "schoolCompanyName",
                            "dType": "string",
                            "lngTag": "20012006",
                        },
                        "Hauptansprechpartner": {
                            "label": "contactPerson",
                            "dType": "string",
                            "lngTag": "20012007",
                        },
                        "Abschluss": {
                            "label": "graduation",
                            "dType": "string",
                            "lngTag": "20012008",
                        },
                        "Art der Ausbildung": {
                            "label": "educationType",
                            "dType": "string",
                            "lngTag": "20012010",
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editEducation",
                                "label": "data",
                                "openModal": "true",
                                "targetModal": "#" + _this.modalId,
                                "dType": "Button",
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteEducation",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            }]
                    },
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-graduation_hat2"
                        },
                        "text": {
                            "label": "educationKindDescr",
                            "dType": "string"
                        },
                        "subtext": [{
                                "label": "caption",
                                "dType": "string"
                            }, {
                                "label": "contactPerson",
                                "dType": "string",
                            }, {
                                "label": "educationType",
                                "dType": "string",
                            }],
                        "buttons": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editEducation",
                                "label": "data",
                                "openModal": "true",
                                "targetModal": "#" + _this.modalId,
                                "dType": "Button",
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteEducation",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            }]
                    },
                    "data": null,
                };
                _this.educationForm = {
                    form: [{
                            placeholder: "Ausbildungstyp auswählen",
                            placeholderTag: "20012026",
                            label: "Ausbildungstyp",
                            type: "Select2",
                            model: "educationKind",
                            lngTag: 20012003,
                            dataSource: "getEducationKindWv",
                            required: true,
                            validate: {
                                message: "Bitte den Ausbildungstyp auswählen.",
                                messageTag: 20012016
                            },
                            events: {
                                hideExpression: "(qmForm.educationKind != null && qmState == 'edit')"
                            },
                            style: {
                                class: "col-md-12 col-xs-12",
                            }
                        }, {
                            lngTag: {
                                dateFrom: "20012004",
                                dateTo: "20012005"
                            },
                            label: {
                                dateFrom: "Gültig von",
                                dateTo: "Gültig bis"
                            },
                            type: "DateRange",
                            model: {
                                dateFrom: "validFrom",
                                dateTo: "validTo"
                            },
                            events: {
                                hideExpression: "(qmForm.educationKind == null)"
                            },
                            style: {
                                class: "col-xs-12"
                            },
                            config: {
                                displayDateTo: true
                            }
                        }, {
                            type: "hr"
                        }, {
                            placeholder: "Art der Ausbildung auswählen",
                            placeholderTag: "20012030",
                            label: "Art der Ausbildung",
                            type: "Select2",
                            model: "educationTypeId",
                            dataSource: "getProfessionalTypeWv",
                            lngTag: 20012010,
                            id: "educationaType",
                            required: true,
                            validate: {
                                message: "Bitte das art der Ausbildung auswählen",
                                messageTag: 20012031
                            },
                            events: {
                                hideExpression: "(qmForm.educationKind != 1) || (qmForm.educationKind == null)"
                            },
                            style: {
                                class: "col-md-6 col-xs-12",
                            },
                            wvId: '5c177c51-a3a8-4516-99ef-54ba88e946d2',
                            wvListData: 'educationSchemaWvList.professionalTypeWvList'
                        },
                        {
                            placeholder: "Art der Ausbildung auswählen",
                            placeholderTag: "20012030",
                            label: "Art der Ausbildung",
                            type: "Select2",
                            model: "educationTypeId",
                            dataSource: "getSchoolTypeWv",
                            lngTag: 20012010,
                            id: "educationaType",
                            required: true,
                            validate: {
                                message: "Bitte das art der Ausbildung auswählen",
                                messageTag: 20012031
                            },
                            events: {
                                hideExpression: "(qmForm.educationKind != 0) || (qmForm.educationKind == null)"
                            },
                            style: {
                                class: "col-md-6 col-xs-12",
                            },
                            wvId: '7bc3ef03-862e-442c-a925-7edf8a2e1cd3',
                            wvListData: 'educationSchemaWvList.schoolTypeWvList'
                        }, {
                            placeholder: "Eintragsart auswählen",
                            placeholderTag: "20012029",
                            label: "Eintragsart",
                            type: "Select2",
                            model: "educationTypeId",
                            dataSource: "getProfessionalCareerTypeWv",
                            lngTag: 20012022,
                            id: "professionalCareer",
                            events: {
                                hideExpression: "(qmForm.educationKind != 2) || (qmForm.educationKind == null)"
                            },
                            style: {
                                class: "col-md-6 col-xs-12",
                            },
                            wvId: 'e709e81f-b8ec-47c8-a72c-8f5d982dbc41',
                            wvListData: 'educationSchemaWvList.professionalCareerTypeWvList'
                        }, {
                            placeholder: "Schule auswählen",
                            placeholderTag: "20012018",
                            label: "Schule",
                            type: "Select2",
                            model: "schoolCompanyId",
                            dataSource: "getSchoolsItemList",
                            lngTag: 20012019,
                            id: "school",
                            events: {
                                hideExpression: "(qmForm.educationKind != 0 ) || (qmForm.educationKind == null)",
                                updateDataSource: "classId"
                            },
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                        },
                        {
                            placeholder: "Firma auswählen",
                            placeholderTag: "20012017",
                            label: "Firma",
                            type: "Select2",
                            model: "schoolCompanyId",
                            dataSource: "getCompaniesItemList",
                            lngTag: 20012011,
                            id: "company",
                            events: {
                                hideExpression: "(qmForm.educationKind == 0) || (qmForm.educationKind == null)",
                                updateDataSource: "contactPersonId"
                            },
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                        }, {
                            placeholder: "Manueller Text",
                            placeholderTag: "20012012",
                            label: "Manueller Text",
                            type: "String",
                            lngTag: 20012012,
                            model: "caption",
                            events: {
                                hideExpression: "(qmForm.educationKind == null)"
                            },
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                        }, {
                            placeholder: "Status auswählen",
                            placeholderTag: "20012028",
                            label: "Status",
                            type: "Select2",
                            model: "statusId",
                            dataSource: "getSchoolStatusWv",
                            lngTag: 20012013,
                            id: "statusSchool",
                            events: {
                                hideExpression: "(qmForm.educationKind != 0) || (qmForm.educationKind == null)"
                            },
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                            wvId: 'fd81f106-4773-493d-a04f-223e4ebfd195',
                            wvListData: 'educationSchemaWvList.schoolStatusWvList'
                        }, {
                            placeholder: "Status auswählen",
                            placeholderTag: "20012028",
                            label: "Status",
                            type: "Select2",
                            model: "statusId",
                            dataSource: "getProfessionalStatusWv",
                            lngTag: 20012013,
                            id: "statusProfessional",
                            events: {
                                hideExpression: "(qmForm.educationKind != 1) || (qmForm.educationKind == null)"
                            },
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                            wvId: 'fd81f106-4773-493d-a04f-223e4ebfd195',
                            wvListData: 'educationSchemaWvList.professionalStatusWvList'
                        }, {
                            placeholder: "Status auswählen",
                            placeholderTag: "20012028",
                            label: "Status",
                            type: "Select2",
                            model: "statusId",
                            dataSource: "getProfessionalCareerStatusWv",
                            lngTag: 20012013,
                            id: "statusProfessionalCareer",
                            events: {
                                hideExpression: "(qmForm.educationKind != 2) || (qmForm.educationKind == null)"
                            },
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                            wvId: 'ddcde80d-3634-4ccc-9434-03bd09f36014',
                            wvListData: 'educationSchemaWvList.professionalCareerStatusWvList'
                        }, {
                            placeholder: "Klasse auswählen",
                            placeholderTag: "20012027",
                            label: "Klasse",
                            type: "Select2",
                            model: "classId",
                            dataSource: "getGradeLevelList",
                            lngTag: 20012021,
                            id: "class",
                            events: {
                                hideExpression: "(qmForm.educationKind != 0) || (qmForm.educationKind == null)"
                            },
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                        },
                        {
                            placeholder: "Ausbildungstyp auswählen",
                            placeholderTag: "20012026",
                            label: "Ausbildungstyp",
                            type: "Select2",
                            model: "professionalTrainingTypeId",
                            dataSource: "getProfessionalTrainingTypeWv",
                            lngTag: 20012014,
                            id: "professionTrainingType",
                            events: {
                                hideExpression: "(qmForm.educationKind != 1) || (qmForm.educationKind == null)"
                            },
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                            wvId: '92528000-789f-4eb5-8f1c-4bcd24a3aeea',
                            wvListData: 'educationSchemaWvList.professionalTrainingTypeWvList'
                        }, {
                            placeholder: "Ansprechpartner auswählen",
                            placeholderTag: "20012025",
                            label: "Ansprechpartner",
                            type: "Select2",
                            model: "contactPersonId",
                            dataSource: "getContactPersonsItemList",
                            lngTag: 20012015,
                            id: "contactPerson",
                            events: {
                                hideExpression: "(qmForm.educationKind == null)"
                            },
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                        }, {
                            placeholder: "Abschluss auswählen",
                            placeholderTag: "20012023",
                            label: "Abschluss",
                            type: "Select2",
                            model: "graduationId",
                            dataSource: "getSchoolGraduationWv",
                            lngTag: 20012008,
                            id: "schoolGraduation",
                            events: {
                                hideExpression: "(qmForm.educationKind != 0) || (qmForm.educationKind == null)"
                            },
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                            wvId: '6fe5a13e-45f2-4c77-b784-b3130c796d72',
                            wvListData: 'educationSchemaWvList.schoolGraduationWvList'
                        }, {
                            placeholder: "Abschluss auswählen",
                            placeholderTag: "20012023",
                            label: "Abschluss",
                            type: "Select2",
                            model: "graduationId",
                            dataSource: "getProfessionalGraduationWv",
                            lngTag: 20012008,
                            id: "professionalGraduation",
                            events: {
                                hideExpression: "(qmForm.educationKind != 1) || (qmForm.educationKind == null)"
                            },
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                            wvId: '770a34b0-2839-4732-84f7-06715703810d',
                            wvListData: 'educationSchemaWvList.professionalGraduationWvList'
                        }, {
                            placeholder: "Bemerkung eintragen",
                            placeholderTag: "20012024",
                            label: "Bemerkung",
                            type: "Summernote",
                            maxLength: -1,
                            lngTag: 20000049,
                            model: "comment",
                            events: {
                                hideExpression: "(qmForm.educationKind == null)"
                            },
                            style: {
                                icon: "qm-icon-note_text",
                                class: "colm-md-6 col-xs-12",
                            }
                        },],
                    actions: {
                        put: "putEducation",
                        post: "addEducation"
                    }
                };
                /**
        * Client detail training table
        * @memberOf UserInterface
        */
                _this.trainingTable = {
                    "table": {
                        "Gueltig von": {
                            "label": "validFrom",
                            "dType": "Date",
                            "lngTag": "20033001"
                        },
                        "Gueltig bis": {
                            "label": "validTo",
                            "dType": "Date",
                            "lngTag": "20033002"
                        },
                        "Typ": {
                            "label": "trainingTypeDescr",
                            "dType": "string",
                            "lngTag": "20033003"
                        },
                        "Faehigkeit": {
                            "label": "trainingDescr",
                            "dType": "string",
                            "lngTag": "20033000"
                        },
                        "Erworben durch": {
                            "label": "acquiredByDescr",
                            "dType": "string",
                            "lngTag": "20033005"
                        },
                        "Bemerkung": {
                            "label": "description",
                            "dType": "string",
                            "lngTag": "20033006"
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editTraining",
                                "label": "data",
                                "dType": "Button",
                                "openModal": "true",
                                "targetModal": "#" + _this.modalId,
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteTraining",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            }]
                    },
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-injection"
                        },
                        "text": {
                            "label": "trainingTypeDescr",
                            "dType": "string"
                        },
                        "subtext": [{
                                "label": "trainingDescr",
                                "dType": "string"
                            }, {
                                "label": "validFrom",
                                "dType": "Date",
                            },],
                        "buttons": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editTraining",
                                "label": "data",
                                "openModal": "true",
                                "targetModal": "#" + _this.modalId,
                                "dType": "Button",
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteTraining",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            }]
                    },
                    "data": null,
                };
                /**
        * Client detail training form
        * @memberOf UserInterface
        */
                _this.trainingForm = {
                    form: [{
                            lngTag: {
                                dateFrom: "20033001",
                                dateTo: "20033002",
                            },
                            label: {
                                dateFrom: "Gültig von",
                                dateTo: "Gültig bis",
                            },
                            type: "DateRange",
                            model: {
                                dateFrom: "validFrom",
                                dateTo: "validTo"
                            },
                            style: {
                                class: "col-xs-12"
                            },
                            config: {
                                displayDateTo: true
                            }
                        }, {
                            placeholder: "Typ",
                            label: "Typ",
                            type: "Select2",
                            model: "trainingTypeId",
                            dataSource: "getTrainingTypeWv",
                            lngTag: 20033003,
                            required: true,
                            validate: {
                                message: "Wählen Sie den Typ aus",
                                messageTag: 20033007
                            },
                            style: {
                                class: "col-md-12 col-xs-12",
                            },
                            wvId: '9837b948-2099-4544-947c-eadbfd5908e2',
                            wvListData: 'trainingSchemaWvList.trainingTypeWvList'
                        }, {
                            placeholder: "Fähigkeit / Fortbildung",
                            label: "Fähigkeit / Fortbildung",
                            type: "Select2",
                            model: "trainingId",
                            dataSource: "getTrainingWv",
                            lngTag: 20033000,
                            required: true,
                            validate: {
                                message: "Wählen Sie die Fähigkeit aus",
                                messageTag: 20033008
                            },
                            style: {
                                class: "col-md-12 col-xs-12"
                            },
                            wvId: '6dfcbb34-3d58-401e-bf1f-29a5da6bde88',
                            wvListData: 'trainingSchemaWvList.trainingWvList'
                        },
                        {
                            placeholder: "Erworben durch",
                            label: "Erworben durch",
                            type: "Select2",
                            model: "acquiredById",
                            dataSource: "getAquiredByWv",
                            lngTag: 20033005,
                            style: {
                                class: "col-md-12 col-xs-12"
                            },
                            wvId: '95dcc367-adf8-4f3d-98fd-bf167221172e',
                            wvListData: 'trainingSchemaWvList.acquiredByWvList'
                        },
                        {
                            placeholder: "Bemerkung eintragen ...",
                            placeholderTag: "20000049",
                            label: "Bemerkung",
                            type: "Textarea",
                            maxLength: -1,
                            model: "description",
                            lngTag: 20033006,
                            style: {
                                icon: "qm-icon-note_text",
                                class: "col-xs-12 col-md-12",
                            }
                        },],
                    actions: {
                        put: "putTraining",
                        post: "addTraining",
                    }
                };
                /**
        * Client detail disease table
        * @memberOf UserInterface
        */
                _this.diseaseTable = {
                    "table": {
                        "Datum von": {
                            "label": "dateFrom",
                            "dType": "Date",
                            "lngTag": "20000047"
                        },
                        "Datum bis": {
                            "label": "dateTo",
                            "dType": "Date",
                            "lngTag": "20000054"
                        },
                        "Codeschema": {
                            "label": "diseaseCodeSchema",
                            "dType": "string",
                            "lngTag": "20007002"
                        },
                        "Krankheit": {
                            "label": "diseaseName",
                            "dType": "string",
                            "lngTag": "20001049"
                        },
                        "Bemerkung": {
                            "label": "comment",
                            "dType": "string",
                            "lngTag": "20000049"
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editDisease",
                                "label": "data",
                                "dType": "Button",
                                "openModal": "true",
                                "targetModal": "#" + _this.modalId,
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteDisease",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            }]
                    },
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-injection"
                        },
                        "text": {
                            "label": "diseaseName",
                            "dType": "string"
                        },
                        "subtext": [{
                                "label": "diseaseCodeSchema",
                                "dType": "string"
                            }, {
                                "label": "dateFrom",
                                "dType": "Date",
                            },],
                        "buttons": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editDisease",
                                "label": "data",
                                "openModal": "true",
                                "targetModal": "#" + _this.modalId,
                                "dType": "Button",
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteDisease",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            }]
                    },
                    "data": null,
                };
                /**
        * Client detail disease form
        * @memberOf UserInterface
        */
                _this.diseaseForm = {
                    form: [{
                            lngTag: {
                                dateFrom: "20000047",
                                dateTo: "20000054",
                            },
                            label: {
                                dateFrom: "Datum von",
                                dateTo: "Datum bis",
                            },
                            type: "DateRange",
                            model: {
                                dateFrom: "dateFrom",
                                dateTo: "dateTo"
                            },
                            style: {
                                class: "col-xs-12"
                            },
                            config: {
                                displayDateTo: true
                            }
                        }, {
                            placeholder: "Codeschema",
                            label: "Codeschema",
                            type: "Select2",
                            model: "diseaseCodeSchemaId",
                            dataSource: "getDiseaseCodeSchemaWvList",
                            lngTag: 20007002,
                            required: true,
                            validate: {
                                message: "Bitte das Codeschema angeben.",
                                messageTag: 21003005
                            },
                            style: {
                                class: "col-md-12 col-xs-12",
                            }
                        }, {
                            placeholder: "Krankheit",
                            label: "Krankheit",
                            type: "Autocomplete",
                            model: "diseaseName",
                            lngTag: 20001049,
                            required: true,
                            id: "liveDiseases",
                            validate: {
                                message: "Bitte die Krankheit angeben."
                            },
                            style: {
                                class: "col-md-12 col-xs-12",
                                icon: "fa fa-globe"
                            }
                        },
                        {
                            placeholder: "Krankheitsart",
                            label: "Krankheitsart",
                            type: "Select2",
                            model: "diseaseTypeId",
                            dataSource: "getDiseaseTypeWvList",
                            lngTag: 20007513,
                            style: {
                                class: "col-md-12 col-xs-12",
                            }
                        },
                        {
                            placeholder: "Bemerkung eintragen ...",
                            placeholderTag: "20000049",
                            label: "Bemerkung",
                            type: "Summernote",
                            maxLength: -1,
                            model: "formattedComment",
                            lngTag: 20000049,
                            style: {
                                icon: "qm-icon-note_text",
                                class: "col-xs-12 col-md-12",
                            }
                        },],
                    actions: {
                        put: "putDisease",
                        post: "addDiseased",
                    }
                };
                /**
        * Client detail absenteeism table
        * @memberOf UserInterface
        */
                _this.absenteeismTable = {
                    "table": {
                        "Datum von": {
                            "label": "dateFrom",
                            "dType": "Date",
                            "withTime": "true",
                            "lngTag": "20000047",
                            "style": "style"
                        },
                        "Datum bis": {
                            "label": "dateTo",
                            "dType": "Date",
                            "withTime": "true",
                            "lngTag": "20000054",
                            "style": "style"
                        },
                        "Abwesenheitsgrund": {
                            "label": "absenteeismReason",
                            "dType": "string",
                            "lngTag": "21008001",
                            "style": "style"
                        },
                        "Kontaktperson": {
                            "label": "contactPersonName",
                            "dType": "string",
                            "lngTag": "20001048",
                            "style": "style"
                        },
                        "Bemerkung": {
                            "label": "comment",
                            "dType": "string",
                            "lngTag": "20000049",
                            "style": "style"
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editAbsenteeism",
                                "label": "data",
                                "openModal": "true",
                                "targetModal": "#" + _this.modalId,
                                "dType": "Button",
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteAbsenteeism",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            }]
                    },
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-calendar_7"
                        },
                        "text": {
                            "label": "absenteeismReason",
                            "dType": "string"
                        },
                        "text": {
                            "label": "contactPersonName",
                            "dType": "string"
                        },
                        "subtext": [{
                                "label": "dateFrom",
                                "dType": "Date"
                            }],
                        "buttons": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editAbsenteeism",
                                "label": "data",
                                "dType": "Button",
                                "openModal": "true",
                                "targetModal": "#" + _this.modalId,
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteAbsenteeism",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            }]
                    },
                    "data": null
                };
                /**
        * Client detail absenteeism form
        * @memberOf UserInterface
        */
                _this.absenteeismForm = {
                    form: [{
                            placeholder: "Abwesenheitsgrund",
                            label: "Abwesenheitsgrund",
                            type: "Select2",
                            lngTag: 21008001,
                            model: "absenteeismReasonId",
                            dataSource: "getWvList",
                            required: true,
                            validate: {
                                message: "Bitte einen Grund auswählen.",
                                messageTag: 21008002
                            },
                            style: {
                                class: "col-md-6 col-xs-12",
                            },
                            wvId: '18ad8c93-5212-4736-b9bb-a00ae7a0d95f',
                            wvListData: 'wvList.absenteeismReasonWvList'
                        }, {
                            placeholder: "Aufenthalt bei",
                            label: "Aufenthalt bei",
                            type: "Select2",
                            lngTag: 21008010,
                            model: "contactPersonId",
                            dataSource: "getContactPersonList",
                            style: {
                                class: "col-md-6 col-xs-12",
                            }
                        }, {
                            type: "hr"
                        }, {
                            lngTag: {
                                dateFrom: "20000047",
                                dateTo: "20000054"
                            },
                            label: {
                                dateFrom: "Datum von",
                                dateTo: "Datum bis",
                            },
                            type: "DateRange",
                            model: {
                                dateFrom: "dateFrom",
                                dateTo: "dateTo"
                            },
                            style: {
                                class: "col-xs-12"
                            },
                            config: {
                                displayTime: true,
                                disableTime: false,
                                displayDateTo: true,
                                disableDate: false,
                            }
                        }, {
                            placeholder: "Bemerkung eintragen ...",
                            label: "Bemerkung",
                            type: "Textarea",
                            maxLength: -1,
                            model: "comment",
                            lngTag: 20000049,
                            style: {
                                icon: "qm-icon-note_text",
                                class: "col-xs-12",
                            }
                        }],
                    actions: {
                        put: "putAbsenteeism",
                        post: "addAbsenteeism"
                    }
                };
                /**
             * Client detail accountingBook table
             * @memberOf UserInterface
             */
                _this.accountingBookTable = {
                    "table": {
                        "Kassenbuchart": {
                            "label": "accountingBookType",
                            "dType": "string",
                            "lngTag": "20019002",
                        },
                        "Bezeichnung": {
                            "label": "caption",
                            "dType": "string",
                            "lngTag": "20000053",
                        },
                        "Kontonummer": {
                            "label": "accountNumber",
                            "dType": "string",
                            "lngTag": "20019004",
                        },
                        "Währung": {
                            "label": "currency",
                            "dType": "string",
                            "lngTag": "20019003",
                        },
                        "MwSt.": {
                            "label": "standardVat",
                            "dType": "string",
                            "lngTag": "20000279"
                        },
                        "Negativen Saldo zulassen": {
                            "label": "onlyPositive",
                            "dType": "Bool",
                            "lngTag": "20019025"
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-magnifying_glass green",
                                "click": "getAccountingBook",
                                "label": "data",
                                "dType": "Button",
                                "lngTag": "21006000",
                                "tooltip": "Einträge anzeigen",
                                "events": {
                                    "hide": "!view"
                                }
                            }, {
                                "icon": "qm-icon-pencil blue",
                                "click": "editAccountingBook",
                                "openModal": "true",
                                "targetModal": "#" + _this.modalId,
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "events": {
                                    "hide": "!modify"
                                }
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteAccountingBook",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "special",
                                "permissionByDataSet": true
                            }, {
                                "icon": "qm-icon-plus green",
                                "openModal": "true",
                                "targetModal": "#edit-entryForm",
                                "click": "initEntryForm",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Eintrag hinzufügen",
                                "lngTag": "20000044",
                                "permission": "entryNew"
                            }]
                    },
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-cashier"
                        },
                        "text": {
                            "label": "caption",
                            "dType": "string"
                        },
                        "subtext": [{
                                "label": "accountingBookType",
                                "dType": "string"
                            }, {
                                "label": "currency",
                                "dType": "string"
                            }],
                        "buttons": [{
                                "icon": "qm-icon-magnifying_glass green",
                                "click": "getAccountingBook",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Einträge anzeigen",
                                "lngTag": "21006000",
                                "permission": "view",
                                "events": {
                                    "hide": "!view"
                                }
                            }, {
                                "icon": "qm-icon-pencil blue",
                                "click": "editAccountingBook",
                                "openModal": "true",
                                "targetModal": "#" + _this.modalId,
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify",
                                "events": {
                                    "hide": "!modify"
                                }
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteAccountingBook",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "special",
                                "permissionByDataSet": true
                            }, {
                                "icon": "qm-icon-plus_selected green",
                                "openModal": "true",
                                "targetModal": "#edit-entryForm",
                                "click": "initEntryForm",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Eintrag hinzufügen",
                                "lngTag": "20000044",
                                "permission": "entryNew"
                            }]
                    },
                    "data": null,
                };
                /**
        * client detail accounting book form
        * @memberOf UserInterface
        */
                _this.accountingBookForm = {
                    form: [{
                            label: "Kassenbuchname",
                            type: "String",
                            model: "caption",
                            lngTag: 20019019,
                            required: true,
                            style: {
                                icon: "qm-icon-note_text",
                                class: "col-md-6 col-xs-12",
                            },
                            validate: {
                                message: "Bitte die Bezeichnung angeben."
                            }
                        }, {
                            label: "Kassenbuchart",
                            type: "Select2",
                            lngTag: "20019002",
                            model: "accountingBookTypeId",
                            dataSource: "getTypeList",
                            id: "accountingBookTypeId",
                            required: true,
                            style: {
                                class: "col-md-6 col-xs-12",
                            },
                            validate: {
                                message: "Bitte die Kassenbuchart angeben."
                            },
                            wvId: '3a2e140f-9e22-414f-bd7c-518085cd0012',
                            wvListData: 'wvList.accountingBookTypeWvList'
                        }, {
                            label: "Konto-Nr.",
                            lngTag: "20019027",
                            type: "String",
                            model: "accountNumber",
                            style: {
                                class: "col-xs-12 col-md-6",
                                icon: "fa fa-hashtag"
                            }
                        }, {
                            type: "hr"
                        }, {
                            placeholder: "Land",
                            label: "Land",
                            type: "Select2",
                            lngTag: 20003521,
                            model: "countryId",
                            dataSource: "getCountryList",
                            required: true,
                            events: {
                                updateDataSource: "currencyId",
                            },
                            style: {
                                class: "col-xs-12",
                            }
                        }, {
                            placeholder: "Währung",
                            label: "Währung",
                            type: "Select",
                            lngTag: 20019003,
                            model: "currencyId",
                            dataSource: "getCurrencyList",
                            required: true,
                            id: "currencyId",
                            validate: {
                                message: "Bitte eine Währung auswählen",
                                messageTag: 20019005
                            },
                            style: {
                                class: "col-md-6 col-xs-12",
                            },
                        }, {
                            placeholder: "Standard Mehrwertsteuer",
                            label: "Standard Mehrwertsteuer",
                            type: "Select",
                            lngTag: 20019006,
                            model: "standardVatId",
                            dataSource: "getVatList",
                            id: "standardVatId",
                            events: {
                                hideExpression: "(d.dataSource.value.length < 1)"
                            },
                            style: {
                                class: "col-md-6 col-xs-12",
                            },
                        }, {
                            label: "Negativen Saldo zulassen",
                            type: "Checkbox",
                            model: "onlyPositive",
                            id: "onlyPositive",
                            lngTag: "20019025",
                            style: {
                                class: "col-xs-6"
                            }
                        }, {
                            label: "abgeschlossen bis",
                            type: "Date",
                            model: "endingDate",
                            lngTag: "20019026",
                            //required: true,
                            //events: {
                            //    hide: "onlyPositive"
                            //},
                            style: {
                                class: "col-xs-6"
                            }
                        }, {
                            label: "Als Standard",
                            lngTag: "20000070",
                            type: "Checkbox",
                            model: "isStandard",
                            id: "isStandard",
                            disabled: true,
                            style: {
                                class: "col-xs-6"
                            },
                            events: {
                                hideExpression: "!qmForm.wasStandard"
                            }
                        }, {
                            label: "Als Standard",
                            lngTag: "20000070",
                            type: "Checkbox",
                            model: "isStandard",
                            id: "isStandard2",
                            disabled: false,
                            style: {
                                class: "col-xs-6"
                            },
                            events: {
                                hideExpression: "qmForm.wasStandard"
                            }
                        },],
                    actions: {
                        put: "putAccountingBook",
                        post: "addAccountingBook"
                    }
                };
                /**
        * client detail accounting book entry table
        * @memberOf UserInterface
        */
                _this.accountingBookEntryTableIn = {
                    "config": {
                        "showTitle": "true",
                        "defaultSort": "date",
                        "sortReverse": "true",
                    },
                    "table": {
                        "Datum": {
                            "label": "date",
                            "dType": "Date",
                            "lngTag": "20000045"
                        },
                        "Belegtyp": {
                            "label": "voucherType",
                            "dType": "string",
                            "lngTag": "20019014"
                        },
                        // "Belegtext": {
                        //     "label": "voucherText",
                        //     "dType": "string",
                        //     "lngTag": "20019003"
                        // },
                        "Betrag": {
                            "label": "amountSigned",
                            "dType": "Number",
                            "calculate": "true",
                            "lngTag": "20000122"
                        },
                        "Währung": {
                            "label": "currency",
                            "dType": "string",
                            "lngTag": "20019003"
                        },
                        // "MwSt.": {
                        //     "label": "vatText",
                        //     "dType": "string"
                        // },
                        "Beleg Nr.": {
                            "label": "voucherNr",
                            "dType": "string",
                            "lngTag": "20019015"
                        },
                        "Gegenb.": {
                            "label": "isCounterBooking",
                            "dType": "Bool",
                            "lngTag": "0"
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editAccountingBookEntry",
                                "openModal": "true",
                                "targetModal": "#edit-entryForm",
                                "label": "data",
                                "dType": "Button",
                                "lngTag": "20000144",
                                "tooltip": "Anzeigen und Bearbeiten",
                                "permission": "entryModify",
                                "events": {
                                    "hide": "!allowEdit"
                                }
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteAccountingBookEntry",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "entryDelete",
                                "events": {
                                    "hide": "!allowDelete"
                                }
                            }]
                    },
                    "card": {
                        "avatar": {
                            "icon": "fa fa-plus-circle fa-green"
                        },
                        "text": {
                            "label": "voucherType",
                            "dType": "string"
                        },
                        "subtext": [{
                                "dType": "string"
                            }, {
                                "label": "amountSigned",
                                "dType": "Number"
                            }],
                        "buttons": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editAccountingBookEntry",
                                "openModal": "true",
                                "targetModal": "#edit-entryForm",
                                "label": "data",
                                "dType": "Button",
                                "lngTag": "20000144",
                                "tooltip": "Bearbeiten",
                                "permission": "entryModify",
                                "events": {
                                    "hide": "!allowEdit"
                                }
                            }]
                    },
                    "data": null,
                };
                _this.accountingBookEntryTableOut = {
                    "config": {
                        "showTitle": "true",
                        "defaultSort": "date",
                        "sortReverse": "true"
                    },
                    "table": {
                        "Datum": {
                            "label": "date",
                            "dType": "Date",
                            "lngTag": "20000045"
                        },
                        "Belegtyp": {
                            "label": "voucherType",
                            "dType": "string",
                            "lngTag": "20019014"
                        },
                        // "Belegtext": {
                        //     "label": "voucherText",
                        //     "dType": "string",
                        //     "lngTag": "20019003"
                        // },
                        "Betrag": {
                            "label": "amountSigned",
                            "dType": "Number",
                            "calculate": "true",
                            "lngTag": "20000122"
                        },
                        "Währung": {
                            "label": "currency",
                            "dType": "string",
                            "lngTag": "20019003"
                        },
                        // "MwSt.": {
                        //     "label": "vatText",
                        //     "dType": "string"
                        // },
                        "Beleg Nr.": {
                            "label": "voucherNr",
                            "dType": "string",
                            "lngTag": "20019015"
                        },
                        "Gegenb.": {
                            "label": "isCounterBooking",
                            "dType": "Bool",
                            "lngTag": "0"
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editAccountingBookEntry",
                                "openModal": "true",
                                "targetModal": "#edit-entryForm",
                                "label": "data",
                                "dType": "Button",
                                "lngTag": "20000144",
                                "tooltip": "Anzeigen und Bearbeiten",
                                "permission": "entryModify",
                                "events": {
                                    "hide": "!allowEdit"
                                }
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteAccountingBookEntry",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "entryDelete",
                                "events": {
                                    "hide": "!allowDelete"
                                }
                            }]
                    },
                    "card": {
                        "avatar": {
                            "icon": "fa fa-minus-circle fa-red"
                        },
                        "text": {
                            "label": "voucherType",
                            "dType": "string"
                        },
                        "subtext": [{
                                "dType": "string"
                            }, {
                                "label": "amountSigned",
                                "dType": "Number"
                            }],
                        "buttons": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editAccountingBookEntry",
                                "openModal": "true",
                                "targetModal": "#edit-entryForm",
                                "label": "data",
                                "dType": "Button",
                                "lngTag": "20000144",
                                "tooltip": "Bearbeiten",
                                "permission": "entryModify",
                                "events": {
                                    "hide": "!allowEdit"
                                }
                            }]
                    },
                    "data": null,
                };
                /**
        * client detail accounting book entry form
        * @memberOf UserInterface
        */
                _this.accountingBookEntryForm = {
                    form: [{
                            lngTag: "20000025",
                            label: "Typ",
                            type: "Select",
                            model: "isDeposit",
                            required: true,
                            dataSource: "getDepositList",
                            style: {
                                class: "col-xs-12- col-md-6"
                            }
                        }, {
                            lngTag: "20019014",
                            label: "Belegtyp",
                            type: "Select2",
                            model: "voucherTypeId",
                            required: true,
                            dataSource: "getVoucherTypeList",
                            style: {
                                class: "col-xs-12 col-md-6",
                                icon: "fa fa-hashtag"
                            },
                            events: {
                                hideExpression: "qmForm.isDeposit == true"
                            },
                            wvId: 'c102cb74-6152-45bb-adf1-9e6a53c5b71b',
                            wvListData: 'wvList.paymentVoucherTypeWvList'
                        }, {
                            lngTag: "20019028",
                            label: "Einnahmetyp",
                            type: "Select2",
                            model: "voucherTypeId",
                            required: true,
                            dataSource: "getDepositTypeList",
                            style: {
                                class: "col-xs-12 col-md-6"
                            },
                            events: {
                                hideExpression: "qmForm.isDeposit == false"
                            },
                            wvId: '7b1c5c67-0606-4613-bac0-97dea9ee78e8',
                            wvListData: 'wvList.depositVoucherTypeWvList'
                        }, {
                            label: "Generiere Belegnummer",
                            type: "Checkbox",
                            model: "createVoucherNr",
                            id: "createVoucherNr",
                            lngTag: "20019021",
                            style: {
                                class: "col-xs-12 col-md-6 col-lg-3",
                            },
                            events: {
                                hideExpression: "(qmForm.generateVoucherNrPossible == false || qmForm.isVoucherNumberFix == true)"
                            }
                        }, {
                            lngTag: "20019015",
                            label: "Beleg Nr.",
                            type: "String",
                            model: "voucherNr",
                            disabled: true,
                            style: {
                                class: "col-xs-12 col-md-6 col-lg-3",
                                icon: "fa fa-hashtag",
                            },
                            events: {
                                hideExpression: "qmForm.createVoucherNr != true"
                            }
                        }, {
                            lngTag: "20019015",
                            label: "Beleg Nr.",
                            type: "String",
                            model: "voucherNr",
                            style: {
                                class: "col-xs-12 col-md-6 col-lg-3",
                                icon: "fa fa-hashtag",
                            },
                            events: {
                                hideExpression: "qmForm.createVoucherNr == true"
                            }
                        }, {
                            lngTag: "20000045",
                            label: "Datum",
                            type: "Date",
                            model: "date",
                            required: true,
                            style: {
                                class: "col-xs-12 col-md-6"
                            }
                        }, {
                            type: "hr"
                        }, {
                            lngTag: "20019029",
                            label: "Belegtext",
                            type: "String",
                            model: "voucherText",
                            required: true,
                            style: {
                                class: "col-xs-12 col-md-12",
                                icon: "qm-icon-note_text"
                            }
                        },
                        {
                            lngTag: "20019024",
                            label: "Personenbezug",
                            type: "Select2",
                            model: "referenceId",
                            dataSource: "getReferences",
                            style: {
                                class: "col-xs-12"
                            }
                        },
                        {
                            lngTag: "20000122",
                            label: "Betrag",
                            type: "Number",
                            model: "amount",
                            minValue: -1000000,
                            //id: "amount",
                            required: true,
                            validate: {
                                message: "Bitte den Betrag ausfüllen",
                                messageTag: 20019005
                            },
                            style: {
                                class: "col-md-6 col-xs-12",
                                icon: "fa fa-eur"
                            },
                        }, {
                            placeholder: "Währung",
                            label: "Währung",
                            type: "String",
                            lngTag: 20019003,
                            model: "currency",
                            disabled: true,
                            style: {
                                class: "col-md-6 col-xs-12",
                                icon: "fa fa-info"
                            },
                        }, {
                            lngTag: "20000049",
                            label: "Bemerkung",
                            type: "Textarea",
                            maxLength: 255,
                            model: "comment",
                            style: {
                                class: "col-xs-12",
                                icon: "qm-icon-note_text",
                            },
                        },],
                    actions: {
                        put: "putAccountingBookEntry",
                        post: "addAccountingBookEntry"
                    }
                };
                _this.accountingBookCounterBookingTable = {
                    "table": {
                        "Typ": {
                            "label": "referenceType",
                            "dType": "string",
                            "lngTag": "20000025",
                        },
                        "Bezug": {
                            "label": "reference",
                            "dType": "string",
                            "lngTag": "20000283",
                        },
                        "Kassenbuch": {
                            "label": "name",
                            "dType": "string",
                            "lngTag": "20001044",
                        },
                        "Kassenbuchart": {
                            "label": "type",
                            "dType": "string",
                            "lngTag": "20019002",
                        },
                        "Hauptkassenbuch": {
                            "label": "isStandard",
                            "dType": "Bool",
                            "lngTag": "20000279"
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-cashier blue",
                                "click": "selectCounterAccountingBook",
                                "dType": "Button",
                                "lngTag": "20019033",
                                "tooltip": "Gegenbuchung für dieses Kassenbuch erstellen",
                            }]
                    },
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-cashier"
                        },
                        "text": {
                            "label": "name",
                            "dType": "string"
                        },
                        "subtext": [{
                                "label": "referenceType",
                                "dType": "string"
                            }, {
                                "label": "reference",
                                "dType": "string"
                            }, {
                                "label": "type",
                                "dType": "string"
                            }],
                        "buttons": [{
                                "icon": "qm-icon-cashier blue",
                                "click": "selectCounterAccountingBook",
                                "dType": "Button",
                                "lngTag": "0",
                                "tooltip": "Gegenbuchung für dieses Kassenbuch erstellen",
                            }]
                    },
                    "data": null,
                };
                _this.smartAufgabeForm = {
                    form: [
                        {
                            label: "Aufgabe",
                            placeholder: "",
                            type: "String",
                            lngTag: "20014007",
                            required: true,
                            model: "taskName",
                            validate: {
                                message: "Bitte die Aufgabe angeben.",
                                messageTag: 20014008
                            },
                            style: {
                                icon: "qm-icon-check",
                                class: "col-xs-12"
                            }
                        },
                        {
                            label: "Kategorie",
                            placeholder: "Kategorie auswählen",
                            type: "Select",
                            lngTag: "20000137",
                            model: "categoryId",
                            dataSource: "getCategoryList",
                            style: {
                                class: "col-md-6 col-xs-12"
                            }
                        },
                        {
                            label: "Priorität",
                            placeholder: "Priorität auswählen",
                            type: "Select",
                            lngTag: "20014013",
                            model: "priorityId",
                            dataSource: "getPriorityList",
                            id: "priorityList",
                            style: {
                                class: "col-md-6 col-xs-12"
                            }
                        },
                        {
                            placeholder: "Erledigungstyp auswählen ...",
                            label: "Erledigungstyp",
                            type: "Select",
                            lngTag: "20014014",
                            model: "executionTypeId",
                            dataSource: "getExecutionTypeList",
                            id: "executionTypeList",
                            required: true,
                            validate: {
                                message: "Bitte Erledigungstyp angeben.",
                                messageTag: 20014021
                            },
                            style: {
                                class: "col-md-6 col-xs-12"
                            }
                        },
                        {
                            label: "Erledigungsfrist",
                            placeholder: "zu erledigen bis",
                            type: "Date",
                            model: "dateToFinishTill",
                            startDate: new Date(),
                            lngTag: "20014005",
                            style: {
                                icon: "fa fa-font",
                                class: "col-md-6 col-xs-12"
                            }
                        },
                        {
                            label: "Termin(e) verwenden",
                            type: "Checkbox",
                            model: "isAppointment",
                            id: "isAppointment",
                            lngTag: "20014030",
                            style: {
                                class: "col-md-6 col-xs-12"
                            }
                        },
                        {
                            label: "Teilnehmer (Mitarbeiter)",
                            type: "Select2",
                            lngTag: "20014010",
                            model: "participants",
                            dataSource: "getParticipantsList",
                            multiple: true,
                            id: "participantsTypeList",
                            style: {
                                class: "col-xs-12"
                            }
                        },
                        {
                            label: "Beschreibung",
                            placeholder: "Beschreibung eingeben ...",
                            type: "Summernote",
                            maxLength: -1,
                            lngTag: "20014019",
                            model: "taskDescription",
                            style: {
                                icon: "qm-icon-note_text",
                                class: "colm-md-6 col-xs-12"
                            }
                        }
                    ],
                    actions: {
                        put: "putAufgabe",
                        post: "addAufgabe",
                    }
                };
                _this.smartContactpersonForm = {
                    form: [
                        {
                            placeholder: "Klient auswählen",
                            label: "Klient",
                            type: "Select",
                            model: "participants",
                            lngTag: 20017049,
                            required: true,
                            id: "selectedClientIds",
                            dataSource: "getClientList",
                            style: {
                                class: "col- xs - 12",
                            },
                            validate: {
                                message: "Bitte einen Klienten angeben.",
                                messageTag: 21003000
                            }
                        },
                        {
                            placeholder: "Kontaktpersonart auswählen",
                            label: "Kontaktpersonart",
                            type: "Select",
                            model: "contactPersonTypeId",
                            lngTag: 20004003,
                            required: true,
                            dataSource: "getContactPersonTypeList",
                            style: {
                                class: "col-md-6 col-xs-12",
                            },
                            validate: {
                                message: "Bitte die Art auswählen!"
                            }
                        }, {
                            placeholder: "Anrede auswählen",
                            label: "Anrede",
                            type: "Select",
                            model: "salutationId",
                            lngTag: 20004005,
                            dataSource: "getSalutationList",
                            style: {
                                class: "col-md-6 col-xs-12",
                            },
                            validate: {
                                message: "Bitte die Anrede auswählen!"
                            }
                        }, {
                            placeholder: "Titel auswählen",
                            label: "Titel",
                            type: "Select",
                            model: "titleId",
                            lngTag: 21002024,
                            dataSource: "getTitleList",
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                        }, {
                            type: "hr"
                        }, {
                            placeholder: "Vorname",
                            label: "Vorname",
                            type: "String",
                            lngTag: 20000057,
                            model: "forename",
                            validate: {
                                message: "Bitte den Vornamen angeben",
                                messageTag: 20003510,
                            },
                            style: {
                                icon: "fa fa-font",
                                class: "col-md-6 col-xs-12"
                            }
                        }, {
                            placeholder: "Nachname",
                            label: "Nachname",
                            type: "String",
                            lngTag: 20000058,
                            required: true,
                            model: "name",
                            validate: {
                                message: "Bitte den Nachnamen angeben",
                                messageTag: 20003510,
                            },
                            style: {
                                icon: "fa fa-font",
                                class: "col-md-6 col-xs-12"
                            }
                        }, {
                            placeholder: "Geburtsdatum",
                            label: "Geburtsdatum",
                            type: "Date",
                            lngTag: 21002004,
                            model: "birthday",
                            validate: {
                                message: "Bitte das Geburtsdatum angeben",
                                messageTag: 21003020,
                            },
                            style: {
                                icon: "fa fa-font",
                                class: "col-md-6 col-xs-12"
                            }
                        }, {
                            placeholder: {
                                dateFrom: "Gültig von",
                                dateTo: "Gültig bis"
                            },
                            label: {
                                dateFrom: "Gültig von",
                                dateTo: "Gültig bis"
                            },
                            type: "DateRange",
                            model: {
                                dateFrom: "dateFrom",
                                dateTo: "dateTo"
                            },
                            style: {
                                class: "col-xs-12"
                            },
                            config: {
                                displayDateTo: true
                            }
                        }, {
                            placeholder: "Bemerkung eintragen ...",
                            label: "Bemerkung",
                            type: "Textarea",
                            maxLength: -1,
                            model: "comment",
                            lngTag: 20000049,
                            style: {
                                icon: "qm-icon-note_text",
                                class: "col-xs-12 col-md-12"
                            }
                        }, {
                            label: "Kontaktsperre",
                            type: "Checkbox",
                            model: "isContactBan",
                            lngTag: 20004512,
                            id: "isContactBan",
                            style: {
                                class: "medium"
                            }
                        }
                    ],
                    actions: {
                        post: "addContactperson",
                        put: "putContactperson"
                    }
                };
                _this.smartAppointmentForm = {
                    form: [{
                            label: "Betreff",
                            placeholder: "Betreff",
                            type: "String",
                            model: "title",
                            required: true,
                            validate: {
                                message: "Bitte den Betreff angeben.",
                                messageTag: 20018024
                            },
                            style: {
                                class: "col-xs-12",
                                icon: "fa fa-font"
                            }
                        },
                        {
                            label: "Teilnehmer (Klienten)",
                            type: "Select2",
                            model: "participants",
                            id: "selectedClientIds",
                            dataSource: "getClientList",
                            multiple: true,
                            style: {
                                class: "col-xs-12"
                            }
                        },
                        {
                            label: "Teilnehmer (Mitarbeiter)",
                            type: "Select2",
                            model: "selectedEmployeeIds",
                            id: "selectedEmployeeIds",
                            dataSource: "getEmployeeList",
                            multiple: true,
                            style: {
                                class: "col-xs-12"
                            }
                        },
                        {
                            type: "hr"
                        }, {
                            placeholder: {
                                dateFrom: "Datum von",
                                dateTo: "Datum bis",
                            },
                            type: "DateRange",
                            lngTag: "20000130",
                            model: {
                                dateFrom: "dateFrom",
                                dateTo: "dateTo"
                            },
                            label: {
                                dateFrom: "Datum von",
                                dateTo: "Datum bis"
                            },
                            style: {
                                class: "col-xs-12"
                            },
                            config: {
                                displayTime: true,
                                displayDateTo: true,
                                disableTime: "isAllDay"
                            }
                        },
                        {
                            placeholder: "Ort",
                            label: "Ort",
                            type: "String",
                            model: "location",
                            style: {
                                class: "col-xs-12",
                                icon: "qm-icon-fa fa-map-marker"
                            }
                        },
                        {
                            label: "Bemerkung",
                            placeholder: "Bemerkung eingeben ...",
                            type: "Textarea",
                            maxLength: -1,
                            lngTag: "20000049",
                            model: "description",
                            style: {
                                icon: "qm-icon-note_text",
                                class: "colm-md-6 col-xs-12"
                            }
                        },
                        {
                            label: "Privat",
                            type: "Checkbox",
                            lngTag: 20018014,
                            model: "isPrivate",
                            id: "isPrivate",
                            style: {
                                class: "col-md-4 col-xs-6"
                            }
                        },
                        {
                            label: "Erledigt",
                            type: "Checkbox",
                            lngTag: 20000120,
                            model: "isFinished",
                            id: "isFinished",
                            style: {
                                class: "col-md-4 col-xs-6"
                            }
                        },
                        {
                            label: "Ganztägig",
                            type: "Checkbox",
                            lngTag: 20018016,
                            model: "isAllDay",
                            id: "isAllDay",
                            style: {
                                class: "col-md-4 col-xs-6"
                            }
                        },],
                    actions: {
                        put: "putAppointment",
                        post: "addAppointment"
                    }
                };
                _this.smartAbsenteeismForm = {
                    form: [{
                            label: "Teilnehmer (Klienten)",
                            type: "Select2",
                            model: "participants",
                            id: "selectedClientIds",
                            dataSource: "getClientList",
                            multiple: true,
                            style: {
                                class: "col-xs-12"
                            }
                        }, {
                            placeholder: "Abwesenheitsgrund",
                            label: "Abwesenheitsgrund",
                            type: "Select",
                            lngTag: 21008001,
                            model: "absenteeismReasonId",
                            dataSource: "getWvList",
                            required: true,
                            validate: {
                                message: "Bitte einen Grund auswählen.",
                                messageTag: 21008002
                            },
                            style: {
                                class: "col-md-6 col-xs-12",
                            }
                        }, {
                            type: "hr"
                        }, {
                            placeholder: {
                                dateFrom: "Datum von",
                                dateTo: "Datum bis"
                            },
                            label: {
                                dateFrom: "Datum von",
                                dateTo: "Datum bis"
                            },
                            type: "DateRange",
                            model: {
                                dateFrom: "dateFrom",
                                dateTo: "dateTo"
                            },
                            style: {
                                class: "col-xs-12"
                            },
                            config: {
                                displayTime: true,
                                disableTime: false,
                                displayDateTo: true
                            }
                        }, {
                            placeholder: "Bemerkung eintragen ...",
                            label: "Bemerkung",
                            type: "Textarea",
                            maxLength: -1,
                            model: "comment",
                            lngTag: 20000049,
                            style: {
                                icon: "qm-icon-note_text",
                                class: "col-xs-12",
                            }
                        },],
                    actions: {
                        put: "putAbsenteeism",
                        post: "addAbsenteeism"
                    }
                };
                _this.smartDiseaseForm = {
                    form: [{
                            label: "Teilnehmer (Klienten)",
                            type: "Select2",
                            model: "participants",
                            id: "selectedClientIds",
                            dataSource: "getClientList",
                            multiple: true,
                            style: {
                                class: "col-xs-12"
                            }
                        }, {
                            placeholder: {
                                dateFrom: "Datum von",
                                dateTo: "Datum bis",
                            },
                            label: {
                                dateFrom: "Datum von",
                                dateTo: "Datum bis",
                            },
                            type: "DateRange",
                            lngTag: 20000130,
                            model: {
                                dateFrom: "dateFrom",
                                dateTo: "dateTo"
                            },
                            style: {
                                class: "col-xs-12"
                            },
                            config: {
                                displayDateTo: true
                            }
                        }, {
                            placeholder: "Codeschema",
                            label: "Codeschema",
                            type: "Select2",
                            model: "diseaseCodeSchemaId",
                            dataSource: "getDiseaseWvList",
                            lngTag: 20007002,
                            required: true,
                            validate: {
                                message: "Bitte das Codeschema angeben.",
                                messageTag: 21003005
                            },
                            style: {
                                class: "col-md-6 col-xs-12",
                            }
                        }, {
                            placeholder: "Krankheit",
                            label: "Krankheit",
                            type: "Autocomplete",
                            model: "diseaseName",
                            lngTag: 20001049,
                            required: true,
                            id: "liveDiseases",
                            validate: {
                                message: "Bitte die Krankheit angeben."
                            },
                            style: {
                                class: "col-md-6 col-xs-12",
                                icon: "fa fa-globe"
                            }
                        }, {
                            placeholder: "Bemerkung eintragen ...",
                            label: "Bemerkung",
                            type: "Textarea",
                            maxLength: -1,
                            model: "comment",
                            lngTag: 20000049,
                            style: {
                                icon: "qm-icon-note_text",
                                class: "col-xs-12 col-md-12",
                            }
                        },],
                    actions: {
                        put: "putDisease",
                        post: "addDisease",
                    }
                };
                _this.smartDocVisitForm = {
                    form: [{
                            label: "Teilnehmer (Klienten)",
                            type: "Select2",
                            model: "participants",
                            id: "selectedClientIds",
                            dataSource: "getClientList",
                            multiple: true,
                            style: {
                                class: "col-xs-12"
                            }
                        }, {
                            placeholder: "Datum",
                            label: "Datum",
                            type: "Date",
                            model: "date",
                            lngTag: 20000045,
                            required: true,
                            style: {
                                class: "col-md-6 col-xs-12",
                            }
                        }, {
                            placeholder: "Uhrzeit",
                            label: "Uhrzeit",
                            type: "Time",
                            lngTag: 20000046,
                            model: "time",
                            style: {
                                class: "col-md-6 col-xs-12",
                            },
                        }, {
                            type: "hr"
                        }, {
                            placeholder: "Arzt",
                            label: "Arzt",
                            type: "Select2",
                            model: "doctorId",
                            lngTag: 20010502,
                            dataSource: "getDoctors",
                            style: {
                                class: "col-md-12 col-xs-12",
                            },
                        }, {
                            placeholder: "Diagnose",
                            label: "Diagnose",
                            type: "Textarea",
                            maxLength: -1,
                            lngTag: 20010503,
                            model: "diagnose",
                            style: {
                                class: "col-md-12 col-xs-12",
                                icon: "fa fa-user-md"
                            },
                        },],
                    actions: {
                        put: "putDocVisit",
                        post: "addDocVisit"
                    }
                };
                _this.smartVaccinationForm = {
                    form: [{
                            label: "Teilnehmer (Klienten)",
                            type: "Select2",
                            model: "participants",
                            id: "selectedClientIds",
                            dataSource: "getClientList",
                            multiple: true,
                            style: {
                                class: "col-xs-12"
                            }
                        }, {
                            lngTag: {
                                dateFrom: "20000045",
                                dateTo: "20009504"
                            },
                            label: {
                                dateFrom: "Datum",
                                dateTo: "Folgetermin"
                            },
                            type: "DateRange",
                            model: {
                                dateFrom: "date",
                                dateTo: "dateFollowupAppointment"
                            },
                            style: {
                                class: "col-xs-12"
                            },
                            config: {
                                displayDateTo: true
                            }
                        }, {
                            type: "hr"
                        }, {
                            placeholder: "Arzt auswählen",
                            label: "Arzt",
                            type: "Select2",
                            model: "doctorId",
                            lngTag: 20010502,
                            dataSource: "getDoctors",
                            required: true,
                            validate: {
                                message: "Bitte den Arzt angeben.",
                                messageTag: 21003014
                            },
                            style: {
                                class: "col-md-6 col-xs-12",
                            }
                        }, {
                            placeholder: "Krankheit auswählen",
                            label: "Krankheit",
                            type: "Select2",
                            model: "diseaseId",
                            dataSource: "getDiseases",
                            lngTag: 20001049,
                            required: true,
                            id: "disease",
                            validate: {
                                message: "Bitte eine Krankheit angeben",
                                messageTag: 21003006
                            },
                            style: {
                                class: "col-md-6 col-xs-12",
                            },
                        }, {
                            placeholder: "Impfstoff Handelsname",
                            label: "Impfstoff",
                            type: "String",
                            lngTag: 20009512,
                            model: "caption",
                            style: {
                                class: "col-md-6 col-xs-12",
                                icon: "fa fa-stethoscope"
                            },
                        }, {
                            placeholder: "Chargen-Nr",
                            label: "Chargen-Nr",
                            type: "String",
                            model: "batchNumber",
                            lngTag: 20009507,
                            style: {
                                class: "col-md-6 col-xs-12",
                                icon: "fa fa-hashtag"
                            },
                        }, {
                            placeholder: "Bemerkung eintragen",
                            label: "Bemerkung",
                            type: "Textarea",
                            maxLength: -1,
                            lngTag: 20000049,
                            model: "comment",
                            style: {
                                icon: "qm-icon-note_text",
                                class: "colm-md-6 col-xs-12",
                            }
                        },],
                    actions: {
                        put: "putVaccination",
                        post: "addVaccination"
                    }
                };
                /**
                * Client detail legal table
                * @memberOf UserInterface
                */
                _this.legalTable = {
                    "table": {
                        "Gültig von": {
                            "label": "dateFrom",
                            "dType": "Date",
                            "lngTag": "20000277"
                        },
                        "Gültig bis": {
                            "label": "dateTo",
                            "dType": "Date",
                            "lngTag": "20000278"
                        },
                        "Rechtsbezeichnung": {
                            "label": "lawType",
                            "dType": "string",
                            "lngTag": "20022004"
                        },
                        "Rechteinhaber": {
                            "label": "firstLawOwner",
                            "dType": "string",
                            "lngTag": "20022005"
                        },
                        "Gesetzbuch": {
                            "label": "lawBook",
                            "dType": "string",
                            "lngTag": "20022006"
                        },
                        "Zusatz zum Recht": {
                            "label": "legalScale",
                            "dType": "string",
                            "lngTag": "20022010"
                        },
                        "Rechtsgrundlage": {
                            "label": "legalBasis",
                            "dType": "string",
                            "lngTag": "20022008"
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editLegal",
                                "label": "data",
                                "openModal": "true",
                                "targetModal": "#" + _this.modalId,
                                "dType": "Button",
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteLegal",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            }]
                    },
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-calendar_7"
                        },
                        "text": {
                            "label": "lawType",
                            "dType": "string"
                        },
                        "subtext": [{
                                "label": "lawBook",
                                "dType": "string"
                            }],
                        "buttons": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editLegal",
                                "label": "data",
                                "dType": "Button",
                                "openModal": "true",
                                "targetModal": "#" + _this.modalId,
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteLegal",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            }]
                    },
                    "data": null
                };
                /**
                * Client detail legal form
                * @memberOf UserInterface
                */
                _this.legalForm = {
                    form: [{
                            lngTag: {
                                dateFrom: "20000277",
                                dateTo: "20000278"
                            },
                            label: {
                                dateFrom: "Gültig von",
                                dateTo: "Gültig bis"
                            },
                            type: "DateRange",
                            model: {
                                dateFrom: "dateFrom",
                                dateTo: "dateTo"
                            },
                            style: {
                                class: "col-xs-12"
                            },
                            config: {
                                displayDateTo: true
                            }
                        },
                        {
                            label: "Recht",
                            type: "Select2",
                            model: "lawTypeId",
                            lngTag: 20022009,
                            dataSource: "getLawTypeList",
                            required: true,
                            //events: {
                            //    updateDataSource: "legalScaleId"
                            //},
                            style: {
                                class: "col-xs-12"
                            },
                            id: "lawTypeId",
                            wvId: '550b1b03-57b9-4329-b7cb-9e9dffb378d1',
                            wvListData: 'wvList.lawWvList'
                        },
                        {
                            label: "Zusatz zum Recht",
                            type: "Select2",
                            model: "legalScaleId",
                            lngTag: 20022010,
                            dataSource: "getLawAdditionList",
                            events: {
                                hideExpression: "qmForm.hasNoLawAdditions || qmForm.lawTypeId == null"
                            },
                            style: {
                                class: "col-xs-12"
                            },
                            id: "legalScaleId",
                            wvId: '3e0d8030-1421-41b1-aed9-053d2d01a344',
                            wvSubParent: 'lawTypeId'
                        },
                        {
                            label: "1. Rechteinhaber",
                            type: "Select2",
                            model: "firstLawOwnerId",
                            lngTag: 20022013,
                            dataSource: "getLawOwnerList",
                            style: {
                                class: "col-xs-6"
                            },
                            id: "firstLawOwnerId"
                        },
                        {
                            label: "2. Rechteinhaber",
                            type: "Select2",
                            model: "secondLawOwnerId",
                            lngTag: 20022014,
                            dataSource: "getLawOwnerList",
                            style: {
                                class: "col-xs-6"
                            },
                            id: "secondLawOwnerId"
                        },
                        {
                            label: "Gesetztesbuch",
                            type: "Select2",
                            model: "lawBookId",
                            lngTag: 20022006,
                            dataSource: "getLawBooks",
                            events: {
                                updateDataSource: "legalBasisId"
                            },
                            style: {
                                class: "col-xs-6"
                            },
                            id: "lawBookId"
                        },
                        {
                            label: "Paragraph",
                            type: "Select2",
                            model: "legalBasisId",
                            dataSource: "getParagraphList",
                            lngTag: 20022015,
                            events: {
                                hideExpression: "qmForm.hasNoParagraphs || qmForm.lawBookId == null"
                            },
                            style: {
                                class: "col-xs-6"
                            },
                            id: "legalBasisId"
                        },
                        {
                            placeholder: "Bemerkung",
                            placeholderTag: "20000049",
                            label: "Notizen",
                            type: "Summernote",
                            lngTag: 20000049,
                            model: "comment",
                            style: {
                                icon: "qm-icon-note_text",
                                class: "col-xs-12"
                            }
                        },
                    ],
                    actions: {
                        put: "putLegal",
                        post: "addLegal"
                    }
                };
                /**
                * detail medicalEvidence table
                * @memberOf UserInterface
                */
                _this.medicalEvidenceTable = {
                    "table": {
                        "Datum": {
                            "label": "date",
                            "dType": "Date",
                            "lngTag": "20000045",
                        },
                        "Ablaufdatum": {
                            "label": "validToDate",
                            "dType": "Date",
                            "lngTag": "20031007",
                        },
                        "Nachweisart": {
                            "label": "evidenceKind",
                            "dType": "string",
                            "lngTag": "20031006",
                        },
                        "Nachweistyp": {
                            "label": "evidenceType",
                            "dType": "string",
                            "lngTag": "20031005",
                        },
                        "Initiative": {
                            "label": "initiative",
                            "dType": "string",
                            "lngTag": "20031004",
                        },
                        "Ergebnis": {
                            "label": "result",
                            "dType": "string",
                            "lngTag": "20031001",
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editMedicalEvidence",
                                "label": "data",
                                "openModal": "true",
                                "targetModal": "#" + _this.modalId,
                                "dType": "Button",
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteMedicalEvidence",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            }]
                    },
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-injection"
                        },
                        "text": {
                            "label": "evidenceKind",
                            "dType": "string"
                        },
                        "subtext": [{
                                "label": "evidenceType",
                                "dType": "string"
                            }, {
                                "label": "date",
                                "dType": "Date",
                            }, {
                                "label": "validToDate",
                                "dType": "Date",
                            }],
                        "buttons": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editMedicalEvidence",
                                "label": "data",
                                "openModal": "true",
                                "targetModal": "#" + _this.modalId,
                                "dType": "Button",
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteMedicalEvidence",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            }]
                    },
                    "data": null,
                };
                /**
                * detail medicalEvidence form
                * @memberOf UserInterface
                */
                _this.medicalEvidenceForm = {
                    form: [{
                            label: "Datum",
                            type: "Date",
                            lngTag: 20000045,
                            model: "date",
                            required: true,
                            validate: {
                                message: "Bitte das Datum angeben",
                                messageTag: 21003001
                            },
                            style: {
                                icon: "fa fa-calendar",
                                class: "col-md-6 col-xs-12"
                            }
                        },
                        {
                            label: "Ablaufdatum",
                            type: "Date",
                            lngTag: 20031007,
                            model: "validToDate",
                            style: {
                                icon: "fa fa-calendar-o",
                                class: "col-md-6 col-xs-12"
                            }
                        },
                        {
                            label: "Nachweisart",
                            type: "Select2",
                            model: "evidenceKindId",
                            lngTag: 20031006,
                            dataSource: "getEvidenceKind",
                            required: true,
                            validate: {
                                message: "Bitte eine Nachweisart auswählen",
                                messageTag: 21003042
                            },
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                            wvId: 'a1f7e0af-f2ab-4b54-beea-82d0aa4c28f7',
                            wvListData: 'wv.evidenceKindWvList'
                        },
                        {
                            label: "Nachweistyp",
                            type: "Select2",
                            model: "evidenceTypeId",
                            lngTag: 20031005,
                            dataSource: "getEvidenceType",
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                            wvId: '15ba6762-32da-40ae-94c5-ce176776d4a4',
                            wvListData: 'wv.evidenceTypeWvList'
                        },
                        {
                            label: "Initiative",
                            type: "Select2",
                            model: "initiativeId",
                            lngTag: 20031004,
                            dataSource: "getInitiative",
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                            wvId: '79906dfe-0730-44a8-9e46-00cd79d4451f',
                            wvListData: 'wv.initiativeWvList'
                        },
                        {
                            label: "Zusatztext",
                            type: "String",
                            model: "additionalText",
                            lngTag: 20031003,
                            style: {
                                icon: "fa fa-font",
                                class: "col-xs-12"
                            },
                        },
                        {
                            label: "Durchgeführt von",
                            type: "Select2",
                            model: "executorId",
                            lngTag: 20031002,
                            dataSource: "getExecutioner",
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                        },
                        {
                            label: "Ergebnis",
                            type: "Select2",
                            model: "resultId",
                            lngTag: 20031001,
                            dataSource: "getResult",
                            required: true,
                            validate: {
                                message: "Bitte ein Ergebnis auswählen.",
                                messageTag: 21003043
                            },
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                            wvId: 'fa480b40-f518-4abd-a14a-836f543cb68a',
                            wvListData: 'wv.resultWvList'
                        },
                        {
                            placeholder: "Bemerkung",
                            placeholderTag: 20000049,
                            label: "Bemerkung",
                            type: "Summernote",
                            lngTag: 20000049,
                            model: "comment",
                            style: {
                                icon: "qm-icon-note_text",
                                class: "col-xs-12"
                            }
                        }],
                    actions: {
                        put: "putMedicalEvidence",
                        post: "addMedicalEvidence",
                    }
                };
                /**
                * detail tempInstituteChange table
                * @memberOf UserInterface
                */
                _this.tempInstituteChangeTable = {
                    "table": {
                        "Datum von": {
                            "label": "dateFrom",
                            "dType": "Date",
                            "lngTag": "20000047",
                        },
                        "Datum bis": {
                            "label": "dateTo",
                            "dType": "Date",
                            "lngTag": "20000054",
                        },
                        "Organisation": {
                            "label": "institute",
                            "dType": "string",
                            "lngTag": "20000279",
                        },
                        "Grund": {
                            "label": "reason",
                            "dType": "string",
                            "lngTag": "20032001",
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editTempInstituteChange",
                                "label": "data",
                                "openModal": "true",
                                "targetModal": "#" + _this.modalId,
                                "dType": "Button",
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteTempInstituteChange",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            }]
                    },
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-injection"
                        },
                        "text": {
                            "label": "institute",
                            "dType": "string"
                        },
                        "subtext": [{
                                "label": "dateFrom",
                                "dType": "Date"
                            }, {
                                "label": "dateTo",
                                "dType": "Date",
                            }, {
                                "label": "reason",
                                "dType": "string",
                            }],
                        "buttons": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editTempInstituteChange",
                                "label": "data",
                                "openModal": "true",
                                "targetModal": "#" + _this.modalId,
                                "dType": "Button",
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteTempInstituteChange",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            }]
                    },
                    "data": null,
                };
                /**
                * detail medicationIssuedThrough table
                * @memberOf UserInterface
                */
                _this.medicationIssuedThroughTable = {
                    "table": {
                        "Organisation": {
                            "label": "displayTitle",
                            "dType": "string",
                            "lngTag": "20034003",
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteMedicalResponsible",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "deleteMedicationIssuedThrough"
                            }]
                    },
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-injection"
                        },
                        "text": {
                            "label": "displayTitle",
                            "dType": "string"
                        },
                        "subtext": [{
                                "label": "organisation",
                                "dType": "string",
                            }],
                        "buttons": [{
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteMedicalResponsible",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "deleteMedicationIssuedThrough"
                            }]
                    },
                    "data": null,
                };
                /**
                * detail medicalResponsible table
                * @memberOf UserInterface
                */
                _this.medicalResponsibleTable = {
                    "table": {
                        "Organisation": {
                            "label": "displayTitle",
                            "dType": "string",
                            "lngTag": "20034003",
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteMedicalResponsible",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "deleteMedicalResponsiblePerm"
                            }]
                    },
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-injection"
                        },
                        "text": {
                            "label": "organisation",
                            "dType": "string"
                        },
                        "subtext": [{
                                "label": "displayTitle",
                                "dType": "string",
                            }],
                        "buttons": [{
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteMedicalResponsible",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "deleteMedicalResponsiblePerm"
                            }]
                    },
                    "data": null,
                };
                /**
                * detail medicalResponsible form
                * @memberOf UserInterface
                */
                _this.medicalResponsibleForm = {
                    form: [{
                            placeholder: "Organisation auswählen",
                            placeholderTag: 20034008,
                            label: "Organisation",
                            type: "Select2",
                            model: "organisationIds",
                            multiple: true,
                            validate: {
                                message: "Bitte die Organisation angeben",
                                messageTag: 20034006
                            },
                            lngTag: 20034003,
                            dataSource: "getInstitute",
                            style: {
                                class: "col-xs-12"
                            },
                        }],
                    actions: {
                        put: "putMedicalResponsible",
                        post: "addOrRemoveOrganisationFrom",
                    }
                };
                /**
                * detail tempInstituteChange form
                * @memberOf UserInterface
                */
                _this.tempInstituteChangeForm = {
                    form: [{
                            label: "Datum von",
                            type: "Date",
                            lngTag: 20000047,
                            model: "dateFrom",
                            required: true,
                            validate: {
                                message: "Bitte das Datum von angeben",
                                messageTag: 21003001
                            },
                            style: {
                                icon: "fa fa-calendar",
                                class: "col-md-6 col-xs-12"
                            }
                        },
                        {
                            label: "Datum bis",
                            type: "Date",
                            lngTag: 20000054,
                            model: "dateTo",
                            required: true,
                            validate: {
                                message: "Bitte das Datum bis angeben",
                                messageTag: 21003001
                            },
                            style: {
                                icon: "fa fa-calendar",
                                class: "col-md-6 col-xs-12"
                            }
                        },
                        {
                            label: "Organisation",
                            type: "Select2",
                            model: "instituteId",
                            required: true,
                            validate: {
                                message: "Bitte die Organisation angeben",
                                messageTag: 21003041
                            },
                            lngTag: 20000279,
                            dataSource: "getInstitute",
                            style: {
                                class: "col-xs-12"
                            },
                        },
                        {
                            label: "Grund",
                            type: "Select2",
                            model: "reasonId",
                            required: true,
                            validate: {
                                message: "Bitte den Grund angeben",
                                messageTag: 21003040
                            },
                            lngTag: 20032001,
                            dataSource: "getReason",
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                            wvId: 'a493c156-d518-40dd-b1b2-c3185f2617a5',
                            wvListData: 'wv.reasonWvList'
                        },
                        {
                            placeholder: "Bemerkung",
                            placeholderTag: 20000049,
                            label: "Bemerkung",
                            type: "Textarea",
                            lngTag: 20000049,
                            model: "comment",
                            style: {
                                icon: "qm-icon-note_text",
                                class: "col-xs-12"
                            }
                        }],
                    actions: {
                        put: "putTempInstituteChange",
                        post: "addTempInstituteChange",
                    }
                };
                _this.modalId = modalId !== null && modalId !== void 0 ? modalId : _this.modalId;
                return _this;
            }
            return DetailUI;
        }(QMC.Common.UserInterface));
        Stammdaten.DetailUI = DetailUI;
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        var _this = this;
        angular.module('QMC.Stammdaten').directive('qmAccountingBook', ['$qui', 'QmcLanguageService', 'QmcPermissionService', 'StammdatenService', 'UserService', function ($qui, lng, permissionService, stammdatenService, userService) {
                return {
                    restrict: 'E',
                    templateUrl: './stammdaten/Directives/AccountingBook',
                    transclude: true,
                    scope: {
                        qmParent: '=',
                        qmCreate: '='
                    },
                    link: function (scope) {
                        scope.vm = scope;
                        //Set defaults
                        scope.allowTableExport = false;
                        scope.ui = new Stammdaten.DetailUI();
                        scope.calcIn = 0;
                        scope.calcOut = 0;
                        scope.isMobile = false;
                        scope.formState = 'new';
                        scope.entryFormState = 'new';
                        scope.timeAmount = 0;
                        scope.loading = true;
                        scope.loadingDetail = false;
                        scope.generateVoucherNrPossible = false;
                        scope.generateVoucherNrPreselection = false;
                        scope.reweNumberData = "";
                        scope.filterWatcher = {
                            dateFrom: null,
                            dateTo: null
                        };
                        scope.validation = {
                            errors: [],
                            warnings: [],
                            isLoading: false
                        };
                        scope.promptOptions = {
                            title: lng.translate(20001044, "Kassenbuch"),
                            yesNo: true,
                            icon: "qm-icon-history2",
                            text: lng.translate(20000290, "Wollen Sie den Eintrag wirklich löschen?")
                        };
                        scope.promptOptionsCounter = {
                            title: lng.translate(20019030, "Gegenbuchung"),
                            yesNo: true,
                            icon: "qm-icon-cashier",
                            text: lng.translate(20019031, "Möchten Sie eine Gegenbuchung eintragen?")
                        };
                        scope.promptOptionsCounterDismiss = {
                            title: lng.translate(20019030, "Gegenbuchung"),
                            yesNo: true,
                            icon: "qm-icon-cashier",
                            text: lng.translate(20019032, "Sie haben kein Ziel für eine Gegenbuchung ausgewählt. Möchten Sie wirklich ohne fortfahren?")
                        };
                        scope.isMobile = QMC.Common.Constants.IS_MOBILE;
                        scope.qmCreate = function () {
                            scope.created = true;
                            scope.showDetail = false;
                            permissionService.getPermissionsByObjectTypes([330003, 330000]).then(function (data) {
                                //permissionService.getPermissionsByObjectTypes([330003, 140008]).then((data: Common.IPermission[]) => {
                                scope.entryView = data[0].view;
                                scope.entryDelete = data[0].delete;
                                scope.entryNew = data[0].new;
                                scope.entryModify = data[0].modify;
                                scope.view = data[1].view;
                                scope.delete = data[1].delete;
                                scope.new = data[1].new;
                                scope.modify = data[1].modify;
                                scope.moduleAccess = data[1].moduleAccess;
                                scope.allowTableExport = data[1].print;
                                $qui.waitForEl('#newModalButton', function () {
                                    if (!scope.new)
                                        document.getElementById('newModalButton').style.visibility = 'hidden';
                                    else
                                        document.getElementById('newModalButton').style.visibility = 'unset';
                                });
                                scope.getWv();
                                $qui.getTableAutoload(userService).then(function (ltd) {
                                    scope.shouldLoadTableData = ltd;
                                    if (scope.shouldLoadTableData) {
                                        scope.getData();
                                    }
                                });
                                userService.getUserSettings(["KASSENBUCH.BELEGNUMMER_BUCHUNGSKREIS", "KLIENT.BELEGNUMMER_BUCHUNGSKREIS", "KASSENBUCH.BELEGNUMMERGENERIEREN.KLIENT", "KASSENBUCH.ShowFiBuDataInSearchDialog", "KASSENBUCH.GEGENBUCHUNG.CREATE"], false).then(function (data) {
                                    scope.generateVoucherNrPossible = (data[0].value.toLowerCase() !== "" && data[0].value.toLowerCase() !== QMC.Common.Constants.GUID_EMPTY);
                                    scope.generateVoucherNrPossible = scope.generateVoucherNrPossible || (data[1].value.toLowerCase() !== "" && data[1].value.toLowerCase() !== QMC.Common.Constants.GUID_EMPTY);
                                    scope.generateVoucherNrPreselection = data[2].value.toLowerCase() === "true";
                                    if (data[3].value.toLowerCase() === "true")
                                        scope.getReweNumberData();
                                    if (scope.entryForm) {
                                        scope.entryForm.generateVoucherNrPossible = scope.generateVoucherNrPossible;
                                        scope.entryForm.createVoucherNr = scope.generateVoucherNrPreselection;
                                    }
                                    scope.counterBookingMode = data[4].value;
                                    if (!(!scope.counterBookingMode || scope.counterBookingMode === '' || scope.counterBookingMode === QMC.Common.Constants.GUID_EMPTY || scope.counterBookingMode === '13358c99-565d-4c56-b9d4-e213977ecfd2')) { //if counterbooking could be shown, load data
                                        stammdatenService.getAccountingBooks().then(function (data) {
                                            scope.ui.accountingBookCounterBookingTable.data = data;
                                        });
                                    }
                                });
                                scope.$watch('vm.entryForm.amount', function (newValue, oldValue) {
                                    if (newValue === oldValue)
                                        return;
                                    scope.validateKassenbuchEntry(false, scope.entryForm);
                                }, true);
                                scope.$watch('vm.entryForm.voucherNr', function (newValue, oldValue) {
                                    if (newValue === oldValue)
                                        return;
                                    scope.validateKassenbuchEntry(false, scope.entryForm);
                                }, true);
                                scope.$watch('vm.entryForm.isDeposit', function (newValue, oldValue) {
                                    if (newValue === oldValue)
                                        return;
                                    scope.validateKassenbuchEntry(false, scope.entryForm);
                                }, true);
                                scope.$watch('vm.entryForm.date', function (newValue, oldValue) {
                                    if (newValue === oldValue)
                                        return;
                                    scope.validateKassenbuchEntry(false, scope.entryForm);
                                }, true);
                                var sortItemListByDate = function () {
                                    scope.detailItems.sort(function (a, b) { return a.date.value > b.date.value ? 1 : a.date.value < b.date.value ? -1 : 0; });
                                };
                                scope.$watch('detailInItems', function (newValue, oldValue) {
                                    var _a, _b;
                                    if (newValue === oldValue)
                                        return;
                                    scope.detailItems = ((_a = scope.detailInItems) !== null && _a !== void 0 ? _a : []).concat((_b = scope.detailOutItems) !== null && _b !== void 0 ? _b : []);
                                    sortItemListByDate();
                                }, true);
                                scope.$watch('detailOutItems', function (newValue, oldValue) {
                                    var _a, _b;
                                    if (newValue === oldValue)
                                        return;
                                    scope.detailItems = ((_a = scope.detailInItems) !== null && _a !== void 0 ? _a : []).concat((_b = scope.detailOutItems) !== null && _b !== void 0 ? _b : []);
                                    sortItemListByDate();
                                }, true);
                            });
                            scope.dateFrom = moment().startOf('month').subtract('months', 3).toDate();
                            scope.dateTo = moment().toDate();
                            scope.events();
                        };
                        scope.events = function () {
                            scope.filterWatcher.dateTo = scope.$watch('vm.dateTo', function (newValue, oldValue) {
                                if (newValue === oldValue || scope.form === (null || undefined))
                                    return;
                                scope.getAccountingBook(scope.form);
                            });
                            scope.filterWatcher.dateFrom = scope.$watch('vm.dateFrom', function (newValue, oldValue) {
                                if (newValue === oldValue || !scope.form)
                                    return;
                                scope.getAccountingBook(scope.form);
                            });
                        };
                        /****************** FORM ******************/
                        scope.initForm = function () {
                            var _a;
                            scope.form = {
                                id: null,
                                objectId: null,
                                caption: null,
                                isStandard: false,
                                standardVatId: scope.userConfig.defaultVat,
                                currencyId: scope.userConfig.defaultCurrency,
                                endingDate: null,
                                onlyPositive: true,
                                accountNumber: null,
                                parentObjectId: scope.qmParent.id,
                                parentObjectType: (_a = scope.qmParent.objectType) !== null && _a !== void 0 ? _a : QMC.Common.Constants.OBJECTTYPE_CLIENT,
                                accountingBookTypeId: null,
                                countryId: scope.userConfig.defaultCountry
                            };
                            scope.entryForm = {
                                objectId: null,
                                id: null,
                                comment: null,
                                voucherTypeId: null,
                                vatId: null,
                                isDeposit: false,
                                amount: 0,
                                date: new Date(),
                                accountingBookId: null,
                                currency: null,
                                currencyShort: null,
                                voucherText: "",
                                voucherNr: "",
                                voucherType: null,
                                vat: null,
                                vatText: null,
                                clientId: scope.qmParent.id,
                                generateVoucherNrPossible: scope.generateVoucherNrPossible,
                                createVoucherNr: scope.generateVoucherNrPreselection,
                                isVoucherNumberFix: false,
                                isCounterBooking: false,
                                counterBookingId: null
                            };
                        };
                        scope.initEntryForm = function (form) {
                            scope.initForm();
                            scope.entryForm.vatId = form.standardVatId;
                            scope.entryForm.accountingBookId = form.id;
                            scope.entryForm.currency = form.currency;
                            scope.entryForm.isVoucherNumberFix = false;
                        };
                        scope.editAccountingBook = function (form) {
                            scope.formState = 'edit';
                            scope.form = form;
                            if (form.endingDate) {
                                scope.form.endingDate = $qui.createDateFromString(form.endingDate);
                            }
                        };
                        scope.editAccountingBookEntry = function (form) {
                            scope.entryFormState = 'edit';
                            scope.entryForm = form;
                            if (form.isVoucherNumberFix)
                                scope.entryForm.createVoucherNr = true;
                            setTimeout(function () {
                                // Parse to two decimal digits comma value (see mantis 0021255)
                                //if (isNaN($(this).val()))
                                //    $(this).val(0);
                                var withPoint = form.amount.toString().replace(',', '.');
                                var twoDecimalDigits = parseFloat(withPoint).toFixed(2);
                                var withComma = twoDecimalDigits.replace('.', ',');
                                $('#amount').val(withComma);
                            }, 300);
                            if (form.date !== (null || undefined))
                                scope.entryForm.date = $qui.createDateFromString(form.date);
                        };
                        /****************** DATA ******************/
                        scope.getData = function () {
                            scope.getAccountingBooks();
                        };
                        scope.getReferences = function () {
                            return stammdatenService.getAccountingBookReferences().then(function (data) {
                                var values = data.map(function (x) { return ({ value: x.objectId, text: x.displayTitle, group: x.objectTypeCaption }); });
                                values.sort(function (a, b) { return (a.text.toLocaleLowerCase() > b.text.toLocaleLowerCase()) ? 1 : ((b.text.toLocaleLowerCase() > a.text.toLocaleLowerCase()) ? -1 : 0); });
                                values.sort(function (a, b) { return (a.group.toLocaleLowerCase() > b.group.toLocaleLowerCase()) ? 1 : ((b.group.toLocaleLowerCase() > a.group.toLocaleLowerCase()) ? -1 : 0); });
                                return values;
                            });
                        };
                        scope.getTypeList = function () {
                            return scope.wvList.accountingBookTypeWvList.map(function (obj) {
                                return {
                                    value: obj.id,
                                    text: obj.name,
                                    isFix: obj.isFix
                                };
                            });
                        };
                        scope.getCountryList = function () {
                            return scope.ui.select(scope.wvList.countryWvList, {
                                value: 'objectId',
                                text: 'name'
                            });
                        };
                        scope.getDepositList = function () {
                            return [{
                                    value: true,
                                    text: "Einnahme"
                                }, {
                                    value: false,
                                    text: "Ausgabe"
                                }];
                        };
                        scope.getCurrencyList = function () {
                            return scope.wvListForCountry.currencyWvList.map(function (obj) {
                                return {
                                    value: obj.id,
                                    text: obj.caption,
                                    isFix: obj.isFix,
                                };
                            });
                        };
                        scope.getVatList = function () {
                            return scope.wvListForCountry.vatWvList.map(function (obj) {
                                return {
                                    value: obj.id,
                                    text: obj.caption,
                                    isFix: obj.isFix,
                                };
                            });
                        };
                        scope.getDepositTypeList = function () {
                            return scope.wvList.depositVoucherTypeWvList.map(function (obj) {
                                return {
                                    value: obj.id,
                                    text: obj.name,
                                    isFix: obj.isFix
                                };
                            });
                        };
                        scope.getVoucherTypeList = function () {
                            return scope.wvList.paymentVoucherTypeWvList.map(function (obj) {
                                return {
                                    value: obj.id,
                                    text: obj.name,
                                    isFix: obj.isFix,
                                };
                            });
                        };
                        /****************** COUNTERBOOKING EXTRA ******************/
                        scope.addAccountingBookEntry = function (form) {
                            if (!scope.counterBookingMode || scope.counterBookingMode === '' || scope.counterBookingMode === QMC.Common.Constants.GUID_EMPTY || scope.counterBookingMode === '13358c99-565d-4c56-b9d4-e213977ecfd2') { //never
                                scope.addAccountingBookEntryAction(form);
                            }
                            else { //always //ask
                                QMC.Common.Utilities.confirm(scope.promptOptionsCounter, function (open) {
                                    if (open) {
                                        scope.counterBookingFilter = '';
                                        scope.entryForm = angular.copy(form);
                                        scope.entryFormState = 'new';
                                        $qui.functionWaiter("createCounterBookingTable", scope);
                                        $('#counterBookingModal').modal('show');
                                    }
                                    else {
                                        scope.addAccountingBookEntryAction(form);
                                    }
                                }, '#promptCounter', true);
                            }
                        };
                        scope.putAccountingBookEntry = function (form) {
                            if (!scope.counterBookingMode || scope.counterBookingMode === '' || scope.counterBookingMode === QMC.Common.Constants.GUID_EMPTY || scope.counterBookingMode === '13358c99-565d-4c56-b9d4-e213977ecfd2') { //never
                                scope.putAccountingBookEntryAction(form);
                            }
                            else { //always //ask
                                QMC.Common.Utilities.confirm(scope.promptOptionsCounter, function (open) {
                                    if (open) {
                                        scope.entryForm = angular.copy(form);
                                        scope.entryFormState = 'edit';
                                        $qui.functionWaiter("createCounterBookingTable", scope);
                                        $('#counterBookingModal').modal('show');
                                    }
                                    else {
                                        scope.putAccountingBookEntryAction(form);
                                    }
                                }, '#promptCounter', true);
                            }
                        };
                        scope.selectCounterAccountingBook = function (item) {
                            if (item === void 0) { item = undefined; }
                            if (item) {
                                scope.entryForm.counterBookingId = item.id;
                                scope.validateKassenbuchEntryCounterBooking(scope.entryForm);
                                return;
                            }
                            scope.performSaveAction();
                        };
                        scope.closeCounterBookingModal = function () {
                            QMC.Common.Utilities.confirm(scope.promptOptionsCounterDismiss, function (dismiss) {
                                if (dismiss) {
                                    scope.entryForm.counterBookingId = undefined;
                                    scope.selectCounterAccountingBook();
                                }
                                else {
                                    $('#counterBookingModal').modal('show');
                                }
                            }, '#promptCounterDismiss', true);
                        };
                        scope.validateKassenbuchEntryCounterBooking = function (form) {
                            scope.validation.errors = null;
                            scope.validation.warnings = null;
                            var validationObject = {
                                idCashJournal: form.counterBookingId,
                                idObjectEntry: undefined,
                                entryDate: form.date,
                                isRevenue: !scope.entryForm.isDeposit,
                                amount: form.amount ? form.amount : 0,
                                voucherNumber: form.voucherNr,
                                infoText: form.comment,
                                isDeletionRequest: false,
                            };
                            stammdatenService.checkForWarningsAndErrors(validationObject).then(function (dataValidation) {
                                if (dataValidation.errors.length > 0 || dataValidation.warnings.length > 0) {
                                    scope.validation.errors = dataValidation.errors;
                                    scope.validation.warnings = dataValidation.warnings;
                                    $('#validationCounterBookingModal').modal('show');
                                }
                                else {
                                    scope.performSaveAction();
                                }
                            });
                        };
                        scope.performSaveAction = function () {
                            $('#counterBookingModal').modal('hide');
                            if (scope.entryFormState === 'new') {
                                scope.addAccountingBookEntryAction(scope.entryForm);
                            }
                            else {
                                scope.putAccountingBookEntryAction(scope.entryForm);
                            }
                        };
                        /****************** SERVICE ******************/
                        scope.addAccountingBook = function (form) {
                            stammdatenService.postAccountingBook(form).then(function () {
                                scope.ui.notify(scope.ui.successNote);
                                scope.formState = 'new';
                                scope.getAccountingBooks();
                            });
                        };
                        scope.putAccountingBook = function (form) {
                            stammdatenService.putAccountingBook(scope.qmParent.id, form.id, form).then(function () {
                                scope.ui.notify(scope.ui.successNote);
                                scope.formState = 'new';
                                scope.getAccountingBooks();
                            });
                        };
                        scope.deleteAccountingBook = function (item) {
                            scope.promptOptions.itemText = item.caption;
                            QMC.Common.Utilities.confirm(scope.promptOptions, function (data) {
                                if (data)
                                    stammdatenService.deleteAccountingBook(scope.qmParent.id, item.id).then(function () {
                                        scope.ui.notify(scope.ui.deleteNote);
                                        scope.formState = 'new';
                                        scope.getAccountingBooks();
                                    });
                            });
                        };
                        scope.addAccountingBookEntryAction = function (form) {
                            form.clientId = scope.qmParent.id;
                            scope.loadingDetail = true;
                            stammdatenService.postAccountingBookEntry(form).then(function () {
                                scope.ui.notify(scope.ui.successNote);
                                scope.getAccountingBook({ id: form.accountingBookId });
                            }).catch(function () {
                                scope.loadingDetail = false;
                            }).finally(function () {
                                scope.entryFormState = 'new';
                            });
                        };
                        scope.putAccountingBookEntryAction = function (form) {
                            form.clientId = scope.qmParent.id;
                            scope.loadingDetail = true;
                            stammdatenService.putAccountingBookEntry(form.id, form).then(function () {
                                scope.ui.notify(scope.ui.successNote);
                                scope.getAccountingBook({ id: form.accountingBookId });
                            }).catch(function () {
                                scope.loadingDetail = false;
                            }).finally(function () {
                                scope.entryFormState = 'new';
                            });
                        };
                        scope.deleteAccountingBookEntry = function (form) {
                            //I put the delete function in the validateKassenbuchEntry in order to better handle the validation result
                            scope.validateKassenbuchEntry(true, form);
                        };
                        scope.getWv = function () {
                            stammdatenService.getAccountingBookWv().then(function (data) {
                                scope.wvList = data;
                                stammdatenService.getAccountingBookUserConfig().then(function (data) {
                                    scope.userConfig = data;
                                    scope.initForm();
                                    scope.getWvForCountry();
                                    $qui.functionWaiter("createEntryForm", scope);
                                    setTimeout(function () {
                                        $('#amount').on('change', function () {
                                            // Parse to two decimal digits comma value (see mantis 0021255)
                                            var input = $(this).val().toString().replace(',', '.');
                                            if (isNaN(input))
                                                $(this).val(0);
                                            var withPoint = $(this).val().toString().replace(',', '.');
                                            var twoDecimalDigits = parseFloat(withPoint).toFixed(2);
                                            var withComma = twoDecimalDigits.replace('.', ',');
                                            $('#amount').val(withComma);
                                        });
                                    }, 300);
                                });
                            });
                        };
                        scope.getWvForCountry = function () {
                            stammdatenService.getAccountingBookWvForCountry(scope.form.countryId).then(function (data) {
                                scope.loading = false;
                                scope.wvListForCountry = data;
                                $qui.functionWaiter("ui.createForm", scope);
                            });
                        };
                        scope.getAccountingBooks = function () {
                            scope.loading = true;
                            stammdatenService.getAccountingBookList(scope.qmParent.id).then(function (data) {
                                data = data.map(function (obj) {
                                    obj.new = obj.permissions.new && this.entryNew;
                                    obj.modify = obj.permissions.modify;
                                    obj.delete = obj.permissions.delete;
                                    obj.view = obj.permissions.view;
                                    obj.permissions.special = obj.permissions.delete && !obj.isStandard;
                                    obj.wasStandard = obj.isStandard;
                                    return obj;
                                }.bind(scope));
                                scope.accountingBooks = data;
                                scope.ui.accountingBookTable.data = data;
                                $qui.functionWaiter("createAcountingbookTable", scope);
                                scope.loading = false;
                            });
                        };
                        scope.getAccountingBook = function (form) {
                            if (!form.id || form.id === QMC.Common.Constants.GUID_EMPTY)
                                return;
                            if (scope.filterWatcher.dateFrom) {
                                scope.filterWatcher.dateFrom();
                                scope.filterWatcher.dateTo();
                            }
                            scope.showDetail = true;
                            scope.loadingDetail = true;
                            scope.form = form;
                            for (var acc in scope.accountingBooks)
                                if (form.id === scope.accountingBooks[acc].id)
                                    scope.caption = scope.accountingBooks[acc].caption;
                            stammdatenService.getAccountingBook(scope.qmParent.id, form.id, scope.dateFrom, scope.dateTo).then(function (data) {
                                scope.totalAmount = data.sum;
                                data.items = data.items.map(function (obj) {
                                    obj.allowEdit = (data.permissions.modify || _this.entryModify) && !obj.isCounterBooking;
                                    obj.allowDelete = (data.permissions.delete || _this.entryDelete);
                                    obj.amountSigned = obj.amount;
                                    if (!obj.isDeposit)
                                        obj.amountSigned = -Math.abs(obj.amount);
                                    return obj;
                                });
                                var input = [];
                                var out = [];
                                scope.timeAmount = 0;
                                for (var _i = 0, _a = data.items; _i < _a.length; _i++) {
                                    var element = _a[_i];
                                    if (element.isDeposit) {
                                        input.push(element);
                                        scope.timeAmount = scope.timeAmount + element.amount;
                                    }
                                    else {
                                        out.push(element);
                                        scope.timeAmount = scope.timeAmount - element.amount;
                                    }
                                }
                                scope.ui.accountingBookEntryTableIn.data = input;
                                scope.ui.accountingBookEntryTableOut.data = out;
                                $qui.functionWaiter("createEntryTableOut", scope);
                                $qui.functionWaiter("createEntryTableIn", scope);
                                scope.loadingDetail = false;
                                scope.events();
                            });
                        };
                        scope.getReweNumberData = function () {
                            scope.reweNumberData = '';
                            stammdatenService.getReweNumber(140000, scope.qmParent.id).then(function (data) {
                                if (data[scope.qmParent.id] && data[scope.qmParent.id].length > 0) {
                                    for (var _i = 0, _a = data[scope.qmParent.id]; _i < _a.length; _i++) {
                                        var number = _a[_i];
                                        if (scope.reweNumberData.length > 0)
                                            scope.reweNumberData += '; ';
                                        scope.reweNumberData += number.caption + ': ' + number.value;
                                    }
                                }
                            });
                        };
                        scope.validateKassenbuchEntry = function (isDeleteRequest, form) {
                            if (!(moment(form.date).isValid()) || isNaN(form.amount))
                                return;
                            scope.validation.errors = null;
                            scope.validation.warnings = null;
                            var validationObject = {
                                idCashJournal: form.accountingBookId,
                                idObjectEntry: form.objectId,
                                entryDate: form.date,
                                isRevenue: scope.entryForm.isDeposit,
                                amount: form.amount ? form.amount : 0,
                                voucherNumber: form.voucherNr,
                                infoText: form.comment,
                                isDeletionRequest: isDeleteRequest,
                            };
                            stammdatenService.checkForWarningsAndErrors(validationObject).then(function (dataValidation) {
                                if (dataValidation.errors.length > 0 || dataValidation.warnings.length > 0) {
                                    scope.validation.errors = dataValidation.errors;
                                    scope.validation.warnings = dataValidation.warnings;
                                }
                                if (isDeleteRequest && dataValidation.errors.length === 0 && dataValidation.warnings.length === 0) {
                                    QMC.Common.Utilities.confirm(scope.promptOptions, function (deleteOK) {
                                        if (deleteOK) {
                                            scope.deleteForm = {
                                                accountingBookId: form.accountingBookId,
                                                objectId: form.objectId
                                            };
                                            scope.deleteEntry();
                                        }
                                    });
                                }
                                else {
                                    if (isDeleteRequest) {
                                        scope.deleteForm = {
                                            accountingBookId: form.accountingBookId,
                                            objectId: form.objectId
                                        };
                                        $('#validationModal').modal('show');
                                    }
                                }
                            });
                        };
                        scope.deleteEntry = function () {
                            stammdatenService.deleteAccountingBookEntry(scope.deleteForm.accountingBookId, scope.deleteForm.objectId).then(function () {
                                $('#validationModal').modal('hide');
                                scope.ui.notify(scope.ui.deleteNote);
                                scope.entryFormState = 'new';
                                scope.getAccountingBook({ id: scope.deleteForm.accountingBookId });
                            });
                        };
                    }
                };
            }
        ]);
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));

//# sourceMappingURL=../../maps/Stammdaten/qmc.stammdaten.js.map
